[
  {
    "name": "search",
    "tags": ["filter", "find", "glass", "look", "magnify", "magnifying", "search", "see"],
    "popularity": 784400
  },
  {
    "name": "home",
    "tags": [
      "address",
      "app",
      "application--house",
      "architecture",
      "building",
      "components",
      "design",
      "estate",
      "home",
      "interface",
      "layout",
      "place",
      "real",
      "residence",
      "residential",
      "screen",
      "shelter",
      "site",
      "structure",
      "ui",
      "unit",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 699128
  },
  {
    "name": "account_circle",
    "tags": ["account", "avatar", "circle", "face", "human", "people", "person", "profile", "thumbnail", "user"],
    "popularity": 569492
  },
  {
    "name": "settings",
    "tags": [
      "application",
      "change",
      "details",
      "gear",
      "info",
      "information",
      "options",
      "personal",
      "service",
      "settings"
    ],
    "popularity": 545175
  },
  {
    "name": "done",
    "tags": [
      "DISABLE_IOS",
      "approve",
      "check",
      "complete",
      "disable_ios",
      "done",
      "mark",
      "ok",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 477359
  },
  {
    "name": "info",
    "tags": [
      "alert",
      "announcement",
      "assistance",
      "details",
      "help",
      "i",
      "info",
      "information",
      "service",
      "support"
    ],
    "popularity": 422835
  },
  {
    "name": "close",
    "tags": ["cancel", "close", "exit", "stop", "x"],
    "popularity": 397156
  },
  {
    "name": "check_circle",
    "tags": [
      "approve",
      "check",
      "circle",
      "complete",
      "done",
      "mark",
      "ok",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 372490
  },
  {
    "name": "delete",
    "tags": ["bin", "can", "delete", "garbage", "remove", "trash"],
    "popularity": 350386
  },
  {
    "name": "menu",
    "tags": [
      "app",
      "application",
      "components",
      "hamburger",
      "interface",
      "line",
      "lines",
      "menu",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 344458
  },
  {
    "name": "person",
    "tags": ["account", "face", "human", "people", "person", "profile", "user"],
    "popularity": 336446
  },
  {
    "name": "expand_more",
    "tags": ["arrow", "arrows", "chevron", "collapse", "direction", "down", "expand", "expandable", "list", "more"],
    "popularity": 328174
  },
  {
    "name": "add",
    "tags": ["+", "add", "new symbol", "plus", "symbol"],
    "popularity": 320267
  },
  {
    "name": "visibility",
    "tags": ["eye", "on", "reveal", "see", "show", "view", "visibility"],
    "popularity": 295186
  },
  {
    "name": "shopping_cart",
    "tags": [
      "add",
      "bill",
      "buy",
      "card",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "shopping"
    ],
    "popularity": 289128
  },
  {
    "name": "edit",
    "tags": ["compose", "create", "edit", "editing", "input", "new", "pen", "pencil", "write", "writing"],
    "popularity": 284063
  },
  {
    "name": "favorite",
    "tags": ["appreciate", "favorite", "heart", "like", "love", "remember", "save", "shape"],
    "popularity": 252911
  },
  {
    "name": "email",
    "tags": ["email", "envelop", "letter", "mail", "message", "send"],
    "popularity": 252367
  },
  {
    "name": "description",
    "tags": [
      "article",
      "data",
      "description",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "notes",
      "page",
      "paper",
      "sheet",
      "slide",
      "text",
      "writing"
    ],
    "popularity": 237813
  },
  {
    "name": "logout",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "design",
      "exit",
      "interface",
      "leave",
      "log",
      "login",
      "logout",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 235636
  },
  {
    "name": "arrow_back",
    "tags": [
      "DISABLE_IOS",
      "app",
      "application",
      "arrow",
      "back",
      "components",
      "direction",
      "disable_ios",
      "interface",
      "left",
      "navigation",
      "previous",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 228331
  },
  {
    "name": "favorite_border",
    "tags": ["border", "favorite", "heart", "like", "love", "outline", "remember", "save", "shape"],
    "popularity": 209838
  },
  {
    "name": "chevron_right",
    "tags": ["arrow", "arrows", "chevron", "direction", "right"],
    "popularity": 205578
  },
  {
    "name": "lock",
    "tags": ["lock", "locked", "password", "privacy", "private", "protection", "safety", "secure", "security"],
    "popularity": 201547
  },
  {
    "name": "location_on",
    "tags": ["destination", "direction", "location", "maps", "on", "pin", "place", "room", "stop"],
    "popularity": 191847
  },
  {
    "name": "notifications",
    "tags": ["active", "alarm", "alert", "bell", "chime", "notifications", "notify", "reminder", "ring", "sound"],
    "popularity": 190094
  },
  {
    "name": "schedule",
    "tags": ["clock", "date", "schedule", "time"],
    "popularity": 187043
  },
  {
    "name": "local_shipping",
    "tags": [
      "automobile",
      "car",
      "cars",
      "delivery",
      "letter",
      "local",
      "mail",
      "maps",
      "office",
      "package",
      "parcel",
      "post",
      "postal",
      "send",
      "shipping",
      "shopping",
      "stamp",
      "transportation",
      "truck",
      "vehicle"
    ],
    "popularity": 182220
  },
  {
    "name": "search",
    "tags": ["filter", "find", "glass", "look", "magnify", "magnifying", "search", "see"],
    "popularity": 175041
  },
  {
    "name": "language",
    "tags": ["globe", "internet", "language", "planet", "website", "world", "www"],
    "popularity": 170862
  },
  {
    "name": "call",
    "tags": ["call", "cell", "contact", "device", "hardware", "mobile", "phone", "telephone"],
    "popularity": 170263
  },
  {
    "name": "file_download",
    "tags": ["arrow", "arrows", "down", "download", "downloads", "drive", "export", "file", "install", "upload"],
    "popularity": 168419
  },
  {
    "name": "arrow_forward_ios",
    "tags": [
      "app",
      "application",
      "arrow",
      "chevron",
      "components",
      "direction",
      "forward",
      "interface",
      "ios",
      "navigation",
      "next",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 164772
  },
  {
    "name": "home",
    "tags": [
      "address",
      "app",
      "application--house",
      "architecture",
      "building",
      "components",
      "design",
      "estate",
      "home",
      "interface",
      "layout",
      "place",
      "real",
      "residence",
      "residential",
      "screen",
      "shelter",
      "site",
      "structure",
      "ui",
      "unit",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 162737
  },
  {
    "name": "arrow_back_ios",
    "tags": [
      "DISABLE_IOS",
      "app",
      "application",
      "arrow",
      "back",
      "chevron",
      "components",
      "direction",
      "disable_ios",
      "interface",
      "ios",
      "left",
      "navigation",
      "previous",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 162558
  },
  {
    "name": "groups",
    "tags": [
      "body",
      "club",
      "collaboration",
      "crowd",
      "gathering",
      "groups",
      "human",
      "meeting",
      "people",
      "person",
      "social",
      "teams"
    ],
    "popularity": 158412
  },
  {
    "name": "cancel",
    "tags": ["cancel", "circle", "close", "exit", "stop", "x"],
    "popularity": 155968
  },
  {
    "name": "help_outline",
    "tags": [
      "?",
      "assistance",
      "circle",
      "help",
      "info",
      "information",
      "outline",
      "punctuation",
      "question mark",
      "recent",
      "restore",
      "shape",
      "support",
      "symbol"
    ],
    "popularity": 154483
  },
  {
    "name": "arrow_drop_down",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "down",
      "drop",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 151488
  },
  {
    "name": "face",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 149257
  },
  {
    "name": "manage_accounts",
    "tags": [
      "accounts",
      "change",
      "details service-human",
      "face",
      "gear",
      "manage",
      "options",
      "people",
      "person",
      "profile",
      "settings",
      "user"
    ],
    "popularity": 143330
  },
  {
    "name": "play_arrow",
    "tags": ["arrow", "control", "controls", "media", "music", "play", "video"],
    "popularity": 141262
  },
  {
    "name": "place",
    "tags": ["destination", "direction", "location", "maps", "navigation", "pin", "place", "point", "stop"],
    "popularity": 139573
  },
  {
    "name": "verified",
    "tags": [
      "approve",
      "badge",
      "burst",
      "check",
      "complete",
      "done",
      "mark",
      "ok",
      "select",
      "star",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 138131
  },
  {
    "name": "more_vert",
    "tags": [
      "3",
      "DISABLE_IOS",
      "android",
      "app",
      "application",
      "components",
      "disable_ios",
      "dots",
      "etc",
      "interface",
      "more",
      "screen",
      "site",
      "three",
      "ui",
      "ux",
      "vert",
      "vertical",
      "web",
      "website"
    ],
    "popularity": 137000
  },
  {
    "name": "add_circle_outline",
    "tags": ["+", "add", "circle", "create", "new", "outline", "plus"],
    "popularity": 136478
  },
  {
    "name": "menu",
    "tags": [
      "app",
      "application",
      "components",
      "hamburger",
      "interface",
      "line",
      "lines",
      "menu",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 136106
  },
  {
    "name": "filter_alt",
    "tags": ["alt", "edit", "filter", "funnel", "options", "refine", "sift"],
    "popularity": 133938
  },
  {
    "name": "thumb_up",
    "tags": [
      "favorite",
      "fingers",
      "gesture",
      "hand",
      "hands",
      "like",
      "rank",
      "ranking",
      "rate",
      "rating",
      "thumb",
      "up"
    ],
    "popularity": 131896
  },
  {
    "name": "fingerprint",
    "tags": [
      "finger",
      "fingerprint",
      "id",
      "identification",
      "identity",
      "print",
      "reader",
      "thumbprint",
      "verification"
    ],
    "popularity": 130937
  },
  {
    "name": "event",
    "tags": ["calendar", "date", "day", "event", "mark", "month", "range", "remember", "reminder", "today", "week"],
    "popularity": 130837
  },
  {
    "name": "close",
    "tags": ["cancel", "close", "exit", "stop", "x"],
    "popularity": 130454
  },
  {
    "name": "star",
    "tags": ["best", "bookmark", "favorite", "highlight", "ranking", "rate", "rating", "save", "star", "toggle"],
    "popularity": 129729
  },
  {
    "name": "dashboard",
    "tags": ["cards", "dashboard", "format", "layout", "rectangle", "shapes", "square", "web", "website"],
    "popularity": 128025
  },
  {
    "name": "people",
    "tags": [
      "accounts",
      "committee",
      "face",
      "family",
      "friends",
      "humans",
      "network",
      "people",
      "persons",
      "profiles",
      "social",
      "team",
      "users"
    ],
    "popularity": 125020
  },
  {
    "name": "list",
    "tags": ["file", "format", "index", "list", "menu", "options"],
    "popularity": 124007
  },
  {
    "name": "content_copy",
    "tags": ["content", "copy", "cut", "doc", "document", "duplicate", "file", "multiple", "paste"],
    "popularity": 123568
  },
  {
    "name": "login",
    "tags": [
      "access",
      "app",
      "application",
      "arrow",
      "components",
      "design",
      "enter",
      "in",
      "interface",
      "left",
      "log",
      "login",
      "screen",
      "sign",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 121089
  },
  {
    "name": "add_circle",
    "tags": ["+", "add", "circle", "create", "new", "plus"],
    "popularity": 120966
  },
  {
    "name": "visibility_off",
    "tags": ["disabled", "enabled", "eye", "off", "on", "reveal", "see", "show", "slash", "view", "visibility"],
    "popularity": 120087
  },
  {
    "name": "check_circle_outline",
    "tags": [
      "approve",
      "check",
      "circle",
      "complete",
      "done",
      "finished",
      "mark",
      "ok",
      "outline",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 119265
  },
  {
    "name": "chevron_left",
    "tags": ["DISABLE_IOS", "arrow", "arrows", "chevron", "direction", "disable_ios", "left"],
    "popularity": 118160
  },
  {
    "name": "arrow_forward",
    "tags": [
      "app",
      "application",
      "arrow",
      "arrows",
      "components",
      "direction",
      "forward",
      "interface",
      "navigation",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 118157
  },
  {
    "name": "calendar_today",
    "tags": ["calendar", "date", "day", "event", "month", "schedule", "today"],
    "popularity": 118041
  },
  {
    "name": "send",
    "tags": ["email", "mail", "message", "paper", "plane", "reply", "right", "send", "share"],
    "popularity": 117435
  },
  {
    "name": "settings",
    "tags": [
      "application",
      "change",
      "details",
      "gear",
      "info",
      "information",
      "options",
      "personal",
      "service",
      "settings"
    ],
    "popularity": 115359
  },
  {
    "name": "check_box",
    "tags": [
      "approved",
      "box",
      "button",
      "check",
      "component",
      "control",
      "form",
      "mark",
      "ok",
      "select",
      "selected",
      "selection",
      "tick",
      "toggle",
      "ui",
      "yes"
    ],
    "popularity": 114840
  },
  {
    "name": "warning",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "symbol",
      "triangle",
      "warning"
    ],
    "popularity": 113816
  },
  {
    "name": "share",
    "tags": [
      "DISABLE_IOS",
      "android",
      "connect",
      "contect",
      "disable_ios",
      "link",
      "media",
      "multimedia",
      "multiple",
      "network",
      "options",
      "share",
      "shared",
      "sharing",
      "social"
    ],
    "popularity": 113767
  },
  {
    "name": "highlight_off",
    "tags": ["cancel", "close", "exit", "highlight", "no", "off", "quit", "remove", "stop", "x"],
    "popularity": 111594
  },
  {
    "name": "navigate_next",
    "tags": ["arrow", "arrows", "direction", "navigate", "next", "right"],
    "popularity": 110519
  },
  {
    "name": "help",
    "tags": [
      "?",
      "assistance",
      "circle",
      "help",
      "info",
      "information",
      "punctuation",
      "question mark",
      "recent",
      "restore",
      "shape",
      "support",
      "symbol"
    ],
    "popularity": 104927
  },
  {
    "name": "phone",
    "tags": ["call", "cell", "contact", "device", "hardware", "mobile", "phone", "telephone"],
    "popularity": 104164
  },
  {
    "name": "paid",
    "tags": ["circle", "currency", "money", "paid", "payment", "transaction"],
    "popularity": 101901
  },
  {
    "name": "task_alt",
    "tags": [
      "approve",
      "check",
      "circle",
      "complete",
      "done",
      "mark",
      "ok",
      "select",
      "task",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 101633
  },
  {
    "name": "question_answer",
    "tags": [
      "answer",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "conversation",
      "feedback",
      "message",
      "question",
      "speech",
      "talk"
    ],
    "popularity": 101383
  },
  {
    "name": "check",
    "tags": [
      "DISABLE_IOS",
      "check",
      "confirm",
      "correct",
      "disable_ios",
      "done",
      "enter",
      "mark",
      "ok",
      "okay",
      "select",
      "tick",
      "yes"
    ],
    "popularity": 100798
  },
  {
    "name": "expand_less",
    "tags": ["arrow", "arrows", "chevron", "collapse", "direction", "expand", "expandable", "less", "list", "up"],
    "popularity": 100741
  },
  {
    "name": "clear",
    "tags": ["back", "cancel", "clear", "correct", "delete", "erase", "exit", "x"],
    "popularity": 99373
  },
  {
    "name": "date_range",
    "tags": [
      "calendar",
      "date",
      "day",
      "event",
      "month",
      "range",
      "remember",
      "reminder",
      "schedule",
      "time",
      "today",
      "week"
    ],
    "popularity": 98511
  },
  {
    "name": "article",
    "tags": ["article", "doc", "document", "file", "page", "paper", "text", "writing"],
    "popularity": 97213
  },
  {
    "name": "error",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "circle",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 96950
  },
  {
    "name": "photo_camera",
    "tags": ["camera", "image", "photo", "photography", "picture"],
    "popularity": 95283
  },
  {
    "name": "more_horiz",
    "tags": [
      "3",
      "DISABLE_IOS",
      "app",
      "application",
      "components",
      "disable_ios",
      "dots",
      "etc",
      "horiz",
      "horizontal",
      "interface",
      "ios",
      "more",
      "screen",
      "site",
      "three",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 94048
  },
  {
    "name": "check_box_outline_blank",
    "tags": [
      "blank",
      "box",
      "button",
      "check",
      "component",
      "control",
      "deselected",
      "empty",
      "form",
      "outline",
      "select",
      "selection",
      "square",
      "tick",
      "toggle",
      "ui"
    ],
    "popularity": 93706
  },
  {
    "name": "open_in_new",
    "tags": [
      "app",
      "application",
      "arrow",
      "box",
      "components",
      "in",
      "interface",
      "new",
      "open",
      "right",
      "screen",
      "site",
      "ui",
      "up",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 93029
  },
  {
    "name": "image",
    "tags": [
      "disabled",
      "enabled",
      "hide",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "off",
      "on",
      "photo",
      "photography",
      "picture",
      "slash"
    ],
    "popularity": 92097
  },
  {
    "name": "shopping_bag",
    "tags": [
      "bag",
      "bill",
      "business",
      "buy",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "shop",
      "shopping",
      "store",
      "storefront"
    ],
    "popularity": 91847
  },
  {
    "name": "person_outline",
    "tags": ["account", "face", "human", "outline", "people", "person", "profile", "user"],
    "popularity": 90599
  },
  {
    "name": "school",
    "tags": [
      "academy",
      "achievement",
      "cap",
      "class",
      "college",
      "education",
      "graduation",
      "hat",
      "knowledge",
      "learning",
      "school",
      "university"
    ],
    "popularity": 90510
  },
  {
    "name": "lightbulb",
    "tags": ["alert", "announcement", "idea", "info", "information", "light", "lightbulb"],
    "popularity": 90256
  },
  {
    "name": "refresh",
    "tags": [
      "around",
      "arrow",
      "arrows",
      "direction",
      "inprogress",
      "load",
      "loading refresh",
      "navigation",
      "refresh",
      "renew",
      "right",
      "rotate",
      "turn"
    ],
    "popularity": 88123
  },
  {
    "name": "file_upload",
    "tags": ["arrow", "arrows", "download", "drive", "export", "file", "up", "upload"],
    "popularity": 86959
  },
  {
    "name": "done",
    "tags": [
      "DISABLE_IOS",
      "approve",
      "check",
      "complete",
      "disable_ios",
      "done",
      "mark",
      "ok",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 85960
  },
  {
    "name": "expand_more",
    "tags": ["arrow", "arrows", "chevron", "collapse", "direction", "down", "expand", "expandable", "list", "more"],
    "popularity": 85598
  },
  {
    "name": "credit_card",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 85146
  },
  {
    "name": "person",
    "tags": ["account", "face", "human", "people", "person", "profile", "user"],
    "popularity": 85146
  },
  {
    "name": "perm_identity",
    "tags": [
      "account",
      "avatar",
      "face",
      "human",
      "identity",
      "people",
      "perm",
      "person",
      "profile",
      "thumbnail",
      "user"
    ],
    "popularity": 84971
  },
  {
    "name": "history",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "clock",
      "date",
      "history",
      "refresh",
      "renew",
      "reverse",
      "rotate",
      "schedule",
      "time",
      "turn"
    ],
    "popularity": 83889
  },
  {
    "name": "support_agent",
    "tags": ["agent", "care", "customer", "face", "headphone", "person", "representative", "service", "support"],
    "popularity": 83112
  },
  {
    "name": "trending_up",
    "tags": [
      "analytics",
      "arrow",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "movement",
      "rate",
      "rating",
      "statistics",
      "tracking",
      "trending",
      "up"
    ],
    "popularity": 82751
  },
  {
    "name": "account_balance",
    "tags": [
      "account",
      "balance",
      "bank",
      "bill",
      "building",
      "card",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "finance",
      "government",
      "money",
      "online",
      "pay",
      "payment"
    ],
    "popularity": 81898
  },
  {
    "name": "delete_outline",
    "tags": ["bin", "can", "delete", "garbage", "outline", "remove", "trash"],
    "popularity": 81563
  },
  {
    "name": "attach_money",
    "tags": [
      "attach",
      "attachment",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "symbol"
    ],
    "popularity": 81346
  },
  {
    "name": "person_add",
    "tags": [
      "+",
      "account",
      "add",
      "avatar",
      "face",
      "human",
      "new",
      "people",
      "person",
      "plus",
      "profile",
      "symbol",
      "user"
    ],
    "popularity": 80646
  },
  {
    "name": "public",
    "tags": ["earth", "global", "globe", "map", "network", "planet", "public", "social", "space", "web", "world"],
    "popularity": 80166
  },
  {
    "name": "check_circle",
    "tags": [
      "approve",
      "check",
      "circle",
      "complete",
      "done",
      "mark",
      "ok",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 79152
  },
  {
    "name": "save",
    "tags": ["data", "disk", "document", "drive", "file", "floppy", "multimedia", "save", "storage"],
    "popularity": 79055
  },
  {
    "name": "error_outline",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "circle",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "outline",
      "symbol",
      "warning"
    ],
    "popularity": 78148
  },
  {
    "name": "mail",
    "tags": ["email", "envelop", "letter", "mail", "message", "send"],
    "popularity": 78132
  },
  {
    "name": "fact_check",
    "tags": [
      "approve",
      "check",
      "complete",
      "done",
      "fact",
      "list",
      "mark",
      "ok",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 77868
  },
  {
    "name": "report_problem",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "feedback",
      "important",
      "mark",
      "notification",
      "problem",
      "report",
      "symbol",
      "triangle",
      "warning"
    ],
    "popularity": 77847
  },
  {
    "name": "radio_button_unchecked",
    "tags": [
      "bullet",
      "button",
      "circle",
      "deselected",
      "form",
      "off",
      "on",
      "point",
      "radio",
      "record",
      "select",
      "toggle",
      "unchecked"
    ],
    "popularity": 77403
  },
  {
    "name": "verified_user",
    "tags": [
      "approve",
      "certified",
      "check",
      "complete",
      "done",
      "mark",
      "ok",
      "privacy",
      "private",
      "protect",
      "protection",
      "security",
      "select",
      "shield",
      "tick",
      "user",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 76735
  },
  {
    "name": "assignment",
    "tags": ["assignment", "clipboard", "doc", "document", "text", "writing"],
    "popularity": 76240
  },
  {
    "name": "link",
    "tags": ["chain", "clip", "connection", "link", "linked", "links", "multimedia", "url"],
    "popularity": 75569
  },
  {
    "name": "favorite",
    "tags": ["appreciate", "favorite", "heart", "like", "love", "remember", "save", "shape"],
    "popularity": 75042
  },
  {
    "name": "play_circle_filled",
    "tags": ["arrow", "circle", "control", "controls", "media", "music", "play", "video"],
    "popularity": 73797
  },
  {
    "name": "emoji_events",
    "tags": [
      "achievement",
      "award",
      "chalice",
      "champion",
      "cup",
      "emoji",
      "events",
      "first",
      "prize",
      "reward",
      "sport",
      "trophy",
      "winner"
    ],
    "popularity": 72935
  },
  {
    "name": "remove",
    "tags": ["can", "delete", "minus", "negative", "remove", "substract", "trash"],
    "popularity": 71731
  },
  {
    "name": "star_rate",
    "tags": [
      "achievement",
      "bookmark",
      "favorite",
      "highlight",
      "important",
      "marked",
      "ranking",
      "rate",
      "rating rank",
      "reward",
      "save",
      "saved",
      "shape",
      "special",
      "star"
    ],
    "popularity": 70994
  },
  {
    "name": "add",
    "tags": ["+", "add", "new symbol", "plus", "symbol"],
    "popularity": 69961
  },
  {
    "name": "apps",
    "tags": [
      "all",
      "applications",
      "apps",
      "circles",
      "collection",
      "components",
      "dots",
      "grid",
      "interface",
      "squares",
      "ui",
      "ux"
    ],
    "popularity": 69869
  },
  {
    "name": "business",
    "tags": [
      "apartment",
      "architecture",
      "building",
      "business",
      "company",
      "estate",
      "home",
      "place",
      "real",
      "residence",
      "residential",
      "shelter"
    ],
    "popularity": 69701
  },
  {
    "name": "download",
    "tags": ["arrow", "down", "download", "downloads", "drive", "install", "upload"],
    "popularity": 69459
  },
  {
    "name": "delete",
    "tags": ["bin", "can", "delete", "garbage", "remove", "trash"],
    "popularity": 69147
  },
  {
    "name": "filter_list",
    "tags": ["filter", "lines", "list", "organize", "sort"],
    "popularity": 69119
  },
  {
    "name": "arrow_right_alt",
    "tags": ["alt", "arrow", "arrows", "direction", "east", "navigation", "pointing", "right"],
    "popularity": 68756
  },
  {
    "name": "chat",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "speech"],
    "popularity": 67515
  },
  {
    "name": "account_balance_wallet",
    "tags": [
      "account",
      "balance",
      "bank",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "wallet"
    ],
    "popularity": 67426
  },
  {
    "name": "payments",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "layer",
      "money",
      "multiple",
      "online",
      "pay",
      "payment",
      "payments",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 66356
  },
  {
    "name": "menu_book",
    "tags": ["book", "dining", "food", "meal", "menu", "restaurant"],
    "popularity": 66158
  },
  {
    "name": "folder",
    "tags": ["data", "doc", "document", "drive", "file", "folder", "folders", "sheet", "slide", "storage"],
    "popularity": 65837
  },
  {
    "name": "account_circle",
    "tags": ["account", "avatar", "circle", "face", "human", "people", "person", "profile", "thumbnail", "user"],
    "popularity": 65631
  },
  {
    "name": "keyboard_arrow_down",
    "tags": ["arrow", "arrows", "down", "keyboard"],
    "popularity": 65138
  },
  {
    "name": "mail",
    "tags": ["email", "envelop", "letter", "mail", "message", "send"],
    "popularity": 64509
  },
  {
    "name": "autorenew",
    "tags": [
      "around",
      "arrow",
      "arrows",
      "autorenew",
      "cache",
      "cached",
      "direction",
      "inprogress",
      "load",
      "loading refresh",
      "navigation",
      "renew",
      "rotate",
      "turn"
    ],
    "popularity": 64281
  },
  {
    "name": "build",
    "tags": ["adjust", "build", "fix", "home", "nest", "repair", "tool", "tools", "wrench"],
    "popularity": 63719
  },
  {
    "name": "view_list",
    "tags": ["design", "format", "grid", "layout", "lines", "list", "stacked", "view", "website"],
    "popularity": 63671
  },
  {
    "name": "videocam",
    "tags": [
      "cam",
      "camera",
      "conference",
      "film",
      "filming",
      "hardware",
      "image",
      "motion",
      "picture",
      "video",
      "videography"
    ],
    "popularity": 63588
  },
  {
    "name": "work",
    "tags": ["bag", "baggage", "briefcase", "business", "case", "job", "suitcase", "work"],
    "popularity": 62941
  },
  {
    "name": "print",
    "tags": ["draft", "fax", "ink", "machine", "office", "paper", "print", "printer", "send"],
    "popularity": 62909
  },
  {
    "name": "store",
    "tags": [
      "bill",
      "building",
      "business",
      "card",
      "cash",
      "coin",
      "commerce",
      "company",
      "credit",
      "currency",
      "dollars",
      "market",
      "money",
      "online",
      "pay",
      "payment",
      "shop",
      "shopping",
      "store",
      "storefront"
    ],
    "popularity": 62881
  },
  {
    "name": "analytics",
    "tags": [
      "analytics",
      "assessment",
      "bar",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 62464
  },
  {
    "name": "radio_button_checked",
    "tags": [
      "app",
      "application",
      "bullet",
      "button",
      "checked",
      "circle",
      "components",
      "design",
      "form",
      "interface",
      "off",
      "on",
      "point",
      "radio",
      "record",
      "screen",
      "select",
      "selected",
      "site",
      "toggle",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 62310
  },
  {
    "name": "phone_iphone",
    "tags": ["Android", "OS", "cell", "device", "hardware", "iOS", "iphone", "mobile", "phone", "tablet"],
    "popularity": 62149
  },
  {
    "name": "play_circle",
    "tags": ["arrow", "circle", "control", "controls", "media", "music", "play", "video"],
    "popularity": 61935
  },
  {
    "name": "tune",
    "tags": [
      "adjust",
      "audio",
      "controls",
      "custom",
      "customize",
      "edit",
      "editing",
      "filter",
      "filters",
      "instant",
      "mix",
      "music",
      "options",
      "setting",
      "settings",
      "slider",
      "sliders",
      "switches",
      "tune"
    ],
    "popularity": 61248
  },
  {
    "name": "delete_forever",
    "tags": ["bin", "can", "cancel", "delete", "exit", "forever", "garbage", "remove", "trash", "x"],
    "popularity": 61041
  },
  {
    "name": "today",
    "tags": ["calendar", "date", "day", "event", "mark", "month", "remember", "reminder", "schedule", "time", "today"],
    "popularity": 60778
  },
  {
    "name": "grid_view",
    "tags": [
      "app",
      "application square",
      "blocks",
      "components",
      "dashboard",
      "design",
      "grid",
      "interface",
      "layout",
      "screen",
      "site",
      "tiles",
      "ui",
      "ux",
      "view",
      "web",
      "website",
      "window"
    ],
    "popularity": 60625
  },
  {
    "name": "arrow_upward",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "up",
      "upward",
      "ux",
      "web",
      "website"
    ],
    "popularity": 60593
  },
  {
    "name": "east",
    "tags": ["arrow", "directional", "east", "maps", "navigation", "right"],
    "popularity": 60186
  },
  {
    "name": "mail_outline",
    "tags": ["email", "envelop", "letter", "mail", "message", "outline", "send"],
    "popularity": 59303
  },
  {
    "name": "calendar_month",
    "tags": ["calendar", "date", "day", "event", "month", "schedule", "today"],
    "popularity": 59230
  },
  {
    "name": "admin_panel_settings",
    "tags": [
      "account",
      "admin",
      "avatar",
      "certified",
      "face",
      "human",
      "panel",
      "people",
      "person",
      "privacy",
      "private",
      "profile",
      "protect",
      "protection",
      "security",
      "settings",
      "shield",
      "user",
      "verified"
    ],
    "popularity": 59142
  },
  {
    "name": "inventory_2",
    "tags": ["archive", "box", "file", "inventory", "organize", "packages", "product", "stock", "storage", "supply"],
    "popularity": 58951
  },
  {
    "name": "mic",
    "tags": ["hear", "hearing", "mic", "microphone", "noise", "record", "sound", "voice"],
    "popularity": 58362
  },
  {
    "name": "picture_as_pdf",
    "tags": [
      "alphabet",
      "as",
      "character",
      "document",
      "file",
      "font",
      "image",
      "letter",
      "multiple",
      "pdf",
      "photo",
      "photography",
      "picture",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 57083
  },
  {
    "name": "group",
    "tags": [
      "accounts",
      "committee",
      "face",
      "family",
      "friends",
      "group",
      "humans",
      "network",
      "people",
      "persons",
      "profiles",
      "social",
      "team",
      "users"
    ],
    "popularity": 57069
  },
  {
    "name": "lock_open",
    "tags": [
      "lock",
      "open",
      "password",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "unlocked"
    ],
    "popularity": 57028
  },
  {
    "name": "volume_up",
    "tags": ["audio", "control", "music", "sound", "speaker", "tv", "up", "volume"],
    "popularity": 56492
  },
  {
    "name": "watch_later",
    "tags": ["clock", "date", "later", "schedule", "time", "watch"],
    "popularity": 56234
  },
  {
    "name": "grade",
    "tags": ["'favorite_news'  .", "'star_outline'", "Duplicate of 'star_boarder'", "star_border_purple500'"],
    "popularity": 55793
  },
  {
    "name": "receipt_long",
    "tags": [
      "bill",
      "check",
      "document",
      "list",
      "long",
      "paper",
      "paperwork",
      "receipt",
      "record",
      "store",
      "transaction"
    ],
    "popularity": 55723
  },
  {
    "name": "local_offer",
    "tags": ["deal", "discount", "offer", "price", "shop", "shopping", "store", "tag"],
    "popularity": 55415
  },
  {
    "name": "update",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "clock",
      "forward",
      "history",
      "load",
      "refresh",
      "reverse",
      "schedule",
      "time",
      "update"
    ],
    "popularity": 55254
  },
  {
    "name": "badge",
    "tags": [
      "account",
      "avatar",
      "badge",
      "card",
      "certified",
      "employee",
      "face",
      "human",
      "identification",
      "name",
      "people",
      "person",
      "profile",
      "security",
      "user",
      "work"
    ],
    "popularity": 55141
  },
  {
    "name": "savings",
    "tags": [
      "bank",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "pig",
      "piggy",
      "savings",
      "symbol"
    ],
    "popularity": 55140
  },
  {
    "name": "room",
    "tags": ["destination", "direction", "location", "maps", "pin", "place", "room", "stop"],
    "popularity": 55109
  },
  {
    "name": "code",
    "tags": ["brackets", "code", "css", "develop", "developer", "engineer", "engineering", "html", "platform"],
    "popularity": 54969
  },
  {
    "name": "map",
    "tags": ["destination", "direction", "location", "map", "maps", "pin", "place", "route", "stop", "travel"],
    "popularity": 54292
  },
  {
    "name": "info",
    "tags": [
      "alert",
      "announcement",
      "assistance",
      "details",
      "help",
      "i",
      "info",
      "information",
      "service",
      "support"
    ],
    "popularity": 53830
  },
  {
    "name": "circle",
    "tags": ["circle", "full", "geometry", "moon"],
    "popularity": 53519
  },
  {
    "name": "light_mode",
    "tags": ["bright", "brightness", "day", "device", "light", "lighting", "mode", "morning", "sky", "sun", "sunny"],
    "popularity": 53409
  },
  {
    "name": "receipt",
    "tags": [],
    "popularity": 53183
  },
  {
    "name": "inventory",
    "tags": [
      "archive",
      "box",
      "clipboard",
      "doc",
      "document",
      "file",
      "inventory",
      "organize",
      "packages",
      "product",
      "stock",
      "supply"
    ],
    "popularity": 53157
  },
  {
    "name": "add_shopping_cart",
    "tags": [
      "add",
      "card",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "plus",
      "shopping"
    ],
    "popularity": 52890
  },
  {
    "name": "contact_support",
    "tags": [
      "?",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "contact",
      "help",
      "info",
      "information",
      "mark",
      "message",
      "punctuation",
      "question",
      "question mark",
      "speech",
      "support",
      "symbol"
    ],
    "popularity": 52881
  },
  {
    "name": "category",
    "tags": ["categories", "category", "circle", "collection", "items", "product", "sort", "square", "triangle"],
    "popularity": 52490
  },
  {
    "name": "arrow_back",
    "tags": [
      "DISABLE_IOS",
      "app",
      "application",
      "arrow",
      "back",
      "components",
      "direction",
      "disable_ios",
      "interface",
      "left",
      "navigation",
      "previous",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 52359
  },
  {
    "name": "edit_note",
    "tags": [
      "compose",
      "create",
      "draft",
      "edit",
      "editing",
      "input",
      "lines",
      "note",
      "pen",
      "pencil",
      "text",
      "write",
      "writing"
    ],
    "popularity": 52259
  },
  {
    "name": "insights",
    "tags": [
      "ai",
      "analytics",
      "artificial",
      "automatic",
      "automation",
      "bar",
      "bars",
      "chart",
      "custom",
      "data",
      "diagram",
      "genai",
      "graph",
      "infographic",
      "insights",
      "intelligence",
      "magic",
      "measure",
      "metrics",
      "smart",
      "spark",
      "sparkle",
      "star",
      "stars",
      "statistics",
      "tracking"
    ],
    "popularity": 51576
  },
  {
    "name": "power_settings_new",
    "tags": ["info", "information", "off", "on", "power", "save", "settings", "shutdown"],
    "popularity": 51451
  },
  {
    "name": "campaign",
    "tags": ["alert", "announcement", "campaign", "loud", "megaphone", "microphone", "notification", "speaker"],
    "popularity": 51100
  },
  {
    "name": "format_list_bulleted",
    "tags": [
      "align",
      "alignment",
      "bulleted",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "notes",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 51018
  },
  {
    "name": "star",
    "tags": ["best", "bookmark", "favorite", "highlight", "ranking", "rate", "rating", "save", "star", "toggle"],
    "popularity": 50928
  },
  {
    "name": "star_border",
    "tags": [
      "best",
      "bookmark",
      "border",
      "favorite",
      "highlight",
      "outline",
      "ranking",
      "rate",
      "rating",
      "save",
      "star",
      "toggle"
    ],
    "popularity": 50451
  },
  {
    "name": "chevron_right",
    "tags": ["arrow", "arrows", "chevron", "direction", "right"],
    "popularity": 50324
  },
  {
    "name": "pause",
    "tags": ["control", "controls", "media", "music", "pause", "video"],
    "popularity": 50153
  },
  {
    "name": "warning_amber",
    "tags": [
      "!",
      "alert",
      "amber",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "symbol",
      "triangle",
      "warning"
    ],
    "popularity": 49825
  },
  {
    "name": "remove_circle_outline",
    "tags": ["block", "can", "circle", "delete", "minus", "negative", "outline", "remove", "substract", "trash"],
    "popularity": 49734
  },
  {
    "name": "restart_alt",
    "tags": [
      "alt",
      "around",
      "arrow",
      "inprogress",
      "load",
      "loading refresh",
      "reboot",
      "renew",
      "repeat",
      "reset",
      "restart"
    ],
    "popularity": 49262
  },
  {
    "name": "wifi",
    "tags": ["connection", "data", "internet", "network", "scan", "service", "signal", "wifi", "wireless"],
    "popularity": 49119
  },
  {
    "name": "arrow_back_ios_new",
    "tags": [
      "DISABLE_IOS",
      "app",
      "application",
      "arrow",
      "back",
      "chevron",
      "components",
      "direction",
      "disable_ios",
      "interface",
      "ios",
      "left",
      "navigation",
      "new",
      "previous",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 49098
  },
  {
    "name": "done_all",
    "tags": [
      "all",
      "approve",
      "check",
      "complete",
      "done",
      "layers",
      "mark",
      "multiple",
      "ok",
      "select",
      "stack",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 48888
  },
  {
    "name": "pets",
    "tags": ["animal", "cat", "dog", "hand", "paw", "pet"],
    "popularity": 48826
  },
  {
    "name": "storefront",
    "tags": [
      "business",
      "buy",
      "cafe",
      "commerce",
      "front",
      "market",
      "places",
      "restaurant",
      "retail",
      "sell",
      "shop",
      "shopping",
      "store",
      "storefront"
    ],
    "popularity": 48471
  },
  {
    "name": "mode_edit",
    "tags": ["compose", "create", "draft", "draw", "edit", "mode", "pen", "pencil", "write"],
    "popularity": 48168
  },
  {
    "name": "sort",
    "tags": ["filter", "find", "lines", "list", "organize", "sort"],
    "popularity": 48076
  },
  {
    "name": "list_alt",
    "tags": ["alt", "box", "contained", "format", "lines", "list", "order", "reorder", "stacked", "title"],
    "popularity": 47883
  },
  {
    "name": "edit",
    "tags": ["compose", "create", "edit", "editing", "input", "new", "pen", "pencil", "write", "writing"],
    "popularity": 47480
  },
  {
    "name": "toggle_on",
    "tags": [
      "active",
      "app",
      "application",
      "components",
      "configuration",
      "control",
      "design",
      "disable",
      "inable",
      "inactive",
      "interface",
      "off",
      "on",
      "selection",
      "settings",
      "site",
      "slider",
      "switch",
      "toggle",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 47416
  },
  {
    "name": "engineering",
    "tags": [
      "body",
      "cogs",
      "cogwheel",
      "construction",
      "engineering",
      "fixing",
      "gears",
      "hat",
      "helmet",
      "human",
      "maintenance",
      "people",
      "person",
      "setting",
      "worker"
    ],
    "popularity": 47046
  },
  {
    "name": "call",
    "tags": ["call", "cell", "contact", "device", "hardware", "mobile", "phone", "telephone"],
    "popularity": 46972
  },
  {
    "name": "notifications_active",
    "tags": [
      "active",
      "alarm",
      "alert",
      "bell",
      "chime",
      "notifications",
      "notify",
      "reminder",
      "ring",
      "ringing",
      "sound"
    ],
    "popularity": 46919
  },
  {
    "name": "dark_mode",
    "tags": [
      "app",
      "application",
      "dark",
      "device",
      "interface",
      "mode",
      "moon",
      "night",
      "silent",
      "theme",
      "ui",
      "ux",
      "website"
    ],
    "popularity": 46882
  },
  {
    "name": "explore",
    "tags": [
      "compass",
      "destination",
      "direction",
      "east",
      "explore",
      "location",
      "maps",
      "needle",
      "north",
      "south",
      "travel",
      "west"
    ],
    "popularity": 46497
  },
  {
    "name": "bolt",
    "tags": ["bolt", "electric", "energy", "fast", "flash", "lightning", "power", "thunderbolt"],
    "popularity": 46352
  },
  {
    "name": "visibility",
    "tags": ["eye", "on", "reveal", "see", "show", "view", "visibility"],
    "popularity": 46243
  },
  {
    "name": "construction",
    "tags": [
      "build",
      "carpenter",
      "construction",
      "equipment",
      "fix",
      "hammer",
      "improvement",
      "industrial",
      "industry",
      "repair",
      "tools",
      "wrench"
    ],
    "popularity": 45982
  },
  {
    "name": "arrow_downward",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "down",
      "downward",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 45764
  },
  {
    "name": "qr_code_scanner",
    "tags": [
      "barcode",
      "camera",
      "code",
      "media",
      "product",
      "qr",
      "quick",
      "response",
      "scanner",
      "smartphone",
      "url",
      "urls"
    ],
    "popularity": 45737
  },
  {
    "name": "bookmark",
    "tags": [
      "archive",
      "bookmark",
      "favorite",
      "label",
      "library",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "tag"
    ],
    "popularity": 45639
  },
  {
    "name": "vpn_key",
    "tags": ["code", "key", "lock", "network", "passcode", "password", "unlock", "vpn"],
    "popularity": 45490
  },
  {
    "name": "monetization_on",
    "tags": [
      "bill",
      "card",
      "cash",
      "circle",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "monetization",
      "money",
      "on",
      "online",
      "pay",
      "payment",
      "shopping",
      "symbol"
    ],
    "popularity": 45431
  },
  {
    "name": "attach_file",
    "tags": ["add", "attach", "attachment", "clip", "file", "link", "mail", "media"],
    "popularity": 45256
  },
  {
    "name": "logout",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "design",
      "exit",
      "interface",
      "leave",
      "log",
      "login",
      "logout",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 45166
  },
  {
    "name": "timer",
    "tags": [
      "alarm",
      "alert",
      "bell",
      "clock",
      "disabled",
      "duration",
      "enabled",
      "notification",
      "off",
      "on",
      "slash",
      "stop",
      "time",
      "timer",
      "watch"
    ],
    "popularity": 45123
  },
  {
    "name": "arrow_forward_ios",
    "tags": [
      "app",
      "application",
      "arrow",
      "chevron",
      "components",
      "direction",
      "forward",
      "interface",
      "ios",
      "navigation",
      "next",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 44578
  },
  {
    "name": "account_box",
    "tags": ["account", "avatar", "box", "face", "human", "people", "person", "profile", "square", "thumbnail", "user"],
    "popularity": 44522
  },
  {
    "name": "note_add",
    "tags": [
      "+",
      "add",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "new",
      "note",
      "page",
      "paper",
      "plus",
      "sheet",
      "slide",
      "symbol",
      "writing"
    ],
    "popularity": 44450
  },
  {
    "name": "reorder",
    "tags": ["format", "lines", "list", "order", "reorder", "stacked"],
    "popularity": 43949
  },
  {
    "name": "bookmark_border",
    "tags": [
      "archive",
      "bookmark",
      "border",
      "favorite",
      "label",
      "library",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "tag"
    ],
    "popularity": 43680
  },
  {
    "name": "arrow_right",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "interface",
      "navigation",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 43530
  },
  {
    "name": "pending_actions",
    "tags": ["actions", "clipboard", "clock", "date", "doc", "document", "pending", "remember", "schedule", "time"],
    "popularity": 43358
  },
  {
    "name": "smartphone",
    "tags": [
      "Android",
      "OS",
      "call",
      "cell",
      "chat",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "smartphone",
      "tablet",
      "text"
    ],
    "popularity": 43066
  },
  {
    "name": "upload_file",
    "tags": [
      "arrow",
      "data",
      "doc",
      "document",
      "download",
      "drive",
      "file",
      "folder",
      "folders",
      "page",
      "paper",
      "sheet",
      "slide",
      "up",
      "upload",
      "writing"
    ],
    "popularity": 42852
  },
  {
    "name": "shopping_cart",
    "tags": [
      "add",
      "bill",
      "buy",
      "card",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "shopping"
    ],
    "popularity": 42781
  },
  {
    "name": "account_tree",
    "tags": [
      "account",
      "analytics",
      "chart",
      "connect",
      "data",
      "diagram",
      "flow",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "process",
      "square",
      "statistics",
      "structure",
      "tracking",
      "tree"
    ],
    "popularity": 42580
  },
  {
    "name": "shopping_basket",
    "tags": [
      "add",
      "basket",
      "bill",
      "buy",
      "card",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "shopping"
    ],
    "popularity": 42260
  },
  {
    "name": "flag",
    "tags": ["country", "flag", "goal", "mark", "nation", "report", "start"],
    "popularity": 42259
  },
  {
    "name": "apartment",
    "tags": [
      "accommodation",
      "apartment",
      "architecture",
      "building",
      "city",
      "company",
      "estate",
      "flat",
      "home",
      "house",
      "office",
      "places",
      "real",
      "residence",
      "residential",
      "shelter",
      "units",
      "workplace"
    ],
    "popularity": 41760
  },
  {
    "name": "people_alt",
    "tags": [
      "accounts",
      "committee",
      "face",
      "family",
      "friends",
      "humans",
      "network",
      "people",
      "persons",
      "profiles",
      "social",
      "team",
      "users"
    ],
    "popularity": 41730
  },
  {
    "name": "restaurant",
    "tags": [
      "breakfast",
      "dining",
      "dinner",
      "eat",
      "food",
      "fork",
      "knife",
      "local",
      "lunch",
      "meal",
      "places",
      "restaurant",
      "spoon",
      "utensils"
    ],
    "popularity": 41698
  },
  {
    "name": "reply",
    "tags": ["arrow", "backward", "left", "mail", "message", "reply", "send", "share"],
    "popularity": 41458
  },
  {
    "name": "play_circle_outline",
    "tags": ["arrow", "circle", "control", "controls", "media", "music", "outline", "play", "video"],
    "popularity": 41350
  },
  {
    "name": "payment",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 41317
  },
  {
    "name": "sync",
    "tags": [
      "360",
      "around",
      "arrow",
      "arrows",
      "direction",
      "inprogress",
      "load",
      "loading refresh",
      "renew",
      "rotate",
      "sync",
      "turn"
    ],
    "popularity": 41231
  },
  {
    "name": "task",
    "tags": [
      "approve",
      "check",
      "complete",
      "data",
      "doc",
      "document",
      "done",
      "drive",
      "file",
      "folder",
      "folders",
      "mark",
      "ok",
      "page",
      "paper",
      "select",
      "sheet",
      "slide",
      "task",
      "tick",
      "validate",
      "verified",
      "writing",
      "yes"
    ],
    "popularity": 40835
  },
  {
    "name": "launch",
    "tags": [
      "app",
      "application",
      "arrow",
      "box",
      "components",
      "interface",
      "launch",
      "new",
      "open",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 40527
  },
  {
    "name": "menu_open",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "hamburger",
      "interface",
      "left",
      "line",
      "lines",
      "menu",
      "open",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 40521
  },
  {
    "name": "add_box",
    "tags": ["add", "box", "new square", "plus", "symbol"],
    "popularity": 40376
  },
  {
    "name": "drag_indicator",
    "tags": [
      "app",
      "application",
      "circles",
      "components",
      "design",
      "dots",
      "drag",
      "drop",
      "indicator",
      "interface",
      "layout",
      "mobile",
      "monitor",
      "move",
      "phone",
      "screen",
      "shape",
      "shift",
      "site",
      "tablet",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 40346
  },
  {
    "name": "supervisor_account",
    "tags": [
      "account",
      "avatar",
      "control",
      "face",
      "human",
      "parental",
      "parental control",
      "parents",
      "people",
      "person",
      "profile",
      "supervised",
      "supervisor",
      "user"
    ],
    "popularity": 39916
  },
  {
    "name": "touch_app",
    "tags": ["app", "command", "fingers", "gesture", "hand", "press", "tap", "touch"],
    "popularity": 39911
  },
  {
    "name": "add_circle",
    "tags": ["+", "add", "circle", "create", "new", "plus"],
    "popularity": 39801
  },
  {
    "name": "pending",
    "tags": ["circle", "dots", "loading", "pending", "progress", "wait", "waiting"],
    "popularity": 39754
  },
  {
    "name": "manage_search",
    "tags": ["glass", "history", "magnifying", "manage", "search", "text"],
    "popularity": 39619
  },
  {
    "name": "zoom_in",
    "tags": [
      "big",
      "bigger",
      "find",
      "glass",
      "grow",
      "in",
      "look",
      "magnify",
      "magnifying",
      "plus",
      "scale",
      "search",
      "see",
      "size",
      "zoom"
    ],
    "popularity": 39505
  },
  {
    "name": "cancel",
    "tags": ["cancel", "circle", "close", "exit", "stop", "x"],
    "popularity": 39390
  },
  {
    "name": "remove_circle",
    "tags": ["block", "can", "circle", "delete", "minus", "negative", "remove", "substract", "trash"],
    "popularity": 39159
  },
  {
    "name": "group_add",
    "tags": [
      "accounts",
      "add",
      "committee",
      "face",
      "family",
      "friends",
      "group",
      "humans",
      "increase",
      "more",
      "network",
      "people",
      "persons",
      "plus",
      "profiles",
      "social",
      "team",
      "users"
    ],
    "popularity": 39119
  },
  {
    "name": "assessment",
    "tags": [
      "analytics",
      "assessment",
      "bar",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 38947
  },
  {
    "name": "chat_bubble_outline",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "outline", "speech"],
    "popularity": 38801
  },
  {
    "name": "priority_high",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "high",
      "important",
      "mark",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 38676
  },
  {
    "name": "arrow_back_ios",
    "tags": [
      "DISABLE_IOS",
      "app",
      "application",
      "arrow",
      "back",
      "chevron",
      "components",
      "direction",
      "disable_ios",
      "interface",
      "ios",
      "left",
      "navigation",
      "previous",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 38617
  },
  {
    "name": "push_pin",
    "tags": ["location", "marker", "pin", "place", "push", "remember", "save"],
    "popularity": 38463
  },
  {
    "name": "leaderboard",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "leaderboard",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 38205
  },
  {
    "name": "block",
    "tags": ["avoid", "block", "cancel", "close", "entry", "exit", "no", "prohibited", "quit", "remove", "stop"],
    "popularity": 38156
  },
  {
    "name": "summarize",
    "tags": ["doc", "document", "list", "menu", "note", "report", "summary"],
    "popularity": 38133
  },
  {
    "name": "feed",
    "tags": [
      "article",
      "feed",
      "headline",
      "information",
      "news",
      "newspaper",
      "paper",
      "public",
      "social",
      "timeline"
    ],
    "popularity": 38075
  },
  {
    "name": "event_available",
    "tags": [
      "approve",
      "available",
      "calendar",
      "check",
      "complete",
      "date",
      "done",
      "event",
      "mark",
      "ok",
      "schedule",
      "select",
      "tick",
      "time",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 37966
  },
  {
    "name": "thumb_up_off_alt",
    "tags": [
      "alt",
      "disabled",
      "enabled",
      "favorite",
      "fingers",
      "gesture",
      "hand",
      "hands",
      "like",
      "off",
      "offline",
      "on",
      "rank",
      "ranking",
      "rate",
      "rating",
      "slash",
      "thumb",
      "up"
    ],
    "popularity": 37790
  },
  {
    "name": "directions_car",
    "tags": ["automobile", "car", "cars", "direction", "directions", "maps", "public", "transportation", "vehicle"],
    "popularity": 37453
  },
  {
    "name": "open_in_full",
    "tags": ["action", "arrow", "arrows", "expand", "full", "grow", "in", "move", "open"],
    "popularity": 37257
  },
  {
    "name": "calendar_month",
    "tags": ["calendar", "date", "day", "event", "month", "schedule", "today"],
    "popularity": 37181
  },
  {
    "name": "auto_stories",
    "tags": ["auto", "book", "flipping", "pages", "stories"],
    "popularity": 37142
  },
  {
    "name": "post_add",
    "tags": [
      "+",
      "add",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "page",
      "paper",
      "plus",
      "post",
      "sheet",
      "slide",
      "text",
      "writing"
    ],
    "popularity": 36718
  },
  {
    "name": "calculate",
    "tags": ["+", "-", "=", "calculate", "count", "finance calculator", "math"],
    "popularity": 36547
  },
  {
    "name": "alternate_email",
    "tags": ["@", "address", "alternate", "contact", "email", "tag"],
    "popularity": 36303
  },
  {
    "name": "cloud_upload",
    "tags": [
      "app",
      "application",
      "arrow",
      "backup",
      "cloud",
      "connection",
      "download",
      "drive",
      "files",
      "folders",
      "internet",
      "network",
      "sky",
      "storage",
      "up",
      "upload"
    ],
    "popularity": 36265
  },
  {
    "name": "local_fire_department",
    "tags": [
      "911",
      "climate",
      "department",
      "fire",
      "firefighter",
      "flame",
      "heat",
      "home",
      "hot",
      "nest",
      "thermostat"
    ],
    "popularity": 36220
  },
  {
    "name": "create",
    "tags": ["compose", "create", "edit", "editing", "input", "new", "pen", "pencil", "write", "writing"],
    "popularity": 36078
  },
  {
    "name": "bar_chart",
    "tags": [
      "analytics",
      "bar",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 35761
  },
  {
    "name": "password",
    "tags": ["key", "login", "password", "pin", "security", "star", "unlock"],
    "popularity": 35516
  },
  {
    "name": "pin_drop",
    "tags": ["destination", "direction", "drop", "location", "maps", "navigation", "pin", "place", "stop"],
    "popularity": 35509
  },
  {
    "name": "collections",
    "tags": [
      "album",
      "collections",
      "gallery",
      "image",
      "landscape",
      "library",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "stack"
    ],
    "popularity": 35417
  },
  {
    "name": "preview",
    "tags": [
      "design",
      "eye",
      "layout",
      "preview",
      "reveal",
      "screen",
      "see",
      "show",
      "site",
      "view",
      "web",
      "website",
      "window",
      "www"
    ],
    "popularity": 35174
  },
  {
    "name": "group",
    "tags": [
      "accounts",
      "committee",
      "face",
      "family",
      "friends",
      "group",
      "humans",
      "network",
      "people",
      "persons",
      "profiles",
      "social",
      "team",
      "users"
    ],
    "popularity": 35093
  },
  {
    "name": "done_outline",
    "tags": [
      "all",
      "approve",
      "check",
      "complete",
      "done",
      "mark",
      "ok",
      "outline",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 35072
  },
  {
    "name": "exit_to_app",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "design",
      "exit",
      "export",
      "interface",
      "layout",
      "leave",
      "mobile",
      "monitor",
      "move",
      "output",
      "phone",
      "screen",
      "site",
      "tablet",
      "to",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 35049
  },
  {
    "name": "star_outline",
    "tags": ["bookmark", "favorite", "half", "highlight", "ranking", "rate", "rating", "save", "star", "toggle"],
    "popularity": 35041
  },
  {
    "name": "psychology",
    "tags": [
      "behavior",
      "body",
      "brain",
      "cognitive",
      "function",
      "gear",
      "head",
      "human",
      "intellectual",
      "mental",
      "mind",
      "people",
      "person",
      "preferences",
      "psychiatric",
      "psychology",
      "science",
      "settings",
      "social",
      "therapy",
      "thinking",
      "thoughts"
    ],
    "popularity": 34860
  },
  {
    "name": "assignment_ind",
    "tags": [
      "account",
      "assignment",
      "clipboard",
      "doc",
      "document",
      "face",
      "ind",
      "people",
      "person",
      "profile",
      "user"
    ],
    "popularity": 34649
  },
  {
    "name": "schedule",
    "tags": ["clock", "date", "schedule", "time"],
    "popularity": 34643
  },
  {
    "name": "volunteer_activism",
    "tags": [
      "activism",
      "donation",
      "fingers",
      "gesture",
      "giving",
      "hand",
      "hands",
      "heart",
      "love",
      "sharing",
      "volunteer"
    ],
    "popularity": 34299
  },
  {
    "name": "notifications",
    "tags": ["active", "alarm", "alert", "bell", "chime", "notifications", "notify", "reminder", "ring", "sound"],
    "popularity": 34271
  },
  {
    "name": "arrow_forward",
    "tags": [
      "app",
      "application",
      "arrow",
      "arrows",
      "components",
      "direction",
      "forward",
      "interface",
      "navigation",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 34255
  },
  {
    "name": "auto_awesome",
    "tags": [
      "adjust",
      "ai",
      "artificial",
      "automatic",
      "automation",
      "custom",
      "edit",
      "editing",
      "enhance",
      "genai",
      "intelligence",
      "magic",
      "smart",
      "spark",
      "sparkle",
      "star",
      "stars"
    ],
    "popularity": 34235
  },
  {
    "name": "navigate_before",
    "tags": ["arrow", "arrows", "before", "direction", "left", "navigate"],
    "popularity": 34228
  },
  {
    "name": "published_with_changes",
    "tags": [
      "approve",
      "arrow",
      "arrows",
      "changes",
      "check",
      "complete",
      "done",
      "inprogress",
      "load",
      "loading",
      "mark",
      "ok",
      "published",
      "refresh",
      "renew",
      "replace",
      "rotate",
      "select",
      "tick",
      "validate",
      "verified",
      "with",
      "yes"
    ],
    "popularity": 34159
  },
  {
    "name": "add_a_photo",
    "tags": ["+", "a photo", "add", "camera", "lens", "new", "photography", "picture", "plus", "symbol"],
    "popularity": 33928
  },
  {
    "name": "card_giftcard",
    "tags": [
      "account",
      "balance",
      "bill",
      "card",
      "cart",
      "cash",
      "certificate",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "gift",
      "giftcard",
      "money",
      "online",
      "pay",
      "payment",
      "present",
      "shopping"
    ],
    "popularity": 33781
  },
  {
    "name": "sell",
    "tags": [
      "bill",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "sell",
      "shopping",
      "tag"
    ],
    "popularity": 33536
  },
  {
    "name": "checklist",
    "tags": [
      "align",
      "alignment",
      "approve",
      "check",
      "checklist",
      "complete",
      "doc",
      "done",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "mark",
      "notes",
      "ok",
      "select",
      "sheet",
      "spreadsheet",
      "text",
      "tick",
      "type",
      "validate",
      "verified",
      "writing",
      "yes"
    ],
    "popularity": 33521
  },
  {
    "name": "fullscreen",
    "tags": [
      "adjust",
      "app",
      "application",
      "components",
      "full",
      "fullscreen",
      "interface",
      "screen",
      "site",
      "size",
      "ui",
      "ux",
      "view",
      "web",
      "website"
    ],
    "popularity": 33455
  },
  {
    "name": "view_in_ar",
    "tags": ["3d", "ar", "augmented", "cube", "daydream", "headset", "in", "reality", "square", "view", "vr"],
    "popularity": 33301
  },
  {
    "name": "undo",
    "tags": ["arrow", "backward", "mail", "previous", "redo", "repeat", "rotate", "undo"],
    "popularity": 33200
  },
  {
    "name": "description",
    "tags": [
      "article",
      "data",
      "description",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "notes",
      "page",
      "paper",
      "sheet",
      "slide",
      "text",
      "writing"
    ],
    "popularity": 32460
  },
  {
    "name": "health_and_safety",
    "tags": [
      "+",
      "add",
      "and",
      "certified",
      "cross",
      "health",
      "home",
      "nest",
      "plus",
      "privacy",
      "private",
      "protect",
      "protection",
      "safety",
      "security",
      "shield",
      "symbol",
      "verified"
    ],
    "popularity": 32268
  },
  {
    "name": "feedback",
    "tags": [
      "!",
      "alert",
      "announcement",
      "attention",
      "caution",
      "chat",
      "chat bubble",
      "comment",
      "communicate",
      "communication",
      "conversation",
      "danger",
      "error",
      "exclamation",
      "failed",
      "feedback",
      "important",
      "mark",
      "message",
      "notification",
      "service",
      "sms",
      "speech",
      "symbol",
      "warning"
    ],
    "popularity": 32243
  },
  {
    "name": "arrow_drop_up",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "drop",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "up",
      "ux",
      "web",
      "website"
    ],
    "popularity": 32217
  },
  {
    "name": "unfold_more",
    "tags": [
      "arrow",
      "arrows",
      "chevron",
      "collapse",
      "direction",
      "down",
      "expand",
      "expandable",
      "list",
      "more",
      "navigation",
      "unfold"
    ],
    "popularity": 31999
  },
  {
    "name": "travel_explore",
    "tags": [
      "earth",
      "explore",
      "find",
      "glass",
      "global",
      "globe",
      "look",
      "magnify",
      "magnifying",
      "map",
      "network",
      "planet",
      "search",
      "see",
      "social",
      "space",
      "travel",
      "web",
      "world"
    ],
    "popularity": 31974
  },
  {
    "name": "work_outline",
    "tags": ["bag", "baggage", "briefcase", "business", "case", "job", "suitcase", "work"],
    "popularity": 31974
  },
  {
    "name": "arrow_drop_down",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "down",
      "drop",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 31920
  },
  {
    "name": "palette",
    "tags": ["art", "color", "colors", "filters", "paint", "palette"],
    "popularity": 31787
  },
  {
    "name": "thumb_up_alt",
    "tags": [
      "agreed",
      "approved",
      "confirm",
      "correct",
      "favorite",
      "feedback",
      "good",
      "happy",
      "like",
      "okay",
      "positive",
      "satisfaction",
      "social",
      "thumb",
      "up",
      "vote",
      "yes"
    ],
    "popularity": 31779
  },
  {
    "name": "keyboard_arrow_right",
    "tags": ["arrow", "arrows", "keyboard", "right"],
    "popularity": 31748
  },
  {
    "name": "double_arrow",
    "tags": ["arrow", "arrows", "direction", "double", "multiple", "navigation", "right"],
    "popularity": 31644
  },
  {
    "name": "computer",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "computer",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "web",
      "window"
    ],
    "popularity": 31511
  },
  {
    "name": "timeline",
    "tags": ["data", "history", "line", "movement", "point", "points", "timeline", "tracking", "trending", "zigzag"],
    "popularity": 31494
  },
  {
    "name": "signal_cellular_alt",
    "tags": [
      "alt",
      "analytics",
      "bar",
      "cell",
      "cellular",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "internet",
      "measure",
      "metrics",
      "mobile",
      "network",
      "phone",
      "signal",
      "statistics",
      "tracking",
      "wifi",
      "wireless"
    ],
    "popularity": 31295
  },
  {
    "name": "swap_horiz",
    "tags": ["arrow", "arrows", "back", "forward", "horizontal", "swap"],
    "popularity": 31278
  },
  {
    "name": "replay",
    "tags": ["arrow", "arrows", "control", "controls", "music", "refresh", "renew", "repeat", "replay", "video"],
    "popularity": 31270
  },
  {
    "name": "volume_off",
    "tags": [
      "audio",
      "control",
      "disabled",
      "enabled",
      "low",
      "music",
      "off",
      "on",
      "slash",
      "sound",
      "speaker",
      "tv",
      "volume"
    ],
    "popularity": 31173
  },
  {
    "name": "forum",
    "tags": [
      "bubble",
      "chat",
      "comment",
      "communicate",
      "community",
      "conversation",
      "feedback",
      "forum",
      "hub",
      "message",
      "speech"
    ],
    "popularity": 31101
  },
  {
    "name": "water_drop",
    "tags": ["drink", "drop", "droplet", "eco", "liquid", "nature", "ocean", "rain", "social", "water"],
    "popularity": 30847
  },
  {
    "name": "skip_next",
    "tags": ["arrow", "control", "controls", "music", "next", "play", "previous", "skip", "video"],
    "popularity": 30714
  },
  {
    "name": "assignment_turned_in",
    "tags": [
      "approve",
      "assignment",
      "check",
      "clipboard",
      "complete",
      "doc",
      "document",
      "done",
      "in",
      "mark",
      "ok",
      "select",
      "tick",
      "turn",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 30675
  },
  {
    "name": "dns",
    "tags": ["address", "bars", "dns", "domain", "information", "ip", "list", "lookup", "name", "server", "system"],
    "popularity": 30648
  },
  {
    "name": "sync_alt",
    "tags": ["alt", "arrow", "arrows", "horizontal", "internet", "sync", "technology", "up", "update", "wifi"],
    "popularity": 30642
  },
  {
    "name": "stars",
    "tags": [
      "achievement",
      "bookmark",
      "circle",
      "favorite",
      "highlight",
      "important",
      "marked",
      "ranking",
      "rate",
      "rating rank",
      "reward",
      "save",
      "saved",
      "shape",
      "special",
      "star"
    ],
    "popularity": 30638
  },
  {
    "name": "library_books",
    "tags": ["add", "album", "audio", "book", "books", "collection", "library", "read", "reading"],
    "popularity": 30637
  },
  {
    "name": "maps_home_work",
    "tags": ["building", "home", "house", "maps", "office", "work"],
    "popularity": 30585
  },
  {
    "name": "notifications_none",
    "tags": ["alarm", "alert", "bell", "none", "notifications", "notify", "reminder", "sound"],
    "popularity": 30547
  },
  {
    "name": "how_to_reg",
    "tags": [
      "approve",
      "ballot",
      "check",
      "complete",
      "done",
      "election",
      "how",
      "mark",
      "ok",
      "poll",
      "register",
      "registration",
      "select",
      "tick",
      "to reg",
      "validate",
      "verified",
      "vote",
      "yes"
    ],
    "popularity": 30535
  },
  {
    "name": "help",
    "tags": [
      "?",
      "assistance",
      "circle",
      "help",
      "info",
      "information",
      "punctuation",
      "question mark",
      "recent",
      "restore",
      "shape",
      "support",
      "symbol"
    ],
    "popularity": 30479
  },
  {
    "name": "flight_takeoff",
    "tags": [
      "airport",
      "departed",
      "departing",
      "flight",
      "fly",
      "landing",
      "plane",
      "takeoff",
      "transportation",
      "travel"
    ],
    "popularity": 30468
  },
  {
    "name": "label",
    "tags": ["favorite", "indent", "label", "library", "mail", "remember", "save", "stamp", "sticker", "tag"],
    "popularity": 30425
  },
  {
    "name": "devices",
    "tags": [
      "Android",
      "OS",
      "computer",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "laptop",
      "mobile",
      "monitor",
      "phone",
      "tablet",
      "watch",
      "wearable",
      "web"
    ],
    "popularity": 30271
  },
  {
    "name": "chat_bubble",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "speech"],
    "popularity": 30260
  },
  {
    "name": "emoji_emotions",
    "tags": [
      "+",
      "add",
      "emoji",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "glad",
      "happiness",
      "happy",
      "icon",
      "icons",
      "insert",
      "like",
      "mood",
      "new",
      "person",
      "pleased",
      "plus",
      "smile",
      "smiling",
      "social",
      "survey",
      "symbol"
    ],
    "popularity": 30099
  },
  {
    "name": "tips_and_updates",
    "tags": [
      "ai",
      "alert",
      "and",
      "announcement",
      "artificial",
      "automatic",
      "automation",
      "custom",
      "electricity",
      "genai",
      "idea",
      "info",
      "information",
      "intelligence",
      "light",
      "lightbulb",
      "magic",
      "smart",
      "spark",
      "sparkle",
      "star",
      "tips",
      "updates"
    ],
    "popularity": 30002
  },
  {
    "name": "remove_red_eye",
    "tags": ["eye", "iris", "look", "looking", "preview", "red", "remove", "see", "sight", "vision"],
    "popularity": 29907
  },
  {
    "name": "content_paste",
    "tags": ["clipboard", "content", "copy", "cut", "doc", "document", "file", "multiple", "paste"],
    "popularity": 29853
  },
  {
    "name": "folder_open",
    "tags": ["data", "doc", "document", "drive", "file", "folder", "folders", "open", "sheet", "slide", "storage"],
    "popularity": 29771
  },
  {
    "name": "text_snippet",
    "tags": ["data", "doc", "document", "file", "note", "notes", "snippet", "storage", "text", "writing"],
    "popularity": 29692
  },
  {
    "name": "my_location",
    "tags": ["destination", "direction", "location", "maps", "navigation", "pin", "place", "point", "stop"],
    "popularity": 29599
  },
  {
    "name": "language",
    "tags": ["globe", "internet", "language", "planet", "website", "world", "www"],
    "popularity": 29550
  },
  {
    "name": "textsms",
    "tags": ["bubble", "chat", "comment", "communicate", "dots", "feedback", "message", "speech", "textsms"],
    "popularity": 29523
  },
  {
    "name": "warning",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "symbol",
      "triangle",
      "warning"
    ],
    "popularity": 29444
  },
  {
    "name": "cloud",
    "tags": [
      "climate",
      "cloud",
      "connection",
      "internet",
      "network",
      "queue",
      "sky",
      "temperature",
      "upload",
      "weather"
    ],
    "popularity": 29341
  },
  {
    "name": "more_vert",
    "tags": [
      "3",
      "DISABLE_IOS",
      "android",
      "app",
      "application",
      "components",
      "disable_ios",
      "dots",
      "etc",
      "interface",
      "more",
      "screen",
      "site",
      "three",
      "ui",
      "ux",
      "vert",
      "vertical",
      "web",
      "website"
    ],
    "popularity": 29242
  },
  {
    "name": "security",
    "tags": ["certified", "privacy", "private", "protect", "protection", "security", "shield", "verified"],
    "popularity": 29200
  },
  {
    "name": "sports_esports",
    "tags": [
      "controller",
      "entertainment",
      "esports",
      "game",
      "gamepad",
      "gaming",
      "hobby",
      "online",
      "social",
      "sports",
      "video"
    ],
    "popularity": 29184
  },
  {
    "name": "request_quote",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "quote",
      "request",
      "shopping",
      "symbol"
    ],
    "popularity": 29049
  },
  {
    "name": "lock",
    "tags": ["lock", "locked", "password", "privacy", "private", "protection", "safety", "secure", "security"],
    "popularity": 28920
  },
  {
    "name": "toggle_off",
    "tags": [
      "active",
      "app",
      "application",
      "components",
      "configuration",
      "control",
      "design",
      "disable",
      "inable",
      "inactive",
      "interface",
      "off",
      "on",
      "selection",
      "settings",
      "site",
      "slider",
      "switch",
      "toggle",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 28854
  },
  {
    "name": "book",
    "tags": [
      "book",
      "bookmark",
      "favorite",
      "label",
      "library",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "tag"
    ],
    "popularity": 28573
  },
  {
    "name": "fiber_manual_record",
    "tags": ["circle", "dot", "fiber", "manual", "play", "record", "watch"],
    "popularity": 28467
  },
  {
    "name": "contact_page",
    "tags": [
      "account",
      "avatar",
      "contact",
      "data",
      "doc",
      "document",
      "drive",
      "face",
      "file",
      "folder",
      "folders",
      "human",
      "page",
      "people",
      "person",
      "profile",
      "sheet",
      "slide",
      "storage",
      "user",
      "writing"
    ],
    "popularity": 28416
  },
  {
    "name": "speed",
    "tags": [
      "arrow",
      "control",
      "controls",
      "fast",
      "gauge",
      "meter",
      "motion",
      "music",
      "slow",
      "speed",
      "speedometer",
      "velocity",
      "video"
    ],
    "popularity": 28365
  },
  {
    "name": "space_dashboard",
    "tags": [
      "cards",
      "dashboard",
      "format",
      "grid",
      "layout",
      "rectangle",
      "shapes",
      "space",
      "squares",
      "web",
      "website"
    ],
    "popularity": 28337
  },
  {
    "name": "bug_report",
    "tags": ["animal", "bug", "fix", "insect", "issue", "problem", "report", "testing", "virus", "warning"],
    "popularity": 28298
  },
  {
    "name": "alarm",
    "tags": ["alarm", "alert", "bell", "clock", "countdown", "date", "notification", "schedule", "time"],
    "popularity": 28277
  },
  {
    "name": "report",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "octagon",
      "report",
      "symbol",
      "warning"
    ],
    "popularity": 28207
  },
  {
    "name": "cached",
    "tags": ["around", "arrows", "cache", "cached", "inprogress", "load", "loading refresh", "renew", "rotate"],
    "popularity": 28163
  },
  {
    "name": "settings_suggest",
    "tags": [
      "ai",
      "artificial",
      "automatic",
      "automation",
      "change",
      "custom",
      "details",
      "gear",
      "genai",
      "intelligence",
      "magic",
      "options",
      "recommendation",
      "service",
      "settings",
      "smart",
      "spark",
      "sparkle",
      "star",
      "suggest",
      "suggestion",
      "system"
    ],
    "popularity": 27854
  },
  {
    "name": "file_copy",
    "tags": ["content", "copy", "cut", "doc", "document", "duplicate", "file", "multiple", "past"],
    "popularity": 27849
  },
  {
    "name": "translate",
    "tags": ["language", "speaking", "speech", "translate", "translator", "words"],
    "popularity": 27849
  },
  {
    "name": "gavel",
    "tags": [
      "agreement",
      "contract",
      "court",
      "document",
      "gavel",
      "government",
      "judge",
      "law",
      "mallet",
      "official",
      "police",
      "rule",
      "rules",
      "terms"
    ],
    "popularity": 27817
  },
  {
    "name": "pan_tool",
    "tags": ["fingers", "gesture", "hand", "hands", "human", "move", "pan", "scan", "stop", "tool"],
    "popularity": 27808
  },
  {
    "name": "edit_calendar",
    "tags": [
      "calendar",
      "compose",
      "create",
      "date",
      "day",
      "draft",
      "edit",
      "editing",
      "event",
      "month",
      "pen",
      "pencil",
      "schedule",
      "write",
      "writing"
    ],
    "popularity": 27701
  },
  {
    "name": "contact_mail",
    "tags": [
      "account",
      "address",
      "avatar",
      "communicate",
      "contact",
      "email",
      "face",
      "human",
      "info",
      "information",
      "mail",
      "message",
      "people",
      "person",
      "profile",
      "user"
    ],
    "popularity": 27526
  },
  {
    "name": "quiz",
    "tags": [
      "?",
      "assistance",
      "faq",
      "help",
      "info",
      "information",
      "punctuation",
      "question mark",
      "quiz",
      "support",
      "symbol",
      "test"
    ],
    "popularity": 27514
  },
  {
    "name": "supervised_user_circle",
    "tags": [
      "account",
      "avatar",
      "circle",
      "control",
      "face",
      "human",
      "parental",
      "parents",
      "people",
      "person",
      "profile",
      "supervised",
      "supervisor",
      "user"
    ],
    "popularity": 27492
  },
  {
    "name": "cloud_download",
    "tags": [
      "app",
      "application",
      "arrow",
      "backup",
      "cloud",
      "connection",
      "down",
      "download",
      "drive",
      "files",
      "folders",
      "internet",
      "network",
      "sky",
      "storage",
      "upload"
    ],
    "popularity": 27437
  },
  {
    "name": "stop",
    "tags": ["control", "controls", "music", "pause", "play", "square", "stop", "video"],
    "popularity": 27411
  },
  {
    "name": "person_search",
    "tags": [
      "account",
      "avatar",
      "face",
      "find",
      "glass",
      "human",
      "look",
      "magnify",
      "magnifying",
      "people",
      "person",
      "profile",
      "search",
      "user"
    ],
    "popularity": 27264
  },
  {
    "name": "check",
    "tags": [
      "DISABLE_IOS",
      "check",
      "confirm",
      "correct",
      "disable_ios",
      "done",
      "enter",
      "mark",
      "ok",
      "okay",
      "select",
      "tick",
      "yes"
    ],
    "popularity": 27195
  },
  {
    "name": "sentiment_very_satisfied",
    "tags": [
      "emotions",
      "expressions",
      "face",
      "feelings",
      "glad",
      "happiness",
      "happy",
      "like",
      "mood",
      "person",
      "pleased",
      "satisfied",
      "sentiment",
      "smile",
      "smiling",
      "survey",
      "very"
    ],
    "popularity": 27133
  },
  {
    "name": "location_city",
    "tags": [
      "apartments",
      "architecture",
      "buildings",
      "business",
      "city",
      "estate",
      "home",
      "landscape",
      "location",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "town",
      "urban"
    ],
    "popularity": 27094
  },
  {
    "name": "minimize",
    "tags": [
      "app",
      "application",
      "components",
      "design",
      "interface",
      "line",
      "minimize",
      "screen",
      "shape",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 26936
  },
  {
    "name": "ios_share",
    "tags": ["arrow", "export", "ios", "send", "share", "up"],
    "popularity": 26836
  },
  {
    "name": "widgets",
    "tags": ["app", "box", "menu", "setting", "squares", "ui", "widgets"],
    "popularity": 26817
  },
  {
    "name": "qr_code",
    "tags": ["barcode", "camera", "code", "media", "product", "qr", "quick", "response", "smartphone", "url", "urls"],
    "popularity": 26731
  },
  {
    "name": "sentiment_satisfied_alt",
    "tags": [
      "account",
      "alt",
      "emoji",
      "face",
      "happy",
      "human",
      "people",
      "person",
      "profile",
      "satisfied",
      "sentiment",
      "smile",
      "user"
    ],
    "popularity": 26632
  },
  {
    "name": "extension",
    "tags": ["app", "extended", "extension", "game", "jigsaw", "plugin add", "puzzle", "shape"],
    "popularity": 26353
  },
  {
    "name": "flight",
    "tags": ["air", "airplane", "airport", "flight", "plane", "transportation", "travel", "trip"],
    "popularity": 26347
  },
  {
    "name": "local_mall",
    "tags": [
      "bag",
      "bill",
      "building",
      "business",
      "buy",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "handbag",
      "local",
      "mall",
      "money",
      "online",
      "pay",
      "payment",
      "shop",
      "shopping",
      "store",
      "storefront"
    ],
    "popularity": 26338
  },
  {
    "name": "qr_code_2",
    "tags": ["barcode", "camera", "code", "media", "product", "qr", "quick", "response", "smartphone", "url", "urls"],
    "popularity": 26326
  },
  {
    "name": "error",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "circle",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 26279
  },
  {
    "name": "desktop_windows",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "television",
      "tv",
      "web",
      "window",
      "windows"
    ],
    "popularity": 26191
  },
  {
    "name": "music_note",
    "tags": ["audio", "audiotrack", "key", "music", "note", "sound", "track"],
    "popularity": 26047
  },
  {
    "name": "accessibility",
    "tags": ["accessibility", "accessible", "body", "handicap", "help", "human", "people", "person"],
    "popularity": 25922
  },
  {
    "name": "android",
    "tags": ["android", "character", "logo", "mascot", "toy"],
    "popularity": 25907
  },
  {
    "name": "sentiment_satisfied",
    "tags": [
      "emotions",
      "expressions",
      "face",
      "feelings",
      "glad",
      "happiness",
      "happy",
      "like",
      "mood",
      "person",
      "pleased",
      "satisfied",
      "sentiment",
      "smile",
      "smiling",
      "survey"
    ],
    "popularity": 25875
  },
  {
    "name": "precision_manufacturing",
    "tags": [
      "arm",
      "automatic",
      "chain",
      "conveyor",
      "crane",
      "factory",
      "industry",
      "machinery",
      "manufacturing",
      "mechanical",
      "precision",
      "production",
      "repairing",
      "robot",
      "supply",
      "warehouse"
    ],
    "popularity": 25840
  },
  {
    "name": "backspace",
    "tags": ["arrow", "back", "backspace", "cancel", "clear", "correct", "delete", "erase", "remove"],
    "popularity": 25807
  },
  {
    "name": "drag_handle",
    "tags": [
      "app",
      "application ui",
      "components",
      "design",
      "drag",
      "handle",
      "interface",
      "layout",
      "menu",
      "move",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 25694
  },
  {
    "name": "smart_display",
    "tags": [
      "airplay",
      "cast",
      "chrome",
      "connect",
      "device",
      "display",
      "play",
      "screen",
      "screencast",
      "smart",
      "stream",
      "television",
      "tv",
      "video",
      "wireless"
    ],
    "popularity": 25639
  },
  {
    "name": "near_me",
    "tags": [
      "destination",
      "direction",
      "location",
      "maps",
      "me",
      "navigation",
      "near",
      "pin",
      "place",
      "point",
      "stop"
    ],
    "popularity": 25588
  },
  {
    "name": "west",
    "tags": ["arrow", "directional", "left", "maps", "navigation", "west"],
    "popularity": 25403
  },
  {
    "name": "get_app",
    "tags": ["app", "arrow", "arrows", "down", "download", "downloads", "export", "get", "install", "play", "upload"],
    "popularity": 25356
  },
  {
    "name": "rocket_launch",
    "tags": ["launch", "rocket", "space", "spaceship", "takeoff"],
    "popularity": 25297
  },
  {
    "name": "person_add_alt",
    "tags": ["+", "account", "add", "face", "human", "people", "person", "plus", "profile", "user"],
    "popularity": 25105
  },
  {
    "name": "fitness_center",
    "tags": [
      "athlete",
      "center",
      "dumbbell",
      "exercise",
      "fitness",
      "gym",
      "hobby",
      "places",
      "sport",
      "weights",
      "workout"
    ],
    "popularity": 25097
  },
  {
    "name": "play_arrow",
    "tags": ["arrow", "control", "controls", "media", "music", "play", "video"],
    "popularity": 25056
  },
  {
    "name": "shield",
    "tags": ["certified", "privacy", "private", "protect", "protection", "security", "shield", "verified"],
    "popularity": 25008
  },
  {
    "name": "message",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "speech"],
    "popularity": 24963
  },
  {
    "name": "question_mark",
    "tags": ["?", "assistance", "help", "info", "information", "punctuation", "question mark", "support", "symbol"],
    "popularity": 24961
  },
  {
    "name": "record_voice_over",
    "tags": [
      "account",
      "face",
      "human",
      "over",
      "people",
      "person",
      "profile",
      "record",
      "recording",
      "speak",
      "speaking",
      "speech",
      "transcript",
      "user",
      "voice"
    ],
    "popularity": 24840
  },
  {
    "name": "add_task",
    "tags": [
      "+",
      "add",
      "approve",
      "check",
      "circle",
      "completed",
      "increase",
      "mark",
      "ok",
      "plus",
      "select",
      "task",
      "tick",
      "yes"
    ],
    "popularity": 24749
  },
  {
    "name": "insert_drive_file",
    "tags": ["doc", "drive", "file", "format", "insert", "sheet", "slide"],
    "popularity": 24637
  },
  {
    "name": "drive_file_rename_outline",
    "tags": [
      "compose",
      "create",
      "draft",
      "drive",
      "edit",
      "editing",
      "file",
      "input",
      "marker",
      "pen",
      "pencil",
      "rename",
      "write",
      "writing"
    ],
    "popularity": 24629
  },
  {
    "name": "show_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "line",
      "measure",
      "metrics",
      "presentation",
      "show chart",
      "statistics",
      "tracking"
    ],
    "popularity": 24598
  },
  {
    "name": "trending_flat",
    "tags": ["arrow", "change", "data", "flat", "metric", "movement", "rate", "right", "track", "tracking", "trending"],
    "popularity": 24499
  },
  {
    "name": "workspace_premium",
    "tags": [
      "certification",
      "degree",
      "ecommerce",
      "guarantee",
      "medal",
      "permit",
      "premium",
      "ribbon",
      "verification",
      "workspace"
    ],
    "popularity": 24483
  },
  {
    "name": "handyman",
    "tags": ["build", "construction", "fix", "hammer", "handyman", "repair", "screw", "screwdriver", "tools"],
    "popularity": 24456
  },
  {
    "name": "help_center",
    "tags": [
      "?",
      "assistance",
      "center",
      "help",
      "info",
      "information",
      "punctuation",
      "question mark",
      "recent",
      "restore",
      "support",
      "symbol"
    ],
    "popularity": 24454
  },
  {
    "name": "military_tech",
    "tags": [
      "army",
      "award",
      "badge",
      "honor",
      "medal",
      "merit",
      "military",
      "order",
      "privilege",
      "prize",
      "rank",
      "reward",
      "ribbon",
      "soldier",
      "star",
      "status",
      "tech",
      "trophy",
      "win",
      "winner"
    ],
    "popularity": 24397
  },
  {
    "name": "hourglass_empty",
    "tags": ["countdown", "empty", "full", "hourglass", "loading", "minutes", "time", "wait", "waiting"],
    "popularity": 24388
  },
  {
    "name": "emoji_objects",
    "tags": ["bulb", "creative", "emoji", "idea", "light", "objects", "solution", "thinking"],
    "popularity": 24300
  },
  {
    "name": "science",
    "tags": [
      "beaker",
      "chemical",
      "chemistry",
      "experiment",
      "flask",
      "glass",
      "laboratory",
      "research",
      "science",
      "tube"
    ],
    "popularity": 24286
  },
  {
    "name": "check_box",
    "tags": [
      "approved",
      "box",
      "button",
      "check",
      "component",
      "control",
      "form",
      "mark",
      "ok",
      "select",
      "selected",
      "selection",
      "tick",
      "toggle",
      "ui",
      "yes"
    ],
    "popularity": 24266
  },
  {
    "name": "storage",
    "tags": ["computer", "data", "drive", "memory", "storage"],
    "popularity": 24021
  },
  {
    "name": "movie",
    "tags": ["cinema", "film", "media", "movie", "slate", "video"],
    "popularity": 23913
  },
  {
    "name": "accessibility_new",
    "tags": ["accessibility", "accessible", "body", "handicap", "help", "human", "new", "people", "person"],
    "popularity": 23906
  },
  {
    "name": "directions_run",
    "tags": ["body", "directions", "human", "jogging", "maps", "people", "person", "route", "run", "running", "walk"],
    "popularity": 23642
  },
  {
    "name": "rule",
    "tags": [
      "approve",
      "check",
      "complete",
      "done",
      "incomplete",
      "line",
      "mark",
      "missing",
      "no",
      "ok",
      "rule",
      "select",
      "tick",
      "validate",
      "verified",
      "wrong",
      "x",
      "yes"
    ],
    "popularity": 23564
  },
  {
    "name": "thumb_down",
    "tags": [
      "ate",
      "dislike",
      "down",
      "favorite",
      "fingers",
      "gesture",
      "hand",
      "hands",
      "like",
      "rank",
      "ranking",
      "rating",
      "thumb"
    ],
    "popularity": 23477
  },
  {
    "name": "toggle_on",
    "tags": [
      "active",
      "app",
      "application",
      "components",
      "configuration",
      "control",
      "design",
      "disable",
      "inable",
      "inactive",
      "interface",
      "off",
      "on",
      "selection",
      "settings",
      "site",
      "slider",
      "switch",
      "toggle",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 23212
  },
  {
    "name": "event_note",
    "tags": ["calendar", "date", "event", "note", "schedule", "text", "time", "writing"],
    "popularity": 23141
  },
  {
    "name": "grade",
    "tags": ["'favorite_news'  .", "'star_outline'", "Duplicate of 'star_boarder'", "star_border_purple500'"],
    "popularity": 23087
  },
  {
    "name": "contacts",
    "tags": [
      "account",
      "avatar",
      "call",
      "cell",
      "contacts",
      "face",
      "human",
      "info",
      "information",
      "mobile",
      "people",
      "person",
      "phone",
      "profile",
      "user"
    ],
    "popularity": 23046
  },
  {
    "name": "comment",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "outline", "speech"],
    "popularity": 22968
  },
  {
    "name": "open_in_new",
    "tags": [
      "app",
      "application",
      "arrow",
      "box",
      "components",
      "in",
      "interface",
      "new",
      "open",
      "right",
      "screen",
      "site",
      "ui",
      "up",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 22796
  },
  {
    "name": "restaurant_menu",
    "tags": ["book", "dining", "eat", "food", "fork", "knife", "local", "meal", "menu", "restaurant", "spoon"],
    "popularity": 22756
  },
  {
    "name": "play_circle",
    "tags": ["arrow", "circle", "control", "controls", "media", "music", "play", "video"],
    "popularity": 22722
  },
  {
    "name": "confirmation_number",
    "tags": ["admission", "confirmation", "entertainment", "event", "number", "ticket"],
    "popularity": 22712
  },
  {
    "name": "add_photo_alternate",
    "tags": [
      "+",
      "add",
      "alternate",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "new",
      "photo",
      "photography",
      "picture",
      "plus",
      "symbol"
    ],
    "popularity": 22681
  },
  {
    "name": "format_quote",
    "tags": [
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "quotation",
      "quote",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 22577
  },
  {
    "name": "sticky_note_2",
    "tags": ["2", "bookmark", "mark", "message", "note", "paper", "sticky", "text", "writing"],
    "popularity": 22571
  },
  {
    "name": "history_edu",
    "tags": [
      "document",
      "edu",
      "education",
      "feather",
      "history",
      "letter",
      "paper",
      "pen",
      "quill",
      "school",
      "story",
      "tools",
      "write",
      "writing"
    ],
    "popularity": 22468
  },
  {
    "name": "upload",
    "tags": ["arrow", "arrows", "download", "drive", "up", "upload"],
    "popularity": 22335
  },
  {
    "name": "business_center",
    "tags": ["bag", "baggage", "briefcase", "business", "case", "center", "places", "purse", "suitcase", "work"],
    "popularity": 22276
  },
  {
    "name": "skip_previous",
    "tags": ["arrow", "control", "controls", "music", "next", "play", "previous", "skip", "video"],
    "popularity": 22265
  },
  {
    "name": "archive",
    "tags": ["archive", "inbox", "mail", "store"],
    "popularity": 22251
  },
  {
    "name": "cake",
    "tags": [
      "add",
      "baked",
      "birthday",
      "cake",
      "candles",
      "celebration",
      "dessert",
      "food",
      "frosting",
      "new",
      "party",
      "pastries",
      "pastry",
      "plus",
      "social",
      "sweet",
      "symbol"
    ],
    "popularity": 22104
  },
  {
    "name": "wb_sunny",
    "tags": ["balance", "bright", "light", "lighting", "sun", "sunny", "wb", "white"],
    "popularity": 22068
  },
  {
    "name": "attachment",
    "tags": ["attach", "attachment", "clip", "compose", "file", "image", "link"],
    "popularity": 22009
  },
  {
    "name": "settings_applications",
    "tags": [
      "application",
      "change",
      "details",
      "gear",
      "info",
      "information",
      "options",
      "personal",
      "service",
      "settings"
    ],
    "popularity": 22007
  },
  {
    "name": "source",
    "tags": [
      "code",
      "composer",
      "content",
      "creation",
      "data",
      "doc",
      "document",
      "file",
      "folder",
      "mode",
      "source",
      "storage",
      "view"
    ],
    "popularity": 21983
  },
  {
    "name": "dashboard_customize",
    "tags": ["cards", "customize", "dashboard", "format", "layout", "rectangle", "shapes", "square", "web", "website"],
    "popularity": 21941
  },
  {
    "name": "find_in_page",
    "tags": [
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "find",
      "folder",
      "folders",
      "glass",
      "in",
      "look",
      "magnify",
      "magnifying",
      "page",
      "paper",
      "search",
      "see",
      "sheet",
      "slide",
      "writing"
    ],
    "popularity": 21858
  },
  {
    "name": "ads_click",
    "tags": ["ads", "browser", "click", "clicks", "cursor", "internet", "target", "traffic", "web"],
    "popularity": 21768
  },
  {
    "name": "support",
    "tags": ["assist", "buoy", "help", "life", "lifebuoy", "rescue", "safe", "safety", "support"],
    "popularity": 21691
  },
  {
    "name": "new_releases",
    "tags": [
      "approve",
      "award",
      "check",
      "checkmark",
      "complete",
      "done",
      "new",
      "notification",
      "ok",
      "release",
      "releases",
      "select",
      "star",
      "symbol",
      "tick",
      "verification",
      "verified",
      "warning",
      "yes"
    ],
    "popularity": 21681
  },
  {
    "name": "save_alt",
    "tags": ["alt", "arrow", "disk", "document", "down", "file", "floppy", "multimedia", "save"],
    "popularity": 21616
  },
  {
    "name": "playlist_add",
    "tags": ["+", "add", "collection", "list", "music", "new", "playlist", "plus", "symbol"],
    "popularity": 21603
  },
  {
    "name": "flutter_dash",
    "tags": ["bird", "dash", "flutter", "mascot"],
    "popularity": 21600
  },
  {
    "name": "credit_score",
    "tags": [
      "approve",
      "bill",
      "card",
      "cash",
      "check",
      "coin",
      "commerce",
      "complete",
      "cost",
      "credit",
      "currency",
      "dollars",
      "done",
      "finance",
      "loan",
      "mark",
      "money",
      "ok",
      "online",
      "pay",
      "payment",
      "score",
      "select",
      "symbol",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 21480
  },
  {
    "name": "close_fullscreen",
    "tags": ["action", "arrow", "arrows", "close", "collapse", "direction", "full", "fullscreen", "minimize", "screen"],
    "popularity": 21468
  },
  {
    "name": "redeem",
    "tags": [
      "bill",
      "card",
      "cart",
      "cash",
      "certificate",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "gift",
      "giftcard",
      "money",
      "online",
      "pay",
      "payment",
      "present",
      "redeem",
      "shopping"
    ],
    "popularity": 21231
  },
  {
    "name": "layers",
    "tags": [
      "arrange",
      "disabled",
      "enabled",
      "interaction",
      "layers",
      "maps",
      "off",
      "on",
      "overlay",
      "pages",
      "slash"
    ],
    "popularity": 21217
  },
  {
    "name": "check_box_outline_blank",
    "tags": [
      "blank",
      "box",
      "button",
      "check",
      "component",
      "control",
      "deselected",
      "empty",
      "form",
      "outline",
      "select",
      "selection",
      "square",
      "tick",
      "toggle",
      "ui"
    ],
    "popularity": 21173
  },
  {
    "name": "spa",
    "tags": [
      "aromatherapy",
      "flower",
      "healthcare",
      "leaf",
      "massage",
      "meditation",
      "nature",
      "petals",
      "places",
      "relax",
      "spa",
      "wellbeing",
      "wellness"
    ],
    "popularity": 21165
  },
  {
    "name": "refresh",
    "tags": [
      "around",
      "arrow",
      "arrows",
      "direction",
      "inprogress",
      "load",
      "loading refresh",
      "navigation",
      "refresh",
      "renew",
      "right",
      "rotate",
      "turn"
    ],
    "popularity": 21088
  },
  {
    "name": "thermostat",
    "tags": ["climate", "forecast", "temperature", "thermostat", "weather"],
    "popularity": 21066
  },
  {
    "name": "share",
    "tags": [
      "DISABLE_IOS",
      "android",
      "connect",
      "contect",
      "disable_ios",
      "link",
      "media",
      "multimedia",
      "multiple",
      "network",
      "options",
      "share",
      "shared",
      "sharing",
      "social"
    ],
    "popularity": 21039
  },
  {
    "name": "send",
    "tags": ["email", "mail", "message", "paper", "plane", "reply", "right", "send", "share"],
    "popularity": 20998
  },
  {
    "name": "announcement",
    "tags": [
      "!",
      "alert",
      "announcement",
      "attention",
      "bubble",
      "caution",
      "chat",
      "comment",
      "communicate",
      "danger",
      "error",
      "exclamation",
      "feedback",
      "important",
      "mark",
      "message",
      "notification",
      "speech",
      "symbol",
      "warning"
    ],
    "popularity": 20969
  },
  {
    "name": "loyalty",
    "tags": [
      "benefits",
      "card",
      "credit",
      "heart",
      "loyalty",
      "membership",
      "miles",
      "points",
      "program",
      "subscription",
      "tag",
      "travel",
      "trip"
    ],
    "popularity": 20918
  },
  {
    "name": "keyboard_backspace",
    "tags": ["arrow", "back", "backspace", "keyboard", "left"],
    "popularity": 20853
  },
  {
    "name": "swap_vert",
    "tags": ["arrow", "arrows", "direction", "down", "navigation", "swap", "up", "vert", "vertical"],
    "popularity": 20821
  },
  {
    "name": "arrow_circle_right",
    "tags": ["arrow", "circle", "direction", "navigation", "right"],
    "popularity": 20730
  },
  {
    "name": "medical_services",
    "tags": ["aid", "bag", "briefcase", "emergency", "first", "kit", "medical", "medicine", "services"],
    "popularity": 20657
  },
  {
    "name": "view_headline",
    "tags": ["design", "format", "grid", "headline", "layout", "paragraph", "text", "view", "website"],
    "popularity": 20647
  },
  {
    "name": "login",
    "tags": [
      "access",
      "app",
      "application",
      "arrow",
      "components",
      "design",
      "enter",
      "in",
      "interface",
      "left",
      "log",
      "login",
      "screen",
      "sign",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 20621
  },
  {
    "name": "sentiment_dissatisfied",
    "tags": [
      "angry",
      "disappointed",
      "dislike",
      "dissatisfied",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "frown",
      "mood",
      "person",
      "sad",
      "sentiment",
      "survey",
      "unhappy",
      "unsatisfied",
      "upset"
    ],
    "popularity": 20620
  },
  {
    "name": "format_list_numbered",
    "tags": [
      "align",
      "alignment",
      "digit",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "notes",
      "number",
      "numbered",
      "sheet",
      "spreadsheet",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 20610
  },
  {
    "name": "phone_android",
    "tags": ["OS", "android", "cell", "device", "hardware", "iOS", "mobile", "phone", "tablet"],
    "popularity": 20227
  },
  {
    "name": "sms",
    "tags": [
      "3",
      "bubble",
      "chat",
      "communication",
      "conversation",
      "dots",
      "message",
      "more",
      "service",
      "sms",
      "speech",
      "three"
    ],
    "popularity": 20152
  },
  {
    "name": "restore",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "clock",
      "date",
      "history",
      "refresh",
      "renew",
      "restore",
      "reverse",
      "rotate",
      "schedule",
      "time",
      "turn"
    ],
    "popularity": 20144
  },
  {
    "name": "policy",
    "tags": [
      "certified",
      "find",
      "glass",
      "legal",
      "look",
      "magnify",
      "magnifying",
      "policy",
      "privacy",
      "private",
      "protect",
      "protection",
      "search",
      "security",
      "see",
      "shield",
      "verified"
    ],
    "popularity": 20096
  },
  {
    "name": "thumb_up",
    "tags": [
      "favorite",
      "fingers",
      "gesture",
      "hand",
      "hands",
      "like",
      "rank",
      "ranking",
      "rate",
      "rating",
      "thumb",
      "up"
    ],
    "popularity": 20012
  },
  {
    "name": "dangerous",
    "tags": ["broken", "danger", "dangerous", "fix", "no", "sign", "stop", "update", "warning", "wrong", "x"],
    "popularity": 19960
  },
  {
    "name": "query_stats",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "find",
      "glass",
      "graph",
      "infographic",
      "line",
      "look",
      "magnify",
      "magnifying",
      "measure",
      "metrics",
      "query",
      "search",
      "see",
      "statistics",
      "stats",
      "tracking"
    ],
    "popularity": 19887
  },
  {
    "name": "chevron_left",
    "tags": ["DISABLE_IOS", "arrow", "arrows", "chevron", "direction", "disable_ios", "left"],
    "popularity": 19884
  },
  {
    "name": "local_shipping",
    "tags": [
      "automobile",
      "car",
      "cars",
      "delivery",
      "letter",
      "local",
      "mail",
      "maps",
      "office",
      "package",
      "parcel",
      "post",
      "postal",
      "send",
      "shipping",
      "shopping",
      "stamp",
      "transportation",
      "truck",
      "vehicle"
    ],
    "popularity": 19813
  },
  {
    "name": "payments",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "layer",
      "money",
      "multiple",
      "online",
      "pay",
      "payment",
      "payments",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 19778
  },
  {
    "name": "euro_symbol",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "euro",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "symbol"
    ],
    "popularity": 19698
  },
  {
    "name": "expand_circle_down",
    "tags": [
      "arrow",
      "arrows",
      "chevron",
      "circle",
      "collapse",
      "direction",
      "down",
      "expand",
      "expandable",
      "list",
      "more"
    ],
    "popularity": 19687
  },
  {
    "name": "battery_full",
    "tags": ["0", "bar", "battery", "cell", "charge", "full", "mobile", "power"],
    "popularity": 19683
  },
  {
    "name": "group_work",
    "tags": ["alliance", "collaboration", "group", "partnership", "team", "teamwork", "together", "work"],
    "popularity": 19567
  },
  {
    "name": "key",
    "tags": ["key", "lock", "password", "unlock"],
    "popularity": 19524
  },
  {
    "name": "sensors",
    "tags": ["connection", "network", "scan", "sensors", "signal", "wireless"],
    "popularity": 19389
  },
  {
    "name": "brush",
    "tags": ["art", "brush", "design", "draw", "edit", "editing", "paint", "painting", "tool"],
    "popularity": 19367
  },
  {
    "name": "keyboard_arrow_up",
    "tags": ["arrow", "arrows", "keyboard", "up"],
    "popularity": 19360
  },
  {
    "name": "visibility_off",
    "tags": ["disabled", "enabled", "eye", "off", "on", "reveal", "see", "show", "slash", "view", "visibility"],
    "popularity": 19358
  },
  {
    "name": "meeting_room",
    "tags": [
      "building",
      "door",
      "doorway",
      "entrance",
      "home",
      "house",
      "interior",
      "meeting",
      "office",
      "open",
      "places",
      "room"
    ],
    "popularity": 19344
  },
  {
    "name": "groups",
    "tags": [
      "body",
      "club",
      "collaboration",
      "crowd",
      "gathering",
      "groups",
      "human",
      "meeting",
      "people",
      "person",
      "social",
      "teams"
    ],
    "popularity": 19309
  },
  {
    "name": "gps_fixed",
    "tags": [
      "destination",
      "direction",
      "fixed",
      "gps",
      "location",
      "maps",
      "pin",
      "place",
      "pointer",
      "stop",
      "tracking"
    ],
    "popularity": 19230
  },
  {
    "name": "house",
    "tags": [
      "architecture",
      "building",
      "estate",
      "family",
      "home",
      "homepage",
      "house",
      "place",
      "places",
      "real",
      "residence",
      "residential",
      "shelter"
    ],
    "popularity": 19188
  },
  {
    "name": "table_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic grid",
      "measure",
      "metrics",
      "statistics",
      "table",
      "tracking"
    ],
    "popularity": 19116
  },
  {
    "name": "border_color",
    "tags": [
      "all",
      "border",
      "doc",
      "edit",
      "editing",
      "editor",
      "pen",
      "pencil",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "writing"
    ],
    "popularity": 19087
  },
  {
    "name": "lunch_dining",
    "tags": ["breakfast", "dining", "dinner", "drink", "fastfood", "food", "hamburger", "lunch", "meal"],
    "popularity": 19082
  },
  {
    "name": "directions_walk",
    "tags": ["body", "direction", "directions", "human", "jogging", "maps", "people", "person", "route", "run", "walk"],
    "popularity": 19029
  },
  {
    "name": "content_copy",
    "tags": ["content", "copy", "cut", "doc", "document", "duplicate", "file", "multiple", "paste"],
    "popularity": 19009
  },
  {
    "name": "compare_arrows",
    "tags": ["arrow", "arrows", "collide", "compare", "direction", "left", "pressure", "push", "right", "together"],
    "popularity": 18998
  },
  {
    "name": "expand_less",
    "tags": ["arrow", "arrows", "chevron", "collapse", "direction", "expand", "expandable", "less", "list", "up"],
    "popularity": 18965
  },
  {
    "name": "south",
    "tags": ["arrow", "directional", "down", "maps", "navigation", "south"],
    "popularity": 18949
  },
  {
    "name": "arrow_left",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "interface",
      "left",
      "navigation",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 18899
  },
  {
    "name": "sentiment_very_dissatisfied",
    "tags": [
      "angry",
      "disappointed",
      "dislike",
      "dissatisfied",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "mood",
      "person",
      "sad",
      "sentiment",
      "sorrow",
      "survey",
      "unhappy",
      "unsatisfied",
      "upset",
      "very"
    ],
    "popularity": 18809
  },
  {
    "name": "tag",
    "tags": ["hash", "hashtag", "key", "media", "number", "pound", "social", "tag", "trend"],
    "popularity": 18750
  },
  {
    "name": "change_circle",
    "tags": ["around", "arrows", "change", "circle", "direction", "navigation", "rotate"],
    "popularity": 18743
  },
  {
    "name": "subject",
    "tags": ["alignment", "doc", "document", "email", "full", "justify", "list", "note", "subject", "text", "writing"],
    "popularity": 18711
  },
  {
    "name": "school",
    "tags": [
      "academy",
      "achievement",
      "cap",
      "class",
      "college",
      "education",
      "graduation",
      "hat",
      "knowledge",
      "learning",
      "school",
      "university"
    ],
    "popularity": 18678
  },
  {
    "name": "local_hospital",
    "tags": ["911", "aid", "cross", "emergency", "first", "hospital", "local", "medicine"],
    "popularity": 18667
  },
  {
    "name": "table_view",
    "tags": ["format", "grid", "group", "layout", "multiple", "table", "view"],
    "popularity": 18592
  },
  {
    "name": "radio_button_unchecked",
    "tags": [
      "bullet",
      "button",
      "circle",
      "deselected",
      "form",
      "off",
      "on",
      "point",
      "radio",
      "record",
      "select",
      "toggle",
      "unchecked"
    ],
    "popularity": 18569
  },
  {
    "name": "notification_important",
    "tags": [
      "!",
      "active",
      "alarm",
      "alert",
      "attention",
      "bell",
      "caution",
      "chime",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "notifications",
      "notify",
      "reminder",
      "ring",
      "sound",
      "symbol",
      "warning"
    ],
    "popularity": 18548
  },
  {
    "name": "disabled_by_default",
    "tags": [
      "box",
      "by",
      "cancel",
      "close",
      "default",
      "disabled",
      "exit",
      "no",
      "quit",
      "remove",
      "square",
      "stop",
      "x"
    ],
    "popularity": 18534
  },
  {
    "name": "celebration",
    "tags": ["activity", "birthday", "celebration", "event", "fun", "party"],
    "popularity": 18484
  },
  {
    "name": "loop",
    "tags": [
      "around",
      "arrow",
      "arrows",
      "direction",
      "inprogress",
      "load",
      "loading refresh",
      "loop",
      "music",
      "navigation",
      "renew",
      "rotate",
      "turn"
    ],
    "popularity": 18446
  },
  {
    "name": "laptop",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "computer",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "laptop",
      "mac",
      "monitor",
      "web",
      "windows"
    ],
    "popularity": 18424
  },
  {
    "name": "privacy_tip",
    "tags": [
      "alert",
      "announcement",
      "assistance",
      "certified",
      "details",
      "help",
      "i",
      "info",
      "information",
      "privacy",
      "private",
      "protect",
      "protection",
      "security",
      "service",
      "shield",
      "support",
      "tip",
      "verified"
    ],
    "popularity": 18345
  },
  {
    "name": "more_horiz",
    "tags": [
      "3",
      "DISABLE_IOS",
      "app",
      "application",
      "components",
      "disable_ios",
      "dots",
      "etc",
      "horiz",
      "horizontal",
      "interface",
      "ios",
      "more",
      "screen",
      "site",
      "three",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 18337
  },
  {
    "name": "nightlight_round",
    "tags": ["dark", "half", "light", "mode", "moon", "night", "nightlight", "round"],
    "popularity": 18328
  },
  {
    "name": "handshake",
    "tags": ["agreement", "hand", "hands", "partnership", "shake"],
    "popularity": 18251
  },
  {
    "name": "import_contacts",
    "tags": ["address", "book", "contacts", "import", "info", "information", "open"],
    "popularity": 18238
  },
  {
    "name": "equalizer",
    "tags": [
      "adjustment",
      "analytics",
      "chart",
      "data",
      "equalizer",
      "graph",
      "measure",
      "metrics",
      "music",
      "noise",
      "sound",
      "static",
      "statistics",
      "tracking",
      "volume"
    ],
    "popularity": 18137
  },
  {
    "name": "apps",
    "tags": [
      "all",
      "applications",
      "apps",
      "circles",
      "collection",
      "components",
      "dots",
      "grid",
      "interface",
      "squares",
      "ui",
      "ux"
    ],
    "popularity": 18023
  },
  {
    "name": "app_registration",
    "tags": ["app", "apps", "edit", "pencil", "register", "registration"],
    "popularity": 18006
  },
  {
    "name": "arrow_right_alt",
    "tags": ["alt", "arrow", "arrows", "direction", "east", "navigation", "pointing", "right"],
    "popularity": 18002
  },
  {
    "name": "keyboard_double_arrow_right",
    "tags": ["arrow", "arrows", "direction", "double", "multiple", "navigation", "right"],
    "popularity": 17976
  },
  {
    "name": "shopping_bag",
    "tags": [
      "bag",
      "bill",
      "business",
      "buy",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "shop",
      "shopping",
      "store",
      "storefront"
    ],
    "popularity": 17958
  },
  {
    "name": "download",
    "tags": ["arrow", "down", "download", "downloads", "drive", "install", "upload"],
    "popularity": 17925
  },
  {
    "name": "radio_button_checked",
    "tags": [
      "app",
      "application",
      "bullet",
      "button",
      "checked",
      "circle",
      "components",
      "design",
      "form",
      "interface",
      "off",
      "on",
      "point",
      "radio",
      "record",
      "screen",
      "select",
      "selected",
      "site",
      "toggle",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 17906
  },
  {
    "name": "corporate_fare",
    "tags": [
      "architecture",
      "building",
      "business",
      "corporate",
      "estate",
      "fare",
      "organization",
      "place",
      "real",
      "residence",
      "residential",
      "shelter"
    ],
    "popularity": 17785
  },
  {
    "name": "local_library",
    "tags": ["book", "community learning", "library", "local", "read"],
    "popularity": 17777
  },
  {
    "name": "https",
    "tags": ["https", "lock", "locked", "password", "privacy", "private", "protection", "safety", "secure", "security"],
    "popularity": 17709
  },
  {
    "name": "price_check",
    "tags": [
      "approve",
      "bill",
      "card",
      "cash",
      "check",
      "coin",
      "commerce",
      "complete",
      "cost",
      "credit",
      "currency",
      "dollars",
      "done",
      "finance",
      "mark",
      "money",
      "ok",
      "online",
      "pay",
      "payment",
      "price",
      "select",
      "shopping",
      "symbol",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 17698
  },
  {
    "name": "euro",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "euro",
      "euros",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 17695
  },
  {
    "name": "pin_drop",
    "tags": ["destination", "direction", "drop", "location", "maps", "navigation", "pin", "place", "stop"],
    "popularity": 17695
  },
  {
    "name": "live_tv",
    "tags": [
      "Android",
      "OS",
      "antennas hardware",
      "chrome",
      "desktop",
      "device",
      "iOS",
      "live",
      "mac",
      "monitor",
      "movie",
      "play",
      "stream",
      "television",
      "tv",
      "web",
      "window"
    ],
    "popularity": 17598
  },
  {
    "name": "park",
    "tags": ["attraction", "fresh", "local", "nature", "outside", "park", "plant", "tree"],
    "popularity": 17547
  },
  {
    "name": "photo_camera",
    "tags": ["camera", "image", "photo", "photography", "picture"],
    "popularity": 17545
  },
  {
    "name": "coronavirus",
    "tags": ["19", "bacteria", "coronavirus", "covid", "disease", "germs", "illness", "sick", "social"],
    "popularity": 17543
  },
  {
    "name": "toc",
    "tags": ["content", "format", "lines", "list", "order", "reorder", "stacked", "table", "title", "titles", "toc"],
    "popularity": 17541
  },
  {
    "name": "flash_on",
    "tags": [
      "bolt",
      "disabled",
      "electric",
      "enabled",
      "fast",
      "flash",
      "lightning",
      "off",
      "on",
      "slash",
      "thunderbolt"
    ],
    "popularity": 17508
  },
  {
    "name": "track_changes",
    "tags": ["bullseye", "changes", "circle", "evolve", "lines", "movement", "rotate", "shift", "target", "track"],
    "popularity": 17497
  },
  {
    "name": "emoji_people",
    "tags": ["arm", "body", "emoji", "greeting", "human", "people", "person", "social", "waving"],
    "popularity": 17474
  },
  {
    "name": "arrow_circle_up",
    "tags": ["arrow", "circle", "direction", "navigation", "up"],
    "popularity": 17463
  },
  {
    "name": "bookmarks",
    "tags": [
      "bookmark",
      "bookmarks",
      "favorite",
      "label",
      "layers",
      "library",
      "multiple",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "stack",
      "tag"
    ],
    "popularity": 17435
  },
  {
    "name": "keyboard_return",
    "tags": ["arrow", "back", "keyboard", "left", "return"],
    "popularity": 17391
  },
  {
    "name": "copyright",
    "tags": ["alphabet", "c", "character", "copyright", "emblem", "font", "legal", "letter", "owner", "symbol", "text"],
    "popularity": 17368
  },
  {
    "name": "chat",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "speech"],
    "popularity": 17333
  },
  {
    "name": "keyboard_arrow_left",
    "tags": ["arrow", "arrows", "keyboard", "left"],
    "popularity": 17299
  },
  {
    "name": "ac_unit",
    "tags": [
      "ac",
      "air",
      "cold",
      "conditioner",
      "flake",
      "snow",
      "snowflake",
      "temperature",
      "unit",
      "weather",
      "winter"
    ],
    "popularity": 17293
  },
  {
    "name": "contact_phone",
    "tags": [
      "account",
      "avatar",
      "call",
      "communicate",
      "contact",
      "face",
      "human",
      "info",
      "information",
      "message",
      "mobile",
      "people",
      "person",
      "phone",
      "profile",
      "user"
    ],
    "popularity": 17289
  },
  {
    "name": "medication",
    "tags": ["doctor", "drug", "emergency", "hospital", "medication", "medicine", "pharmacy", "pills", "prescription"],
    "popularity": 17185
  },
  {
    "name": "grading",
    "tags": [
      "'favorite'_new'.  ' Remove this icon & keep 'star'.",
      "'star_boarder'",
      "'star_border_purple500'",
      "'star_outline'",
      "'star_purple500'",
      "'star_rate'",
      "Same as 'star'"
    ],
    "popularity": 17168
  },
  {
    "name": "person_add",
    "tags": [
      "+",
      "account",
      "add",
      "avatar",
      "face",
      "human",
      "new",
      "people",
      "person",
      "plus",
      "profile",
      "symbol",
      "user"
    ],
    "popularity": 17139
  },
  {
    "name": "public",
    "tags": ["earth", "global", "globe", "map", "network", "planet", "public", "social", "space", "web", "world"],
    "popularity": 17138
  },
  {
    "name": "import_export",
    "tags": ["arrow", "arrows", "direction", "down", "explort", "import", "up"],
    "popularity": 17110
  },
  {
    "name": "smart_toy",
    "tags": ["bot", "droid", "games", "robot", "smart", "toy"],
    "popularity": 17073
  },
  {
    "name": "input",
    "tags": ["arrow", "box", "download", "input", "login", "move", "right"],
    "popularity": 17025
  },
  {
    "name": "api",
    "tags": ["api", "developer", "development", "enterprise", "software"],
    "popularity": 17013
  },
  {
    "name": "self_improvement",
    "tags": [
      "body",
      "calm",
      "care",
      "chi",
      "human",
      "improvement",
      "meditate",
      "meditation",
      "people",
      "person",
      "relax",
      "self",
      "sitting",
      "wellbeing",
      "yoga",
      "zen"
    ],
    "popularity": 16958
  },
  {
    "name": "perm_media",
    "tags": [
      "collection",
      "data",
      "doc",
      "document",
      "file",
      "folder",
      "folders",
      "image",
      "landscape",
      "media",
      "mountain",
      "mountains",
      "perm",
      "photo",
      "photography",
      "picture",
      "storage"
    ],
    "popularity": 16942
  },
  {
    "name": "live_help",
    "tags": [
      "?",
      "assistance",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "help",
      "info",
      "information",
      "live",
      "message",
      "punctuation",
      "question mark",
      "recent",
      "restore",
      "speech",
      "support",
      "symbol"
    ],
    "popularity": 16940
  },
  {
    "name": "query_builder",
    "tags": ["builder", "clock", "date", "query", "schedule", "time"],
    "popularity": 16927
  },
  {
    "name": "download_for_offline",
    "tags": ["arrow", "circle", "down", "download", "for offline", "install", "upload"],
    "popularity": 16843
  },
  {
    "name": "monitoring",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "monitoring",
      "statistics",
      "tracking"
    ],
    "popularity": 16836
  },
  {
    "name": "view_module",
    "tags": ["design", "format", "grid", "layout", "module", "square", "squares", "stacked", "view", "website"],
    "popularity": 16777
  },
  {
    "name": "pie_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "pie",
      "statistics",
      "tracking"
    ],
    "popularity": 16753
  },
  {
    "name": "currency_exchange",
    "tags": [
      "360",
      "around",
      "arrow",
      "arrows",
      "cash",
      "coin",
      "commerce",
      "currency",
      "direction",
      "dollars",
      "exchange",
      "inprogress",
      "money",
      "pay",
      "renew",
      "rotate",
      "sync",
      "turn",
      "universal"
    ],
    "popularity": 16739
  },
  {
    "name": "pin",
    "tags": [
      "1",
      "2",
      "3",
      "digit",
      "key",
      "login",
      "logout",
      "number",
      "password",
      "pattern",
      "pin",
      "security",
      "star",
      "symbol",
      "unlock"
    ],
    "popularity": 16727
  },
  {
    "name": "person_remove",
    "tags": [
      "account",
      "avatar",
      "delete",
      "face",
      "human",
      "minus",
      "people",
      "person",
      "profile",
      "remove",
      "unfriend",
      "user"
    ],
    "popularity": 16699
  },
  {
    "name": "forward_to_inbox",
    "tags": [
      "arrow",
      "arrows",
      "directions",
      "email",
      "envelop",
      "forward",
      "inbox",
      "letter",
      "mail",
      "message",
      "navigation",
      "outgoing",
      "right",
      "send",
      "to"
    ],
    "popularity": 16687
  },
  {
    "name": "local_atm",
    "tags": [
      "atm",
      "bill",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "local",
      "money",
      "online",
      "pay",
      "payment",
      "shopping",
      "symbol"
    ],
    "popularity": 16672
  },
  {
    "name": "fast_forward",
    "tags": ["control", "fast", "forward", "media", "music", "play", "speed", "time", "tv", "video"],
    "popularity": 16671
  },
  {
    "name": "build_circle",
    "tags": ["adjust", "build", "circle", "fix", "repair", "tool", "wrench"],
    "popularity": 16564
  },
  {
    "name": "star_half",
    "tags": [
      "achievement",
      "bookmark",
      "favorite",
      "half",
      "highlight",
      "important",
      "marked",
      "ranking",
      "rate",
      "rating rank",
      "reward",
      "save",
      "saved",
      "shape",
      "special",
      "star",
      "toggle"
    ],
    "popularity": 16520
  },
  {
    "name": "redo",
    "tags": ["arrow", "backward", "forward", "next", "redo", "repeat", "rotate", "undo"],
    "popularity": 16469
  },
  {
    "name": "verified",
    "tags": [
      "approve",
      "badge",
      "burst",
      "check",
      "complete",
      "done",
      "mark",
      "ok",
      "select",
      "star",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 16450
  },
  {
    "name": "web",
    "tags": ["browser", "internet", "page", "screen", "site", "web", "website", "www"],
    "popularity": 16418
  },
  {
    "name": "north_east",
    "tags": ["arrow", "east", "maps", "navigation", "noth", "right", "up"],
    "popularity": 16338
  },
  {
    "name": "location_on",
    "tags": ["destination", "direction", "location", "maps", "on", "pin", "place", "room", "stop"],
    "popularity": 16330
  },
  {
    "name": "filter_alt",
    "tags": ["alt", "edit", "filter", "funnel", "options", "refine", "sift"],
    "popularity": 16328
  },
  {
    "name": "remove",
    "tags": ["can", "delete", "minus", "negative", "remove", "substract", "trash"],
    "popularity": 16327
  },
  {
    "name": "north",
    "tags": ["arrow", "directional", "maps", "navigation", "north", "up"],
    "popularity": 16267
  },
  {
    "name": "local_activity",
    "tags": ["activity", "event", "event ticket", "local", "star", "things", "ticket"],
    "popularity": 16242
  },
  {
    "name": "cottage",
    "tags": [
      "architecture",
      "beach",
      "cottage",
      "estate",
      "home",
      "house",
      "lake",
      "lodge",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling"
    ],
    "popularity": 16192
  },
  {
    "name": "hourglass_bottom",
    "tags": ["bottom", "countdown", "half", "hourglass", "loading", "minute", "minutes", "time", "wait", "waiting"],
    "popularity": 16127
  },
  {
    "name": "video_library",
    "tags": ["arrow", "collection", "library", "play", "video"],
    "popularity": 16112
  },
  {
    "name": "dashboard",
    "tags": ["cards", "dashboard", "format", "layout", "rectangle", "shapes", "square", "web", "website"],
    "popularity": 16030
  },
  {
    "name": "headphones",
    "tags": ["accessory", "audio", "device", "ear", "earphone", "headphones", "headset", "listen", "music", "sound"],
    "popularity": 16009
  },
  {
    "name": "image",
    "tags": [
      "disabled",
      "enabled",
      "hide",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "off",
      "on",
      "photo",
      "photography",
      "picture",
      "slash"
    ],
    "popularity": 16006
  },
  {
    "name": "zoom_out",
    "tags": [
      "find",
      "glass",
      "look",
      "magnify",
      "magnifying",
      "minus",
      "negative",
      "out",
      "scale",
      "search",
      "see",
      "size",
      "small",
      "smaller",
      "zoom"
    ],
    "popularity": 15995
  },
  {
    "name": "perm_contact_calendar",
    "tags": [
      "account",
      "calendar",
      "contact",
      "date",
      "face",
      "human",
      "information",
      "people",
      "perm",
      "person",
      "profile",
      "schedule",
      "time",
      "user"
    ],
    "popularity": 15992
  },
  {
    "name": "poll",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "poll",
      "statistics",
      "survey",
      "tracking",
      "vote"
    ],
    "popularity": 15942
  },
  {
    "name": "forward",
    "tags": ["arrow", "forward", "mail", "message", "playback", "right", "sent"],
    "popularity": 15861
  },
  {
    "name": "newspaper",
    "tags": [
      "article",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "magazine",
      "media",
      "news",
      "newspaper",
      "notes",
      "page",
      "paper",
      "sheet",
      "slide",
      "text",
      "writing"
    ],
    "popularity": 15844
  },
  {
    "name": "person_pin",
    "tags": [
      "account",
      "avatar",
      "destination",
      "direction",
      "face",
      "human",
      "location",
      "maps",
      "people",
      "person",
      "pin",
      "place",
      "profile",
      "stop",
      "user"
    ],
    "popularity": 15830
  },
  {
    "name": "playlist_add_check",
    "tags": [
      "add",
      "approve",
      "check",
      "collection",
      "complete",
      "done",
      "list",
      "mark",
      "music",
      "ok",
      "playlist",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 15770
  },
  {
    "name": "design_services",
    "tags": [
      "compose",
      "create",
      "design",
      "draft",
      "edit",
      "editing",
      "input",
      "pen",
      "pencil",
      "ruler",
      "service",
      "write",
      "writing"
    ],
    "popularity": 15759
  },
  {
    "name": "looks_one",
    "tags": ["1", "digit", "looks", "numbers", "square", "symbol"],
    "popularity": 15754
  },
  {
    "name": "home_work",
    "tags": [
      "architecture",
      "building",
      "estate",
      "home",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "work"
    ],
    "popularity": 15742
  },
  {
    "name": "settings_phone",
    "tags": ["call", "cell", "contact", "device", "hardware", "mobile", "phone", "settings", "telephone"],
    "popularity": 15734
  },
  {
    "name": "ondemand_video",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "demand",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "ondemand",
      "play",
      "television",
      "tv",
      "video",
      "web",
      "window"
    ],
    "popularity": 15718
  },
  {
    "name": "local_cafe",
    "tags": ["bottle", "cafe", "coffee", "cup", "drink", "food", "restaurant", "tea"],
    "popularity": 15701
  },
  {
    "name": "manage_accounts",
    "tags": [
      "accounts",
      "change",
      "details service-human",
      "face",
      "gear",
      "manage",
      "options",
      "people",
      "person",
      "profile",
      "settings",
      "user"
    ],
    "popularity": 15676
  },
  {
    "name": "memory",
    "tags": ["card", "chip", "digital", "memory", "micro", "processor", "sd", "storage"],
    "popularity": 15666
  },
  {
    "name": "backup",
    "tags": ["arrow", "backup", "cloud", "data", "drive", "files folders", "storage", "up", "upload"],
    "popularity": 15658
  },
  {
    "name": "open_with",
    "tags": ["arrow", "arrows", "direction", "expand", "move", "open", "pan", "with"],
    "popularity": 15626
  },
  {
    "name": "hourglass_top",
    "tags": ["countdown", "half", "hourglass", "loading", "minute", "minutes", "time", "top", "wait", "waiting"],
    "popularity": 15619
  },
  {
    "name": "content_cut",
    "tags": ["content", "copy", "cut", "doc", "document", "file", "paste", "scissors", "trim"],
    "popularity": 15616
  },
  {
    "name": "keyboard",
    "tags": ["computer", "device", "hardware", "input", "keyboard", "keypad", "letter", "office", "text", "type"],
    "popularity": 15562
  },
  {
    "name": "rss_feed",
    "tags": [
      "application",
      "blog",
      "connection",
      "data",
      "feed",
      "internet",
      "network",
      "rss",
      "service",
      "signal",
      "website",
      "wifi",
      "wireless"
    ],
    "popularity": 15543
  },
  {
    "name": "first_page",
    "tags": ["arrow", "back", "chevron", "first", "left", "page", "rewind"],
    "popularity": 15535
  },
  {
    "name": "rate_review",
    "tags": ["comment", "feedback", "pen", "pencil", "rate", "review", "stars", "write"],
    "popularity": 15515
  },
  {
    "name": "delivery_dining",
    "tags": [
      "delivery",
      "dining",
      "food",
      "meal",
      "restaurant",
      "scooter",
      "takeout",
      "transportation",
      "vehicle",
      "vespa"
    ],
    "popularity": 15500
  },
  {
    "name": "auto_fix_high",
    "tags": [
      "adjust",
      "ai",
      "artificial",
      "auto",
      "automatic",
      "automation",
      "custom",
      "edit",
      "editing",
      "enhance",
      "erase",
      "fix",
      "genai",
      "high",
      "intelligence",
      "magic",
      "modify",
      "pen",
      "smart",
      "spark",
      "sparkle",
      "star",
      "tool",
      "wand"
    ],
    "popularity": 15451
  },
  {
    "name": "control_point",
    "tags": ["+", "add", "circle", "control", "plus", "point"],
    "popularity": 15432
  },
  {
    "name": "gpp_good",
    "tags": ["certified", "check", "good", "gpp", "ok", "pass", "security", "shield", "sim", "tick"],
    "popularity": 15429
  },
  {
    "name": "circle_notifications",
    "tags": [
      "active",
      "alarm",
      "alert",
      "bell",
      "chime",
      "circle",
      "notifications",
      "notify",
      "reminder",
      "ring",
      "sound"
    ],
    "popularity": 15349
  },
  {
    "name": "point_of_sale",
    "tags": [
      "checkout",
      "cost",
      "machine",
      "merchant",
      "money",
      "of",
      "pay",
      "payment",
      "point",
      "pos",
      "retail",
      "sale",
      "system",
      "transaction"
    ],
    "popularity": 15205
  },
  {
    "name": "notes",
    "tags": ["comment", "doc", "document", "note", "notes", "text", "write", "writing"],
    "popularity": 15172
  },
  {
    "name": "book_online",
    "tags": [
      "Android",
      "OS",
      "admission",
      "appointment",
      "book",
      "cell",
      "device",
      "event",
      "hardware",
      "iOS",
      "mobile",
      "online",
      "pass",
      "phone",
      "reservation",
      "tablet",
      "ticket"
    ],
    "popularity": 15171
  },
  {
    "name": "perm_phone_msg",
    "tags": [
      "bubble",
      "call",
      "cell",
      "chat",
      "comment",
      "communicate",
      "contact",
      "device",
      "message",
      "msg",
      "perm",
      "phone",
      "recording",
      "speech",
      "telephone",
      "voice"
    ],
    "popularity": 15144
  },
  {
    "name": "speaker_notes",
    "tags": [
      "bubble",
      "chat",
      "comment",
      "communicate",
      "format",
      "list",
      "message",
      "notes",
      "speaker",
      "speech",
      "text"
    ],
    "popularity": 15106
  },
  {
    "name": "fullscreen_exit",
    "tags": [
      "adjust",
      "app",
      "application",
      "components",
      "exit",
      "full",
      "fullscreen",
      "interface",
      "screen",
      "site",
      "size",
      "ui",
      "ux",
      "view",
      "web",
      "website"
    ],
    "popularity": 15023
  },
  {
    "name": "headset_mic",
    "tags": [
      "accessory",
      "audio",
      "chat",
      "device",
      "ear",
      "earphone",
      "headphones",
      "headset",
      "listen",
      "mic",
      "music",
      "sound",
      "talk"
    ],
    "popularity": 14982
  },
  {
    "name": "card_membership",
    "tags": [
      "bill",
      "bookmark",
      "card",
      "cash",
      "certificate",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "loyalty",
      "membership",
      "money",
      "online",
      "pay",
      "payment",
      "shopping",
      "subscription"
    ],
    "popularity": 14946
  },
  {
    "name": "wysiwyg",
    "tags": [
      "composer",
      "mode",
      "screen",
      "site",
      "software",
      "system",
      "text",
      "view",
      "visibility",
      "web",
      "website",
      "window",
      "wysiwyg"
    ],
    "popularity": 14943
  },
  {
    "name": "label_important",
    "tags": [
      "favorite",
      "important",
      "indent",
      "label",
      "library",
      "mail",
      "remember",
      "save",
      "stamp",
      "sticker",
      "tag",
      "wing"
    ],
    "popularity": 14934
  },
  {
    "name": "create_new_folder",
    "tags": [
      "+",
      "add",
      "create",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "new",
      "plus",
      "sheet",
      "slide",
      "storage",
      "symbol"
    ],
    "popularity": 14920
  },
  {
    "name": "directions_bus",
    "tags": ["automobile", "bus", "car", "cars", "directions", "maps", "public", "transportation", "vehicle"],
    "popularity": 14904
  },
  {
    "name": "style",
    "tags": ["booklet", "cards", "filters", "options", "style", "tags"],
    "popularity": 14885
  },
  {
    "name": "arrow_circle_down",
    "tags": ["arrow", "circle", "direction", "down", "navigation"],
    "popularity": 14846
  },
  {
    "name": "link",
    "tags": ["chain", "clip", "connection", "link", "linked", "links", "multimedia", "url"],
    "popularity": 14821
  },
  {
    "name": "file_present",
    "tags": [
      "clip",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "note",
      "paper",
      "present",
      "reminder",
      "sheet",
      "slide",
      "storage",
      "writing"
    ],
    "popularity": 14818
  },
  {
    "name": "whatshot",
    "tags": ["arrow", "circle", "direction", "fire", "frames", "hot", "round", "whatshot"],
    "popularity": 14788
  },
  {
    "name": "sports_soccer",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "entertainment",
      "exercise",
      "football",
      "game",
      "hobby",
      "soccer",
      "social",
      "sports"
    ],
    "popularity": 14696
  },
  {
    "name": "indeterminate_check_box",
    "tags": [
      "app",
      "application",
      "box",
      "button",
      "check",
      "components",
      "control",
      "design",
      "form",
      "indeterminate",
      "interface",
      "screen",
      "select",
      "selected",
      "selection",
      "site",
      "square",
      "toggle",
      "ui",
      "undetermined",
      "ux",
      "web",
      "website"
    ],
    "popularity": 14690
  },
  {
    "name": "outlined_flag",
    "tags": ["country", "flag", "goal", "mark", "nation", "outlined", "report", "start"],
    "popularity": 14673
  },
  {
    "name": "price_change",
    "tags": [
      "arrows",
      "bill",
      "card",
      "cash",
      "change",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "down",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol",
      "up"
    ],
    "popularity": 14640
  },
  {
    "name": "mark_email_read",
    "tags": [
      "approve",
      "check",
      "complete",
      "done",
      "email",
      "envelop",
      "letter",
      "mail",
      "mark",
      "message",
      "note",
      "ok",
      "read",
      "select",
      "send",
      "sent",
      "tick",
      "yes"
    ],
    "popularity": 14607
  },
  {
    "name": "library_add",
    "tags": [
      "+",
      "add",
      "collection",
      "layers",
      "library",
      "multiple",
      "music",
      "new",
      "plus",
      "stacked",
      "symbol",
      "video"
    ],
    "popularity": 14559
  },
  {
    "name": "pageview",
    "tags": ["doc", "document", "find", "glass", "magnifying", "page", "paper", "search", "view"],
    "popularity": 14524
  },
  {
    "name": "inbox",
    "tags": ["archive", "email", "inbox", "incoming", "mail", "message"],
    "popularity": 14477
  },
  {
    "name": "tv",
    "tags": ["device", "display", "monitor", "screen", "screencast", "stream", "television", "tv", "video", "wireless"],
    "popularity": 14474
  },
  {
    "name": "adjust",
    "tags": ["adjust", "alter", "center", "circle", "circles", "dot", "fix", "image", "move", "target"],
    "popularity": 14440
  },
  {
    "name": "domain",
    "tags": [
      "apartment",
      "architecture",
      "building",
      "business",
      "domain",
      "estate",
      "home",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "web",
      "www"
    ],
    "popularity": 14429
  },
  {
    "name": "edit_note",
    "tags": [
      "compose",
      "create",
      "draft",
      "edit",
      "editing",
      "input",
      "lines",
      "note",
      "pen",
      "pencil",
      "text",
      "write",
      "writing"
    ],
    "popularity": 14333
  },
  {
    "name": "battery_charging_full",
    "tags": ["battery", "bolt", "cell", "charge", "charging", "full", "lightening", "mobile", "power", "thunderbolt"],
    "popularity": 14310
  },
  {
    "name": "bolt",
    "tags": ["bolt", "electric", "energy", "fast", "flash", "lightning", "power", "thunderbolt"],
    "popularity": 14298
  },
  {
    "name": "3d_rotation",
    "tags": [
      "3",
      "3d",
      "D",
      "alphabet",
      "arrow",
      "arrows",
      "av",
      "camera",
      "character",
      "digit",
      "font",
      "letter",
      "number",
      "rotation",
      "symbol",
      "text",
      "type",
      "vr"
    ],
    "popularity": 14260
  },
  {
    "name": "toggle_off",
    "tags": [
      "active",
      "app",
      "application",
      "components",
      "configuration",
      "control",
      "design",
      "disable",
      "inable",
      "inactive",
      "interface",
      "off",
      "on",
      "selection",
      "settings",
      "site",
      "slider",
      "switch",
      "toggle",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 14235
  },
  {
    "name": "chair",
    "tags": [
      "chair",
      "comfort",
      "couch",
      "decoration",
      "furniture",
      "home",
      "house",
      "living",
      "lounging",
      "loveseat",
      "room",
      "seat",
      "seating",
      "sofa"
    ],
    "popularity": 14224
  },
  {
    "name": "directions_bike",
    "tags": [
      "bicycle",
      "bike",
      "direction",
      "directions",
      "human",
      "maps",
      "person",
      "public",
      "route",
      "transportation"
    ],
    "popularity": 14212
  },
  {
    "name": "local_police",
    "tags": ["911", "badge", "law", "local", "officer", "police", "protect", "protection", "security", "shield"],
    "popularity": 14210
  },
  {
    "name": "mic_off",
    "tags": [
      "audio",
      "disabled",
      "enabled",
      "hear",
      "hearing",
      "mic",
      "microphone",
      "noise",
      "off",
      "on",
      "record",
      "recording",
      "slash",
      "sound",
      "voice"
    ],
    "popularity": 14197
  },
  {
    "name": "navigate_next",
    "tags": ["arrow", "arrows", "direction", "navigate", "next", "right"],
    "popularity": 14159
  },
  {
    "name": "arrow_upward",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "up",
      "upward",
      "ux",
      "web",
      "website"
    ],
    "popularity": 14114
  },
  {
    "name": "menu_book",
    "tags": ["book", "dining", "food", "meal", "menu", "restaurant"],
    "popularity": 14102
  },
  {
    "name": "fastfood",
    "tags": ["drink", "fastfood", "food", "hamburger", "maps", "meal", "places"],
    "popularity": 14094
  },
  {
    "name": "history",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "clock",
      "date",
      "history",
      "refresh",
      "renew",
      "reverse",
      "rotate",
      "schedule",
      "time",
      "turn"
    ],
    "popularity": 14092
  },
  {
    "name": "tungsten",
    "tags": ["electricity", "indoor", "lamp", "light", "lightbulb", "setting", "tungsten"],
    "popularity": 14068
  },
  {
    "name": "credit_card",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 14058
  },
  {
    "name": "mood",
    "tags": [
      "emoji",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "glad",
      "happiness",
      "happy",
      "like",
      "mood",
      "person",
      "pleased",
      "smile",
      "smiling",
      "social",
      "survey"
    ],
    "popularity": 14046
  },
  {
    "name": "task_alt",
    "tags": [
      "approve",
      "check",
      "circle",
      "complete",
      "done",
      "mark",
      "ok",
      "select",
      "task",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 14031
  },
  {
    "name": "pause_circle",
    "tags": ["circle", "control", "controls", "media", "music", "pause", "video"],
    "popularity": 14001
  },
  {
    "name": "recommend",
    "tags": [
      "approved",
      "circle",
      "confirm",
      "favorite",
      "gesture",
      "hand",
      "like",
      "reaction",
      "recommend",
      "social",
      "support",
      "thumbs",
      "up",
      "well"
    ],
    "popularity": 13997
  },
  {
    "name": "upgrade",
    "tags": ["arrow", "export", "instal", "line", "replace", "up", "update", "upgrade"],
    "popularity": 13963
  },
  {
    "name": "fmd_good",
    "tags": ["destination", "direction", "fmd", "good", "location", "maps", "pin", "place", "stop"],
    "popularity": 13962
  },
  {
    "name": "directions_car_filled",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "directions",
      "filled",
      "maps",
      "public",
      "transportation",
      "vehicle"
    ],
    "popularity": 13941
  },
  {
    "name": "integration_instructions",
    "tags": [
      "brackets",
      "clipboard",
      "code",
      "css",
      "develop",
      "developer",
      "doc",
      "document",
      "engineer",
      "engineering clipboard",
      "html",
      "instructions",
      "integration",
      "platform"
    ],
    "popularity": 13891
  },
  {
    "name": "format_bold",
    "tags": [
      "B",
      "alphabet",
      "bold",
      "character",
      "doc",
      "edit",
      "editing",
      "editor",
      "font",
      "format",
      "letter",
      "sheet",
      "spreadsheet",
      "styles",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 13791
  },
  {
    "name": "trending_down",
    "tags": [
      "analytics",
      "arrow",
      "data",
      "diagram",
      "down",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "movement",
      "rate",
      "rating",
      "statistics",
      "tracking",
      "trending"
    ],
    "popularity": 13781
  },
  {
    "name": "change_history",
    "tags": ["change", "history", "shape", "triangle"],
    "popularity": 13775
  },
  {
    "name": "people_outline",
    "tags": [
      "accounts",
      "committee",
      "face",
      "family",
      "friends",
      "humans",
      "network",
      "outline",
      "people",
      "persons",
      "profiles",
      "social",
      "team",
      "users"
    ],
    "popularity": 13772
  },
  {
    "name": "grid_view",
    "tags": [
      "app",
      "application square",
      "blocks",
      "components",
      "dashboard",
      "design",
      "grid",
      "interface",
      "layout",
      "screen",
      "site",
      "tiles",
      "ui",
      "ux",
      "view",
      "web",
      "website",
      "window"
    ],
    "popularity": 13730
  },
  {
    "name": "female",
    "tags": ["female", "gender", "girl", "lady", "social", "symbol", "woman", "women"],
    "popularity": 13671
  },
  {
    "name": "link_off",
    "tags": [
      "attached",
      "chain",
      "clip",
      "connection",
      "disabled",
      "enabled",
      "link",
      "linked",
      "links",
      "multimedia",
      "off",
      "on",
      "slash",
      "url"
    ],
    "popularity": 13644
  },
  {
    "name": "reviews",
    "tags": [
      "bubble",
      "chat",
      "comment",
      "communicate",
      "feedback",
      "message",
      "rate",
      "rating",
      "recommendation",
      "reviews",
      "speech"
    ],
    "popularity": 13639
  },
  {
    "name": "text_fields",
    "tags": [
      "T",
      "add",
      "alphabet",
      "character",
      "field",
      "fields",
      "font",
      "input",
      "letter",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 13604
  },
  {
    "name": "filter_list",
    "tags": ["filter", "lines", "list", "organize", "sort"],
    "popularity": 13600
  },
  {
    "name": "home_repair_service",
    "tags": [
      "box",
      "equipment",
      "fix",
      "home",
      "kit",
      "mechanic",
      "repair",
      "repairing",
      "service",
      "tool",
      "toolbox",
      "tools",
      "workshop"
    ],
    "popularity": 13560
  },
  {
    "name": "tune",
    "tags": [
      "adjust",
      "audio",
      "controls",
      "custom",
      "customize",
      "edit",
      "editing",
      "filter",
      "filters",
      "instant",
      "mix",
      "music",
      "options",
      "setting",
      "settings",
      "slider",
      "sliders",
      "switches",
      "tune"
    ],
    "popularity": 13558
  },
  {
    "name": "straighten",
    "tags": ["length", "measure", "measurement", "ruler", "size", "straighten"],
    "popularity": 13544
  },
  {
    "name": "subscriptions",
    "tags": ["enroll", "list", "media", "order", "play", "signup", "subscribe", "subscriptions"],
    "popularity": 13541
  },
  {
    "name": "swipe",
    "tags": ["arrow", "arrows", "fingers", "gesture", "hand", "hands", "swipe", "touch"],
    "popularity": 13526
  },
  {
    "name": "video_call",
    "tags": [
      "+",
      "add",
      "call",
      "camera",
      "chat",
      "conference",
      "film",
      "filming",
      "hardware",
      "image",
      "motion",
      "new",
      "picture",
      "plus",
      "symbol",
      "video",
      "videography"
    ],
    "popularity": 13524
  },
  {
    "name": "drive_eta",
    "tags": [
      "automobile",
      "car",
      "cars",
      "destination",
      "direction",
      "drive",
      "estimate",
      "eta",
      "maps",
      "public",
      "transportation",
      "travel",
      "trip",
      "vehicle"
    ],
    "popularity": 13522
  },
  {
    "name": "phone_iphone",
    "tags": ["Android", "OS", "cell", "device", "hardware", "iOS", "iphone", "mobile", "phone", "tablet"],
    "popularity": 13512
  },
  {
    "name": "zoom_out_map",
    "tags": ["arrow", "arrows", "destination", "location", "maps", "move", "out", "place", "stop", "zoom"],
    "popularity": 13491
  },
  {
    "name": "bed",
    "tags": [
      "bed",
      "bedroom",
      "double",
      "full",
      "furniture",
      "home",
      "hotel",
      "house",
      "king",
      "night",
      "pillows",
      "queen",
      "rest",
      "room",
      "size",
      "sleep"
    ],
    "popularity": 13449
  },
  {
    "name": "arrow_drop_down_circle",
    "tags": [
      "app",
      "application",
      "arrow",
      "circle",
      "components",
      "direction",
      "down",
      "drop",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 13435
  },
  {
    "name": "class",
    "tags": [
      "archive",
      "book",
      "bookmark",
      "class",
      "favorite",
      "label",
      "library",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "tag"
    ],
    "popularity": 13401
  },
  {
    "name": "ballot",
    "tags": ["ballot", "bullet", "election", "list", "point", "poll", "vote"],
    "popularity": 13384
  },
  {
    "name": "drafts",
    "tags": ["document", "draft", "drafts", "email", "file", "letter", "mail", "message", "read"],
    "popularity": 13384
  },
  {
    "name": "volume_mute",
    "tags": ["audio", "control", "music", "mute", "sound", "speaker", "tv", "volume"],
    "popularity": 13366
  },
  {
    "name": "stop_circle",
    "tags": ["circle", "control", "controls", "music", "pause", "play", "square", "stop", "video"],
    "popularity": 13334
  },
  {
    "name": "accessible",
    "tags": ["accessibility", "accessible", "body", "handicap", "help", "human", "people", "person", "wheelchair"],
    "popularity": 13300
  },
  {
    "name": "table_rows",
    "tags": ["grid", "layout", "lines", "rows", "stacked", "table"],
    "popularity": 13291
  },
  {
    "name": "family_restroom",
    "tags": ["bathroom", "child", "children", "family", "father", "kids", "mother", "parents", "restroom", "wc"],
    "popularity": 13232
  },
  {
    "name": "title",
    "tags": ["T", "alphabet", "character", "font", "header", "letter", "subject", "symbol", "text", "title", "type"],
    "popularity": 13227
  },
  {
    "name": "checklist_rtl",
    "tags": [
      "align",
      "alignment",
      "approve",
      "check",
      "checklist",
      "complete",
      "doc",
      "done",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "mark",
      "notes",
      "ok",
      "rtl",
      "select",
      "sheet",
      "spreadsheet",
      "text",
      "tick",
      "type",
      "validate",
      "verified",
      "writing",
      "yes"
    ],
    "popularity": 13226
  },
  {
    "name": "insert_emoticon",
    "tags": [
      "account",
      "emoji",
      "emoticon",
      "face",
      "happy",
      "human",
      "insert",
      "people",
      "person",
      "profile",
      "sentiment",
      "smile",
      "user"
    ],
    "popularity": 13221
  },
  {
    "name": "g_translate",
    "tags": [
      "emblem",
      "g",
      "google",
      "language",
      "logo",
      "mark",
      "speaking",
      "speech",
      "translate",
      "translator",
      "words"
    ],
    "popularity": 13202
  },
  {
    "name": "biotech",
    "tags": ["biotech", "chemistry", "laboratory", "microscope", "research", "science", "technology"],
    "popularity": 13195
  },
  {
    "name": "percent",
    "tags": ["math", "number", "percent", "symbol"],
    "popularity": 13193
  },
  {
    "name": "publish",
    "tags": ["arrow", "cloud", "file", "import", "publish", "up", "upload"],
    "popularity": 13188
  },
  {
    "name": "last_page",
    "tags": [
      "app",
      "application",
      "arrow",
      "chevron",
      "components",
      "end",
      "forward",
      "interface",
      "last",
      "page",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 13186
  },
  {
    "name": "repeat",
    "tags": ["arrow", "arrows", "control", "controls", "media", "music", "repeat", "video"],
    "popularity": 13122
  },
  {
    "name": "settings_accessibility",
    "tags": [
      "accessibility",
      "body",
      "details",
      "human",
      "information",
      "people",
      "person",
      "personal",
      "preferences",
      "profile",
      "settings",
      "user"
    ],
    "popularity": 13101
  },
  {
    "name": "wifi_off",
    "tags": [
      "connection",
      "data",
      "disabled",
      "enabled",
      "internet",
      "network",
      "off",
      "offline",
      "on",
      "scan",
      "service",
      "signal",
      "slash",
      "wifi",
      "wireless"
    ],
    "popularity": 13084
  },
  {
    "name": "receipt_long",
    "tags": [
      "bill",
      "check",
      "document",
      "list",
      "long",
      "paper",
      "paperwork",
      "receipt",
      "record",
      "store",
      "transaction"
    ],
    "popularity": 12994
  },
  {
    "name": "event",
    "tags": ["calendar", "date", "day", "event", "mark", "month", "range", "remember", "reminder", "today", "week"],
    "popularity": 12985
  },
  {
    "name": "hotel",
    "tags": ["body", "hotel", "human", "people", "person", "sleep", "stay", "travel", "trip"],
    "popularity": 12982
  },
  {
    "name": "delete_forever",
    "tags": ["bin", "can", "cancel", "delete", "exit", "forever", "garbage", "remove", "trash", "x"],
    "popularity": 12963
  },
  {
    "name": "insert_photo",
    "tags": ["image", "insert", "landscape", "mountain", "mountains", "photo", "photography", "picture"],
    "popularity": 12952
  },
  {
    "name": "cleaning_services",
    "tags": ["clean", "cleaning", "dust", "services", "sweep"],
    "popularity": 12943
  },
  {
    "name": "handshake",
    "tags": ["agreement", "hand", "hands", "partnership", "shake"],
    "popularity": 12931
  },
  {
    "name": "downloading",
    "tags": [
      "arrow",
      "circle",
      "down",
      "download",
      "downloading",
      "downloads",
      "install",
      "pending",
      "progress",
      "upload"
    ],
    "popularity": 12877
  },
  {
    "name": "expand",
    "tags": ["arrow", "arrows", "compress", "enlarge", "expand", "grow", "move", "push", "together"],
    "popularity": 12851
  },
  {
    "name": "local_phone",
    "tags": ["booth", "call", "communication", "phone", "telecommunication"],
    "popularity": 12843
  },
  {
    "name": "offline_bolt",
    "tags": ["bolt", "circle", "electric", "fast", "lightning", "offline", "thunderbolt"],
    "popularity": 12838
  },
  {
    "name": "air",
    "tags": ["air", "blowing", "breeze", "flow", "wave", "weather", "wind"],
    "popularity": 12816
  },
  {
    "name": "bookmark",
    "tags": [
      "archive",
      "bookmark",
      "favorite",
      "label",
      "library",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "tag"
    ],
    "popularity": 12786
  },
  {
    "name": "auto_graph",
    "tags": [
      "analytics",
      "auto",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "line",
      "measure",
      "metrics",
      "stars",
      "statistics",
      "tracking"
    ],
    "popularity": 12764
  },
  {
    "name": "photo_library",
    "tags": ["album", "image", "library", "mountain", "mountains", "photo", "photography", "picture"],
    "popularity": 12749
  },
  {
    "name": "settings_backup_restore",
    "tags": ["arrow", "back", "backup", "backwards", "refresh", "restore", "reverse", "rotate", "settings"],
    "popularity": 12738
  },
  {
    "name": "local_grocery_store",
    "tags": ["grocery", "market", "shop", "store"],
    "popularity": 12726
  },
  {
    "name": "miscellaneous_services",
    "tags": [],
    "popularity": 12720
  },
  {
    "name": "note_alt",
    "tags": ["alt", "clipboard", "document", "file", "memo", "note", "page", "paper", "writing"],
    "popularity": 12717
  },
  {
    "name": "production_quantity_limits",
    "tags": [
      "!",
      "alert",
      "attention",
      "bill",
      "card",
      "cart",
      "cash",
      "caution",
      "coin",
      "commerce",
      "credit",
      "currency",
      "danger",
      "dollars",
      "error",
      "exclamation",
      "important",
      "limits",
      "mark",
      "money",
      "notification",
      "online",
      "pay",
      "payment",
      "production",
      "quantity",
      "shopping",
      "symbol",
      "warning"
    ],
    "popularity": 12659
  },
  {
    "name": "recycling",
    "tags": [
      "bio",
      "eco",
      "green",
      "loop",
      "recyclable",
      "recycle",
      "recycling",
      "rotate",
      "sustainability",
      "sustainable",
      "trash"
    ],
    "popularity": 12649
  },
  {
    "name": "person_off",
    "tags": [
      "account",
      "avatar",
      "disabled",
      "enabled",
      "face",
      "human",
      "off",
      "on",
      "people",
      "person",
      "profile",
      "slash",
      "user"
    ],
    "popularity": 12633
  },
  {
    "name": "support_agent",
    "tags": ["agent", "care", "customer", "face", "headphone", "person", "representative", "service", "support"],
    "popularity": 12631
  },
  {
    "name": "report_gmailerrorred",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "gmail",
      "gmailerrorred",
      "important",
      "mark",
      "notification",
      "octagon",
      "report",
      "symbol",
      "warning"
    ],
    "popularity": 12620
  },
  {
    "name": "map",
    "tags": ["destination", "direction", "location", "map", "maps", "pin", "place", "route", "stop", "travel"],
    "popularity": 12592
  },
  {
    "name": "camera",
    "tags": ["aperture", "camera", "lens", "photo", "photography", "picture", "shutter"],
    "popularity": 12541
  },
  {
    "name": "face",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 12433
  },
  {
    "name": "male",
    "tags": ["boy", "gender", "male", "man", "social", "symbol"],
    "popularity": 12414
  },
  {
    "name": "not_interested",
    "tags": ["cancel", "close", "dislike", "exit", "interested", "no", "not", "off", "quit", "remove", "stop", "x"],
    "popularity": 12395
  },
  {
    "name": "arrow_circle_left",
    "tags": ["arrow", "circle", "direction", "left", "navigation"],
    "popularity": 12384
  },
  {
    "name": "attach_money",
    "tags": [
      "attach",
      "attachment",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "symbol"
    ],
    "popularity": 12383
  },
  {
    "name": "event_busy",
    "tags": [
      "busy",
      "calendar",
      "cancel",
      "close",
      "date",
      "event",
      "exit",
      "no",
      "remove",
      "schedule",
      "stop",
      "time",
      "unavailable",
      "x"
    ],
    "popularity": 12351
  },
  {
    "name": "shuffle",
    "tags": ["arrow", "arrows", "control", "controls", "music", "random", "shuffle", "video"],
    "popularity": 12264
  },
  {
    "name": "aspect_ratio",
    "tags": ["aspect", "expand", "image", "ratio", "resize", "scale", "size", "square"],
    "popularity": 12260
  },
  {
    "name": "other_houses",
    "tags": [
      "architecture",
      "cottage",
      "estate",
      "home",
      "house",
      "houses",
      "maps",
      "other",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling"
    ],
    "popularity": 12211
  },
  {
    "name": "insert_chart_outlined",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "insert",
      "measure",
      "metrics",
      "outlined",
      "statistics",
      "tracking"
    ],
    "popularity": 12198
  },
  {
    "name": "model_training",
    "tags": [
      "arrow",
      "bulb",
      "idea",
      "inprogress",
      "light",
      "load",
      "loading",
      "model",
      "refresh",
      "renew",
      "restore",
      "reverse",
      "rotate",
      "training"
    ],
    "popularity": 12198
  },
  {
    "name": "unfold_less",
    "tags": [
      "arrow",
      "arrows",
      "chevron",
      "collapse",
      "direction",
      "expand",
      "expandable",
      "inward",
      "less",
      "list",
      "navigation",
      "unfold",
      "up"
    ],
    "popularity": 12196
  },
  {
    "name": "autorenew",
    "tags": [
      "around",
      "arrow",
      "arrows",
      "autorenew",
      "cache",
      "cached",
      "direction",
      "inprogress",
      "load",
      "loading refresh",
      "navigation",
      "renew",
      "rotate",
      "turn"
    ],
    "popularity": 12171
  },
  {
    "name": "view_column",
    "tags": ["column", "design", "format", "grid", "layout", "vertical", "view", "website"],
    "popularity": 12146
  },
  {
    "name": "donut_large",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "donut",
      "graph",
      "infographic",
      "inprogress",
      "large",
      "measure",
      "metrics",
      "pie",
      "statistics",
      "tracking"
    ],
    "popularity": 12142
  },
  {
    "name": "forum",
    "tags": [
      "bubble",
      "chat",
      "comment",
      "communicate",
      "community",
      "conversation",
      "feedback",
      "forum",
      "hub",
      "message",
      "speech"
    ],
    "popularity": 12076
  },
  {
    "name": "segment",
    "tags": [
      "alignment",
      "fonts",
      "format",
      "lines",
      "list",
      "paragraph",
      "part",
      "piece",
      "rule",
      "rules",
      "segment",
      "style",
      "text"
    ],
    "popularity": 12075
  },
  {
    "name": "checkroom",
    "tags": ["checkroom", "closet", "clothes", "coat check", "hanger"],
    "popularity": 12041
  },
  {
    "name": "mode",
    "tags": ["compose", "create", "draft", "draw", "edit", "mode", "pen", "pencil", "write"],
    "popularity": 12021
  },
  {
    "name": "portrait",
    "tags": ["account", "face", "human", "people", "person", "photo", "picture", "portrait", "profile", "user"],
    "popularity": 12006
  },
  {
    "name": "keyboard_double_arrow_left",
    "tags": ["arrow", "arrows", "direction", "double", "left", "multiple", "navigation"],
    "popularity": 11908
  },
  {
    "name": "hub",
    "tags": ["center", "connection", "core", "focal point", "hub", "network", "nucleus", "topology"],
    "popularity": 11904
  },
  {
    "name": "delete_sweep",
    "tags": ["bin", "can", "delete", "garbage", "remove", "sweep", "trash"],
    "popularity": 11851
  },
  {
    "name": "camera_alt",
    "tags": ["alt", "camera", "image", "photo", "photography", "picture"],
    "popularity": 11837
  },
  {
    "name": "draw",
    "tags": [
      "compose",
      "create",
      "design",
      "draft",
      "draw",
      "edit",
      "editing",
      "input",
      "pen",
      "pencil",
      "write",
      "writing"
    ],
    "popularity": 11826
  },
  {
    "name": "audiotrack",
    "tags": ["audio", "audiotrack", "key", "music", "note", "sound", "track"],
    "popularity": 11742
  },
  {
    "name": "calendar_view_month",
    "tags": ["calendar", "date", "day", "event", "format", "grid", "layout", "month", "schedule", "today", "view"],
    "popularity": 11720
  },
  {
    "name": "folder_shared",
    "tags": [
      "account",
      "collaboration",
      "data",
      "doc",
      "document",
      "drive",
      "face",
      "file",
      "folder",
      "human",
      "people",
      "person",
      "profile",
      "share",
      "shared",
      "sheet",
      "slide",
      "storage",
      "team",
      "user"
    ],
    "popularity": 11671
  },
  {
    "name": "navigation",
    "tags": ["destination", "direction", "location", "maps", "navigation", "pin", "place", "point", "stop"],
    "popularity": 11651
  },
  {
    "name": "dark_mode",
    "tags": [
      "app",
      "application",
      "dark",
      "device",
      "interface",
      "mode",
      "moon",
      "night",
      "silent",
      "theme",
      "ui",
      "ux",
      "website"
    ],
    "popularity": 11646
  },
  {
    "name": "read_more",
    "tags": ["arrow", "more", "read", "text"],
    "popularity": 11623
  },
  {
    "name": "stacked_bar_chart",
    "tags": [
      "analytics",
      "bar",
      "chart-chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "stacked",
      "statistics",
      "tracking"
    ],
    "popularity": 11515
  },
  {
    "name": "storefront",
    "tags": [
      "business",
      "buy",
      "cafe",
      "commerce",
      "front",
      "market",
      "places",
      "restaurant",
      "retail",
      "sell",
      "shop",
      "shopping",
      "store",
      "storefront"
    ],
    "popularity": 11511
  },
  {
    "name": "light_mode",
    "tags": ["bright", "brightness", "day", "device", "light", "lighting", "mode", "morning", "sky", "sun", "sunny"],
    "popularity": 11502
  },
  {
    "name": "bluetooth",
    "tags": ["bluetooth", "cast", "connect", "connection", "device", "paring", "streaming", "symbol", "wireless"],
    "popularity": 11496
  },
  {
    "name": "mic",
    "tags": ["hear", "hearing", "mic", "microphone", "noise", "record", "sound", "voice"],
    "popularity": 11484
  },
  {
    "name": "save",
    "tags": ["data", "disk", "document", "drive", "file", "floppy", "multimedia", "save", "storage"],
    "popularity": 11469
  },
  {
    "name": "mode_comment",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "mode comment", "speech"],
    "popularity": 11468
  },
  {
    "name": "schedule_send",
    "tags": ["calendar", "clock", "date", "email", "letter", "mail", "remember", "schedule", "send", "share", "time"],
    "popularity": 11467
  },
  {
    "name": "graphic_eq",
    "tags": [
      "audio",
      "detect",
      "detection",
      "eq",
      "equalizer",
      "graphic",
      "music",
      "noise",
      "recording",
      "sound",
      "voice"
    ],
    "popularity": 11451
  },
  {
    "name": "person_add_alt_1",
    "tags": [],
    "popularity": 11437
  },
  {
    "name": "markunread",
    "tags": ["email", "envelop", "letter", "mail", "markunread", "message", "send", "unread"],
    "popularity": 11422
  },
  {
    "name": "key",
    "tags": ["key", "lock", "password", "unlock"],
    "popularity": 11397
  },
  {
    "name": "alarm_on",
    "tags": [
      "alarm",
      "alert",
      "bell",
      "clock",
      "disabled",
      "duration",
      "enabled",
      "notification",
      "off",
      "on",
      "slash",
      "time",
      "timer",
      "watch"
    ],
    "popularity": 11389
  },
  {
    "name": "local_gas_station",
    "tags": ["auto", "car", "gas", "local", "oil", "station", "vehicle"],
    "popularity": 11380
  },
  {
    "name": "calendar_today",
    "tags": ["calendar", "date", "day", "event", "month", "schedule", "today"],
    "popularity": 11374
  },
  {
    "name": "list",
    "tags": ["file", "format", "index", "list", "menu", "options"],
    "popularity": 11373
  },
  {
    "name": "maximize",
    "tags": [
      "app",
      "application",
      "components",
      "design",
      "interface",
      "line",
      "maximize",
      "screen",
      "shape",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 11337
  },
  {
    "name": "sell",
    "tags": [
      "bill",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "sell",
      "shopping",
      "tag"
    ],
    "popularity": 11295
  },
  {
    "name": "trending_up",
    "tags": [
      "analytics",
      "arrow",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "movement",
      "rate",
      "rating",
      "statistics",
      "tracking",
      "trending",
      "up"
    ],
    "popularity": 11294
  },
  {
    "name": "badge",
    "tags": [
      "account",
      "avatar",
      "badge",
      "card",
      "certified",
      "employee",
      "face",
      "human",
      "identification",
      "name",
      "people",
      "person",
      "profile",
      "security",
      "user",
      "work"
    ],
    "popularity": 11250
  },
  {
    "name": "dvr",
    "tags": [
      "Android",
      "OS",
      "audio",
      "chrome",
      "computer",
      "desktop",
      "device",
      "display",
      "dvr",
      "electronic",
      "hardware",
      "iOS",
      "list",
      "mac",
      "monitor",
      "record",
      "recorder",
      "screen",
      "tv",
      "video",
      "web",
      "window"
    ],
    "popularity": 11240
  },
  {
    "name": "do_not_disturb_on",
    "tags": [
      "cancel",
      "close",
      "denied",
      "deny",
      "disabled",
      "disturb",
      "do",
      "enabled",
      "off",
      "on",
      "remove",
      "silence",
      "slash",
      "stop"
    ],
    "popularity": 11231
  },
  {
    "name": "train",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "maps",
      "public",
      "rail",
      "subway",
      "train",
      "transportation",
      "vehicle"
    ],
    "popularity": 11224
  },
  {
    "name": "bookmark_add",
    "tags": ["+", "add", "bookmark", "favorite", "plus", "remember", "ribbon", "save", "symbol"],
    "popularity": 11217
  },
  {
    "name": "document_scanner",
    "tags": [
      "article",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "notes",
      "page",
      "paper",
      "scan",
      "scanner",
      "sheet",
      "slide",
      "text",
      "writing"
    ],
    "popularity": 11167
  },
  {
    "name": "person_pin_circle",
    "tags": [
      "account",
      "circle",
      "destination",
      "direction",
      "face",
      "human",
      "location",
      "maps",
      "people",
      "person",
      "pin",
      "place",
      "profile",
      "stop",
      "user"
    ],
    "popularity": 11163
  },
  {
    "name": "square_foot",
    "tags": [
      "construction",
      "feet",
      "foot",
      "inches",
      "length",
      "measurement",
      "ruler",
      "school",
      "set",
      "square",
      "tools"
    ],
    "popularity": 11161
  },
  {
    "name": "thumbs_up_down",
    "tags": ["dislike", "down", "favorite", "fingers", "gesture", "hands", "like", "rate", "rating", "thumbs", "up"],
    "popularity": 11135
  },
  {
    "name": "more_time",
    "tags": ["+", "add", "clock", "date", "more", "new", "plus", "schedule", "symbol", "time"],
    "popularity": 11109
  },
  {
    "name": "timer",
    "tags": [
      "alarm",
      "alert",
      "bell",
      "clock",
      "disabled",
      "duration",
      "enabled",
      "notification",
      "off",
      "on",
      "slash",
      "stop",
      "time",
      "timer",
      "watch"
    ],
    "popularity": 11079
  },
  {
    "name": "settings_ethernet",
    "tags": [
      "arrows",
      "computer",
      "connect",
      "connection",
      "connectivity",
      "dots",
      "ethernet",
      "internet",
      "network",
      "settings",
      "wifi"
    ],
    "popularity": 11075
  },
  {
    "name": "sort_by_alpha",
    "tags": [
      "alphabet",
      "alphabetize",
      "az",
      "by alpha",
      "character",
      "font",
      "letter",
      "list",
      "order",
      "organize",
      "sort",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 11016
  },
  {
    "name": "info_outline",
    "tags": [
      "alert",
      "announcement",
      "assistance",
      "details",
      "help",
      "i",
      "info",
      "information",
      "outline",
      "service",
      "support"
    ],
    "popularity": 11009
  },
  {
    "name": "theaters",
    "tags": ["film", "movie", "movies", "show", "showtimes", "theater", "theaters", "watch"],
    "popularity": 10990
  },
  {
    "name": "local_parking",
    "tags": [
      "alphabet",
      "auto",
      "car",
      "character",
      "font",
      "garage",
      "letter",
      "local",
      "park",
      "parking",
      "symbol",
      "text",
      "type",
      "vehicle"
    ],
    "popularity": 10979
  },
  {
    "name": "cloud_done",
    "tags": [
      "app",
      "application",
      "approve",
      "backup",
      "check",
      "cloud",
      "complete",
      "connection",
      "done",
      "drive",
      "files",
      "folders",
      "internet",
      "mark",
      "network",
      "ok",
      "select",
      "sky",
      "storage",
      "tick",
      "upload",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 10965
  },
  {
    "name": "view_agenda",
    "tags": ["agenda", "cards", "design", "format", "grid", "layout", "stacked", "view", "website"],
    "popularity": 10954
  },
  {
    "name": "apartment",
    "tags": [
      "accommodation",
      "apartment",
      "architecture",
      "building",
      "city",
      "company",
      "estate",
      "flat",
      "home",
      "house",
      "office",
      "places",
      "real",
      "residence",
      "residential",
      "shelter",
      "units",
      "workplace"
    ],
    "popularity": 10942
  },
  {
    "name": "mark_email_unread",
    "tags": [
      "check",
      "circle",
      "email",
      "envelop",
      "letter",
      "mail",
      "mark",
      "message",
      "note",
      "notification",
      "send",
      "unread"
    ],
    "popularity": 10920
  },
  {
    "name": "local_florist",
    "tags": ["florist", "flower", "local", "shop"],
    "popularity": 10879
  },
  {
    "name": "arrow_downward",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "down",
      "downward",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 10870
  },
  {
    "name": "connect_without_contact",
    "tags": ["communicating", "connect", "contact", "distance", "people", "signal", "social", "socialize", "without"],
    "popularity": 10868
  },
  {
    "name": "sync",
    "tags": [
      "360",
      "around",
      "arrow",
      "arrows",
      "direction",
      "inprogress",
      "load",
      "loading refresh",
      "renew",
      "rotate",
      "sync",
      "turn"
    ],
    "popularity": 10855
  },
  {
    "name": "thumb_down_off_alt",
    "tags": [
      "disabled",
      "dislike",
      "down",
      "enabled",
      "favorite",
      "filled",
      "fingers",
      "gesture",
      "hand",
      "hands",
      "like",
      "off",
      "offline",
      "on",
      "rank",
      "ranking",
      "rate",
      "rating",
      "slash",
      "thumb"
    ],
    "popularity": 10838
  },
  {
    "name": "sentiment_satisfied",
    "tags": [
      "emotions",
      "expressions",
      "face",
      "feelings",
      "glad",
      "happiness",
      "happy",
      "like",
      "mood",
      "person",
      "pleased",
      "satisfied",
      "sentiment",
      "smile",
      "smiling",
      "survey"
    ],
    "popularity": 10834
  },
  {
    "name": "call_end",
    "tags": ["call", "cell", "contact", "device", "end", "hardware", "mobile", "phone", "telephone"],
    "popularity": 10824
  },
  {
    "name": "sentiment_neutral",
    "tags": [
      "emotionless",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "fine",
      "indifference",
      "mood",
      "neutral",
      "okay",
      "person",
      "sentiment",
      "survey"
    ],
    "popularity": 10819
  },
  {
    "name": "sort",
    "tags": ["filter", "find", "lines", "list", "organize", "sort"],
    "popularity": 10800
  },
  {
    "name": "account_balance",
    "tags": [
      "account",
      "balance",
      "bank",
      "bill",
      "building",
      "card",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "finance",
      "government",
      "money",
      "online",
      "pay",
      "payment"
    ],
    "popularity": 10770
  },
  {
    "name": "monitor_heart",
    "tags": ["baseline", "device", "ecc", "ecg", "fitness", "health", "heart", "medical", "monitor", "track"],
    "popularity": 10767
  },
  {
    "name": "block",
    "tags": ["avoid", "block", "cancel", "close", "entry", "exit", "no", "prohibited", "quit", "remove", "stop"],
    "popularity": 10754
  },
  {
    "name": "diamond",
    "tags": ["diamond", "fashion", "gems", "jewelry", "logo", "retail", "valuable", "valuables"],
    "popularity": 10754
  },
  {
    "name": "subdirectory_arrow_right",
    "tags": ["arrow", "directory", "down", "navigation", "right", "sub", "subdirectory"],
    "popularity": 10753
  },
  {
    "name": "inventory_2",
    "tags": ["archive", "box", "file", "inventory", "organize", "packages", "product", "stock", "storage", "supply"],
    "popularity": 10690
  },
  {
    "name": "add_box",
    "tags": ["add", "box", "new square", "plus", "symbol"],
    "popularity": 10627
  },
  {
    "name": "all_inclusive",
    "tags": [
      "all",
      "endless",
      "forever",
      "inclusive",
      "infinity",
      "loop",
      "mobius",
      "neverending",
      "strip",
      "sustainability",
      "sustainable"
    ],
    "popularity": 10587
  },
  {
    "name": "grass",
    "tags": ["backyard", "fodder", "grass", "ground", "home", "lawn", "plant", "turf", "yard"],
    "popularity": 10579
  },
  {
    "name": "important_devices",
    "tags": [
      "Android",
      "OS",
      "desktop",
      "devices",
      "hardware",
      "iOS",
      "important",
      "mobile",
      "monitor",
      "phone",
      "star",
      "tablet",
      "web"
    ],
    "popularity": 10573
  },
  {
    "name": "wc",
    "tags": ["bathroom", "closet", "female", "male", "man", "restroom", "room", "wash", "water", "wc", "women"],
    "popularity": 10565
  },
  {
    "name": "podcasts",
    "tags": ["broadcast", "casting", "network", "podcasts", "signal", "transmitting", "wireless"],
    "popularity": 10563
  },
  {
    "name": "hiking",
    "tags": [
      "backpacking",
      "bag",
      "climbing",
      "duffle",
      "hiking",
      "mountain",
      "social",
      "sports",
      "stick",
      "trail",
      "travel",
      "walking"
    ],
    "popularity": 10533
  },
  {
    "name": "home_pin",
    "tags": ["destination", "direction", "home", "house", "location", "maps", "pin", "place", "stop"],
    "popularity": 10528
  },
  {
    "name": "back_hand",
    "tags": ["back", "fingers", "gesture", "hand", "raised"],
    "popularity": 10520
  },
  {
    "name": "work",
    "tags": ["bag", "baggage", "briefcase", "business", "case", "job", "suitcase", "work"],
    "popularity": 10514
  },
  {
    "name": "arrow_back_ios_new",
    "tags": [
      "DISABLE_IOS",
      "app",
      "application",
      "arrow",
      "back",
      "chevron",
      "components",
      "direction",
      "disable_ios",
      "interface",
      "ios",
      "left",
      "navigation",
      "new",
      "previous",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 10501
  },
  {
    "name": "videocam",
    "tags": [
      "cam",
      "camera",
      "conference",
      "film",
      "filming",
      "hardware",
      "image",
      "motion",
      "picture",
      "video",
      "videography"
    ],
    "popularity": 10464
  },
  {
    "name": "local_post_office",
    "tags": [
      "delivery",
      "email",
      "envelop",
      "letter",
      "local",
      "mail",
      "message",
      "office",
      "package",
      "parcel",
      "post",
      "postal",
      "send",
      "stamp"
    ],
    "popularity": 10462
  },
  {
    "name": "waving_hand",
    "tags": ["bye", "fingers", "gesture", "goodbye", "greetings", "hand", "hello", "palm", "wave", "waving"],
    "popularity": 10455
  },
  {
    "name": "verified_user",
    "tags": [
      "approve",
      "certified",
      "check",
      "complete",
      "done",
      "mark",
      "ok",
      "privacy",
      "private",
      "protect",
      "protection",
      "security",
      "select",
      "shield",
      "tick",
      "user",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 10446
  },
  {
    "name": "functions",
    "tags": [
      "average",
      "calculate",
      "count",
      "custom",
      "doc",
      "edit",
      "editing",
      "editor",
      "functions",
      "math",
      "sheet",
      "spreadsheet",
      "style",
      "sum",
      "text",
      "type",
      "writing"
    ],
    "popularity": 10444
  },
  {
    "name": "architecture",
    "tags": ["architecture", "art", "compass", "design", "draw", "drawing", "engineering", "geometric", "tool"],
    "popularity": 10428
  },
  {
    "name": "smartphone",
    "tags": [
      "Android",
      "OS",
      "call",
      "cell",
      "chat",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "smartphone",
      "tablet",
      "text"
    ],
    "popularity": 10415
  },
  {
    "name": "directions",
    "tags": ["arrow", "directions", "maps", "right", "route", "sign", "traffic"],
    "popularity": 10413
  },
  {
    "name": "money",
    "tags": [
      "100",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "digit",
      "dollars",
      "finance",
      "money",
      "number",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 10402
  },
  {
    "name": "masks",
    "tags": [
      "air",
      "cover",
      "covid",
      "face",
      "hospital",
      "masks",
      "medical",
      "pollution",
      "protection",
      "respirator",
      "sick",
      "social"
    ],
    "popularity": 10394
  },
  {
    "name": "wifi",
    "tags": ["connection", "data", "internet", "network", "scan", "service", "signal", "wifi", "wireless"],
    "popularity": 10382
  },
  {
    "name": "paid",
    "tags": ["circle", "currency", "money", "paid", "payment", "transaction"],
    "popularity": 10379
  },
  {
    "name": "unpublished",
    "tags": [
      "approve",
      "check",
      "circle",
      "complete",
      "disabled",
      "done",
      "enabled",
      "mark",
      "off",
      "ok",
      "on",
      "select",
      "slash",
      "tick",
      "unpublished",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 10328
  },
  {
    "name": "airport_shuttle",
    "tags": [
      "airport",
      "automobile",
      "car",
      "cars",
      "commercial",
      "delivery",
      "direction",
      "maps",
      "mini",
      "public",
      "shuttle",
      "transport",
      "transportation",
      "travel",
      "truck",
      "van",
      "vehicle"
    ],
    "popularity": 10299
  },
  {
    "name": "notifications_off",
    "tags": [
      "active",
      "alarm",
      "alert",
      "bell",
      "chime",
      "disabled",
      "enabled",
      "notifications",
      "notify",
      "off",
      "offline",
      "on",
      "reminder",
      "ring",
      "slash",
      "sound"
    ],
    "popularity": 10285
  },
  {
    "name": "thumb_down_alt",
    "tags": [
      "bad",
      "decline",
      "disapprove",
      "dislike",
      "down",
      "feedback",
      "hate",
      "negative",
      "no",
      "reject",
      "social",
      "thumb",
      "veto",
      "vote"
    ],
    "popularity": 10245
  },
  {
    "name": "keyboard_double_arrow_down",
    "tags": ["arrow", "arrows", "direction", "double", "down", "multiple", "navigation"],
    "popularity": 10243
  },
  {
    "name": "two_wheeler",
    "tags": [
      "automobile",
      "bike",
      "car",
      "cars",
      "direction",
      "maps",
      "motorcycle",
      "public",
      "scooter",
      "sport",
      "transportation",
      "travel",
      "two wheeler",
      "vehicle"
    ],
    "popularity": 10221
  },
  {
    "name": "insert_link",
    "tags": ["add", "attach", "clip", "file", "insert", "link", "mail", "media"],
    "popularity": 10203
  },
  {
    "name": "nightlight",
    "tags": ["dark", "disturb", "mode", "moon", "night", "nightlight", "sleep"],
    "popularity": 10162
  },
  {
    "name": "clear_all",
    "tags": ["all", "clear", "doc", "document", "format", "lines", "list"],
    "popularity": 10137
  },
  {
    "name": "mic_none",
    "tags": ["hear", "hearing", "mic", "microphone", "noise", "none", "record", "sound", "voice"],
    "popularity": 10127
  },
  {
    "name": "account_balance_wallet",
    "tags": [
      "account",
      "balance",
      "bank",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "wallet"
    ],
    "popularity": 10117
  },
  {
    "name": "restart_alt",
    "tags": [
      "alt",
      "around",
      "arrow",
      "inprogress",
      "load",
      "loading refresh",
      "reboot",
      "renew",
      "repeat",
      "reset",
      "restart"
    ],
    "popularity": 10106
  },
  {
    "name": "invert_colors",
    "tags": ["colors", "drop", "droplet", "edit", "editing", "hue", "invert", "inverted", "palette", "tone", "water"],
    "popularity": 10103
  },
  {
    "name": "mouse",
    "tags": ["click", "computer", "cursor", "device", "hardware", "mouse", "wireless"],
    "popularity": 10092
  },
  {
    "name": "opacity",
    "tags": ["color", "drop", "droplet", "hue", "invert", "inverted", "opacity", "palette", "tone", "water"],
    "popularity": 9997
  },
  {
    "name": "volume_up",
    "tags": ["audio", "control", "music", "sound", "speaker", "tv", "up", "volume"],
    "popularity": 9995
  },
  {
    "name": "analytics",
    "tags": [
      "analytics",
      "assessment",
      "bar",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 9991
  },
  {
    "name": "mode_edit_outline",
    "tags": ["compose", "create", "draft", "draw", "edit", "mode", "outline", "pen", "pencil", "write"],
    "popularity": 9981
  },
  {
    "name": "fast_rewind",
    "tags": ["back", "control", "fast", "media", "music", "play", "rewind", "speed", "time", "tv", "video"],
    "popularity": 9970
  },
  {
    "name": "commute",
    "tags": [
      "automobile",
      "car",
      "commute",
      "direction",
      "maps",
      "public",
      "train",
      "transportation",
      "trip",
      "vehicle"
    ],
    "popularity": 9966
  },
  {
    "name": "open_in_browser",
    "tags": ["arrow", "browser", "in", "open", "site", "up", "web", "website", "window"],
    "popularity": 9962
  },
  {
    "name": "folder",
    "tags": ["data", "doc", "document", "drive", "file", "folder", "folders", "sheet", "slide", "storage"],
    "popularity": 9957
  },
  {
    "name": "insert_invitation",
    "tags": [
      "calendar",
      "date",
      "day",
      "event",
      "insert",
      "invitation",
      "mark",
      "month",
      "range",
      "remember",
      "reminder",
      "today",
      "week"
    ],
    "popularity": 9951
  },
  {
    "name": "workspaces",
    "tags": ["circles", "collaboration", "dot", "filled", "group", "outline", "space", "team", "work", "workspaces"],
    "popularity": 9932
  },
  {
    "name": "no_accounts",
    "tags": [
      "account",
      "accounts",
      "avatar",
      "disabled",
      "enabled",
      "face",
      "human",
      "no",
      "off",
      "offline",
      "on",
      "people",
      "person",
      "profile",
      "slash",
      "thumbnail",
      "unavailable",
      "unidentifiable",
      "unknown",
      "user"
    ],
    "popularity": 9927
  },
  {
    "name": "addchart",
    "tags": [
      "+",
      "addchart",
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "new",
      "plus",
      "statistics",
      "symbol",
      "tracking"
    ],
    "popularity": 9926
  },
  {
    "name": "video_camera_front",
    "tags": [
      "account",
      "camera",
      "face",
      "front",
      "human",
      "image",
      "people",
      "person",
      "photo",
      "photography",
      "picture",
      "profile",
      "user",
      "video"
    ],
    "popularity": 9925
  },
  {
    "name": "luggage",
    "tags": ["airport", "bag", "baggage", "carry", "flight", "hotel", "luggage", "on", "suitcase", "travel", "trip"],
    "popularity": 9914
  },
  {
    "name": "coffee",
    "tags": ["beverage", "coffee", "cup", "drink", "mug", "plate", "set", "tea"],
    "popularity": 9907
  },
  {
    "name": "child_care",
    "tags": ["babies", "baby", "care", "child", "children", "face", "infant", "kids", "newborn", "toddler", "young"],
    "popularity": 9891
  },
  {
    "name": "rocket_launch",
    "tags": ["launch", "rocket", "space", "spaceship", "takeoff"],
    "popularity": 9888
  },
  {
    "name": "system_update_alt",
    "tags": ["arrow", "down", "download", "export", "system", "update"],
    "popularity": 9863
  },
  {
    "name": "history_toggle_off",
    "tags": ["clock", "date", "history", "off", "schedule", "time", "toggle"],
    "popularity": 9861
  },
  {
    "name": "sports_score",
    "tags": ["destination", "flag", "goal", "score", "sports"],
    "popularity": 9851
  },
  {
    "name": "rotate_right",
    "tags": [
      "around",
      "arrow",
      "direction",
      "inprogress",
      "load",
      "loading refresh",
      "renew",
      "right",
      "rotate",
      "turn"
    ],
    "popularity": 9822
  },
  {
    "name": "library_music",
    "tags": ["add", "album", "collection", "library", "music", "song", "sounds"],
    "popularity": 9811
  },
  {
    "name": "cloud_queue",
    "tags": [
      "climate",
      "cloud",
      "connection",
      "internet",
      "network",
      "queue",
      "sky",
      "temperature",
      "upload",
      "weather"
    ],
    "popularity": 9801
  },
  {
    "name": "access_time",
    "tags": [],
    "popularity": 9793
  },
  {
    "name": "color_lens",
    "tags": ["art", "color", "lens", "paint", "pallet"],
    "popularity": 9782
  },
  {
    "name": "real_estate_agent",
    "tags": [
      "agent",
      "architecture",
      "broker",
      "estate",
      "hand",
      "home",
      "house",
      "loan",
      "mortgage",
      "property",
      "real",
      "residence",
      "residential",
      "sales",
      "social"
    ],
    "popularity": 9771
  },
  {
    "name": "directions_car",
    "tags": ["automobile", "car", "cars", "direction", "directions", "maps", "public", "transportation", "vehicle"],
    "popularity": 9752
  },
  {
    "name": "grid_on",
    "tags": ["collage", "disabled", "enabled", "grid", "image", "layout", "off", "on", "slash", "view"],
    "popularity": 9733
  },
  {
    "name": "crop_free",
    "tags": [
      "adjust",
      "adjustments",
      "crop",
      "edit",
      "editing",
      "focus",
      "frame",
      "free",
      "image",
      "photo",
      "photos",
      "settings",
      "size",
      "zoom"
    ],
    "popularity": 9717
  },
  {
    "name": "view_week",
    "tags": ["bars", "columns", "design", "format", "grid", "layout", "view", "website", "week"],
    "popularity": 9695
  },
  {
    "name": "format_align_left",
    "tags": [
      "align",
      "alignment",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "left",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 9690
  },
  {
    "name": "keyboard_voice",
    "tags": ["keyboard", "mic", "microphone", "noise", "record", "recorder", "speaker", "voice"],
    "popularity": 9688
  },
  {
    "name": "horizontal_rule",
    "tags": ["gmail", "horizontal", "line", "novitas", "rule"],
    "popularity": 9669
  },
  {
    "name": "phone_in_talk",
    "tags": [
      "call",
      "cell",
      "connection",
      "contact",
      "data",
      "device",
      "hardware",
      "in",
      "mobile",
      "network",
      "phone",
      "scan",
      "service",
      "signal",
      "sound",
      "speaker",
      "talk",
      "telephone",
      "waves",
      "wireless"
    ],
    "popularity": 9660
  },
  {
    "name": "add_business",
    "tags": [
      "+",
      "add",
      "bill",
      "building",
      "business",
      "card",
      "cash",
      "coin",
      "commerce",
      "company",
      "credit",
      "currency",
      "dollars",
      "market",
      "money",
      "new",
      "online",
      "pay",
      "payment",
      "plus",
      "shop",
      "shopping",
      "store",
      "storefront",
      "symbol"
    ],
    "popularity": 9602
  },
  {
    "name": "topic",
    "tags": ["data", "doc", "document", "drive", "file", "folder", "sheet", "slide", "storage", "topic"],
    "popularity": 9602
  },
  {
    "name": "format_italic",
    "tags": [
      "alphabet",
      "character",
      "doc",
      "edit",
      "editing",
      "editor",
      "font",
      "format",
      "italic",
      "letter",
      "sheet",
      "spreadsheet",
      "style",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 9601
  },
  {
    "name": "shower",
    "tags": [
      "bath",
      "bathroom",
      "closet",
      "home",
      "house",
      "place",
      "plumbing",
      "room",
      "shower",
      "sprinkler",
      "wash",
      "water",
      "wc"
    ],
    "popularity": 9595
  },
  {
    "name": "timelapse",
    "tags": ["duration", "motion", "photo", "time", "timelapse", "timer", "video"],
    "popularity": 9578
  },
  {
    "name": "factory",
    "tags": ["factory", "industry", "manufacturing", "warehouse"],
    "popularity": 9570
  },
  {
    "name": "traffic",
    "tags": ["direction", "light", "maps", "signal", "street", "traffic"],
    "popularity": 9561
  },
  {
    "name": "electrical_services",
    "tags": ["charge", "cord", "electric", "electrical", "plug", "power", "services", "wire"],
    "popularity": 9546
  },
  {
    "name": "youtube_searched_for",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "find",
      "glass",
      "history",
      "inprogress",
      "load",
      "loading",
      "look",
      "magnify",
      "magnifying",
      "refresh",
      "renew",
      "restore",
      "reverse",
      "rotate",
      "search",
      "see",
      "youtube"
    ],
    "popularity": 9546
  },
  {
    "name": "question_mark",
    "tags": ["?", "assistance", "help", "info", "information", "punctuation", "question mark", "support", "symbol"],
    "popularity": 9523
  },
  {
    "name": "contact_support",
    "tags": [
      "?",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "contact",
      "help",
      "info",
      "information",
      "mark",
      "message",
      "punctuation",
      "question",
      "question mark",
      "speech",
      "support",
      "symbol"
    ],
    "popularity": 9460
  },
  {
    "name": "front_hand",
    "tags": ["fingers", "front", "gesture", "hand", "hello", "palm", "stop"],
    "popularity": 9451
  },
  {
    "name": "chat_bubble",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "speech"],
    "popularity": 9435
  },
  {
    "name": "yard",
    "tags": ["backyard", "flower", "garden", "home", "house", "nature", "pettle", "plants", "yard"],
    "popularity": 9412
  },
  {
    "name": "lightbulb",
    "tags": ["alert", "announcement", "idea", "info", "information", "light", "lightbulb"],
    "popularity": 9410
  },
  {
    "name": "campaign",
    "tags": ["alert", "announcement", "campaign", "loud", "megaphone", "microphone", "notification", "speaker"],
    "popularity": 9409
  },
  {
    "name": "developer_board",
    "tags": ["board", "chip", "computer", "developer", "development", "hardware", "microchip", "processor"],
    "popularity": 9408
  },
  {
    "name": "tour",
    "tags": ["destination", "flag", "places", "tour", "travel", "visit"],
    "popularity": 9391
  },
  {
    "name": "more",
    "tags": [
      "3",
      "archive",
      "bookmark",
      "dots",
      "etc",
      "favorite",
      "indent",
      "label",
      "more",
      "remember",
      "save",
      "stamp",
      "sticker",
      "tab",
      "tag",
      "three"
    ],
    "popularity": 9361
  },
  {
    "name": "list_alt",
    "tags": ["alt", "box", "contained", "format", "lines", "list", "order", "reorder", "stacked", "title"],
    "popularity": 9349
  },
  {
    "name": "shopping_cart_checkout",
    "tags": [
      "arrow",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "right",
      "shopping"
    ],
    "popularity": 9345
  },
  {
    "name": "menu_open",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "hamburger",
      "interface",
      "left",
      "line",
      "lines",
      "menu",
      "open",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 9328
  },
  {
    "name": "star_purple500",
    "tags": [
      "500",
      "best",
      "bookmark",
      "favorite",
      "highlight",
      "purple",
      "ranking",
      "rate",
      "rating",
      "save",
      "star",
      "toggle"
    ],
    "popularity": 9319
  },
  {
    "name": "format_color_fill",
    "tags": [
      "bucket",
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "fill",
      "format",
      "paint",
      "sheet",
      "spreadsheet",
      "style",
      "text",
      "type",
      "writing"
    ],
    "popularity": 9309
  },
  {
    "name": "beach_access",
    "tags": ["access", "beach", "places", "summer", "sunny", "umbrella"],
    "popularity": 9170
  },
  {
    "name": "explore",
    "tags": [
      "compass",
      "destination",
      "direction",
      "east",
      "explore",
      "location",
      "maps",
      "needle",
      "north",
      "south",
      "travel",
      "west"
    ],
    "popularity": 9169
  },
  {
    "name": "fingerprint",
    "tags": [
      "finger",
      "fingerprint",
      "id",
      "identification",
      "identity",
      "print",
      "reader",
      "thumbprint",
      "verification"
    ],
    "popularity": 9155
  },
  {
    "name": "local_bar",
    "tags": ["alcohol", "bar", "bottle", "club", "cocktail", "drink", "food", "liquor", "local", "wine"],
    "popularity": 9140
  },
  {
    "name": "add_link",
    "tags": ["add", "attach", "clip", "link", "new", "plus", "symbol"],
    "popularity": 9132
  },
  {
    "name": "landscape",
    "tags": ["image", "landscape", "mountain", "mountains", "nature", "photo", "photography", "picture"],
    "popularity": 9113
  },
  {
    "name": "slideshow",
    "tags": ["movie", "photos", "play", "slideshow", "square", "video", "view"],
    "popularity": 9092
  },
  {
    "name": "query_stats",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "find",
      "glass",
      "graph",
      "infographic",
      "line",
      "look",
      "magnify",
      "magnifying",
      "measure",
      "metrics",
      "query",
      "search",
      "see",
      "statistics",
      "stats",
      "tracking"
    ],
    "popularity": 9078
  },
  {
    "name": "directions_boat",
    "tags": [
      "automobile",
      "boat",
      "car",
      "cars",
      "direction",
      "directions",
      "ferry",
      "maps",
      "public",
      "transportation",
      "vehicle"
    ],
    "popularity": 9063
  },
  {
    "name": "route",
    "tags": ["directions", "maps", "path", "route", "sign", "traffic"],
    "popularity": 9045
  },
  {
    "name": "vaccines",
    "tags": [
      "aid",
      "covid",
      "doctor",
      "drug",
      "emergency",
      "hospital",
      "immunity",
      "injection",
      "medical",
      "medication",
      "medicine",
      "needle",
      "pharmacy",
      "sick",
      "syringe",
      "vaccination",
      "vaccines",
      "vial"
    ],
    "popularity": 9028
  },
  {
    "name": "expand_circle_down",
    "tags": [
      "arrow",
      "arrows",
      "chevron",
      "circle",
      "collapse",
      "direction",
      "down",
      "expand",
      "expandable",
      "list",
      "more"
    ],
    "popularity": 9023
  },
  {
    "name": "stream",
    "tags": ["cast", "connected", "feed", "live", "network", "signal", "stream", "wireless"],
    "popularity": 9014
  },
  {
    "name": "download_done",
    "tags": [
      "arrow",
      "arrows",
      "check",
      "done",
      "down",
      "download",
      "downloads",
      "drive",
      "install",
      "installed",
      "ok",
      "tick",
      "upload"
    ],
    "popularity": 9006
  },
  {
    "name": "videocam_off",
    "tags": [
      "cam",
      "camera",
      "conference",
      "disabled",
      "enabled",
      "film",
      "filming",
      "hardware",
      "image",
      "motion",
      "off",
      "offline",
      "on",
      "picture",
      "slash",
      "video",
      "videography"
    ],
    "popularity": 9002
  },
  {
    "name": "alt_route",
    "tags": [
      "alt",
      "alternate",
      "alternative",
      "arrows",
      "direction",
      "maps",
      "navigation",
      "options",
      "other",
      "route",
      "routes",
      "split",
      "symbol"
    ],
    "popularity": 9000
  },
  {
    "name": "volume_down",
    "tags": ["audio", "control", "down", "music", "sound", "speaker", "tv", "volume"],
    "popularity": 8999
  },
  {
    "name": "mood_bad",
    "tags": [
      "bad",
      "disappointment",
      "dislike",
      "emoji",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "mood",
      "person",
      "rating",
      "social",
      "survey",
      "unhappiness",
      "unhappy",
      "unpleased",
      "unsmile",
      "unsmiling"
    ],
    "popularity": 8975
  },
  {
    "name": "dialpad",
    "tags": ["buttons", "call", "contact", "device", "dial", "dialpad", "dots", "mobile", "numbers", "pad", "phone"],
    "popularity": 8963
  },
  {
    "name": "restaurant",
    "tags": [
      "breakfast",
      "dining",
      "dinner",
      "eat",
      "food",
      "fork",
      "knife",
      "local",
      "lunch",
      "meal",
      "places",
      "restaurant",
      "spoon",
      "utensils"
    ],
    "popularity": 8956
  },
  {
    "name": "currency_rupee",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "rupee",
      "shopping",
      "symbol"
    ],
    "popularity": 8954
  },
  {
    "name": "hide_source",
    "tags": ["circle", "disabled", "enabled", "hide", "off", "offline", "on", "shape", "slash", "source"],
    "popularity": 8943
  },
  {
    "name": "shopping_cart_checkout",
    "tags": [
      "arrow",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "right",
      "shopping"
    ],
    "popularity": 8930
  },
  {
    "name": "backspace",
    "tags": ["arrow", "back", "backspace", "cancel", "clear", "correct", "delete", "erase", "remove"],
    "popularity": 8913
  },
  {
    "name": "bookmark_added",
    "tags": [
      "added",
      "approve",
      "bookmark",
      "check",
      "complete",
      "done",
      "favorite",
      "mark",
      "ok",
      "remember",
      "save",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 8912
  },
  {
    "name": "mark_as_unread",
    "tags": ["as", "envelop", "letter", "mail", "mark", "post", "postal", "read", "receive", "send", "unread"],
    "popularity": 8904
  },
  {
    "name": "plagiarism",
    "tags": ["doc", "document", "find", "glass", "look", "magnifying", "page", "paper", "plagiarism", "search", "see"],
    "popularity": 8889
  },
  {
    "name": "undo",
    "tags": ["arrow", "backward", "mail", "previous", "redo", "repeat", "rotate", "undo"],
    "popularity": 8889
  },
  {
    "name": "shop",
    "tags": [
      "bag",
      "bill",
      "buy",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "google",
      "money",
      "online",
      "pay",
      "payment",
      "play",
      "shop",
      "shopping",
      "store"
    ],
    "popularity": 8888
  },
  {
    "name": "settings_input_antenna",
    "tags": [
      "airplay",
      "antenna",
      "arrows",
      "cast",
      "computer",
      "connect",
      "connection",
      "connectivity",
      "dots",
      "input",
      "internet",
      "network",
      "screencast",
      "settings",
      "stream",
      "wifi",
      "wireless"
    ],
    "popularity": 8885
  },
  {
    "name": "pool",
    "tags": [
      "athlete",
      "athletic",
      "beach",
      "body",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "ocean",
      "people",
      "person",
      "places",
      "pool",
      "sea",
      "sports",
      "swim",
      "swimming",
      "water"
    ],
    "popularity": 8863
  },
  {
    "name": "turned_in",
    "tags": [
      "archive",
      "bookmark",
      "favorite",
      "in",
      "label",
      "library",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "tag",
      "turned"
    ],
    "popularity": 8859
  },
  {
    "name": "arrow_circle_right",
    "tags": ["arrow", "circle", "direction", "navigation", "right"],
    "popularity": 8857
  },
  {
    "name": "search_off",
    "tags": [
      "cancel",
      "close",
      "disabled",
      "enabled",
      "find",
      "glass",
      "look",
      "magnify",
      "magnifying",
      "off",
      "on",
      "search",
      "see",
      "slash",
      "stop",
      "x"
    ],
    "popularity": 8857
  },
  {
    "name": "approval",
    "tags": [
      "apply",
      "approval",
      "approvals",
      "approve",
      "certificate",
      "certification",
      "disapproval",
      "drive",
      "file",
      "impression",
      "ink",
      "mark",
      "postage",
      "stamp"
    ],
    "popularity": 8855
  },
  {
    "name": "category",
    "tags": ["categories", "category", "circle", "collection", "items", "product", "sort", "square", "triangle"],
    "popularity": 8849
  },
  {
    "name": "power",
    "tags": ["charge", "cord", "electric", "electrical", "outlet", "plug", "power"],
    "popularity": 8844
  },
  {
    "name": "collections_bookmark",
    "tags": [
      "album",
      "archive",
      "bookmark",
      "collections",
      "favorite",
      "gallery",
      "label",
      "library",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "stack",
      "tag"
    ],
    "popularity": 8843
  },
  {
    "name": "not_started",
    "tags": ["circle", "media", "not", "pause", "play", "started", "video"],
    "popularity": 8842
  },
  {
    "name": "inventory",
    "tags": [
      "archive",
      "box",
      "clipboard",
      "doc",
      "document",
      "file",
      "inventory",
      "organize",
      "packages",
      "product",
      "stock",
      "supply"
    ],
    "popularity": 8833
  },
  {
    "name": "water",
    "tags": ["aqua", "beach", "lake", "ocean", "river", "water", "waves", "weather"],
    "popularity": 8817
  },
  {
    "name": "group_add",
    "tags": [
      "accounts",
      "add",
      "committee",
      "face",
      "family",
      "friends",
      "group",
      "humans",
      "increase",
      "more",
      "network",
      "people",
      "persons",
      "plus",
      "profiles",
      "social",
      "team",
      "users"
    ],
    "popularity": 8796
  },
  {
    "name": "router",
    "tags": ["box", "cable", "connection", "hardware", "internet", "network", "router", "signal", "wifi"],
    "popularity": 8788
  },
  {
    "name": "pedal_bike",
    "tags": [
      "automobile",
      "bicycle",
      "bike",
      "car",
      "cars",
      "direction",
      "human",
      "maps",
      "pedal",
      "public",
      "route",
      "scooter",
      "transportation",
      "vehicle",
      "vespa"
    ],
    "popularity": 8782
  },
  {
    "name": "done_all",
    "tags": [
      "all",
      "approve",
      "check",
      "complete",
      "done",
      "layers",
      "mark",
      "multiple",
      "ok",
      "select",
      "stack",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 8759
  },
  {
    "name": "picture_as_pdf",
    "tags": [
      "alphabet",
      "as",
      "character",
      "document",
      "file",
      "font",
      "image",
      "letter",
      "multiple",
      "pdf",
      "photo",
      "photography",
      "picture",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 8757
  },
  {
    "name": "print",
    "tags": ["draft", "fax", "ink", "machine", "office", "paper", "print", "printer", "send"],
    "popularity": 8757
  },
  {
    "name": "agriculture",
    "tags": [
      "agriculture",
      "automobile",
      "car",
      "cars",
      "cultivation",
      "farm",
      "harvest",
      "maps",
      "tractor",
      "transport",
      "travel",
      "truck",
      "vehicle"
    ],
    "popularity": 8743
  },
  {
    "name": "folder_open",
    "tags": ["data", "doc", "document", "drive", "file", "folder", "folders", "open", "sheet", "slide", "storage"],
    "popularity": 8741
  },
  {
    "name": "house",
    "tags": [
      "architecture",
      "building",
      "estate",
      "family",
      "home",
      "homepage",
      "house",
      "place",
      "places",
      "real",
      "residence",
      "residential",
      "shelter"
    ],
    "popularity": 8729
  },
  {
    "name": "flight_land",
    "tags": ["airport", "arrival", "arriving", "flight", "fly", "land", "landing", "plane", "transportation", "travel"],
    "popularity": 8726
  },
  {
    "name": "beenhere",
    "tags": [
      "approve",
      "archive",
      "beenhere",
      "bookmark",
      "check",
      "complete",
      "done",
      "favorite",
      "label",
      "library",
      "mark",
      "ok",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "select",
      "tag",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 8719
  },
  {
    "name": "where_to_vote",
    "tags": [
      "approve",
      "ballot",
      "check",
      "complete",
      "destination",
      "direction",
      "done",
      "location",
      "maps",
      "mark",
      "ok",
      "pin",
      "place",
      "poll",
      "select",
      "stop",
      "tick",
      "to",
      "validate election",
      "verified",
      "vote",
      "where",
      "yes"
    ],
    "popularity": 8708
  },
  {
    "name": "add_comment",
    "tags": [
      "+",
      "add",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "feedback",
      "message",
      "new",
      "plus",
      "speech",
      "symbol"
    ],
    "popularity": 8702
  },
  {
    "name": "dynamic_feed",
    "tags": ["'mail_outline'", "'markunread'. Keep 'mail' and remove others.", "Duplicate of 'email'"],
    "popularity": 8669
  },
  {
    "name": "copy_all",
    "tags": ["all", "content", "copy", "cut", "doc", "document", "file", "multiple", "page", "paper", "past"],
    "popularity": 8664
  },
  {
    "name": "arrow_right",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "interface",
      "navigation",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 8638
  },
  {
    "name": "recent_actors",
    "tags": [
      "account",
      "actors",
      "avatar",
      "card",
      "cards",
      "carousel",
      "face",
      "human",
      "layers",
      "list",
      "people",
      "person",
      "profile",
      "recent",
      "thumbnail",
      "user"
    ],
    "popularity": 8622
  },
  {
    "name": "videogame_asset",
    "tags": ["asset", "console", "controller", "device", "game", "gamepad", "gaming", "playstation", "video"],
    "popularity": 8607
  },
  {
    "name": "move_to_inbox",
    "tags": [
      "archive",
      "arrow",
      "down",
      "email",
      "envelop",
      "inbox",
      "incoming",
      "letter",
      "mail",
      "message",
      "move to",
      "send"
    ],
    "popularity": 8594
  },
  {
    "name": "crop_square",
    "tags": [
      "adjust",
      "adjustments",
      "app",
      "application",
      "area",
      "components",
      "crop",
      "design",
      "edit",
      "editing",
      "expand",
      "frame",
      "image",
      "images",
      "interface",
      "open",
      "photo",
      "photos",
      "rectangle",
      "screen",
      "settings",
      "shape",
      "shapes",
      "site",
      "size",
      "square",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 8592
  },
  {
    "name": "notifications_active",
    "tags": [
      "active",
      "alarm",
      "alert",
      "bell",
      "chime",
      "notifications",
      "notify",
      "reminder",
      "ring",
      "ringing",
      "sound"
    ],
    "popularity": 8578
  },
  {
    "name": "flag",
    "tags": ["country", "flag", "goal", "mark", "nation", "report", "start"],
    "popularity": 8560
  },
  {
    "name": "cloud_off",
    "tags": [
      "app",
      "application",
      "backup",
      "cloud",
      "connection",
      "disabled",
      "drive",
      "enabled",
      "files",
      "folders",
      "internet",
      "network",
      "off",
      "offline",
      "on",
      "sky",
      "slash",
      "storage",
      "upload"
    ],
    "popularity": 8542
  },
  {
    "name": "emoji_nature",
    "tags": [
      "animal",
      "bee",
      "bug",
      "daisy",
      "emoji",
      "flower",
      "insect",
      "ladybug",
      "nature",
      "petals",
      "spring",
      "summer"
    ],
    "popularity": 8530
  },
  {
    "name": "panorama_fish_eye",
    "tags": ["angle", "circle", "eye", "fish", "image", "panorama", "photo", "photography", "picture", "wide"],
    "popularity": 8503
  },
  {
    "name": "construction",
    "tags": [
      "build",
      "carpenter",
      "construction",
      "equipment",
      "fix",
      "hammer",
      "improvement",
      "industrial",
      "industry",
      "repair",
      "tools",
      "wrench"
    ],
    "popularity": 8497
  },
  {
    "name": "lens",
    "tags": ["circle", "full", "geometry", "lens", "moon"],
    "popularity": 8494
  },
  {
    "name": "store",
    "tags": [
      "bill",
      "building",
      "business",
      "card",
      "cash",
      "coin",
      "commerce",
      "company",
      "credit",
      "currency",
      "dollars",
      "market",
      "money",
      "online",
      "pay",
      "payment",
      "shop",
      "shopping",
      "store",
      "storefront"
    ],
    "popularity": 8477
  },
  {
    "name": "savings",
    "tags": [
      "bank",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "pig",
      "piggy",
      "savings",
      "symbol"
    ],
    "popularity": 8473
  },
  {
    "name": "360",
    "tags": ["360", "arrow", "av", "camera", "direction", "rotate", "rotation", "vr"],
    "popularity": 8464
  },
  {
    "name": "keyboard_arrow_down",
    "tags": ["arrow", "arrows", "down", "keyboard"],
    "popularity": 8464
  },
  {
    "name": "share_location",
    "tags": ["destination", "direction", "gps", "location", "maps", "pin", "place", "share", "stop", "tracking"],
    "popularity": 8442
  },
  {
    "name": "switch_account",
    "tags": [
      "account",
      "choices",
      "face",
      "human",
      "multiple",
      "options",
      "people",
      "person",
      "profile",
      "social",
      "switch",
      "user"
    ],
    "popularity": 8409
  },
  {
    "name": "workspace_premium",
    "tags": [
      "certification",
      "degree",
      "ecommerce",
      "guarantee",
      "medal",
      "permit",
      "premium",
      "ribbon",
      "verification",
      "workspace"
    ],
    "popularity": 8406
  },
  {
    "name": "assignment_late",
    "tags": [
      "!",
      "alert",
      "assignment",
      "attention",
      "caution",
      "clipboard",
      "danger",
      "doc",
      "document",
      "error",
      "exclamation",
      "important",
      "late",
      "mark",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 8398
  },
  {
    "name": "looks_two",
    "tags": ["2", "digit", "looks", "numbers", "square", "symbol"],
    "popularity": 8365
  },
  {
    "name": "do_not_disturb",
    "tags": ["cancel", "close", "denied", "deny", "disturb", "do", "remove", "silence", "stop"],
    "popularity": 8358
  },
  {
    "name": "update",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "clock",
      "forward",
      "history",
      "load",
      "refresh",
      "reverse",
      "schedule",
      "time",
      "update"
    ],
    "popularity": 8340
  },
  {
    "name": "assignment_return",
    "tags": ["arrow", "assignment", "back", "clipboard", "doc", "document", "left", "retun"],
    "popularity": 8330
  },
  {
    "name": "donut_small",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "donut",
      "graph",
      "infographic",
      "inprogress",
      "measure",
      "metrics",
      "pie",
      "small",
      "statistics",
      "tracking"
    ],
    "popularity": 8326
  },
  {
    "name": "warehouse",
    "tags": ["garage", "industry", "manufacturing", "storage", "warehouse"],
    "popularity": 8306
  },
  {
    "name": "saved_search",
    "tags": ["find", "glass", "important", "look", "magnify", "magnifying", "marked", "saved", "search", "see", "star"],
    "popularity": 8301
  },
  {
    "name": "contactless",
    "tags": [
      "bluetooth",
      "cash",
      "connect",
      "connection",
      "connectivity",
      "contact",
      "contactless",
      "credit",
      "device",
      "finance",
      "pay",
      "payment",
      "signal",
      "transaction",
      "wifi",
      "wireless"
    ],
    "popularity": 8259
  },
  {
    "name": "article",
    "tags": ["article", "doc", "document", "file", "page", "paper", "text", "writing"],
    "popularity": 8233
  },
  {
    "name": "highlight_alt",
    "tags": [
      "alt",
      "arrow",
      "box",
      "click",
      "cursor",
      "draw",
      "focus",
      "highlight",
      "pointer",
      "select",
      "selection",
      "target"
    ],
    "popularity": 8230
  },
  {
    "name": "kitchen",
    "tags": [
      "appliance",
      "cold",
      "food",
      "fridge",
      "home",
      "house",
      "ice",
      "kitchen",
      "places",
      "refrigerator",
      "storage"
    ],
    "popularity": 8227
  },
  {
    "name": "gpp_maybe",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "certified",
      "danger",
      "error",
      "exclamation",
      "gpp",
      "important",
      "mark",
      "maybe",
      "notification",
      "privacy",
      "private",
      "protect",
      "protection",
      "security",
      "shield",
      "sim",
      "symbol",
      "verified",
      "warning"
    ],
    "popularity": 8208
  },
  {
    "name": "settings_input_component",
    "tags": [
      "audio",
      "av",
      "cable",
      "cables",
      "component",
      "connect",
      "connection",
      "connectivity",
      "input",
      "internet",
      "plug",
      "points",
      "settings",
      "video",
      "wifi"
    ],
    "popularity": 8181
  },
  {
    "name": "liquor",
    "tags": ["alcohol", "bar", "bottle", "club", "cocktail", "drink", "food", "liquor", "party", "store", "wine"],
    "popularity": 8162
  },
  {
    "name": "waves",
    "tags": ["beach", "lake", "ocean", "pool", "river", "sea", "swim", "water", "wave", "waves"],
    "popularity": 8151
  },
  {
    "name": "filter_alt_off",
    "tags": ["alt", "disabled", "edit", "filter", "funnel", "off", "offline", "options", "refine", "sift", "slash"],
    "popularity": 8149
  },
  {
    "name": "hotel_class",
    "tags": [
      "achievement",
      "bookmark",
      "class",
      "favorite",
      "highlight",
      "hotel",
      "important",
      "marked",
      "rank",
      "ranking",
      "rate",
      "rating",
      "reward",
      "save",
      "saved",
      "shape",
      "special",
      "star"
    ],
    "popularity": 8148
  },
  {
    "name": "insert_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "insert",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 8147
  },
  {
    "name": "balance",
    "tags": [
      "balance",
      "equal",
      "equity",
      "impartiality",
      "justice",
      "parity",
      "stability. equilibrium",
      "steadiness",
      "symmetry"
    ],
    "popularity": 8108
  },
  {
    "name": "view_carousel",
    "tags": ["cards", "carousel", "design", "format", "grid", "layout", "view", "website"],
    "popularity": 8096
  },
  {
    "name": "web_asset",
    "tags": [
      "-website",
      "app",
      "application desktop",
      "asset",
      "browser",
      "design",
      "download",
      "image",
      "interface",
      "internet",
      "layout",
      "screen",
      "site",
      "ui",
      "ux",
      "video",
      "web",
      "website",
      "window",
      "www"
    ],
    "popularity": 8086
  },
  {
    "name": "pause",
    "tags": ["control", "controls", "media", "music", "pause", "video"],
    "popularity": 8080
  },
  {
    "name": "casino",
    "tags": ["casino", "dice", "dots", "entertainment", "gamble", "gambling", "game", "games", "luck", "places"],
    "popularity": 8072
  },
  {
    "name": "start",
    "tags": ["arrow", "keyboard", "next", "right", "start"],
    "popularity": 8070
  },
  {
    "name": "view_quilt",
    "tags": ["design", "format", "grid", "layout", "quilt", "square", "squares", "stacked", "view", "website"],
    "popularity": 8064
  },
  {
    "name": "library_add_check",
    "tags": [
      "add",
      "approve",
      "check",
      "collection",
      "complete",
      "done",
      "layers",
      "library",
      "mark",
      "multiple",
      "music",
      "ok",
      "select",
      "stacked",
      "tick",
      "validate",
      "verified",
      "video",
      "yes"
    ],
    "popularity": 8051
  },
  {
    "name": "computer",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "computer",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "web",
      "window"
    ],
    "popularity": 8050
  },
  {
    "name": "anchor",
    "tags": ["anchor", "google", "logo"],
    "popularity": 8046
  },
  {
    "name": "lock_open",
    "tags": [
      "lock",
      "open",
      "password",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "unlocked"
    ],
    "popularity": 8040
  },
  {
    "name": "queue_music",
    "tags": ["collection", "list", "music", "playlist", "queue"],
    "popularity": 8035
  },
  {
    "name": "emergency",
    "tags": ["asterisk", "clinic", "emergency", "health", "hospital", "maps", "medical", "symbol"],
    "popularity": 8033
  },
  {
    "name": "phone_enabled",
    "tags": ["call", "cell", "contact", "device", "enabled", "hardware", "mobile", "phone", "telephone"],
    "popularity": 8017
  },
  {
    "name": "hearing",
    "tags": [
      "accessibility",
      "accessible",
      "aid",
      "ear",
      "handicap",
      "hearing",
      "help",
      "impaired",
      "listen",
      "sound",
      "volume"
    ],
    "popularity": 8002
  },
  {
    "name": "do_not_disturb_on",
    "tags": [
      "cancel",
      "close",
      "denied",
      "deny",
      "disabled",
      "disturb",
      "do",
      "enabled",
      "off",
      "on",
      "remove",
      "silence",
      "slash",
      "stop"
    ],
    "popularity": 7999
  },
  {
    "name": "holiday_village",
    "tags": [
      "architecture",
      "beach",
      "camping",
      "cottage",
      "estate",
      "holiday",
      "home",
      "house",
      "lake",
      "lodge",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling",
      "vacation",
      "village"
    ],
    "popularity": 7993
  },
  {
    "name": "linear_scale",
    "tags": [
      "app",
      "application",
      "components",
      "design",
      "interface",
      "layout",
      "linear",
      "measure",
      "menu",
      "scale",
      "screen",
      "site",
      "slider",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 7978
  },
  {
    "name": "monetization_on",
    "tags": [
      "bill",
      "card",
      "cash",
      "circle",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "monetization",
      "money",
      "on",
      "online",
      "pay",
      "payment",
      "shopping",
      "symbol"
    ],
    "popularity": 7971
  },
  {
    "name": "all_inbox",
    "tags": ["Inbox", "all", "delivered", "delivery", "email", "mail", "message", "send"],
    "popularity": 7966
  },
  {
    "name": "sync_problem",
    "tags": [
      "!",
      "360",
      "alert",
      "around",
      "arrow",
      "arrows",
      "attention",
      "caution",
      "danger",
      "direction",
      "error",
      "exclamation",
      "important",
      "inprogress",
      "load",
      "loading refresh",
      "mark",
      "notification",
      "problem",
      "renew",
      "rotate",
      "symbol",
      "sync",
      "turn",
      "warning"
    ],
    "popularity": 7966
  },
  {
    "name": "turned_in_not",
    "tags": [
      "archive",
      "bookmark",
      "favorite",
      "in",
      "label",
      "library",
      "not",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "tag",
      "turned"
    ],
    "popularity": 7957
  },
  {
    "name": "open_in_full",
    "tags": ["action", "arrow", "arrows", "expand", "full", "grow", "in", "move", "open"],
    "popularity": 7924
  },
  {
    "name": "mediation",
    "tags": ["arrow", "arrows", "direction", "dots", "mediation", "right"],
    "popularity": 7905
  },
  {
    "name": "priority_high",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "high",
      "important",
      "mark",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 7898
  },
  {
    "name": "settings_remote",
    "tags": ["bluetooth", "connection", "connectivity", "device", "remote", "settings", "signal", "wifi", "wireless"],
    "popularity": 7896
  },
  {
    "name": "edit_off",
    "tags": [
      "compose",
      "create",
      "disabled",
      "draft",
      "edit",
      "editing",
      "enabled",
      "input",
      "new",
      "off",
      "offline",
      "on",
      "pen",
      "pencil",
      "slash",
      "write",
      "writing"
    ],
    "popularity": 7880
  },
  {
    "name": "my_location",
    "tags": ["destination", "direction", "location", "maps", "navigation", "pin", "place", "point", "stop"],
    "popularity": 7837
  },
  {
    "name": "hourglass_full",
    "tags": ["countdown", "empty", "full", "hourglass", "loading", "minutes", "time", "wait", "waiting"],
    "popularity": 7831
  },
  {
    "name": "nights_stay",
    "tags": [
      "climate",
      "cloud",
      "crescent",
      "dark",
      "lunar",
      "mode",
      "moon",
      "nights",
      "phases",
      "silence",
      "silent",
      "sky",
      "stay",
      "time",
      "weather"
    ],
    "popularity": 7829
  },
  {
    "name": "fit_screen",
    "tags": ["enlarge", "fit", "format", "layout", "reduce", "scale", "screen", "size"],
    "popularity": 7816
  },
  {
    "name": "drive_file_move",
    "tags": [
      "arrow",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "move",
      "right",
      "sheet",
      "slide",
      "storage"
    ],
    "popularity": 7806
  },
  {
    "name": "engineering",
    "tags": [
      "body",
      "cogs",
      "cogwheel",
      "construction",
      "engineering",
      "fixing",
      "gears",
      "hat",
      "helmet",
      "human",
      "maintenance",
      "people",
      "person",
      "setting",
      "worker"
    ],
    "popularity": 7801
  },
  {
    "name": "manage_search",
    "tags": ["glass", "history", "magnifying", "manage", "search", "text"],
    "popularity": 7757
  },
  {
    "name": "pause_circle_filled",
    "tags": ["circle", "control", "controls", "filled", "media", "music", "pause", "video"],
    "popularity": 7743
  },
  {
    "name": "king_bed",
    "tags": [
      "bed",
      "bedroom",
      "double",
      "furniture",
      "home",
      "hotel",
      "house",
      "king",
      "night",
      "pillows",
      "queen",
      "rest",
      "room",
      "sleep"
    ],
    "popularity": 7734
  },
  {
    "name": "catching_pokemon",
    "tags": ["catching", "go", "pokemon", "pokestop", "travel"],
    "popularity": 7721
  },
  {
    "name": "circle",
    "tags": ["circle", "full", "geometry", "moon"],
    "popularity": 7717
  },
  {
    "name": "double_arrow",
    "tags": ["arrow", "arrows", "direction", "double", "multiple", "navigation", "right"],
    "popularity": 7717
  },
  {
    "name": "admin_panel_settings",
    "tags": [
      "account",
      "admin",
      "avatar",
      "certified",
      "face",
      "human",
      "panel",
      "people",
      "person",
      "privacy",
      "private",
      "profile",
      "protect",
      "protection",
      "security",
      "settings",
      "shield",
      "user",
      "verified"
    ],
    "popularity": 7710
  },
  {
    "name": "flaky",
    "tags": [
      "approve",
      "check",
      "close",
      "complete",
      "contrast",
      "done",
      "exit",
      "flaky",
      "mark",
      "no",
      "ok",
      "options",
      "select",
      "stop",
      "tick",
      "verified",
      "x",
      "yes"
    ],
    "popularity": 7708
  },
  {
    "name": "code",
    "tags": ["brackets", "code", "css", "develop", "developer", "engineer", "engineering", "html", "platform"],
    "popularity": 7707
  },
  {
    "name": "fact_check",
    "tags": [
      "approve",
      "check",
      "complete",
      "done",
      "fact",
      "list",
      "mark",
      "ok",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 7704
  },
  {
    "name": "keyboard_double_arrow_up",
    "tags": ["arrow", "arrows", "direction", "double", "multiple", "navigation", "up"],
    "popularity": 7691
  },
  {
    "name": "interests",
    "tags": ["circle", "heart", "interests", "shapes", "social", "square", "triangle"],
    "popularity": 7672
  },
  {
    "name": "format_size",
    "tags": [
      "alphabet",
      "character",
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "fill",
      "font",
      "format",
      "letter",
      "paint",
      "sheet",
      "size",
      "spreadsheet",
      "style",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 7671
  },
  {
    "name": "toll",
    "tags": [
      "bill",
      "booth",
      "car",
      "card",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "highway",
      "money",
      "online",
      "pay",
      "payment",
      "ticket",
      "toll"
    ],
    "popularity": 7656
  },
  {
    "name": "stacked_line_chart",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "line",
      "measure",
      "metrics",
      "stacked",
      "statistics",
      "tracking"
    ],
    "popularity": 7653
  },
  {
    "name": "location_searching",
    "tags": [
      "destination",
      "direction",
      "location",
      "maps",
      "pin",
      "place",
      "pointer",
      "searching",
      "stop",
      "tracking"
    ],
    "popularity": 7651
  },
  {
    "name": "subtitles",
    "tags": [
      "accessible",
      "caption",
      "cc",
      "character",
      "closed",
      "decoder",
      "language",
      "media",
      "movies",
      "subtitle",
      "subtitles",
      "tv"
    ],
    "popularity": 7644
  },
  {
    "name": "cable",
    "tags": ["cable", "connect", "connection", "device", "electronics", "usb", "wire"],
    "popularity": 7637
  },
  {
    "name": "unarchive",
    "tags": ["archive", "arrow", "inbox", "mail", "store", "unarchive", "undo", "up"],
    "popularity": 7637
  },
  {
    "name": "time_to_leave",
    "tags": [
      "automobile",
      "car",
      "cars",
      "destination",
      "direction",
      "drive",
      "estimate",
      "eta",
      "maps",
      "public",
      "transportation",
      "travel",
      "trip",
      "vehicle"
    ],
    "popularity": 7636
  },
  {
    "name": "moving",
    "tags": ["arrow", "direction", "moving", "navigation", "travel", "up"],
    "popularity": 7627
  },
  {
    "name": "alternate_email",
    "tags": ["@", "address", "alternate", "contact", "email", "tag"],
    "popularity": 7625
  },
  {
    "name": "remove_shopping_cart",
    "tags": [
      "card",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "credit",
      "currency",
      "disabled",
      "dollars",
      "enabled",
      "off",
      "on",
      "online",
      "pay",
      "payment",
      "remove",
      "shopping",
      "slash",
      "tick"
    ],
    "popularity": 7610
  },
  {
    "name": "rocket",
    "tags": ["rocket", "space", "spaceship"],
    "popularity": 7537
  },
  {
    "name": "fiber_new",
    "tags": ["alphabet", "character", "fiber", "font", "letter", "network", "new", "symbol", "text", "type"],
    "popularity": 7522
  },
  {
    "name": "compost",
    "tags": [
      "bio",
      "compost",
      "compostable",
      "decomposable",
      "decompose",
      "eco",
      "green",
      "leaf",
      "leafs",
      "nature",
      "organic",
      "plant",
      "recycle",
      "sustainability",
      "sustainable"
    ],
    "popularity": 7509
  },
  {
    "name": "cast_for_education",
    "tags": [
      "Android",
      "OS",
      "airplay",
      "cast",
      "chrome",
      "connect",
      "desktop",
      "device",
      "display",
      "education",
      "for",
      "hardware",
      "iOS",
      "learning",
      "lessons teaching",
      "mac",
      "monitor",
      "screen",
      "screencast",
      "streaming",
      "television",
      "tv",
      "web",
      "window",
      "wireless"
    ],
    "popularity": 7506
  },
  {
    "name": "pause_circle_outline",
    "tags": ["circle", "control", "controls", "media", "music", "outline", "pause", "video"],
    "popularity": 7500
  },
  {
    "name": "build",
    "tags": ["adjust", "build", "fix", "home", "nest", "repair", "tool", "tools", "wrench"],
    "popularity": 7491
  },
  {
    "name": "format_underlined",
    "tags": [
      "alphabet",
      "character",
      "doc",
      "edit",
      "editing",
      "editor",
      "font",
      "format",
      "letter",
      "line",
      "sheet",
      "spreadsheet",
      "style",
      "symbol",
      "text",
      "type",
      "under",
      "underlined",
      "writing"
    ],
    "popularity": 7475
  },
  {
    "name": "mark_chat_unread",
    "tags": [
      "bubble",
      "chat",
      "circle",
      "comment",
      "communicate",
      "mark",
      "message",
      "notification",
      "speech",
      "unread"
    ],
    "popularity": 7475
  },
  {
    "name": "attach_file",
    "tags": ["add", "attach", "attachment", "clip", "file", "link", "mail", "media"],
    "popularity": 7474
  },
  {
    "name": "report",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "octagon",
      "report",
      "symbol",
      "warning"
    ],
    "popularity": 7470
  },
  {
    "name": "insert_comment",
    "tags": ["add", "bubble", "chat", "comment", "feedback", "insert", "message"],
    "popularity": 7468
  },
  {
    "name": "local_airport",
    "tags": ["air", "airplane", "airport", "flight", "plane", "transportation", "travel", "trip"],
    "popularity": 7459
  },
  {
    "name": "cameraswitch",
    "tags": ["arrows", "camera", "cameraswitch", "flip", "rotate", "swap", "switch", "view"],
    "popularity": 7457
  },
  {
    "name": "content_paste_search",
    "tags": ["clipboard", "content", "doc", "document", "file", "find", "paste", "search", "trace", "track"],
    "popularity": 7445
  },
  {
    "name": "device_hub",
    "tags": [
      "Android",
      "OS",
      "circle",
      "computer",
      "desktop",
      "device",
      "hardware",
      "hub",
      "iOS",
      "laptop",
      "mobile",
      "monitor",
      "phone",
      "square",
      "tablet",
      "triangle",
      "watch",
      "wearable",
      "web"
    ],
    "popularity": 7441
  },
  {
    "name": "lock_clock",
    "tags": [
      "clock",
      "date",
      "lock",
      "locked",
      "password",
      "privacy",
      "private",
      "protection",
      "safety",
      "schedule",
      "secure",
      "security",
      "time"
    ],
    "popularity": 7433
  },
  {
    "name": "sync_alt",
    "tags": ["alt", "arrow", "arrows", "horizontal", "internet", "sync", "technology", "up", "update", "wifi"],
    "popularity": 7426
  },
  {
    "name": "filter_vintage",
    "tags": [
      "edit",
      "editing",
      "effect",
      "filter",
      "flower",
      "image",
      "images",
      "photography",
      "picture",
      "pictures",
      "vintage"
    ],
    "popularity": 7414
  },
  {
    "name": "roofing",
    "tags": [
      "architecture",
      "building",
      "chimney",
      "construction",
      "estate",
      "home",
      "house",
      "real",
      "residence",
      "residential",
      "roof",
      "roofing",
      "service",
      "shelter"
    ],
    "popularity": 7413
  },
  {
    "name": "sailing",
    "tags": [
      "boat",
      "entertainment",
      "fishing",
      "hobby",
      "ocean",
      "sailboat",
      "sailing",
      "sea",
      "social sports",
      "travel",
      "water"
    ],
    "popularity": 7413
  },
  {
    "name": "psychology",
    "tags": [
      "behavior",
      "body",
      "brain",
      "cognitive",
      "function",
      "gear",
      "head",
      "human",
      "intellectual",
      "mental",
      "mind",
      "people",
      "person",
      "preferences",
      "psychiatric",
      "psychology",
      "science",
      "settings",
      "social",
      "therapy",
      "thinking",
      "thoughts"
    ],
    "popularity": 7409
  },
  {
    "name": "swap_horizontal_circle",
    "tags": ["arrow", "arrows", "back", "circle", "forward", "horizontal", "swap"],
    "popularity": 7401
  },
  {
    "name": "room_service",
    "tags": ["alert", "bell", "delivery", "hotel", "notify", "room", "service"],
    "popularity": 7376
  },
  {
    "name": "volunteer_activism",
    "tags": [
      "activism",
      "donation",
      "fingers",
      "gesture",
      "giving",
      "hand",
      "hands",
      "heart",
      "love",
      "sharing",
      "volunteer"
    ],
    "popularity": 7370
  },
  {
    "name": "settings_voice",
    "tags": ["mic", "microphone", "record", "recorder", "settings", "speaker", "voice"],
    "popularity": 7369
  },
  {
    "name": "file_open",
    "tags": ["arrow", "doc", "document", "drive", "file", "left", "open", "page", "paper"],
    "popularity": 7354
  },
  {
    "name": "bubble_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "bubble",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 7353
  },
  {
    "name": "compare",
    "tags": [
      "adjust",
      "adjustment",
      "compare",
      "edit",
      "editing",
      "edits",
      "enhance",
      "fix",
      "image",
      "images",
      "photo",
      "photography",
      "photos",
      "scan",
      "settings"
    ],
    "popularity": 7352
  },
  {
    "name": "add_location_alt",
    "tags": [
      "+",
      "add",
      "alt",
      "destination",
      "direction",
      "location",
      "maps",
      "new",
      "pin",
      "place",
      "plus",
      "stop",
      "symbol"
    ],
    "popularity": 7350
  },
  {
    "name": "reply_all",
    "tags": ["all", "arrow", "backward", "group", "left", "mail", "message", "multiple", "reply", "send", "share"],
    "popularity": 7348
  },
  {
    "name": "date_range",
    "tags": [
      "calendar",
      "date",
      "day",
      "event",
      "month",
      "range",
      "remember",
      "reminder",
      "schedule",
      "time",
      "today",
      "week"
    ],
    "popularity": 7323
  },
  {
    "name": "money_off",
    "tags": [
      "bill",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "disabled",
      "dollars",
      "enabled",
      "money",
      "off",
      "on",
      "online",
      "pay",
      "payment",
      "shopping",
      "slash",
      "symbol"
    ],
    "popularity": 7323
  },
  {
    "name": "shortcut",
    "tags": ["arrow", "direction", "forward", "right", "shortcut"],
    "popularity": 7310
  },
  {
    "name": "calculate",
    "tags": ["+", "-", "=", "calculate", "count", "finance calculator", "math"],
    "popularity": 7303
  },
  {
    "name": "filter_drama",
    "tags": [
      "cloud",
      "drama",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "photo",
      "photography",
      "picture",
      "sky camera"
    ],
    "popularity": 7287
  },
  {
    "name": "zoom_in",
    "tags": [
      "big",
      "bigger",
      "find",
      "glass",
      "grow",
      "in",
      "look",
      "magnify",
      "magnifying",
      "plus",
      "scale",
      "search",
      "see",
      "size",
      "zoom"
    ],
    "popularity": 7286
  },
  {
    "name": "looks_3",
    "tags": ["3", "digit", "looks", "numbers", "square", "symbol"],
    "popularity": 7277
  },
  {
    "name": "note",
    "tags": [
      "bookmark",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "message",
      "note",
      "page",
      "paper",
      "plus",
      "sheet",
      "slide",
      "symbol",
      "writing"
    ],
    "popularity": 7275
  },
  {
    "name": "view_sidebar",
    "tags": ["design", "format", "grid", "layout", "sidebar", "view", "web"],
    "popularity": 7268
  },
  {
    "name": "vertical_align_bottom",
    "tags": [
      "align",
      "alignment",
      "arrow",
      "bottom",
      "doc",
      "down",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "vertical",
      "writing"
    ],
    "popularity": 7266
  },
  {
    "name": "done_outline",
    "tags": [
      "all",
      "approve",
      "check",
      "complete",
      "done",
      "mark",
      "ok",
      "outline",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 7261
  },
  {
    "name": "cancel_presentation",
    "tags": [
      "cancel",
      "close",
      "device",
      "exit",
      "no",
      "present",
      "presentation",
      "quit",
      "remove",
      "screen",
      "slide",
      "stop",
      "website",
      "window",
      "x"
    ],
    "popularity": 7235
  },
  {
    "name": "sms",
    "tags": [
      "3",
      "bubble",
      "chat",
      "communication",
      "conversation",
      "dots",
      "message",
      "more",
      "service",
      "sms",
      "speech",
      "three"
    ],
    "popularity": 7228
  },
  {
    "name": "3p",
    "tags": [
      "3",
      "3p",
      "account",
      "avatar",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "face",
      "human",
      "message",
      "party",
      "people",
      "person",
      "profile",
      "speech",
      "user"
    ],
    "popularity": 7227
  },
  {
    "name": "event_seat",
    "tags": ["assign", "assigned", "chair", "event", "furniture", "reservation", "row", "seat", "section", "sit"],
    "popularity": 7218
  },
  {
    "name": "select_all",
    "tags": ["all", "select", "selection", "square", "tool"],
    "popularity": 7217
  },
  {
    "name": "av_timer",
    "tags": ["av", "clock", "countdown", "duration", "minutes", "seconds", "time", "timer", "watch"],
    "popularity": 7200
  },
  {
    "name": "online_prediction",
    "tags": ["bulb", "connection", "idea", "light", "network", "online", "prediction", "signal", "wireless"],
    "popularity": 7188
  },
  {
    "name": "album",
    "tags": [
      "album",
      "artist",
      "audio",
      "bvb",
      "cd",
      "computer",
      "data",
      "disk",
      "file",
      "music",
      "record",
      "sound",
      "storage",
      "track"
    ],
    "popularity": 7182
  },
  {
    "name": "window",
    "tags": ["close", "glass", "grid", "home", "house", "interior", "layout", "outside", "window"],
    "popularity": 7179
  },
  {
    "name": "qr_code_scanner",
    "tags": [
      "barcode",
      "camera",
      "code",
      "media",
      "product",
      "qr",
      "quick",
      "response",
      "scanner",
      "smartphone",
      "url",
      "urls"
    ],
    "popularity": 7172
  },
  {
    "name": "headset",
    "tags": ["accessory", "audio", "device", "ear", "earphone", "headphones", "headset", "listen", "music", "sound"],
    "popularity": 7165
  },
  {
    "name": "bar_chart",
    "tags": [
      "analytics",
      "bar",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 7157
  },
  {
    "name": "local_dining",
    "tags": ["dining", "eat", "food", "fork", "knife", "local", "meal", "restaurant", "spoon"],
    "popularity": 7156
  },
  {
    "name": "airplane_ticket",
    "tags": ["airplane", "airport", "boarding", "flight", "fly", "maps", "pass", "ticket", "transportation", "travel"],
    "popularity": 7150
  },
  {
    "name": "maps_ugc",
    "tags": [
      "+",
      "add",
      "bubble",
      "comment",
      "communicate",
      "feedback",
      "maps",
      "message",
      "new",
      "plus",
      "speech",
      "symbol",
      "ugc"
    ],
    "popularity": 7137
  },
  {
    "name": "format_list_bulleted",
    "tags": [
      "align",
      "alignment",
      "bulleted",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "notes",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 7135
  },
  {
    "name": "vertical_split",
    "tags": ["design", "format", "grid", "layout", "paragraph", "split", "text", "vertical", "website", "writing"],
    "popularity": 7125
  },
  {
    "name": "palette",
    "tags": ["art", "color", "colors", "filters", "paint", "palette"],
    "popularity": 7106
  },
  {
    "name": "next_plan",
    "tags": ["arrow", "circle", "next", "plan", "right"],
    "popularity": 7092
  },
  {
    "name": "drive_folder_upload",
    "tags": [
      "arrow",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "sheet",
      "slide",
      "storage",
      "up",
      "upload"
    ],
    "popularity": 7083
  },
  {
    "name": "sports_basketball",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "basketball",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "social",
      "sports"
    ],
    "popularity": 7074
  },
  {
    "name": "wallpaper",
    "tags": ["background", "image", "landscape", "photo", "photography", "picture", "wallpaper"],
    "popularity": 7046
  },
  {
    "name": "pregnant_woman",
    "tags": [
      "baby",
      "birth",
      "body",
      "female",
      "human",
      "lady",
      "maternity",
      "mom",
      "mother",
      "people",
      "person",
      "pregnant",
      "women"
    ],
    "popularity": 7041
  },
  {
    "name": "image_search",
    "tags": [
      "find",
      "glass",
      "image",
      "landscape",
      "look",
      "magnify",
      "magnifying",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "search",
      "see"
    ],
    "popularity": 7039
  },
  {
    "name": "device_thermostat",
    "tags": ["celsius", "device", "fahrenheit", "meter", "temp", "temperature", "thermometer", "thermostat"],
    "popularity": 7023
  },
  {
    "name": "data_exploration",
    "tags": [
      "analytics",
      "arrow",
      "chart",
      "data",
      "diagram",
      "exploration",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 7019
  },
  {
    "name": "supervisor_account",
    "tags": [
      "account",
      "avatar",
      "control",
      "face",
      "human",
      "parental",
      "parental control",
      "parents",
      "people",
      "person",
      "profile",
      "supervised",
      "supervisor",
      "user"
    ],
    "popularity": 7007
  },
  {
    "name": "upload_file",
    "tags": [
      "arrow",
      "data",
      "doc",
      "document",
      "download",
      "drive",
      "file",
      "folder",
      "folders",
      "page",
      "paper",
      "sheet",
      "slide",
      "up",
      "upload",
      "writing"
    ],
    "popularity": 6995
  },
  {
    "name": "healing",
    "tags": ["bandage", "edit", "editing", "emergency", "fix", "healing", "hospital", "image", "medicine"],
    "popularity": 6993
  },
  {
    "name": "laptop_mac",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "device",
      "display",
      "hardware",
      "iOS",
      "laptop",
      "mac",
      "monitor",
      "screen",
      "web",
      "window"
    ],
    "popularity": 6991
  },
  {
    "name": "height",
    "tags": [
      "arrow",
      "color",
      "doc",
      "down",
      "edit",
      "editing",
      "editor",
      "fill",
      "format",
      "height",
      "paint",
      "sheet",
      "spreadsheet",
      "style",
      "text",
      "type",
      "up",
      "writing"
    ],
    "popularity": 6985
  },
  {
    "name": "restore_from_trash",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "clock",
      "date",
      "history",
      "refresh",
      "renew",
      "restore",
      "reverse",
      "rotate",
      "schedule",
      "time",
      "turn"
    ],
    "popularity": 6976
  },
  {
    "name": "diversity_3",
    "tags": [
      "committee",
      "diverse",
      "diversity",
      "family",
      "friends",
      "group",
      "groups",
      "humans",
      "network",
      "people",
      "persons",
      "social",
      "team"
    ],
    "popularity": 6940
  },
  {
    "name": "radar",
    "tags": ["detect", "military", "near", "network", "position", "radar", "scan"],
    "popularity": 6939
  },
  {
    "name": "file_download_done",
    "tags": [
      "arrow",
      "arrows",
      "check",
      "done",
      "down",
      "download",
      "downloads",
      "drive",
      "file",
      "install",
      "installed",
      "tick",
      "upload"
    ],
    "popularity": 6936
  },
  {
    "name": "call_made",
    "tags": ["arrow", "call", "device", "made", "mobile"],
    "popularity": 6924
  },
  {
    "name": "auto_awesome_motion",
    "tags": ["adjust", "auto", "awesome", "collage", "edit", "editing", "enhance", "image", "motion", "photo", "video"],
    "popularity": 6915
  },
  {
    "name": "local_taxi",
    "tags": [
      "automobile",
      "cab",
      "call",
      "car",
      "cars",
      "direction",
      "local",
      "lyft",
      "maps",
      "public",
      "taxi",
      "transportation",
      "uber",
      "vehicle",
      "yellow"
    ],
    "popularity": 6888
  },
  {
    "name": "notification_add",
    "tags": [
      "+",
      "active",
      "add",
      "alarm",
      "alert",
      "bell",
      "chime",
      "notification",
      "notifications",
      "notify",
      "plus",
      "reminder",
      "ring",
      "sound",
      "symbol"
    ],
    "popularity": 6883
  },
  {
    "name": "terminal",
    "tags": ["application", "code", "emulator", "program", "software", "terminal"],
    "popularity": 6883
  },
  {
    "name": "rotate_left",
    "tags": [
      "around",
      "arrow",
      "direction",
      "inprogress",
      "left",
      "load",
      "loading refresh",
      "renew",
      "rotate",
      "turn"
    ],
    "popularity": 6880
  },
  {
    "name": "camera_enhance",
    "tags": [
      "ai",
      "artificial",
      "automatic",
      "automation",
      "camera",
      "custom",
      "enhance",
      "genai",
      "important",
      "intelligence",
      "lens",
      "magic",
      "photo",
      "photography",
      "picture",
      "quality",
      "smart",
      "spark",
      "sparkle",
      "special",
      "star"
    ],
    "popularity": 6874
  },
  {
    "name": "gpp_bad",
    "tags": [
      "bad",
      "cancel",
      "certified",
      "close",
      "error",
      "exit",
      "gpp",
      "no",
      "privacy",
      "private",
      "protect",
      "protection",
      "remove",
      "security",
      "shield",
      "sim",
      "stop",
      "verified",
      "x"
    ],
    "popularity": 6862
  },
  {
    "name": "playlist_play",
    "tags": ["arrow", "collection", "list", "music", "play", "playlist"],
    "popularity": 6857
  },
  {
    "name": "star_border_purple500",
    "tags": [
      "500",
      "best",
      "bookmark",
      "border",
      "favorite",
      "highlight",
      "outline",
      "purple",
      "ranking",
      "rate",
      "rating",
      "save",
      "star",
      "toggle"
    ],
    "popularity": 6853
  },
  {
    "name": "drag_indicator",
    "tags": [
      "app",
      "application",
      "circles",
      "components",
      "design",
      "dots",
      "drag",
      "drop",
      "indicator",
      "interface",
      "layout",
      "mobile",
      "monitor",
      "move",
      "phone",
      "screen",
      "shape",
      "shift",
      "site",
      "tablet",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 6840
  },
  {
    "name": "account_tree",
    "tags": [
      "account",
      "analytics",
      "chart",
      "connect",
      "data",
      "diagram",
      "flow",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "process",
      "square",
      "statistics",
      "structure",
      "tracking",
      "tree"
    ],
    "popularity": 6830
  },
  {
    "name": "cast",
    "tags": [
      "Android",
      "OS",
      "airplay",
      "cast",
      "chrome",
      "connect",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "screencast",
      "streaming",
      "television",
      "tv",
      "web",
      "window",
      "wireless"
    ],
    "popularity": 6819
  },
  {
    "name": "vertical_align_top",
    "tags": [
      "align",
      "alignment",
      "arrow",
      "doc",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "text",
      "top",
      "type",
      "up",
      "vertical",
      "writing"
    ],
    "popularity": 6819
  },
  {
    "name": "assignment",
    "tags": ["assignment", "clipboard", "doc", "document", "text", "writing"],
    "popularity": 6811
  },
  {
    "name": "add_shopping_cart",
    "tags": [
      "add",
      "card",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "plus",
      "shopping"
    ],
    "popularity": 6807
  },
  {
    "name": "markunread_mailbox",
    "tags": [
      "deliver",
      "envelop",
      "letter",
      "mail",
      "mailbox",
      "markunread",
      "post",
      "postal",
      "postbox",
      "receive",
      "send",
      "unread"
    ],
    "popularity": 6807
  },
  {
    "name": "lock_reset",
    "tags": [
      "around",
      "inprogress",
      "load",
      "loading refresh",
      "lock",
      "locked",
      "password",
      "privacy",
      "private",
      "protection",
      "renew",
      "rotate",
      "safety",
      "secure",
      "security",
      "turn"
    ],
    "popularity": 6806
  },
  {
    "name": "emoji_objects",
    "tags": ["bulb", "creative", "emoji", "idea", "light", "objects", "solution", "thinking"],
    "popularity": 6798
  },
  {
    "name": "data_usage",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking",
      "usage"
    ],
    "popularity": 6791
  },
  {
    "name": "ramen_dining",
    "tags": [
      "breakfast",
      "dining",
      "dinner",
      "drink",
      "fastfood",
      "food",
      "lunch",
      "meal",
      "noodles",
      "ramen",
      "restaurant"
    ],
    "popularity": 6782
  },
  {
    "name": "queue",
    "tags": [
      "add",
      "collection",
      "layers",
      "list",
      "multiple",
      "music",
      "playlist",
      "queue",
      "stack",
      "stream",
      "video"
    ],
    "popularity": 6779
  },
  {
    "name": "center_focus_strong",
    "tags": ["camera", "center", "focus", "image", "lens", "photo", "photography", "strong", "zoom"],
    "popularity": 6768
  },
  {
    "name": "dynamic_form",
    "tags": [
      "bolt",
      "code",
      "dynamic",
      "electric",
      "fast",
      "form",
      "lightning",
      "lists",
      "questionnaire",
      "thunderbolt"
    ],
    "popularity": 6750
  },
  {
    "name": "screen_share",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "cast",
      "chrome",
      "device",
      "display",
      "hardware",
      "iOS",
      "laptop",
      "mac",
      "mirror",
      "monitor",
      "screen",
      "share",
      "steam",
      "streaming",
      "web",
      "window"
    ],
    "popularity": 6748
  },
  {
    "name": "low_priority",
    "tags": ["arrange", "arrow", "backward", "bottom", "list", "low", "move", "order", "priority"],
    "popularity": 6742
  },
  {
    "name": "games",
    "tags": [
      "adjust",
      "arrow",
      "arrows",
      "control",
      "controller",
      "direction",
      "games",
      "gaming",
      "left",
      "move",
      "right"
    ],
    "popularity": 6733
  },
  {
    "name": "room_preferences",
    "tags": [
      "building",
      "door",
      "doorway",
      "entrance",
      "gear",
      "home",
      "house",
      "interior",
      "office",
      "open",
      "preferences",
      "room",
      "settings"
    ],
    "popularity": 6733
  },
  {
    "name": "music_note",
    "tags": ["audio", "audiotrack", "key", "music", "note", "sound", "track"],
    "popularity": 6732
  },
  {
    "name": "tab",
    "tags": [
      "browser",
      "computer",
      "document",
      "documents",
      "folder",
      "internet",
      "tab",
      "tabs",
      "web",
      "website",
      "window",
      "windows"
    ],
    "popularity": 6711
  },
  {
    "name": "crop",
    "tags": [
      "adjust",
      "adjustments",
      "area",
      "crop",
      "edit",
      "editing",
      "frame",
      "image",
      "images",
      "photo",
      "photos",
      "rectangle",
      "settings",
      "size",
      "square"
    ],
    "popularity": 6707
  },
  {
    "name": "trip_origin",
    "tags": ["circle", "departure", "origin", "trip"],
    "popularity": 6703
  },
  {
    "name": "calendar_view_week",
    "tags": [
      "calendar",
      "date",
      "day",
      "event",
      "format",
      "grid",
      "layout",
      "month",
      "schedule",
      "today",
      "view",
      "week"
    ],
    "popularity": 6689
  },
  {
    "name": "monitor_weight",
    "tags": ["body", "device", "diet", "health", "monitor", "scale", "smart", "weight"],
    "popularity": 6683
  },
  {
    "name": "water_drop",
    "tags": ["drink", "drop", "droplet", "eco", "liquid", "nature", "ocean", "rain", "social", "water"],
    "popularity": 6674
  },
  {
    "name": "view_stream",
    "tags": ["design", "format", "grid", "layout", "lines", "list", "stacked", "stream", "view", "website"],
    "popularity": 6670
  },
  {
    "name": "blur_on",
    "tags": [
      "blur",
      "disabled",
      "dots",
      "edit",
      "editing",
      "effect",
      "enabled",
      "enhance",
      "filter",
      "off",
      "on",
      "slash"
    ],
    "popularity": 6654
  },
  {
    "name": "do_disturb_on",
    "tags": [
      "cancel",
      "close",
      "denied",
      "deny",
      "disabled",
      "disturb",
      "do",
      "enabled",
      "off",
      "on",
      "remove",
      "silence",
      "slash",
      "stop"
    ],
    "popularity": 6645
  },
  {
    "name": "fullscreen",
    "tags": [
      "adjust",
      "app",
      "application",
      "components",
      "full",
      "fullscreen",
      "interface",
      "screen",
      "site",
      "size",
      "ui",
      "ux",
      "view",
      "web",
      "website"
    ],
    "popularity": 6644
  },
  {
    "name": "radio",
    "tags": [
      "antenna",
      "audio",
      "device",
      "frequency",
      "hardware",
      "listen",
      "media",
      "music",
      "player",
      "radio",
      "signal",
      "tune"
    ],
    "popularity": 6640
  },
  {
    "name": "hail",
    "tags": ["body", "hail", "human", "people", "person", "pick", "public", "stop", "taxi", "transportation"],
    "popularity": 6634
  },
  {
    "name": "eco",
    "tags": ["eco", "economical", "green", "leaf", "nature", "sustainable"],
    "popularity": 6631
  },
  {
    "name": "sensor_door",
    "tags": ["alarm", "security", "security system"],
    "popularity": 6626
  },
  {
    "name": "signal_wifi_4_bar",
    "tags": [
      "4",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 6621
  },
  {
    "name": "task",
    "tags": [
      "approve",
      "check",
      "complete",
      "data",
      "doc",
      "document",
      "done",
      "drive",
      "file",
      "folder",
      "folders",
      "mark",
      "ok",
      "page",
      "paper",
      "select",
      "sheet",
      "slide",
      "task",
      "tick",
      "validate",
      "verified",
      "writing",
      "yes"
    ],
    "popularity": 6618
  },
  {
    "name": "receipt",
    "tags": [],
    "popularity": 6617
  },
  {
    "name": "local_drink",
    "tags": ["cup", "drink", "drop", "droplet", "liquid", "local", "park", "water"],
    "popularity": 6611
  },
  {
    "name": "wb_incandescent",
    "tags": [
      "balance",
      "bright",
      "edit",
      "editing",
      "incandescent",
      "light",
      "lighting",
      "setting",
      "settings",
      "white",
      "wp"
    ],
    "popularity": 6601
  },
  {
    "name": "redeem",
    "tags": [
      "bill",
      "card",
      "cart",
      "cash",
      "certificate",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "gift",
      "giftcard",
      "money",
      "online",
      "pay",
      "payment",
      "present",
      "redeem",
      "shopping"
    ],
    "popularity": 6596
  },
  {
    "name": "pets",
    "tags": ["animal", "cat", "dog", "hand", "paw", "pet"],
    "popularity": 6591
  },
  {
    "name": "replay_circle_filled",
    "tags": [
      "arrow",
      "arrows",
      "circle",
      "control",
      "controls",
      "filled",
      "music",
      "refresh",
      "renew",
      "repeat",
      "replay",
      "video"
    ],
    "popularity": 6589
  },
  {
    "name": "accessible_forward",
    "tags": [
      "accessibility",
      "accessible",
      "body",
      "forward",
      "handicap",
      "help",
      "human",
      "people",
      "person",
      "wheelchair"
    ],
    "popularity": 6578
  },
  {
    "name": "travel_explore",
    "tags": [
      "earth",
      "explore",
      "find",
      "glass",
      "global",
      "globe",
      "look",
      "magnify",
      "magnifying",
      "map",
      "network",
      "planet",
      "search",
      "see",
      "social",
      "space",
      "travel",
      "web",
      "world"
    ],
    "popularity": 6565
  },
  {
    "name": "local_laundry_service",
    "tags": ["cleaning", "clothing", "dry", "dryer", "hotel", "laundry", "local", "service", "washer"],
    "popularity": 6544
  },
  {
    "name": "local_printshop",
    "tags": ["draft", "fax", "ink", "local", "machine", "office", "paper", "print", "printer", "printshop", "send"],
    "popularity": 6543
  },
  {
    "name": "event_available",
    "tags": [
      "approve",
      "available",
      "calendar",
      "check",
      "complete",
      "date",
      "done",
      "event",
      "mark",
      "ok",
      "schedule",
      "select",
      "tick",
      "time",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 6542
  },
  {
    "name": "schema",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "flow",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "schema",
      "squares",
      "statistics",
      "tracking"
    ],
    "popularity": 6527
  },
  {
    "name": "directions_bus_filled",
    "tags": [
      "automobile",
      "bus",
      "car",
      "cars",
      "direction",
      "directions",
      "filled",
      "maps",
      "public",
      "transportation",
      "vehicle"
    ],
    "popularity": 6521
  },
  {
    "name": "vpn_lock",
    "tags": [
      "earth",
      "globe",
      "lock",
      "locked",
      "network",
      "password",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "virtual",
      "vpn",
      "world"
    ],
    "popularity": 6512
  },
  {
    "name": "request_page",
    "tags": [
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "page",
      "paper",
      "request",
      "sheet",
      "slide",
      "writing"
    ],
    "popularity": 6509
  },
  {
    "name": "token",
    "tags": ["badge", "hexagon", "mark", "shield", "sign", "symbol"],
    "popularity": 6508
  },
  {
    "name": "theater_comedy",
    "tags": [
      "broadway",
      "comedy",
      "event",
      "movie",
      "musical",
      "places",
      "show",
      "standup",
      "theater",
      "tour",
      "watch"
    ],
    "popularity": 6476
  },
  {
    "name": "branding_watermark",
    "tags": [
      "branding",
      "components",
      "copyright",
      "design",
      "emblem",
      "format",
      "identity",
      "interface",
      "layout",
      "logo",
      "screen",
      "site",
      "stamp",
      "ui",
      "ux",
      "watermark",
      "web",
      "website",
      "window"
    ],
    "popularity": 6454
  },
  {
    "name": "text_format",
    "tags": ["alphabet", "character", "font", "format", "letter", "square A", "style", "symbol", "text", "type"],
    "popularity": 6454
  },
  {
    "name": "devices",
    "tags": [
      "Android",
      "OS",
      "computer",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "laptop",
      "mobile",
      "monitor",
      "phone",
      "tablet",
      "watch",
      "wearable",
      "web"
    ],
    "popularity": 6432
  },
  {
    "name": "ads_click",
    "tags": ["ads", "browser", "click", "clicks", "cursor", "internet", "target", "traffic", "web"],
    "popularity": 6425
  },
  {
    "name": "checklist",
    "tags": [
      "align",
      "alignment",
      "approve",
      "check",
      "checklist",
      "complete",
      "doc",
      "done",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "mark",
      "notes",
      "ok",
      "select",
      "sheet",
      "spreadsheet",
      "text",
      "tick",
      "type",
      "validate",
      "verified",
      "writing",
      "yes"
    ],
    "popularity": 6425
  },
  {
    "name": "remove_done",
    "tags": [
      "approve",
      "check",
      "complete",
      "disabled",
      "done",
      "enabled",
      "finished",
      "mark",
      "multiple",
      "off",
      "ok",
      "on",
      "remove",
      "select",
      "slash",
      "tick",
      "yes"
    ],
    "popularity": 6420
  },
  {
    "name": "sports_bar",
    "tags": ["alcohol", "bar", "beer", "drink", "liquor", "pint", "places", "pub", "sports"],
    "popularity": 6408
  },
  {
    "name": "watch",
    "tags": ["Android", "OS", "ar", "clock", "gadget", "iOS", "time", "vr", "watch", "wearables", "web", "wristwatch"],
    "popularity": 6377
  },
  {
    "name": "library_books",
    "tags": ["add", "album", "audio", "book", "books", "collection", "library", "read", "reading"],
    "popularity": 6372
  },
  {
    "name": "settings_power",
    "tags": ["info", "information", "off", "on", "power", "save", "settings", "shutdown"],
    "popularity": 6343
  },
  {
    "name": "format_align_center",
    "tags": [
      "align",
      "alignment",
      "center",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 6339
  },
  {
    "name": "add_to_drive",
    "tags": [
      "add",
      "app",
      "application",
      "backup",
      "cloud",
      "drive",
      "files",
      "folders",
      "gdrive",
      "google",
      "recovery",
      "shortcut",
      "storage"
    ],
    "popularity": 6336
  },
  {
    "name": "local_pizza",
    "tags": ["drink", "fastfood", "food", "local", "meal", "pizza"],
    "popularity": 6297
  },
  {
    "name": "keyboard_double_arrow_right",
    "tags": ["arrow", "arrows", "direction", "double", "multiple", "navigation", "right"],
    "popularity": 6293
  },
  {
    "name": "comment",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "outline", "speech"],
    "popularity": 6292
  },
  {
    "name": "smart_button",
    "tags": [
      "action",
      "ai",
      "artificial",
      "automatic",
      "automation",
      "button",
      "components",
      "composer",
      "custom",
      "function",
      "genai",
      "intelligence",
      "interface",
      "magic",
      "site",
      "smart",
      "spark",
      "sparkle",
      "special",
      "star",
      "stars",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 6289
  },
  {
    "name": "add_alert",
    "tags": [
      "+",
      "active",
      "add",
      "alarm",
      "alert",
      "bell",
      "chime",
      "new",
      "notifications",
      "notify",
      "plus",
      "reminder",
      "ring",
      "sound",
      "symbol"
    ],
    "popularity": 6281
  },
  {
    "name": "diversity_3",
    "tags": [
      "committee",
      "diverse",
      "diversity",
      "family",
      "friends",
      "group",
      "groups",
      "humans",
      "network",
      "people",
      "persons",
      "social",
      "team"
    ],
    "popularity": 6264
  },
  {
    "name": "flare",
    "tags": [
      "bright",
      "edit",
      "editing",
      "effect",
      "flare",
      "image",
      "images",
      "light",
      "photography",
      "picture",
      "pictures",
      "sun"
    ],
    "popularity": 6255
  },
  {
    "name": "star_half",
    "tags": [
      "achievement",
      "bookmark",
      "favorite",
      "half",
      "highlight",
      "important",
      "marked",
      "ranking",
      "rate",
      "rating rank",
      "reward",
      "save",
      "saved",
      "shape",
      "special",
      "star",
      "toggle"
    ],
    "popularity": 6255
  },
  {
    "name": "developer_mode",
    "tags": [
      "Android",
      "OS",
      "bracket",
      "cell",
      "code",
      "developer",
      "development",
      "device",
      "engineer",
      "hardware",
      "iOS",
      "mobile",
      "mode",
      "phone",
      "tablet"
    ],
    "popularity": 6240
  },
  {
    "name": "call_split",
    "tags": ["arrow", "call", "device", "mobile", "split"],
    "popularity": 6231
  },
  {
    "name": "face_retouching_natural",
    "tags": [
      "ai",
      "artificial",
      "automatic",
      "automation",
      "custom",
      "edit",
      "editing",
      "effect",
      "emoji",
      "emotion",
      "face",
      "faces",
      "genai",
      "image",
      "intelligence",
      "magic",
      "natural",
      "photo",
      "photography",
      "retouch",
      "retouching",
      "settings",
      "smart",
      "spark",
      "sparkle",
      "star",
      "tag"
    ],
    "popularity": 6219
  },
  {
    "name": "settings_accessibility",
    "tags": [
      "accessibility",
      "body",
      "details",
      "human",
      "information",
      "people",
      "person",
      "personal",
      "preferences",
      "profile",
      "settings",
      "user"
    ],
    "popularity": 6219
  },
  {
    "name": "free_breakfast",
    "tags": ["beverage", "breakfast", "cafe", "coffee", "cup", "drink", "free", "mug", "tea"],
    "popularity": 6209
  },
  {
    "name": "ios_share",
    "tags": ["arrow", "export", "ios", "send", "share", "up"],
    "popularity": 6199
  },
  {
    "name": "sports_kabaddi",
    "tags": [
      "athlete",
      "athletic",
      "body",
      "combat",
      "entertainment",
      "exercise",
      "fighting",
      "game",
      "hobby",
      "human",
      "kabaddi",
      "people",
      "person",
      "social",
      "sports",
      "wrestle",
      "wrestling"
    ],
    "popularity": 6193
  },
  {
    "name": "auto_delete",
    "tags": ["auto", "bin", "can", "clock", "date", "delete", "garbage", "remove", "schedule", "time", "trash"],
    "popularity": 6191
  },
  {
    "name": "power_settings_new",
    "tags": ["info", "information", "off", "on", "power", "save", "settings", "shutdown"],
    "popularity": 6187
  },
  {
    "name": "not_listed_location",
    "tags": [
      "?",
      "assistance",
      "destination",
      "direction",
      "help",
      "info",
      "information",
      "listed",
      "location",
      "maps",
      "not",
      "pin",
      "place",
      "punctuation",
      "question mark",
      "stop",
      "support",
      "symbol"
    ],
    "popularity": 6168
  },
  {
    "name": "wb_cloudy",
    "tags": ["balance", "cloud", "cloudy", "edit", "editing", "white", "wp"],
    "popularity": 6159
  },
  {
    "name": "sports",
    "tags": [
      "athlete",
      "athletic",
      "blowing",
      "coach",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "instrument",
      "referee",
      "social",
      "sound",
      "sports",
      "warning",
      "whistle"
    ],
    "popularity": 6158
  },
  {
    "name": "forward_10",
    "tags": [
      "10",
      "arrow",
      "control",
      "controls",
      "digit",
      "fast",
      "forward",
      "music",
      "number",
      "play",
      "seconds",
      "symbol",
      "video"
    ],
    "popularity": 6154
  },
  {
    "name": "bathtub",
    "tags": ["bath", "bathing", "bathroom", "bathtub", "home", "hotel", "human", "person", "shower", "travel", "tub"],
    "popularity": 6133
  },
  {
    "name": "add_a_photo",
    "tags": ["+", "a photo", "add", "camera", "lens", "new", "photography", "picture", "plus", "symbol"],
    "popularity": 6131
  },
  {
    "name": "emoji_symbols",
    "tags": ["ampersand", "character", "emoji", "hieroglyph", "music", "note", "percent", "sign", "symbols"],
    "popularity": 6129
  },
  {
    "name": "discount",
    "tags": [],
    "popularity": 6117
  },
  {
    "name": "arrow_drop_up",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "drop",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "up",
      "ux",
      "web",
      "website"
    ],
    "popularity": 6111
  },
  {
    "name": "save_as",
    "tags": [
      "compose",
      "create",
      "data",
      "disk",
      "document",
      "draft",
      "drive",
      "edit",
      "editing",
      "file",
      "floppy",
      "input",
      "multimedia",
      "pen",
      "pencil",
      "save",
      "storage",
      "write",
      "writing"
    ],
    "popularity": 6101
  },
  {
    "name": "tablet_mac",
    "tags": ["Android", "OS", "device", "hardware", "iOS", "ipad", "mobile", "tablet mac", "web"],
    "popularity": 6097
  },
  {
    "name": "mood",
    "tags": [
      "emoji",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "glad",
      "happiness",
      "happy",
      "like",
      "mood",
      "person",
      "pleased",
      "smile",
      "smiling",
      "social",
      "survey"
    ],
    "popularity": 6086
  },
  {
    "name": "broken_image",
    "tags": [
      "broken",
      "corrupt",
      "error",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "torn"
    ],
    "popularity": 6085
  },
  {
    "name": "assistant",
    "tags": [
      "ai",
      "artificial",
      "assistant",
      "automatic",
      "automation",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "custom",
      "feedback",
      "genai",
      "intelligence",
      "magic",
      "message",
      "recommendation",
      "smart",
      "spark",
      "sparkle",
      "speech",
      "star",
      "suggestion",
      "twinkle"
    ],
    "popularity": 6074
  },
  {
    "name": "mode_night",
    "tags": ["dark", "disturb", "lunar", "mode", "moon", "night", "sleep"],
    "popularity": 6072
  },
  {
    "name": "reply",
    "tags": ["arrow", "backward", "left", "mail", "message", "reply", "send", "share"],
    "popularity": 6064
  },
  {
    "name": "escalator_warning",
    "tags": ["body", "child", "escalator", "human", "kid", "parent", "people", "person", "warning"],
    "popularity": 6063
  },
  {
    "name": "cases",
    "tags": ["bag", "baggage", "briefcase", "business", "case", "cases", "purse", "suitcase"],
    "popularity": 6056
  },
  {
    "name": "cloud_upload",
    "tags": [
      "app",
      "application",
      "arrow",
      "backup",
      "cloud",
      "connection",
      "download",
      "drive",
      "files",
      "folders",
      "internet",
      "network",
      "sky",
      "storage",
      "up",
      "upload"
    ],
    "popularity": 6055
  },
  {
    "name": "card_travel",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "membership",
      "miles",
      "money",
      "online",
      "pay",
      "payment",
      "travel",
      "trip"
    ],
    "popularity": 6042
  },
  {
    "name": "wifi_tethering",
    "tags": [
      "cell",
      "cellular",
      "connection",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "scan",
      "service",
      "signal",
      "speed",
      "tethering",
      "wifi",
      "wireless"
    ],
    "popularity": 6042
  },
  {
    "name": "reduce_capacity",
    "tags": ["arrow", "body", "capacity", "covid", "decrease", "down", "human", "people", "person", "reduce", "social"],
    "popularity": 6039
  },
  {
    "name": "font_download",
    "tags": ["A", "alphabet", "character", "download", "font", "letter", "square", "symbol", "text", "type"],
    "popularity": 6026
  },
  {
    "name": "today",
    "tags": ["calendar", "date", "day", "event", "mark", "month", "remember", "reminder", "schedule", "time", "today"],
    "popularity": 6025
  },
  {
    "name": "emoji_food_beverage",
    "tags": ["beverage", "coffee", "cup", "drink", "emoji", "mug", "plate", "set", "tea"],
    "popularity": 6024
  },
  {
    "name": "colorize",
    "tags": ["color", "colorize", "dropper", "extract", "eye", "picker", "tool"],
    "popularity": 6020
  },
  {
    "name": "outbox",
    "tags": ["box", "mail", "outbox", "send", "sent"],
    "popularity": 6009
  },
  {
    "name": "cloud_sync",
    "tags": [
      "app",
      "application",
      "around",
      "backup",
      "cloud",
      "connection",
      "drive",
      "files",
      "folders",
      "inprogress",
      "internet",
      "load",
      "loading refresh",
      "network",
      "renew",
      "rotate",
      "sky",
      "storage",
      "turn",
      "upload"
    ],
    "popularity": 5991
  },
  {
    "name": "try",
    "tags": [
      "bookmark",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "favorite",
      "feedback",
      "highlight",
      "important",
      "marked",
      "message",
      "save",
      "saved",
      "shape",
      "special",
      "speech",
      "star",
      "try"
    ],
    "popularity": 5983
  },
  {
    "name": "sick",
    "tags": [
      "covid",
      "discomfort",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "fever",
      "flu",
      "ill",
      "mood",
      "pain",
      "person",
      "sick",
      "survey",
      "upset"
    ],
    "popularity": 5980
  },
  {
    "name": "hub",
    "tags": ["center", "connection", "core", "focal point", "hub", "network", "nucleus", "topology"],
    "popularity": 5975
  },
  {
    "name": "running_with_errors",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "duration",
      "error",
      "errors",
      "exclamation",
      "important",
      "mark",
      "notification",
      "process",
      "processing",
      "running",
      "symbol",
      "time",
      "warning",
      "with"
    ],
    "popularity": 5968
  },
  {
    "name": "devices_other",
    "tags": [
      "Android",
      "OS",
      "ar",
      "cell",
      "chrome",
      "desktop",
      "device",
      "gadget",
      "hardware",
      "iOS",
      "ipad",
      "mac",
      "mobile",
      "monitor",
      "other",
      "phone",
      "tablet",
      "vr",
      "watch",
      "wearables",
      "window"
    ],
    "popularity": 5967
  },
  {
    "name": "add_location",
    "tags": [
      "+",
      "add",
      "destination",
      "direction",
      "location",
      "maps",
      "new",
      "pin",
      "place",
      "plus",
      "stop",
      "symbol"
    ],
    "popularity": 5963
  },
  {
    "name": "man",
    "tags": ["boy", "gender", "male", "man", "social", "symbol"],
    "popularity": 5958
  },
  {
    "name": "battery_std",
    "tags": ["battery", "cell", "charge", "mobile", "plus", "power", "standard", "std"],
    "popularity": 5953
  },
  {
    "name": "filter_none",
    "tags": ["filter", "multiple", "none", "square", "stack"],
    "popularity": 5950
  },
  {
    "name": "cruelty_free",
    "tags": [
      "animal",
      "bunny",
      "cruelty",
      "eco",
      "free",
      "nature",
      "rabbit",
      "social",
      "sustainability",
      "sustainable",
      "testing"
    ],
    "popularity": 5939
  },
  {
    "name": "transfer_within_a_station",
    "tags": [
      "a",
      "arrow",
      "arrows",
      "body",
      "direction",
      "human",
      "left",
      "maps",
      "people",
      "person",
      "public",
      "right",
      "route",
      "station",
      "stop",
      "transfer",
      "transportation",
      "vehicle",
      "walk",
      "within"
    ],
    "popularity": 5911
  },
  {
    "name": "offline_pin",
    "tags": [
      "approve",
      "check",
      "checkmark",
      "circle",
      "complete",
      "done",
      "mark",
      "offline",
      "ok",
      "pin",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 5906
  },
  {
    "name": "touch_app",
    "tags": ["app", "command", "fingers", "gesture", "hand", "press", "tap", "touch"],
    "popularity": 5900
  },
  {
    "name": "bloodtype",
    "tags": [
      "blood",
      "bloodtype",
      "donate",
      "droplet",
      "emergency",
      "hospital",
      "medicine",
      "negative",
      "positive",
      "type",
      "water"
    ],
    "popularity": 5899
  },
  {
    "name": "dinner_dining",
    "tags": ["breakfast", "dining", "dinner", "food", "fork", "lunch", "meal", "restaurant", "spaghetti", "utensils"],
    "popularity": 5894
  },
  {
    "name": "child_friendly",
    "tags": [
      "baby",
      "care",
      "carriage",
      "child",
      "children",
      "friendly",
      "infant",
      "kid",
      "newborn",
      "stroller",
      "toddler",
      "young"
    ],
    "popularity": 5890
  },
  {
    "name": "weekend",
    "tags": ["chair", "couch", "furniture", "home", "living", "lounge", "relax", "room", "weekend"],
    "popularity": 5884
  },
  {
    "name": "sunny",
    "tags": ["climate", "hot", "summer", "sun", "sunny", "temperature", "warm", "weather"],
    "popularity": 5880
  },
  {
    "name": "draft",
    "tags": ["data", "doc", "document", "draft", "drive", "file", "folder", "folders", "sheet", "slide", "storage"],
    "popularity": 5870
  },
  {
    "name": "replay_10",
    "tags": [
      "10",
      "arrow",
      "arrows",
      "control",
      "controls",
      "digit",
      "music",
      "number",
      "refresh",
      "renew",
      "repeat",
      "replay",
      "symbol",
      "ten",
      "video"
    ],
    "popularity": 5869
  },
  {
    "name": "local_fire_department",
    "tags": [
      "911",
      "climate",
      "department",
      "fire",
      "firefighter",
      "flame",
      "heat",
      "home",
      "hot",
      "nest",
      "thermostat"
    ],
    "popularity": 5861
  },
  {
    "name": "brightness_4",
    "tags": ["4", "brightness", "circle", "control", "crescent", "level", "moon", "screen", "sun"],
    "popularity": 5849
  },
  {
    "name": "emoji_transportation",
    "tags": [
      "architecture",
      "automobile",
      "building",
      "car",
      "cars",
      "direction",
      "emoji",
      "estate",
      "maps",
      "place",
      "public",
      "real",
      "residence",
      "residential",
      "shelter",
      "transportation",
      "travel",
      "vehicle"
    ],
    "popularity": 5835
  },
  {
    "name": "folder_special",
    "tags": [
      "bookmark",
      "data",
      "doc",
      "document",
      "drive",
      "favorite",
      "file",
      "folder",
      "highlight",
      "important",
      "marked",
      "save",
      "saved",
      "shape",
      "sheet",
      "slide",
      "special",
      "star",
      "storage"
    ],
    "popularity": 5835
  },
  {
    "name": "area_chart",
    "tags": [
      "analytics",
      "area",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 5834
  },
  {
    "name": "bakery_dining",
    "tags": ["bakery", "bread", "breakfast", "brunch", "croissant", "dining", "food"],
    "popularity": 5823
  },
  {
    "name": "format_paint",
    "tags": [
      "brush",
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "fill",
      "format",
      "paint",
      "roller",
      "sheet",
      "spreadsheet",
      "style",
      "text",
      "type",
      "writing"
    ],
    "popularity": 5821
  },
  {
    "name": "filter_center_focus",
    "tags": ["camera", "center", "dot", "edit", "filter", "focus", "image", "photo", "photography", "picture"],
    "popularity": 5817
  },
  {
    "name": "legend_toggle",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "legend",
      "measure",
      "metrics",
      "monitoring",
      "stackdriver",
      "statistics",
      "toggle",
      "tracking"
    ],
    "popularity": 5808
  },
  {
    "name": "calendar_view_day",
    "tags": [
      "calendar",
      "date",
      "day",
      "event",
      "format",
      "grid",
      "layout",
      "month",
      "schedule",
      "today",
      "view",
      "week"
    ],
    "popularity": 5794
  },
  {
    "name": "door_front",
    "tags": ["closed", "door", "doorway", "entrance", "exit", "front", "home", "house", "way"],
    "popularity": 5794
  },
  {
    "name": "find_replace",
    "tags": [
      "around",
      "arrows",
      "find",
      "glass",
      "inprogress",
      "load",
      "loading refresh",
      "look",
      "magnify",
      "magnifying",
      "renew",
      "replace",
      "rotate",
      "search",
      "see"
    ],
    "popularity": 5782
  },
  {
    "name": "person_pin_circle",
    "tags": [
      "account",
      "circle",
      "destination",
      "direction",
      "face",
      "human",
      "location",
      "maps",
      "people",
      "person",
      "pin",
      "place",
      "profile",
      "stop",
      "user"
    ],
    "popularity": 5772
  },
  {
    "name": "light",
    "tags": ["bulb", "ceiling", "hanging", "inside", "interior", "lamp", "light", "lighting", "pendent", "room"],
    "popularity": 5766
  },
  {
    "name": "crop_original",
    "tags": [
      "adjust",
      "adjustments",
      "area",
      "crop",
      "edit",
      "editing",
      "frame",
      "image",
      "images",
      "original",
      "photo",
      "photos",
      "picture",
      "settings",
      "size"
    ],
    "popularity": 5764
  },
  {
    "name": "enhanced_encryption",
    "tags": [
      "+",
      "add",
      "encryption",
      "enhanced",
      "lock",
      "locked",
      "new",
      "password",
      "plus",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "symbol"
    ],
    "popularity": 5754
  },
  {
    "name": "rowing",
    "tags": ["activity", "boat", "body", "canoe", "human", "people", "person", "row", "rowing", "sport", "water"],
    "popularity": 5752
  },
  {
    "name": "local_mall",
    "tags": [
      "bag",
      "bill",
      "building",
      "business",
      "buy",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "handbag",
      "local",
      "mall",
      "money",
      "online",
      "pay",
      "payment",
      "shop",
      "shopping",
      "store",
      "storefront"
    ],
    "popularity": 5751
  },
  {
    "name": "forest",
    "tags": ["forest", "jungle", "nature", "plantation", "plants", "trees", "woodland"],
    "popularity": 5741
  },
  {
    "name": "how_to_vote",
    "tags": ["ballot", "election", "how", "poll", "to", "vote"],
    "popularity": 5727
  },
  {
    "name": "chrome_reader_mode",
    "tags": ["chrome", "mode", "read", "reader", "text"],
    "popularity": 5723
  },
  {
    "name": "near_me",
    "tags": [
      "destination",
      "direction",
      "location",
      "maps",
      "me",
      "navigation",
      "near",
      "pin",
      "place",
      "point",
      "stop"
    ],
    "popularity": 5723
  },
  {
    "name": "compress",
    "tags": ["arrow", "arrows", "collide", "compress", "pressure", "push", "together"],
    "popularity": 5715
  },
  {
    "name": "auto_fix_normal",
    "tags": [
      "ai",
      "artificial",
      "auto",
      "automatic",
      "automation",
      "custom",
      "edit",
      "erase",
      "fix",
      "genai",
      "intelligence",
      "magic",
      "modify",
      "smart",
      "spark",
      "sparkle",
      "star",
      "wand"
    ],
    "popularity": 5714
  },
  {
    "name": "dehaze",
    "tags": [
      "adjust",
      "dehaze",
      "edit",
      "editing",
      "enhance",
      "haze",
      "image",
      "lines",
      "photo",
      "photography",
      "remove"
    ],
    "popularity": 5707
  },
  {
    "name": "density_medium",
    "tags": ["density", "horizontal", "lines", "medium", "rule", "rules"],
    "popularity": 5706
  },
  {
    "name": "movie",
    "tags": ["cinema", "film", "media", "movie", "slate", "video"],
    "popularity": 5704
  },
  {
    "name": "currency_exchange",
    "tags": [
      "360",
      "around",
      "arrow",
      "arrows",
      "cash",
      "coin",
      "commerce",
      "currency",
      "direction",
      "dollars",
      "exchange",
      "inprogress",
      "money",
      "pay",
      "renew",
      "rotate",
      "sync",
      "turn",
      "universal"
    ],
    "popularity": 5702
  },
  {
    "name": "exit_to_app",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "design",
      "exit",
      "export",
      "interface",
      "layout",
      "leave",
      "mobile",
      "monitor",
      "move",
      "output",
      "phone",
      "screen",
      "site",
      "tablet",
      "to",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 5700
  },
  {
    "name": "desktop_mac",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "web",
      "window"
    ],
    "popularity": 5684
  },
  {
    "name": "outlet",
    "tags": ["connect", "connecter", "electricity", "outlet", "plug", "power"],
    "popularity": 5684
  },
  {
    "name": "summarize",
    "tags": ["doc", "document", "list", "menu", "note", "report", "summary"],
    "popularity": 5680
  },
  {
    "name": "nature_people",
    "tags": [
      "activity",
      "body",
      "forest",
      "human",
      "nature",
      "outdoor",
      "outside",
      "park",
      "people",
      "person",
      "tree",
      "wilderness"
    ],
    "popularity": 5669
  },
  {
    "name": "fax",
    "tags": ["fax", "machine", "office", "phone", "send"],
    "popularity": 5666
  },
  {
    "name": "square",
    "tags": ["draw", "four", "shape quadrangle", "sides", "square"],
    "popularity": 5655
  },
  {
    "name": "sports_tennis",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "bat",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "racket",
      "social",
      "sports",
      "tennis"
    ],
    "popularity": 5645
  },
  {
    "name": "assignment_returned",
    "tags": ["arrow", "assignment", "clipboard", "doc", "document", "down", "returned"],
    "popularity": 5633
  },
  {
    "name": "upcoming",
    "tags": ["alarm", "calendar", "mail", "message", "notification", "upcoming"],
    "popularity": 5620
  },
  {
    "name": "cookie",
    "tags": ["biscuit", "cookies", "data", "dessert", "wafer"],
    "popularity": 5614
  },
  {
    "name": "settings_brightness",
    "tags": ["brightness", "dark", "filter", "light", "mode", "setting", "settings"],
    "popularity": 5590
  },
  {
    "name": "quiz",
    "tags": [
      "?",
      "assistance",
      "faq",
      "help",
      "info",
      "information",
      "punctuation",
      "question mark",
      "quiz",
      "support",
      "symbol",
      "test"
    ],
    "popularity": 5582
  },
  {
    "name": "http",
    "tags": ["alphabet", "character", "font", "http", "letter", "symbol", "text", "transfer", "type", "url", "website"],
    "popularity": 5566
  },
  {
    "name": "flight",
    "tags": ["air", "airplane", "airport", "flight", "plane", "transportation", "travel", "trip"],
    "popularity": 5564
  },
  {
    "name": "attach_email",
    "tags": [
      "attach",
      "attachment",
      "clip",
      "compose",
      "email",
      "envelop",
      "letter",
      "link",
      "mail",
      "message",
      "send"
    ],
    "popularity": 5562
  },
  {
    "name": "terrain",
    "tags": ["geography", "landscape", "mountain", "terrain"],
    "popularity": 5559
  },
  {
    "name": "photo",
    "tags": ["image", "mountain", "mountains", "photo", "photography", "picture"],
    "popularity": 5555
  },
  {
    "name": "health_and_safety",
    "tags": [
      "+",
      "add",
      "and",
      "certified",
      "cross",
      "health",
      "home",
      "nest",
      "plus",
      "privacy",
      "private",
      "protect",
      "protection",
      "safety",
      "security",
      "shield",
      "symbol",
      "verified"
    ],
    "popularity": 5553
  },
  {
    "name": "wine_bar",
    "tags": ["alcohol", "bar", "cocktail", "cup", "drink", "glass", "liquor", "wine"],
    "popularity": 5553
  },
  {
    "name": "garage",
    "tags": [
      "automobile",
      "automotive",
      "car",
      "cars",
      "direction",
      "garage",
      "maps",
      "transportation",
      "travel",
      "vehicle"
    ],
    "popularity": 5549
  },
  {
    "name": "heart_broken",
    "tags": ["break", "broken", "core", "crush", "health", "heart", "nucleus", "split"],
    "popularity": 5547
  },
  {
    "name": "unfold_more",
    "tags": [
      "arrow",
      "arrows",
      "chevron",
      "collapse",
      "direction",
      "down",
      "expand",
      "expandable",
      "list",
      "more",
      "navigation",
      "unfold"
    ],
    "popularity": 5547
  },
  {
    "name": "feed",
    "tags": [
      "article",
      "feed",
      "headline",
      "information",
      "news",
      "newspaper",
      "paper",
      "public",
      "social",
      "timeline"
    ],
    "popularity": 5545
  },
  {
    "name": "draw",
    "tags": [
      "compose",
      "create",
      "design",
      "draft",
      "draw",
      "edit",
      "editing",
      "input",
      "pen",
      "pencil",
      "write",
      "writing"
    ],
    "popularity": 5539
  },
  {
    "name": "multiple_stop",
    "tags": ["arrows", "directions", "dots", "left", "maps", "multiple", "navigation", "right", "stop"],
    "popularity": 5537
  },
  {
    "name": "format_color_text",
    "tags": [
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "fill",
      "format",
      "paint",
      "sheet",
      "spreadsheet",
      "style",
      "text",
      "type",
      "writing"
    ],
    "popularity": 5533
  },
  {
    "name": "gesture",
    "tags": ["drawing", "finger", "gesture", "gestures", "hand", "motion"],
    "popularity": 5521
  },
  {
    "name": "cloud",
    "tags": [
      "climate",
      "cloud",
      "connection",
      "internet",
      "network",
      "queue",
      "sky",
      "temperature",
      "upload",
      "weather"
    ],
    "popularity": 5519
  },
  {
    "name": "sentiment_dissatisfied",
    "tags": [
      "angry",
      "disappointed",
      "dislike",
      "dissatisfied",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "frown",
      "mood",
      "person",
      "sad",
      "sentiment",
      "survey",
      "unhappy",
      "unsatisfied",
      "upset"
    ],
    "popularity": 5516
  },
  {
    "name": "signal_cellular_alt",
    "tags": [
      "alt",
      "analytics",
      "bar",
      "cell",
      "cellular",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "internet",
      "measure",
      "metrics",
      "mobile",
      "network",
      "phone",
      "signal",
      "statistics",
      "tracking",
      "wifi",
      "wireless"
    ],
    "popularity": 5504
  },
  {
    "name": "pending",
    "tags": ["circle", "dots", "loading", "pending", "progress", "wait", "waiting"],
    "popularity": 5493
  },
  {
    "name": "format_align_right",
    "tags": [
      "align",
      "alignment",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "right",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 5489
  },
  {
    "name": "preview",
    "tags": [
      "design",
      "eye",
      "layout",
      "preview",
      "reveal",
      "screen",
      "see",
      "show",
      "site",
      "view",
      "web",
      "website",
      "window",
      "www"
    ],
    "popularity": 5477
  },
  {
    "name": "transgender",
    "tags": ["female", "gender", "lgbt", "male", "neutral", "social", "symbol", "transgender"],
    "popularity": 5475
  },
  {
    "name": "alarm_add",
    "tags": [
      "+",
      "add",
      "alarm",
      "alert",
      "bell",
      "clock",
      "countdown",
      "date",
      "new",
      "notification",
      "plus",
      "schedule",
      "symbol",
      "time"
    ],
    "popularity": 5453
  },
  {
    "name": "skip_next",
    "tags": ["arrow", "control", "controls", "music", "next", "play", "previous", "skip", "video"],
    "popularity": 5439
  },
  {
    "name": "new_label",
    "tags": [
      "+",
      "add",
      "archive",
      "bookmark",
      "favorite",
      "label",
      "library",
      "new",
      "plus",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "symbol",
      "tag"
    ],
    "popularity": 5433
  },
  {
    "name": "south_east",
    "tags": ["arrow", "directional", "down", "east", "maps", "navigation", "right", "south"],
    "popularity": 5425
  },
  {
    "name": "generating_tokens",
    "tags": [
      "access",
      "ai",
      "api",
      "artificial",
      "automatic",
      "automation",
      "coin",
      "custom",
      "genai",
      "generating",
      "intelligence",
      "magic",
      "smart",
      "spark",
      "sparkle",
      "star",
      "tokens"
    ],
    "popularity": 5424
  },
  {
    "name": "add_card",
    "tags": [
      "+",
      "add",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "new",
      "online",
      "pay",
      "payment",
      "plus",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 5416
  },
  {
    "name": "backup_table",
    "tags": ["backup", "drive", "files folders", "format", "layout", "stack", "storage", "table"],
    "popularity": 5413
  },
  {
    "name": "speed",
    "tags": [
      "arrow",
      "control",
      "controls",
      "fast",
      "gauge",
      "meter",
      "motion",
      "music",
      "slow",
      "speed",
      "speedometer",
      "velocity",
      "video"
    ],
    "popularity": 5403
  },
  {
    "name": "stars",
    "tags": [
      "achievement",
      "bookmark",
      "circle",
      "favorite",
      "highlight",
      "important",
      "marked",
      "ranking",
      "rate",
      "rating rank",
      "reward",
      "save",
      "saved",
      "shape",
      "special",
      "star"
    ],
    "popularity": 5401
  },
  {
    "name": "science",
    "tags": [
      "beaker",
      "chemical",
      "chemistry",
      "experiment",
      "flask",
      "glass",
      "laboratory",
      "research",
      "science",
      "tube"
    ],
    "popularity": 5397
  },
  {
    "name": "unsubscribe",
    "tags": [
      "cancel",
      "close",
      "email",
      "envelop",
      "letter",
      "mail",
      "message",
      "newsletter",
      "off",
      "remove",
      "send",
      "subscribe",
      "unsubscribe"
    ],
    "popularity": 5387
  },
  {
    "name": "flash_off",
    "tags": [
      "bolt",
      "disabled",
      "electric",
      "enabled",
      "fast",
      "flash",
      "lightning",
      "off",
      "on",
      "slash",
      "thunderbolt"
    ],
    "popularity": 5384
  },
  {
    "name": "elderly",
    "tags": ["body", "cane", "elderly", "human", "old", "people", "person", "senior"],
    "popularity": 5375
  },
  {
    "name": "spellcheck",
    "tags": [
      "a",
      "alphabet",
      "approve",
      "character",
      "check",
      "font",
      "letter",
      "mark",
      "ok",
      "processor",
      "select",
      "spell",
      "spellcheck",
      "symbol",
      "text",
      "tick",
      "type",
      "word",
      "write",
      "yes"
    ],
    "popularity": 5372
  },
  {
    "name": "sentiment_very_satisfied",
    "tags": [
      "emotions",
      "expressions",
      "face",
      "feelings",
      "glad",
      "happiness",
      "happy",
      "like",
      "mood",
      "person",
      "pleased",
      "satisfied",
      "sentiment",
      "smile",
      "smiling",
      "survey",
      "very"
    ],
    "popularity": 5354
  },
  {
    "name": "restore_page",
    "tags": ["arrow", "data", "doc", "file", "page", "paper", "refresh", "restore", "rotate", "sheet", "storage"],
    "popularity": 5346
  },
  {
    "name": "auto_awesome_mosaic",
    "tags": ["adjust", "auto", "awesome", "collage", "edit", "editing", "enhance", "image", "mosaic", "photo"],
    "popularity": 5342
  },
  {
    "name": "outdoor_grill",
    "tags": ["barbecue", "bbq", "charcoal", "cooking", "grill", "home", "house", "outdoor", "outside"],
    "popularity": 5342
  },
  {
    "name": "trending_flat",
    "tags": ["arrow", "change", "data", "flat", "metric", "movement", "rate", "right", "track", "tracking", "trending"],
    "popularity": 5338
  },
  {
    "name": "add_moderator",
    "tags": [
      "+",
      "add",
      "certified",
      "moderator",
      "new",
      "plus",
      "privacy",
      "private",
      "protect",
      "protection",
      "security",
      "shield",
      "symbol",
      "verified"
    ],
    "popularity": 5333
  },
  {
    "name": "foundation",
    "tags": [
      "architecture",
      "base",
      "basis",
      "building",
      "construction",
      "estate",
      "foundation",
      "home",
      "house",
      "real",
      "residential"
    ],
    "popularity": 5328
  },
  {
    "name": "credit_card_off",
    "tags": [
      "card",
      "charge",
      "commerce",
      "cost",
      "credit",
      "disabled",
      "enabled",
      "finance",
      "money",
      "off",
      "online",
      "pay",
      "payment",
      "slash"
    ],
    "popularity": 5324
  },
  {
    "name": "new_releases",
    "tags": [
      "approve",
      "award",
      "check",
      "checkmark",
      "complete",
      "done",
      "new",
      "notification",
      "ok",
      "release",
      "releases",
      "select",
      "star",
      "symbol",
      "tick",
      "verification",
      "verified",
      "warning",
      "yes"
    ],
    "popularity": 5312
  },
  {
    "name": "scatter_plot",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "circles",
      "data",
      "diagram",
      "dot",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "plot",
      "scatter",
      "statistics",
      "tracking"
    ],
    "popularity": 5305
  },
  {
    "name": "play_for_work",
    "tags": ["arrow", "circle", "down", "google", "half", "play", "work"],
    "popularity": 5302
  },
  {
    "name": "signal_cellular_4_bar",
    "tags": [
      "4",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "signal",
      "speed",
      "wifi",
      "wireless"
    ],
    "popularity": 5297
  },
  {
    "name": "library_add",
    "tags": [
      "+",
      "add",
      "collection",
      "layers",
      "library",
      "multiple",
      "music",
      "new",
      "plus",
      "stacked",
      "symbol",
      "video"
    ],
    "popularity": 5296
  },
  {
    "name": "where_to_vote",
    "tags": [
      "approve",
      "ballot",
      "check",
      "complete",
      "destination",
      "direction",
      "done",
      "location",
      "maps",
      "mark",
      "ok",
      "pin",
      "place",
      "poll",
      "select",
      "stop",
      "tick",
      "to",
      "validate election",
      "verified",
      "vote",
      "where",
      "yes"
    ],
    "popularity": 5288
  },
  {
    "name": "wifi_protected_setup",
    "tags": ["around", "arrow", "arrows", "protected", "rotate", "setup", "wifi"],
    "popularity": 5288
  },
  {
    "name": "app_settings_alt",
    "tags": [
      "Android",
      "OS",
      "app",
      "applications",
      "cell",
      "device",
      "gear",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "setting",
      "settings",
      "tablet"
    ],
    "popularity": 5279
  },
  {
    "name": "keyboard_tab",
    "tags": ["arrow", "keyboard", "left", "next", "right", "tab"],
    "popularity": 5279
  },
  {
    "name": "deck",
    "tags": [
      "chairs",
      "deck",
      "home",
      "house",
      "outdoors",
      "outside",
      "patio",
      "social",
      "terrace",
      "umbrella",
      "yard"
    ],
    "popularity": 5271
  },
  {
    "name": "shopping_basket",
    "tags": [
      "add",
      "basket",
      "bill",
      "buy",
      "card",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "money",
      "online",
      "pay",
      "payment",
      "shopping"
    ],
    "popularity": 5257
  },
  {
    "name": "cached",
    "tags": ["around", "arrows", "cache", "cached", "inprogress", "load", "loading refresh", "renew", "rotate"],
    "popularity": 5254
  },
  {
    "name": "takeout_dining",
    "tags": ["box", "container", "delivery", "dining", "food", "meal", "restaurant", "takeout"],
    "popularity": 5236
  },
  {
    "name": "person_search",
    "tags": [
      "account",
      "avatar",
      "face",
      "find",
      "glass",
      "human",
      "look",
      "magnify",
      "magnifying",
      "people",
      "person",
      "profile",
      "search",
      "user"
    ],
    "popularity": 5232
  },
  {
    "name": "woman",
    "tags": ["female", "gender", "girl", "lady", "social", "symbol", "woman", "women"],
    "popularity": 5232
  },
  {
    "name": "photo_library",
    "tags": ["album", "image", "library", "mountain", "mountains", "photo", "photography", "picture"],
    "popularity": 5231
  },
  {
    "name": "tag_faces",
    "tags": ["emoji", "emotion", "faces", "happy", "satisfied", "smile", "tag"],
    "popularity": 5230
  },
  {
    "name": "brightness_6",
    "tags": ["6", "brightness", "circle", "control", "crescent", "level", "moon", "screen", "sun"],
    "popularity": 5214
  },
  {
    "name": "free_cancellation",
    "tags": [
      "approve",
      "calendar",
      "cancel",
      "cancellation",
      "check",
      "complete",
      "date",
      "day",
      "done",
      "event",
      "exit",
      "free",
      "mark",
      "month",
      "no",
      "ok",
      "remove",
      "schedule",
      "select",
      "stop",
      "tick",
      "validate",
      "verified",
      "x",
      "yes"
    ],
    "popularity": 5201
  },
  {
    "name": "edit_document",
    "tags": [
      "compose",
      "create",
      "doc",
      "document",
      "draft",
      "drive",
      "edit",
      "editing",
      "file",
      "folder",
      "folders",
      "input",
      "page",
      "paper",
      "pen",
      "pencil",
      "write",
      "writing"
    ],
    "popularity": 5189
  },
  {
    "name": "assistant_direction",
    "tags": [
      "assistant",
      "destination",
      "direction",
      "location",
      "maps",
      "navigate",
      "navigation",
      "pin",
      "place",
      "right",
      "stop"
    ],
    "popularity": 5175
  },
  {
    "name": "brightness_5",
    "tags": ["5", "brightness", "circle", "control", "crescent", "level", "moon", "screen", "sun"],
    "popularity": 5141
  },
  {
    "name": "subdirectory_arrow_left",
    "tags": ["arrow", "directory", "down", "left", "navigation", "sub", "subdirectory"],
    "popularity": 5141
  },
  {
    "name": "add_reaction",
    "tags": [
      "+",
      "add",
      "emoji",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "glad",
      "happiness",
      "happy",
      "icon",
      "icons",
      "insert",
      "like",
      "mood",
      "new",
      "person",
      "pleased",
      "plus",
      "smile",
      "smiling",
      "social",
      "survey",
      "symbol"
    ],
    "popularity": 5138
  },
  {
    "name": "social_distance",
    "tags": ["6", "apart", "body", "distance", "ft", "human", "people", "person", "social", "space"],
    "popularity": 5132
  },
  {
    "name": "store_mall_directory",
    "tags": ["directory", "mall", "store"],
    "popularity": 5123
  },
  {
    "name": "laptop_chromebook",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "chromebook",
      "device",
      "display",
      "hardware",
      "iOS",
      "laptop",
      "mac chromebook",
      "monitor",
      "screen",
      "web",
      "window"
    ],
    "popularity": 5122
  },
  {
    "name": "format_list_numbered_rtl",
    "tags": [
      "align",
      "alignment",
      "digit",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "notes",
      "number",
      "numbered",
      "rtl",
      "sheet",
      "spreadsheet",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 5117
  },
  {
    "name": "account_box",
    "tags": ["account", "avatar", "box", "face", "human", "people", "person", "profile", "square", "thumbnail", "user"],
    "popularity": 5109
  },
  {
    "name": "settings_overscan",
    "tags": ["arrows", "expand", "image", "photo", "picture", "scan", "settings"],
    "popularity": 5096
  },
  {
    "name": "security",
    "tags": ["certified", "privacy", "private", "protect", "protection", "security", "shield", "verified"],
    "popularity": 5095
  },
  {
    "name": "select_check_box",
    "tags": [
      "approved",
      "box",
      "button",
      "check",
      "component",
      "form",
      "mark",
      "ok",
      "select",
      "selected",
      "selection",
      "tick",
      "toggle",
      "ui",
      "verified",
      "yes"
    ],
    "popularity": 5090
  },
  {
    "name": "follow_the_signs",
    "tags": ["arrow", "body", "directional", "follow", "human", "people", "person", "right", "signs", "social", "the"],
    "popularity": 5089
  },
  {
    "name": "icecream",
    "tags": ["cream", "dessert", "food", "ice", "icecream", "snack"],
    "popularity": 5089
  },
  {
    "name": "celebration",
    "tags": ["activity", "birthday", "celebration", "event", "fun", "party"],
    "popularity": 5086
  },
  {
    "name": "details",
    "tags": ["details", "edit", "editing", "enhance", "image", "photo", "photography", "sharpen", "triangle"],
    "popularity": 5077
  },
  {
    "name": "personal_injury",
    "tags": [
      "accident",
      "aid",
      "arm",
      "bandage",
      "body",
      "broke",
      "cast",
      "fracture",
      "health",
      "human",
      "injury",
      "medical",
      "patient",
      "people",
      "person",
      "personal",
      "sling",
      "social"
    ],
    "popularity": 5072
  },
  {
    "name": "terminal",
    "tags": ["application", "code", "emulator", "program", "software", "terminal"],
    "popularity": 5062
  },
  {
    "name": "food_bank",
    "tags": [
      "architecture",
      "bank",
      "building",
      "charity",
      "eat",
      "estate",
      "food",
      "fork",
      "house",
      "knife",
      "meal",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "utensils"
    ],
    "popularity": 5050
  },
  {
    "name": "attribution",
    "tags": ["attribute", "attribution", "body", "copyright", "copywriter", "human", "people", "person"],
    "popularity": 5043
  },
  {
    "name": "business_center",
    "tags": ["bag", "baggage", "briefcase", "business", "case", "center", "places", "purse", "suitcase", "work"],
    "popularity": 5036
  },
  {
    "name": "closed_caption",
    "tags": [
      "accessible",
      "alphabet",
      "caption",
      "cc",
      "character",
      "closed",
      "decoder",
      "font",
      "language",
      "letter",
      "media",
      "movies",
      "subtitle",
      "subtitles",
      "symbol",
      "text",
      "tv",
      "type"
    ],
    "popularity": 5036
  },
  {
    "name": "grain",
    "tags": [
      "dots",
      "edit",
      "editing",
      "effect",
      "filter",
      "grain",
      "image",
      "images",
      "photography",
      "picture",
      "pictures"
    ],
    "popularity": 5025
  },
  {
    "name": "phonelink",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "computer",
      "connect",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "link",
      "mac",
      "mobile",
      "phone",
      "phonelink",
      "sync",
      "tablet",
      "web",
      "windows"
    ],
    "popularity": 5025
  },
  {
    "name": "flip_camera_android",
    "tags": [
      "android",
      "camera",
      "center",
      "edit",
      "editing",
      "flip",
      "image",
      "mobile",
      "orientation",
      "rotate",
      "turn"
    ],
    "popularity": 5008
  },
  {
    "name": "gif",
    "tags": [
      "alphabet",
      "animated",
      "animation",
      "bitmap",
      "character",
      "font",
      "format",
      "gif",
      "graphics",
      "interchange",
      "letter",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 5008
  },
  {
    "name": "sports_esports",
    "tags": [
      "controller",
      "entertainment",
      "esports",
      "game",
      "gamepad",
      "gaming",
      "hobby",
      "online",
      "social",
      "sports",
      "video"
    ],
    "popularity": 4989
  },
  {
    "name": "museum",
    "tags": [
      "architecture",
      "attraction",
      "building",
      "estate",
      "event",
      "exhibition",
      "explore",
      "local",
      "museum",
      "places",
      "real",
      "see",
      "shop",
      "store",
      "tour"
    ],
    "popularity": 4983
  },
  {
    "name": "north_west",
    "tags": ["arrow", "directional", "left", "maps", "navigation", "north", "up", "west"],
    "popularity": 4981
  },
  {
    "name": "brightness_1",
    "tags": ["1", "brightness", "circle", "control", "crescent", "level", "moon", "screen"],
    "popularity": 4974
  },
  {
    "name": "military_tech",
    "tags": [
      "army",
      "award",
      "badge",
      "honor",
      "medal",
      "merit",
      "military",
      "order",
      "privilege",
      "prize",
      "rank",
      "reward",
      "ribbon",
      "soldier",
      "star",
      "status",
      "tech",
      "trophy",
      "win",
      "winner"
    ],
    "popularity": 4974
  },
  {
    "name": "electric_bolt",
    "tags": ["bolt", "electric", "energy", "fast", "lightning", "nest", "thunderbolt"],
    "popularity": 4972
  },
  {
    "name": "highlight",
    "tags": [
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "emphasize",
      "fill",
      "flash",
      "format",
      "highlight",
      "light",
      "paint",
      "sheet",
      "spreadsheet",
      "style",
      "text",
      "type",
      "writing"
    ],
    "popularity": 4972
  },
  {
    "name": "plus_one",
    "tags": ["1", "add", "digit", "increase", "number", "one", "plus", "symbol"],
    "popularity": 4970
  },
  {
    "name": "desktop_windows",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "television",
      "tv",
      "web",
      "window",
      "windows"
    ],
    "popularity": 4968
  },
  {
    "name": "how_to_reg",
    "tags": [
      "approve",
      "ballot",
      "check",
      "complete",
      "done",
      "election",
      "how",
      "mark",
      "ok",
      "poll",
      "register",
      "registration",
      "select",
      "tick",
      "to reg",
      "validate",
      "verified",
      "vote",
      "yes"
    ],
    "popularity": 4954
  },
  {
    "name": "gite",
    "tags": [
      "architecture",
      "estate",
      "gite",
      "home",
      "hostel",
      "house",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling"
    ],
    "popularity": 4953
  },
  {
    "name": "flashlight_on",
    "tags": ["disabled", "enabled", "flash", "flashlight", "light", "off", "on", "slash"],
    "popularity": 4950
  },
  {
    "name": "translate",
    "tags": ["language", "speaking", "speech", "translate", "translator", "words"],
    "popularity": 4948
  },
  {
    "name": "east",
    "tags": ["arrow", "directional", "east", "maps", "navigation", "right"],
    "popularity": 4947
  },
  {
    "name": "fmd_bad",
    "tags": [
      "!",
      "alert",
      "attention",
      "bad",
      "caution",
      "danger",
      "destination",
      "direction",
      "error",
      "exclamation",
      "fmd",
      "important",
      "location",
      "maps",
      "mark",
      "notification",
      "pin",
      "place",
      "symbol",
      "warning"
    ],
    "popularity": 4940
  },
  {
    "name": "work_history",
    "tags": [
      "back",
      "backwards",
      "bag",
      "baggage",
      "briefcase",
      "business",
      "case",
      "clock",
      "date",
      "history",
      "job",
      "pending",
      "recent",
      "schedule",
      "suitcase",
      "time",
      "updates",
      "work"
    ],
    "popularity": 4929
  },
  {
    "name": "bug_report",
    "tags": ["animal", "bug", "fix", "insect", "issue", "problem", "report", "testing", "virus", "warning"],
    "popularity": 4927
  },
  {
    "name": "change_circle",
    "tags": ["around", "arrows", "change", "circle", "direction", "navigation", "rotate"],
    "popularity": 4926
  },
  {
    "name": "flip",
    "tags": ["edit", "editing", "flip", "image", "orientation", "scan scanning"],
    "popularity": 4915
  },
  {
    "name": "123",
    "tags": ["1", "2", "3", "digit", "number", "symbol"],
    "popularity": 4913
  },
  {
    "name": "villa",
    "tags": [
      "architecture",
      "beach",
      "estate",
      "home",
      "house",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "traveling",
      "vacation stay",
      "villa"
    ],
    "popularity": 4912
  },
  {
    "name": "password",
    "tags": ["key", "login", "password", "pin", "security", "star", "unlock"],
    "popularity": 4904
  },
  {
    "name": "stadia_controller",
    "tags": [
      "console",
      "control",
      "controller",
      "device",
      "esports",
      "game",
      "gaming",
      "google",
      "handheld",
      "hardware",
      "playstation",
      "remote",
      "stadia",
      "video",
      "xbox"
    ],
    "popularity": 4897
  },
  {
    "name": "do_disturb",
    "tags": ["cancel", "close", "denied", "deny", "disturb", "do", "remove", "silence", "stop"],
    "popularity": 4895
  },
  {
    "name": "nightlife",
    "tags": [
      "alcohol",
      "bar",
      "bottle",
      "club",
      "cocktail",
      "dance",
      "drink",
      "food",
      "glass",
      "liquor",
      "music",
      "nightlife",
      "note",
      "wine"
    ],
    "popularity": 4895
  },
  {
    "name": "present_to_all",
    "tags": ["all", "arrow", "present", "presentation", "screen", "share", "site", "slides", "to", "web", "website"],
    "popularity": 4894
  },
  {
    "name": "outbound",
    "tags": ["arrow", "circle", "directional", "outbound", "right", "up"],
    "popularity": 4890
  },
  {
    "name": "newspaper",
    "tags": [
      "article",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "magazine",
      "media",
      "news",
      "newspaper",
      "notes",
      "page",
      "paper",
      "sheet",
      "slide",
      "text",
      "writing"
    ],
    "popularity": 4885
  },
  {
    "name": "disabled_by_default",
    "tags": [
      "box",
      "by",
      "cancel",
      "close",
      "default",
      "disabled",
      "exit",
      "no",
      "quit",
      "remove",
      "square",
      "stop",
      "x"
    ],
    "popularity": 4884
  },
  {
    "name": "file_copy",
    "tags": ["content", "copy", "cut", "doc", "document", "duplicate", "file", "multiple", "past"],
    "popularity": 4875
  },
  {
    "name": "view_list",
    "tags": ["design", "format", "grid", "layout", "lines", "list", "stacked", "view", "website"],
    "popularity": 4874
  },
  {
    "name": "splitscreen",
    "tags": ["column", "grid", "layout", "multitasking", "row", "screen", "split", "splitscreen", "two"],
    "popularity": 4867
  },
  {
    "name": "waterfall_chart",
    "tags": [
      "analytics",
      "bar",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking",
      "waterfall"
    ],
    "popularity": 4863
  },
  {
    "name": "local_pharmacy",
    "tags": ["911", "aid", "cross", "emergency", "first", "hospital", "local", "medicine", "pharmacy", "places"],
    "popularity": 4861
  },
  {
    "name": "domain_verification",
    "tags": [
      "app",
      "application desktop",
      "approve",
      "check",
      "complete",
      "design",
      "domain",
      "done",
      "interface",
      "internet",
      "layout",
      "mark",
      "ok",
      "screen",
      "select",
      "site",
      "tick",
      "ui",
      "ux",
      "validate",
      "verification",
      "verified",
      "web",
      "website",
      "window",
      "www",
      "yes"
    ],
    "popularity": 4853
  },
  {
    "name": "disabled_visible",
    "tags": [
      "cancel",
      "close",
      "disabled",
      "exit",
      "eye",
      "no",
      "on",
      "quit",
      "remove",
      "reveal",
      "see",
      "show",
      "stop",
      "view",
      "visibility",
      "visible"
    ],
    "popularity": 4837
  },
  {
    "name": "swap_vertical_circle",
    "tags": ["arrow", "arrows", "circle", "down", "swap", "up", "vertical"],
    "popularity": 4834
  },
  {
    "name": "switch_left",
    "tags": ["arrows", "directional", "left", "navigation", "switch", "toggle"],
    "popularity": 4832
  },
  {
    "name": "import_contacts",
    "tags": ["address", "book", "contacts", "import", "info", "information", "open"],
    "popularity": 4822
  },
  {
    "name": "lan",
    "tags": ["computer", "connection", "data", "internet", "lan", "network", "service"],
    "popularity": 4815
  },
  {
    "name": "fireplace",
    "tags": [
      "chimney",
      "fire",
      "fireplace",
      "flame",
      "home",
      "house",
      "living",
      "pit",
      "place",
      "room",
      "warm",
      "winter"
    ],
    "popularity": 4804
  },
  {
    "name": "settings_input_composite",
    "tags": ["component", "composite", "connection", "connectivity", "input", "plug", "points", "settings"],
    "popularity": 4804
  },
  {
    "name": "video_settings",
    "tags": [
      "change",
      "details",
      "gear",
      "info",
      "information",
      "options",
      "play",
      "screen",
      "service",
      "setting",
      "settings",
      "video",
      "window"
    ],
    "popularity": 4802
  },
  {
    "name": "format_align_justify",
    "tags": [
      "align",
      "alignment",
      "density",
      "doc",
      "edit",
      "editing",
      "editor",
      "extra",
      "format",
      "justify",
      "sheet",
      "small",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 4800
  },
  {
    "name": "network_wifi",
    "tags": ["cell", "cellular", "data", "internet", "mobile", "network", "phone", "speed", "wifi", "wireless"],
    "popularity": 4797
  },
  {
    "name": "cancel_schedule_send",
    "tags": ["cancel", "email", "mail", "no", "quit", "remove", "schedule", "send", "share", "stop", "x"],
    "popularity": 4793
  },
  {
    "name": "network_check",
    "tags": [
      "check",
      "connect",
      "connection",
      "internet",
      "meter",
      "network",
      "signal",
      "speed",
      "tick",
      "wifi",
      "wireless"
    ],
    "popularity": 4792
  },
  {
    "name": "quickreply",
    "tags": [
      "bolt",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "fast",
      "lightning",
      "message",
      "quick",
      "quickreply",
      "reply",
      "speech",
      "thunderbolt"
    ],
    "popularity": 4787
  },
  {
    "name": "loupe",
    "tags": ["+", "add", "details", "focus", "glass", "loupe", "magnifying", "new", "plus", "symbol"],
    "popularity": 4780
  },
  {
    "name": "sms_failed",
    "tags": [
      "!",
      "alert",
      "announcement",
      "attention",
      "caution",
      "chat",
      "chat bubble",
      "comment",
      "communicate",
      "communication",
      "conversation",
      "danger",
      "error",
      "exclamation",
      "failed",
      "feedback",
      "important",
      "mark",
      "message",
      "notification",
      "service",
      "sms",
      "speech",
      "symbol",
      "warning"
    ],
    "popularity": 4776
  },
  {
    "name": "monitor",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "web",
      "window"
    ],
    "popularity": 4758
  },
  {
    "name": "replay",
    "tags": ["arrow", "arrows", "control", "controls", "music", "refresh", "renew", "repeat", "replay", "video"],
    "popularity": 4753
  },
  {
    "name": "night_shelter",
    "tags": [
      "architecture",
      "bed",
      "building",
      "estate",
      "homeless",
      "house",
      "night",
      "place",
      "real",
      "shelter",
      "sleep"
    ],
    "popularity": 4750
  },
  {
    "name": "swap_horiz",
    "tags": ["arrow", "arrows", "back", "forward", "horizontal", "swap"],
    "popularity": 4747
  },
  {
    "name": "view_day",
    "tags": ["cards", "carousel", "day", "design", "format", "grid", "layout", "view", "website"],
    "popularity": 4743
  },
  {
    "name": "navigate_before",
    "tags": ["arrow", "arrows", "before", "direction", "left", "navigate"],
    "popularity": 4733
  },
  {
    "name": "clean_hands",
    "tags": ["bacteria", "clean", "disinfect", "germs", "gesture", "hand", "hands", "sanitize", "sanitizer"],
    "popularity": 4731
  },
  {
    "name": "comment_bank",
    "tags": [
      "archive",
      "bank",
      "bookmark",
      "bubble",
      "cchat",
      "comment",
      "communicate",
      "favorite",
      "label",
      "library",
      "message",
      "remember",
      "ribbon",
      "save",
      "speech",
      "tag"
    ],
    "popularity": 4728
  },
  {
    "name": "mark_chat_read",
    "tags": [
      "approve",
      "bubble",
      "chat",
      "check",
      "comment",
      "communicate",
      "complete",
      "done",
      "mark",
      "message",
      "ok",
      "read",
      "select",
      "sent",
      "speech",
      "tick",
      "verified",
      "yes"
    ],
    "popularity": 4727
  },
  {
    "name": "sim_card_download",
    "tags": ["arrow", "camera", "card", "chip", "device", "down", "download", "memory", "phone", "sim", "storage"],
    "popularity": 4726
  },
  {
    "name": "qr_code_2",
    "tags": ["barcode", "camera", "code", "media", "product", "qr", "quick", "response", "smartphone", "url", "urls"],
    "popularity": 4723
  },
  {
    "name": "location_city",
    "tags": [
      "apartments",
      "architecture",
      "buildings",
      "business",
      "city",
      "estate",
      "home",
      "landscape",
      "location",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "town",
      "urban"
    ],
    "popularity": 4713
  },
  {
    "name": "smart_display",
    "tags": [
      "airplay",
      "cast",
      "chrome",
      "connect",
      "device",
      "display",
      "play",
      "screen",
      "screencast",
      "smart",
      "stream",
      "television",
      "tv",
      "video",
      "wireless"
    ],
    "popularity": 4713
  },
  {
    "name": "auto_stories",
    "tags": ["auto", "book", "flipping", "pages", "stories"],
    "popularity": 4706
  },
  {
    "name": "note_add",
    "tags": [
      "+",
      "add",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "new",
      "note",
      "page",
      "paper",
      "plus",
      "sheet",
      "slide",
      "symbol",
      "writing"
    ],
    "popularity": 4705
  },
  {
    "name": "piano",
    "tags": ["instrument", "keyboard", "keys", "music", "musical", "piano", "social"],
    "popularity": 4685
  },
  {
    "name": "scale",
    "tags": ["measure", "monitor", "scale", "weight"],
    "popularity": 4678
  },
  {
    "name": "switch_access_shortcut",
    "tags": [
      "access",
      "arrow",
      "arrows",
      "direction",
      "navigation",
      "new",
      "north",
      "shortcut",
      "switch",
      "symbol",
      "up"
    ],
    "popularity": 4669
  },
  {
    "name": "wallet",
    "tags": [],
    "popularity": 4663
  },
  {
    "name": "add_ic_call",
    "tags": [
      "+",
      "add",
      "call",
      "cell",
      "contact",
      "device",
      "hardware",
      "mobile",
      "new",
      "phone",
      "plus",
      "symbol",
      "telephone"
    ],
    "popularity": 4642
  },
  {
    "name": "contact_mail",
    "tags": [
      "account",
      "address",
      "avatar",
      "communicate",
      "contact",
      "email",
      "face",
      "human",
      "info",
      "information",
      "mail",
      "message",
      "people",
      "person",
      "profile",
      "user"
    ],
    "popularity": 4641
  },
  {
    "name": "contacts",
    "tags": [
      "account",
      "avatar",
      "call",
      "cell",
      "contacts",
      "face",
      "human",
      "info",
      "information",
      "mobile",
      "people",
      "person",
      "phone",
      "profile",
      "user"
    ],
    "popularity": 4640
  },
  {
    "name": "border_color",
    "tags": [
      "all",
      "border",
      "doc",
      "edit",
      "editing",
      "editor",
      "pen",
      "pencil",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "writing"
    ],
    "popularity": 4637
  },
  {
    "name": "image_not_supported",
    "tags": [
      "disabled",
      "enabled",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "not",
      "off",
      "on",
      "photo",
      "photography",
      "picture",
      "slash",
      "supported"
    ],
    "popularity": 4634
  },
  {
    "name": "fitness_center",
    "tags": [
      "athlete",
      "center",
      "dumbbell",
      "exercise",
      "fitness",
      "gym",
      "hobby",
      "places",
      "sport",
      "weights",
      "workout"
    ],
    "popularity": 4633
  },
  {
    "name": "hardware",
    "tags": ["break", "construction", "hammer", "hardware", "nail", "repair", "tool"],
    "popularity": 4632
  },
  {
    "name": "add_road",
    "tags": [
      "+",
      "add",
      "destination",
      "direction",
      "highway",
      "maps",
      "new",
      "plus",
      "road",
      "stop",
      "street",
      "symbol",
      "traffic"
    ],
    "popularity": 4631
  },
  {
    "name": "phone_callback",
    "tags": [
      "arrow",
      "call",
      "callback",
      "cell",
      "contact",
      "device",
      "down",
      "hardware",
      "mobile",
      "phone",
      "telephone"
    ],
    "popularity": 4629
  },
  {
    "name": "assured_workload",
    "tags": [
      "assured",
      "compliance",
      "confidential",
      "federal",
      "government",
      "secure",
      "sensitive regulatory",
      "workload"
    ],
    "popularity": 4627
  },
  {
    "name": "rule_folder",
    "tags": [
      "approve",
      "cancel",
      "check",
      "close",
      "complete",
      "data",
      "doc",
      "document",
      "done",
      "drive",
      "exit",
      "file",
      "folder",
      "mark",
      "no",
      "ok",
      "remove",
      "rule",
      "select",
      "sheet",
      "slide",
      "storage",
      "tick",
      "validate",
      "verified",
      "x",
      "yes"
    ],
    "popularity": 4625
  },
  {
    "name": "event_repeat",
    "tags": [
      "around",
      "calendar",
      "date",
      "day",
      "event",
      "inprogress",
      "load",
      "loading refresh",
      "month",
      "renew",
      "rotate",
      "schedule",
      "turn"
    ],
    "popularity": 4623
  },
  {
    "name": "line_weight",
    "tags": ["height", "line", "size", "spacing", "style", "thickness", "weight"],
    "popularity": 4617
  },
  {
    "name": "access_time_filled",
    "tags": [],
    "popularity": 4602
  },
  {
    "name": "flip_camera_ios",
    "tags": [
      "DISABLE_IOS",
      "android",
      "camera",
      "disable_ios",
      "edit",
      "editing",
      "flip",
      "image",
      "ios",
      "mobile",
      "orientation",
      "rotate",
      "turn"
    ],
    "popularity": 4602
  },
  {
    "name": "view_timeline",
    "tags": ["grid", "layout", "pattern", "squares", "timeline", "view"],
    "popularity": 4598
  },
  {
    "name": "swap_vert",
    "tags": ["arrow", "arrows", "direction", "down", "navigation", "swap", "up", "vert", "vertical"],
    "popularity": 4596
  },
  {
    "name": "dining",
    "tags": ["cafe", "cafeteria", "cutlery", "diner", "dining", "eat", "eating", "fork", "room", "spoon"],
    "popularity": 4594
  },
  {
    "name": "directions_run",
    "tags": ["body", "directions", "human", "jogging", "maps", "people", "person", "route", "run", "running", "walk"],
    "popularity": 4591
  },
  {
    "name": "confirmation_number",
    "tags": ["admission", "confirmation", "entertainment", "event", "number", "ticket"],
    "popularity": 4588
  },
  {
    "name": "push_pin",
    "tags": ["location", "marker", "pin", "place", "push", "remember", "save"],
    "popularity": 4587
  },
  {
    "name": "display_settings",
    "tags": [
      "Android",
      "OS",
      "application",
      "change",
      "chrome",
      "desktop",
      "details",
      "device",
      "display",
      "gear",
      "hardware",
      "iOS",
      "info",
      "information",
      "mac",
      "monitor",
      "options",
      "personal",
      "screen",
      "service",
      "settings",
      "web",
      "window"
    ],
    "popularity": 4585
  },
  {
    "name": "book",
    "tags": [
      "book",
      "bookmark",
      "favorite",
      "label",
      "library",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "tag"
    ],
    "popularity": 4583
  },
  {
    "name": "airplanemode_active",
    "tags": ["active", "airplane", "airplanemode", "flight", "mode", "on", "signal"],
    "popularity": 4580
  },
  {
    "name": "history_edu",
    "tags": [
      "document",
      "edu",
      "education",
      "feather",
      "history",
      "letter",
      "paper",
      "pen",
      "quill",
      "school",
      "story",
      "tools",
      "write",
      "writing"
    ],
    "popularity": 4567
  },
  {
    "name": "departure_board",
    "tags": [
      "automobile",
      "board",
      "bus",
      "car",
      "cars",
      "clock",
      "departure",
      "maps",
      "public",
      "schedule",
      "time",
      "transportation",
      "travel",
      "vehicle"
    ],
    "popularity": 4565
  },
  {
    "name": "set_meal",
    "tags": ["chopsticks", "dinner", "fish", "food", "lunch", "meal", "restaurant", "set", "teishoku"],
    "popularity": 4563
  },
  {
    "name": "dns",
    "tags": ["address", "bars", "dns", "domain", "information", "ip", "list", "lookup", "name", "server", "system"],
    "popularity": 4550
  },
  {
    "name": "mobile_friendly",
    "tags": [
      "Android",
      "OS",
      "approve",
      "cell",
      "check",
      "complete",
      "device",
      "done",
      "friendly",
      "hardware",
      "iOS",
      "mark",
      "mobile",
      "ok",
      "phone",
      "select",
      "tablet",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 4546
  },
  {
    "name": "merge_type",
    "tags": ["arrow", "combine", "direction", "format", "merge", "text", "type"],
    "popularity": 4543
  },
  {
    "name": "thumb_down",
    "tags": [
      "ate",
      "dislike",
      "down",
      "favorite",
      "fingers",
      "gesture",
      "hand",
      "hands",
      "like",
      "rank",
      "ranking",
      "rating",
      "thumb"
    ],
    "popularity": 4542
  },
  {
    "name": "design_services",
    "tags": [
      "compose",
      "create",
      "design",
      "draft",
      "edit",
      "editing",
      "input",
      "pen",
      "pencil",
      "ruler",
      "service",
      "write",
      "writing"
    ],
    "popularity": 4529
  },
  {
    "name": "pix",
    "tags": ["bill", "brazil", "card", "cash", "commerce", "credit", "currency", "finance", "money", "payment"],
    "popularity": 4515
  },
  {
    "name": "surfing",
    "tags": [
      "athlete",
      "athletic",
      "beach",
      "body",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "people",
      "person",
      "sea",
      "social sports",
      "sports",
      "summer",
      "surfing",
      "water"
    ],
    "popularity": 4510
  },
  {
    "name": "volume_off",
    "tags": [
      "audio",
      "control",
      "disabled",
      "enabled",
      "low",
      "music",
      "off",
      "on",
      "slash",
      "sound",
      "speaker",
      "tv",
      "volume"
    ],
    "popularity": 4505
  },
  {
    "name": "sanitizer",
    "tags": ["bacteria", "bottle", "clean", "covid", "disinfect", "germs", "pump", "sanitizer"],
    "popularity": 4504
  },
  {
    "name": "horizontal_split",
    "tags": ["bars", "format", "horizontal", "layout", "lines", "split", "stacked"],
    "popularity": 4496
  },
  {
    "name": "view_comfy",
    "tags": ["comfy", "grid", "layout", "pattern", "squares", "view"],
    "popularity": 4496
  },
  {
    "name": "phonelink_ring",
    "tags": [
      "Android",
      "OS",
      "cell",
      "connection",
      "data",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "network",
      "phone",
      "phonelink",
      "ring",
      "service",
      "signal",
      "tablet",
      "wireless"
    ],
    "popularity": 4488
  },
  {
    "name": "sports_motorsports",
    "tags": [
      "athlete",
      "athletic",
      "automobile",
      "bike",
      "drive",
      "driving",
      "entertainment",
      "helmet",
      "hobby",
      "motorcycle",
      "motorsports",
      "protect",
      "social",
      "sports",
      "vehicle"
    ],
    "popularity": 4469
  },
  {
    "name": "data_object",
    "tags": ["brackets", "code", "coder", "data", "object", "parentheses"],
    "popularity": 4463
  },
  {
    "name": "co_present",
    "tags": ["arrow", "co-present", "presentation", "screen", "share", "site", "slides", "togather", "web", "website"],
    "popularity": 4450
  },
  {
    "name": "polymer",
    "tags": ["emblem", "logo", "mark", "polymer"],
    "popularity": 4441
  },
  {
    "name": "filter_1",
    "tags": [
      "1",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 4436
  },
  {
    "name": "golf_course",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "club",
      "course",
      "entertainment",
      "flag",
      "golf",
      "golfer",
      "golfing",
      "hobby",
      "hole",
      "places",
      "putt",
      "sports"
    ],
    "popularity": 4432
  },
  {
    "name": "usb",
    "tags": ["cable", "connection", "device", "usb", "wire"],
    "popularity": 4420
  },
  {
    "name": "stay_current_portrait",
    "tags": ["Android", "OS", "current", "device", "hardware", "iOS", "mobile", "phone", "portrait", "stay", "tablet"],
    "popularity": 4413
  },
  {
    "name": "pan_tool_alt",
    "tags": ["fingers", "gesture", "hand", "hands", "human", "move", "pan", "scan", "stop", "tool"],
    "popularity": 4406
  },
  {
    "name": "gavel",
    "tags": [
      "agreement",
      "contract",
      "court",
      "document",
      "gavel",
      "government",
      "judge",
      "law",
      "mallet",
      "official",
      "police",
      "rule",
      "rules",
      "terms"
    ],
    "popularity": 4405
  },
  {
    "name": "alarm",
    "tags": ["alarm", "alert", "bell", "clock", "countdown", "date", "notification", "schedule", "time"],
    "popularity": 4404
  },
  {
    "name": "batch_prediction",
    "tags": ["batch", "bulb", "idea", "light", "prediction"],
    "popularity": 4403
  },
  {
    "name": "satellite_alt",
    "tags": ["alternative", "artificial", "communication", "satellite", "space", "space station", "television"],
    "popularity": 4401
  },
  {
    "name": "featured_play_list",
    "tags": ["collection", "featured", "highlighted", "list", "music", "play", "playlist", "recommended"],
    "popularity": 4400
  },
  {
    "name": "ev_station",
    "tags": [
      "automobile",
      "car",
      "cars",
      "charging",
      "electric",
      "electricity",
      "ev",
      "maps",
      "places",
      "station",
      "transportation",
      "vehicle"
    ],
    "popularity": 4396
  },
  {
    "name": "widgets",
    "tags": ["app", "box", "menu", "setting", "squares", "ui", "widgets"],
    "popularity": 4396
  },
  {
    "name": "noise_control_off",
    "tags": [
      "audio",
      "aware",
      "cancel",
      "cancellation",
      "control",
      "disabled",
      "enabled",
      "music",
      "noise",
      "note",
      "off",
      "offline",
      "on",
      "slash",
      "sound"
    ],
    "popularity": 4389
  },
  {
    "name": "webhook",
    "tags": ["api", "developer", "development", "enterprise", "software", "webhook"],
    "popularity": 4385
  },
  {
    "name": "domain",
    "tags": [
      "apartment",
      "architecture",
      "building",
      "business",
      "domain",
      "estate",
      "home",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "web",
      "www"
    ],
    "popularity": 4381
  },
  {
    "name": "recycling",
    "tags": [
      "bio",
      "eco",
      "green",
      "loop",
      "recyclable",
      "recycle",
      "recycling",
      "rotate",
      "sustainability",
      "sustainable",
      "trash"
    ],
    "popularity": 4376
  },
  {
    "name": "adb",
    "tags": ["adb", "android", "bridge", "debug"],
    "popularity": 4373
  },
  {
    "name": "send_and_archive",
    "tags": ["archive", "arrow", "down", "download", "email", "letter", "mail", "save", "send", "share"],
    "popularity": 4373
  },
  {
    "name": "send_to_mobile",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "device",
      "export",
      "forward",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "right",
      "send",
      "share",
      "tablet",
      "to"
    ],
    "popularity": 4363
  },
  {
    "name": "movie_creation",
    "tags": ["cinema", "clapperboard", "creation", "film", "movie", "movies", "slate", "video"],
    "popularity": 4355
  },
  {
    "name": "local_see",
    "tags": ["camera", "lens", "local", "photo", "photography", "picture", "see"],
    "popularity": 4351
  },
  {
    "name": "flatware",
    "tags": ["cafe", "cafeteria", "cutlery", "diner", "dining", "eat", "eating", "fork", "room", "spoon"],
    "popularity": 4349
  },
  {
    "name": "call_received",
    "tags": ["arrow", "call", "device", "mobile", "received"],
    "popularity": 4347
  },
  {
    "name": "speaker",
    "tags": ["box", "electronic", "loud", "music", "sound", "speaker", "stereo", "system", "video"],
    "popularity": 4343
  },
  {
    "name": "picture_in_picture",
    "tags": [
      "chat",
      "crop",
      "cropped",
      "overlap",
      "photo",
      "picture",
      "pip",
      "position",
      "shape",
      "sizes",
      "talktrack"
    ],
    "popularity": 4341
  },
  {
    "name": "edit_calendar",
    "tags": [
      "calendar",
      "compose",
      "create",
      "date",
      "day",
      "draft",
      "edit",
      "editing",
      "event",
      "month",
      "pen",
      "pencil",
      "schedule",
      "write",
      "writing"
    ],
    "popularity": 4333
  },
  {
    "name": "system_update",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "arrows",
      "cell",
      "device",
      "direction",
      "down",
      "download",
      "hardware",
      "iOS",
      "install",
      "mobile",
      "phone",
      "system",
      "tablet",
      "update"
    ],
    "popularity": 4326
  },
  {
    "name": "battery_alert",
    "tags": [
      "!",
      "alert",
      "attention",
      "battery",
      "caution",
      "cell",
      "charge",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "mobile",
      "notification",
      "power",
      "symbol",
      "warning"
    ],
    "popularity": 4322
  },
  {
    "name": "keyboard_backspace",
    "tags": ["arrow", "back", "backspace", "keyboard", "left"],
    "popularity": 4319
  },
  {
    "name": "add_chart",
    "tags": [
      "+",
      "add",
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "new",
      "plus",
      "statistics",
      "symbol",
      "tracking"
    ],
    "popularity": 4312
  },
  {
    "name": "electric_car",
    "tags": ["automobile", "car", "cars", "electric", "electricity", "maps", "transportation", "travel", "vehicle"],
    "popularity": 4294
  },
  {
    "name": "sports_handball",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "body",
      "entertainment",
      "exercise",
      "game",
      "handball",
      "hobby",
      "human",
      "people",
      "person",
      "social",
      "sports"
    ],
    "popularity": 4286
  },
  {
    "name": "diversity_1",
    "tags": [
      "committee",
      "diverse",
      "diversity",
      "family",
      "friends",
      "group",
      "groups",
      "heart",
      "humans",
      "network",
      "people",
      "persons",
      "social",
      "team"
    ],
    "popularity": 4269
  },
  {
    "name": "phone_forwarded",
    "tags": [
      "arrow",
      "call",
      "cell",
      "contact",
      "device",
      "direction",
      "forwarded",
      "hardware",
      "mobile",
      "phone",
      "right",
      "telephone"
    ],
    "popularity": 4263
  },
  {
    "name": "add_to_photos",
    "tags": [
      "add",
      "collection",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "photos",
      "picture",
      "plus",
      "to"
    ],
    "popularity": 4257
  },
  {
    "name": "pending_actions",
    "tags": ["actions", "clipboard", "clock", "date", "doc", "document", "pending", "remember", "schedule", "time"],
    "popularity": 4249
  },
  {
    "name": "code_off",
    "tags": [
      "brackets",
      "code",
      "css",
      "develop",
      "developer",
      "disabled",
      "enabled",
      "engineer",
      "engineering",
      "html",
      "off",
      "on",
      "platform",
      "slash"
    ],
    "popularity": 4233
  },
  {
    "name": "power_off",
    "tags": [
      "charge",
      "cord",
      "disabled",
      "electric",
      "electrical",
      "enabled",
      "off",
      "on",
      "outlet",
      "plug",
      "power",
      "slash"
    ],
    "popularity": 4231
  },
  {
    "name": "bookmark_remove",
    "tags": ["bookmark", "delete", "favorite", "minus", "remember", "remove", "ribbon", "save", "subtract"],
    "popularity": 4222
  },
  {
    "name": "diamond",
    "tags": ["diamond", "fashion", "gems", "jewelry", "logo", "retail", "valuable", "valuables"],
    "popularity": 4222
  },
  {
    "name": "close_fullscreen",
    "tags": ["action", "arrow", "arrows", "close", "collapse", "direction", "full", "fullscreen", "minimize", "screen"],
    "popularity": 4205
  },
  {
    "name": "screen_search_desktop",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "lock",
      "monitor",
      "rotate",
      "screen",
      "web"
    ],
    "popularity": 4203
  },
  {
    "name": "format_quote",
    "tags": [
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "quotation",
      "quote",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 4200
  },
  {
    "name": "festival",
    "tags": ["circus", "event", "festival", "local", "maps", "places", "tent", "tour", "travel"],
    "popularity": 4194
  },
  {
    "name": "edit_square",
    "tags": ["compose", "create", "draft", "edit", "editing", "input", "pen", "pencil", "square", "write", "writing"],
    "popularity": 4186
  },
  {
    "name": "panorama",
    "tags": ["angle", "image", "mountain", "mountains", "panorama", "photo", "photography", "picture", "view", "wide"],
    "popularity": 4183
  },
  {
    "name": "lens_blur",
    "tags": ["blur", "camera", "dim", "dot", "effect", "foggy", "fuzzy", "image", "lens", "photo", "soften"],
    "popularity": 4178
  },
  {
    "name": "app_registration",
    "tags": ["app", "apps", "edit", "pencil", "register", "registration"],
    "popularity": 4177
  },
  {
    "name": "sports_baseball",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "baseball",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "social",
      "sports"
    ],
    "popularity": 4177
  },
  {
    "name": "settings_bluetooth",
    "tags": ["bluetooth", "connect", "connection", "connectivity", "device", "settings", "signal", "symbol"],
    "popularity": 4175
  },
  {
    "name": "plumbing",
    "tags": ["build", "construction", "fix", "handyman", "plumbing", "repair", "tools", "wrench"],
    "popularity": 4171
  },
  {
    "name": "download_for_offline",
    "tags": ["arrow", "circle", "down", "download", "for offline", "install", "upload"],
    "popularity": 4159
  },
  {
    "name": "label",
    "tags": ["favorite", "indent", "label", "library", "mail", "remember", "save", "stamp", "sticker", "tag"],
    "popularity": 4158
  },
  {
    "name": "vpn_key",
    "tags": ["code", "key", "lock", "network", "passcode", "password", "unlock", "vpn"],
    "popularity": 4148
  },
  {
    "name": "manage_history",
    "tags": [
      "application",
      "arrow",
      "back",
      "backwards",
      "change",
      "clock",
      "date",
      "details",
      "gear",
      "history",
      "options",
      "refresh",
      "renew",
      "reverse",
      "rotate",
      "schedule",
      "settings",
      "time",
      "turn"
    ],
    "popularity": 4138
  },
  {
    "name": "arrow_circle_left",
    "tags": ["arrow", "circle", "direction", "left", "navigation"],
    "popularity": 4135
  },
  {
    "name": "pause_circle",
    "tags": ["circle", "control", "controls", "media", "music", "pause", "video"],
    "popularity": 4129
  },
  {
    "name": "toys",
    "tags": ["car", "games", "kids", "toy", "toys", "windmill"],
    "popularity": 4129
  },
  {
    "name": "coffee_maker",
    "tags": ["appliances", "beverage", "coffee", "cup", "drink", "machine", "maker", "mug"],
    "popularity": 4127
  },
  {
    "name": "arrow_circle_up",
    "tags": ["arrow", "circle", "direction", "navigation", "up"],
    "popularity": 4126
  },
  {
    "name": "restaurant_menu",
    "tags": ["book", "dining", "eat", "food", "fork", "knife", "local", "meal", "menu", "restaurant", "spoon"],
    "popularity": 4122
  },
  {
    "name": "headphones",
    "tags": ["accessory", "audio", "device", "ear", "earphone", "headphones", "headset", "listen", "music", "sound"],
    "popularity": 4121
  },
  {
    "name": "bedtime",
    "tags": ["bedtime", "nightime", "sleep"],
    "popularity": 4119
  },
  {
    "name": "edit_notifications",
    "tags": [
      "active",
      "alarm",
      "alert",
      "bell",
      "chime",
      "compose",
      "create",
      "draft",
      "edit",
      "editing",
      "input",
      "new",
      "notifications",
      "notify",
      "pen",
      "pencil",
      "reminder",
      "ring",
      "sound",
      "write",
      "writing"
    ],
    "popularity": 4112
  },
  {
    "name": "flag_circle",
    "tags": ["circle", "country", "flag", "goal", "mark", "nation", "report", "round", "start"],
    "popularity": 4112
  },
  {
    "name": "animation",
    "tags": ["animation", "circles", "film", "motion", "movement", "sequence", "video"],
    "popularity": 4107
  },
  {
    "name": "gamepad",
    "tags": ["buttons", "console", "controller", "device", "game", "gamepad", "gaming", "playstation", "video"],
    "popularity": 4094
  },
  {
    "name": "personal_video",
    "tags": [
      "Android",
      "OS",
      "cam",
      "chrome",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "personal",
      "television",
      "tv",
      "video",
      "web",
      "window"
    ],
    "popularity": 4094
  },
  {
    "name": "view_in_ar",
    "tags": ["3d", "ar", "augmented", "cube", "daydream", "headset", "in", "reality", "square", "view", "vr"],
    "popularity": 4094
  },
  {
    "name": "file_open",
    "tags": ["arrow", "doc", "document", "drive", "file", "left", "open", "page", "paper"],
    "popularity": 4087
  },
  {
    "name": "folder_zip",
    "tags": [
      "compress",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "open",
      "sheet",
      "slide",
      "storage",
      "zip"
    ],
    "popularity": 4083
  },
  {
    "name": "center_focus_weak",
    "tags": ["camera", "center", "focus", "image", "lens", "photo", "photography", "weak", "zoom"],
    "popularity": 4070
  },
  {
    "name": "minimize",
    "tags": [
      "app",
      "application",
      "components",
      "design",
      "interface",
      "line",
      "minimize",
      "screen",
      "shape",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 4058
  },
  {
    "name": "looks_4",
    "tags": ["4", "digit", "looks", "numbers", "square", "symbol"],
    "popularity": 4052
  },
  {
    "name": "real_estate_agent",
    "tags": [
      "agent",
      "architecture",
      "broker",
      "estate",
      "hand",
      "home",
      "house",
      "loan",
      "mortgage",
      "property",
      "real",
      "residence",
      "residential",
      "sales",
      "social"
    ],
    "popularity": 4052
  },
  {
    "name": "signal_wifi_statusbar_4_bar",
    "tags": [
      "4",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "signal",
      "speed",
      "statusbar",
      "wifi",
      "wireless"
    ],
    "popularity": 4052
  },
  {
    "name": "south_west",
    "tags": ["arrow", "directional", "down", "left", "maps", "navigation", "south", "west"],
    "popularity": 4048
  },
  {
    "name": "extension",
    "tags": ["app", "extended", "extension", "game", "jigsaw", "plugin add", "puzzle", "shape"],
    "popularity": 4034
  },
  {
    "name": "cloud_circle",
    "tags": [
      "app",
      "application",
      "backup",
      "circle",
      "cloud",
      "connection",
      "drive",
      "files",
      "folders",
      "internet",
      "network",
      "sky",
      "storage",
      "upload"
    ],
    "popularity": 4024
  },
  {
    "name": "format_shapes",
    "tags": [
      "alphabet",
      "character",
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "fill",
      "font",
      "format",
      "letter",
      "paint",
      "shapes",
      "sheet",
      "spreadsheet",
      "style",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 4024
  },
  {
    "name": "hive",
    "tags": ["bee", "honey", "honeycomb"],
    "popularity": 4017
  },
  {
    "name": "monitor_heart",
    "tags": ["baseline", "device", "ecc", "ecg", "fitness", "health", "heart", "medical", "monitor", "track"],
    "popularity": 4016
  },
  {
    "name": "open_with",
    "tags": ["arrow", "arrows", "direction", "expand", "move", "open", "pan", "with"],
    "popularity": 4014
  },
  {
    "name": "dataset",
    "tags": [],
    "popularity": 4009
  },
  {
    "name": "event_note",
    "tags": ["calendar", "date", "event", "note", "schedule", "text", "time", "writing"],
    "popularity": 3999
  },
  {
    "name": "movie_filter",
    "tags": [
      "ai",
      "artificial",
      "automatic",
      "automation",
      "clapperboard",
      "creation",
      "custom",
      "film",
      "filter",
      "genai",
      "intelligence",
      "magic",
      "movie",
      "movies",
      "slate",
      "smart",
      "spark",
      "sparkle",
      "star",
      "stars",
      "video"
    ],
    "popularity": 3999
  },
  {
    "name": "keyboard_double_arrow_left",
    "tags": ["arrow", "arrows", "direction", "double", "left", "multiple", "navigation"],
    "popularity": 3997
  },
  {
    "name": "layers_clear",
    "tags": [
      "arrange",
      "clear",
      "delete",
      "disabled",
      "enabled",
      "interaction",
      "layers",
      "maps",
      "off",
      "on",
      "overlay",
      "pages",
      "slash"
    ],
    "popularity": 3997
  },
  {
    "name": "car_rental",
    "tags": ["automobile", "car", "cars", "key", "maps", "rental", "transportation", "vehicle"],
    "popularity": 3995
  },
  {
    "name": "post_add",
    "tags": [
      "+",
      "add",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "page",
      "paper",
      "plus",
      "post",
      "sheet",
      "slide",
      "text",
      "writing"
    ],
    "popularity": 3992
  },
  {
    "name": "playlist_add_check_circle",
    "tags": [
      "add",
      "album",
      "artist",
      "audio",
      "cd",
      "check",
      "circle",
      "collection",
      "list",
      "mark",
      "music",
      "playlist",
      "record",
      "sound",
      "track"
    ],
    "popularity": 3990
  },
  {
    "name": "content_paste_go",
    "tags": ["clipboard", "content", "disabled", "doc", "document", "enabled", "file", "go", "on", "paste", "slash"],
    "popularity": 3988
  },
  {
    "name": "request_quote",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "quote",
      "request",
      "shopping",
      "symbol"
    ],
    "popularity": 3969
  },
  {
    "name": "no_photography",
    "tags": ["camera", "disabled", "enabled", "image", "no", "off", "on", "photo", "photography", "picture", "slash"],
    "popularity": 3967
  },
  {
    "name": "attractions",
    "tags": ["amusement", "attractions", "entertainment", "ferris", "fun", "maps", "park", "places", "wheel"],
    "popularity": 3963
  },
  {
    "name": "phonelink_lock",
    "tags": [
      "Android",
      "OS",
      "cell",
      "connection",
      "device",
      "erase",
      "hardware",
      "iOS",
      "lock",
      "locked",
      "mobile",
      "password",
      "phone",
      "phonelink",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "tablet"
    ],
    "popularity": 3950
  },
  {
    "name": "add_task",
    "tags": [
      "+",
      "add",
      "approve",
      "check",
      "circle",
      "completed",
      "increase",
      "mark",
      "ok",
      "plus",
      "select",
      "task",
      "tick",
      "yes"
    ],
    "popularity": 3946
  },
  {
    "name": "shop_two",
    "tags": ["add", "arrow", "buy", "cart", "google", "play", "purchase", "shop", "shopping", "two"],
    "popularity": 3938
  },
  {
    "name": "numbers",
    "tags": ["digit", "number", "numbers", "symbol"],
    "popularity": 3934
  },
  {
    "name": "shield",
    "tags": ["certified", "privacy", "private", "protect", "protection", "security", "shield", "verified"],
    "popularity": 3925
  },
  {
    "name": "home_filled",
    "tags": [
      "address",
      "app",
      "application--house",
      "architecture",
      "building",
      "components",
      "design",
      "estate",
      "filled",
      "home",
      "interface",
      "layout",
      "place",
      "real",
      "residence",
      "residential",
      "screen",
      "shelter",
      "site",
      "structure",
      "ui",
      "unit",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 3920
  },
  {
    "name": "edit_location",
    "tags": ["destination", "direction", "edit", "location", "maps", "pen", "pencil", "pin", "place", "stop"],
    "popularity": 3919
  },
  {
    "name": "record_voice_over",
    "tags": [
      "account",
      "face",
      "human",
      "over",
      "people",
      "person",
      "profile",
      "record",
      "recording",
      "speak",
      "speaking",
      "speech",
      "transcript",
      "user",
      "voice"
    ],
    "popularity": 3908
  },
  {
    "name": "sim_card",
    "tags": ["camera", "card", "chip", "device", "memory", "phone", "sim", "storage"],
    "popularity": 3906
  },
  {
    "name": "control_camera",
    "tags": ["adjust", "arrow", "arrows", "camera", "center", "control", "direction", "left", "move", "right"],
    "popularity": 3904
  },
  {
    "name": "flip_to_front",
    "tags": ["arrange", "arrangement", "back", "flip", "format", "front", "layout", "move", "order", "sort", "to"],
    "popularity": 3904
  },
  {
    "name": "screen_rotation",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "rotate",
      "rotation",
      "screen",
      "tablet",
      "turn"
    ],
    "popularity": 3903
  },
  {
    "name": "blender",
    "tags": ["appliance", "blender", "cooking", "electric", "juicer", "kitchen", "machine", "vitamix"],
    "popularity": 3901
  },
  {
    "name": "rate_review",
    "tags": ["comment", "feedback", "pen", "pencil", "rate", "review", "stars", "write"],
    "popularity": 3898
  },
  {
    "name": "start",
    "tags": ["arrow", "keyboard", "next", "right", "start"],
    "popularity": 3894
  },
  {
    "name": "sports_volleyball",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "social",
      "sports",
      "volleyball"
    ],
    "popularity": 3883
  },
  {
    "name": "folder_copy",
    "tags": [
      "content",
      "copy",
      "cut",
      "data",
      "doc",
      "document",
      "drive",
      "duplicate",
      "file",
      "folder",
      "folders",
      "multiple",
      "paste",
      "sheet",
      "slide",
      "storage"
    ],
    "popularity": 3882
  },
  {
    "name": "web",
    "tags": ["browser", "internet", "page", "screen", "site", "web", "website", "www"],
    "popularity": 3877
  },
  {
    "name": "high_quality",
    "tags": [
      "alphabet",
      "character",
      "definition",
      "display",
      "font",
      "high",
      "hq",
      "letter",
      "movie",
      "movies",
      "quality",
      "resolution",
      "screen",
      "symbol",
      "text",
      "tv",
      "type"
    ],
    "popularity": 3876
  },
  {
    "name": "keyboard_double_arrow_down",
    "tags": ["arrow", "arrows", "direction", "double", "down", "multiple", "navigation"],
    "popularity": 3873
  },
  {
    "name": "html",
    "tags": [
      "alphabet",
      "brackets",
      "character",
      "code",
      "css",
      "develop",
      "developer",
      "engineer",
      "engineering",
      "font",
      "html",
      "letter",
      "platform",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 3869
  },
  {
    "name": "lunch_dining",
    "tags": ["breakfast", "dining", "dinner", "drink", "fastfood", "food", "hamburger", "lunch", "meal"],
    "popularity": 3869
  },
  {
    "name": "keyboard_voice",
    "tags": ["keyboard", "mic", "microphone", "noise", "record", "recorder", "speaker", "voice"],
    "popularity": 3868
  },
  {
    "name": "output",
    "tags": [],
    "popularity": 3861
  },
  {
    "name": "stairs",
    "tags": ["down", "staircase", "stairs", "up"],
    "popularity": 3856
  },
  {
    "name": "keyboard_alt",
    "tags": [
      "alt",
      "computer",
      "device",
      "hardware",
      "input",
      "keyboard",
      "keypad",
      "letter",
      "office",
      "text",
      "type"
    ],
    "popularity": 3852
  },
  {
    "name": "signal_wifi_statusbar_connected_no_internet_4",
    "tags": [
      "!",
      "4",
      "alert",
      "attention",
      "caution",
      "cell",
      "cellular",
      "connected",
      "danger",
      "data",
      "error",
      "exclamation",
      "important",
      "internet",
      "mark",
      "mobile",
      "network",
      "no",
      "notification",
      "phone",
      "signal",
      "speed",
      "statusbar",
      "symbol",
      "warning",
      "wifi",
      "wireless"
    ],
    "popularity": 3848
  },
  {
    "name": "crop_din",
    "tags": [
      "adjust",
      "adjustments",
      "area",
      "crop",
      "din",
      "edit",
      "editing",
      "frame",
      "image",
      "images",
      "photo",
      "photos",
      "rectangle",
      "settings",
      "size",
      "square"
    ],
    "popularity": 3845
  },
  {
    "name": "handyman",
    "tags": ["build", "construction", "fix", "hammer", "handyman", "repair", "screw", "screwdriver", "tools"],
    "popularity": 3843
  },
  {
    "name": "add_photo_alternate",
    "tags": [
      "+",
      "add",
      "alternate",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "new",
      "photo",
      "photography",
      "picture",
      "plus",
      "symbol"
    ],
    "popularity": 3838
  },
  {
    "name": "precision_manufacturing",
    "tags": [
      "arm",
      "automatic",
      "chain",
      "conveyor",
      "crane",
      "factory",
      "industry",
      "machinery",
      "manufacturing",
      "mechanical",
      "precision",
      "production",
      "repairing",
      "robot",
      "supply",
      "warehouse"
    ],
    "popularity": 3836
  },
  {
    "name": "create_new_folder",
    "tags": [
      "+",
      "add",
      "create",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "new",
      "plus",
      "sheet",
      "slide",
      "storage",
      "symbol"
    ],
    "popularity": 3830
  },
  {
    "name": "qr_code",
    "tags": ["barcode", "camera", "code", "media", "product", "qr", "quick", "response", "smartphone", "url", "urls"],
    "popularity": 3826
  },
  {
    "name": "directions_walk",
    "tags": ["body", "direction", "directions", "human", "jogging", "maps", "people", "person", "route", "run", "walk"],
    "popularity": 3819
  },
  {
    "name": "pivot_table_chart",
    "tags": [
      "analytics",
      "arrow",
      "arrows",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "direction",
      "drive",
      "edit",
      "editing",
      "graph",
      "grid",
      "infographic",
      "measure",
      "metrics",
      "pivot",
      "rotate",
      "sheet",
      "statistics",
      "table",
      "tracking"
    ],
    "popularity": 3819
  },
  {
    "name": "microwave",
    "tags": ["appliance", "cooking", "electric", "heat", "home", "house", "kitchen", "machine", "microwave"],
    "popularity": 3813
  },
  {
    "name": "hourglass_empty",
    "tags": ["countdown", "empty", "full", "hourglass", "loading", "minutes", "time", "wait", "waiting"],
    "popularity": 3809
  },
  {
    "name": "policy",
    "tags": [
      "certified",
      "find",
      "glass",
      "legal",
      "look",
      "magnify",
      "magnifying",
      "policy",
      "privacy",
      "private",
      "protect",
      "protection",
      "search",
      "security",
      "see",
      "shield",
      "verified"
    ],
    "popularity": 3801
  },
  {
    "name": "leaderboard",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "leaderboard",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 3798
  },
  {
    "name": "voice_chat",
    "tags": [
      "bubble",
      "cam",
      "camera",
      "chat",
      "comment",
      "communicate",
      "facetime",
      "feedback",
      "message",
      "speech",
      "video",
      "voice"
    ],
    "popularity": 3788
  },
  {
    "name": "gif_box",
    "tags": [
      "alphabet",
      "animated",
      "animation",
      "bitmap",
      "character",
      "font",
      "format",
      "gif",
      "graphics",
      "interchange",
      "letter",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 3785
  },
  {
    "name": "gps_not_fixed",
    "tags": [
      "destination",
      "direction",
      "disabled",
      "enabled",
      "gps",
      "location",
      "maps",
      "not fixed",
      "off",
      "on",
      "online",
      "place",
      "pointer",
      "slash",
      "tracking"
    ],
    "popularity": 3781
  },
  {
    "name": "local_convenience_store",
    "tags": [
      "--",
      "24",
      "bill",
      "building",
      "business",
      "card",
      "cash",
      "coin",
      "commerce",
      "company",
      "convenience",
      "credit",
      "currency",
      "dollars",
      "local",
      "maps",
      "market",
      "money",
      "new",
      "online",
      "pay",
      "payment",
      "plus",
      "shop",
      "shopping",
      "store",
      "storefront",
      "symbol"
    ],
    "popularity": 3776
  },
  {
    "name": "cloud_download",
    "tags": [
      "app",
      "application",
      "arrow",
      "backup",
      "cloud",
      "connection",
      "down",
      "download",
      "drive",
      "files",
      "folders",
      "internet",
      "network",
      "sky",
      "storage",
      "upload"
    ],
    "popularity": 3767
  },
  {
    "name": "edit_square",
    "tags": ["compose", "create", "draft", "edit", "editing", "input", "pen", "pencil", "square", "write", "writing"],
    "popularity": 3767
  },
  {
    "name": "table_restaurant",
    "tags": ["bar", "dining", "table"],
    "popularity": 3764
  },
  {
    "name": "cake",
    "tags": [
      "add",
      "baked",
      "birthday",
      "cake",
      "candles",
      "celebration",
      "dessert",
      "food",
      "frosting",
      "new",
      "party",
      "pastries",
      "pastry",
      "plus",
      "social",
      "sweet",
      "symbol"
    ],
    "popularity": 3755
  },
  {
    "name": "emoji_people",
    "tags": ["arm", "body", "emoji", "greeting", "human", "people", "person", "social", "waving"],
    "popularity": 3749
  },
  {
    "name": "pages",
    "tags": ["article", "gplus", "pages", "paper", "post", "star"],
    "popularity": 3742
  },
  {
    "name": "switch_right",
    "tags": ["arrows", "directional", "navigation", "right", "switch", "toggle"],
    "popularity": 3740
  },
  {
    "name": "speaker_notes_off",
    "tags": [
      "bubble",
      "chat",
      "comment",
      "communicate",
      "disabled",
      "enabled",
      "format",
      "list",
      "message",
      "notes",
      "off",
      "on",
      "slash",
      "speaker",
      "speech",
      "text"
    ],
    "popularity": 3739
  },
  {
    "name": "factory",
    "tags": ["factory", "industry", "manufacturing", "warehouse"],
    "popularity": 3738
  },
  {
    "name": "eject",
    "tags": ["disc", "drive", "dvd", "eject", "remove", "triangle", "usb"],
    "popularity": 3721
  },
  {
    "name": "phone_disabled",
    "tags": [
      "call",
      "cell",
      "contact",
      "device",
      "disabled",
      "enabled",
      "hardware",
      "mobile",
      "off",
      "offline",
      "on",
      "phone",
      "slash",
      "telephone"
    ],
    "popularity": 3720
  },
  {
    "name": "control_point_duplicate",
    "tags": ["+", "add", "circle", "control", "duplicate", "multiple", "new", "plus", "point", "symbol"],
    "popularity": 3707
  },
  {
    "name": "spa",
    "tags": [
      "aromatherapy",
      "flower",
      "healthcare",
      "leaf",
      "massage",
      "meditation",
      "nature",
      "petals",
      "places",
      "relax",
      "spa",
      "wellbeing",
      "wellness"
    ],
    "popularity": 3705
  },
  {
    "name": "fiber_manual_record",
    "tags": ["circle", "dot", "fiber", "manual", "play", "record", "watch"],
    "popularity": 3703
  },
  {
    "name": "filter",
    "tags": [
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "settings"
    ],
    "popularity": 3698
  },
  {
    "name": "zoom_in_map",
    "tags": ["arrow", "arrows", "destination", "in", "location", "maps", "move", "place", "stop", "zoom"],
    "popularity": 3696
  },
  {
    "name": "published_with_changes",
    "tags": [
      "approve",
      "arrow",
      "arrows",
      "changes",
      "check",
      "complete",
      "done",
      "inprogress",
      "load",
      "loading",
      "mark",
      "ok",
      "published",
      "refresh",
      "renew",
      "replace",
      "rotate",
      "select",
      "tick",
      "validate",
      "verified",
      "with",
      "yes"
    ],
    "popularity": 3695
  },
  {
    "name": "pest_control",
    "tags": ["bug", "control", "exterminator", "insects", "pest"],
    "popularity": 3692
  },
  {
    "name": "brightness_7",
    "tags": ["7", "brightness", "circle", "control", "crescent", "level", "moon", "screen", "sun"],
    "popularity": 3689
  },
  {
    "name": "backpack",
    "tags": ["back", "backpack", "bag", "book", "bookbag", "knapsack", "pack", "storage", "travel"],
    "popularity": 3683
  },
  {
    "name": "drag_handle",
    "tags": [
      "app",
      "application ui",
      "components",
      "design",
      "drag",
      "handle",
      "interface",
      "layout",
      "menu",
      "move",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 3680
  },
  {
    "name": "leak_add",
    "tags": ["add", "connection", "data", "leak", "link", "network", "service", "signals", "synce", "wireless"],
    "popularity": 3672
  },
  {
    "name": "brush",
    "tags": ["art", "brush", "design", "draw", "edit", "editing", "paint", "painting", "tool"],
    "popularity": 3667
  },
  {
    "name": "ring_volume",
    "tags": [
      "call",
      "calling",
      "cell",
      "contact",
      "device",
      "hardware",
      "incoming",
      "mobile",
      "phone",
      "ring",
      "ringer",
      "sound",
      "telephone",
      "volume"
    ],
    "popularity": 3657
  },
  {
    "name": "local_library",
    "tags": ["book", "community learning", "library", "local", "read"],
    "popularity": 3655
  },
  {
    "name": "flight_takeoff",
    "tags": [
      "airport",
      "departed",
      "departing",
      "flight",
      "fly",
      "landing",
      "plane",
      "takeoff",
      "transportation",
      "travel"
    ],
    "popularity": 3653
  },
  {
    "name": "system_security_update_good",
    "tags": [
      "Android",
      "OS",
      "approve",
      "cell",
      "check",
      "complete",
      "device",
      "done",
      "good",
      "hardware",
      "iOS",
      "mark",
      "mobile",
      "ok",
      "phone",
      "security",
      "select",
      "system",
      "tablet",
      "tick",
      "update",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 3648
  },
  {
    "name": "money_off_csred",
    "tags": [
      "bill",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "csred",
      "currency",
      "disabled",
      "dollars",
      "enabled",
      "money",
      "off",
      "on",
      "online",
      "pay",
      "payment",
      "shopping",
      "slash",
      "symbol"
    ],
    "popularity": 3632
  },
  {
    "name": "sports_football",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "entertainment",
      "exercise",
      "football",
      "game",
      "hobby",
      "social",
      "sports"
    ],
    "popularity": 3610
  },
  {
    "name": "nature",
    "tags": ["forest", "nature", "outdoor", "outside", "park", "tree", "wilderness"],
    "popularity": 3601
  },
  {
    "name": "vibration",
    "tags": [
      "Android",
      "OS",
      "alert",
      "cell",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "mode",
      "motion",
      "notification",
      "phone",
      "silence",
      "silent",
      "tablet",
      "vibrate",
      "vibration"
    ],
    "popularity": 3597
  },
  {
    "name": "snippet_folder",
    "tags": ["data", "doc", "document", "drive", "file", "folder", "sheet", "slide", "snippet", "storage"],
    "popularity": 3592
  },
  {
    "name": "currency_bitcoin",
    "tags": [
      "bill",
      "blockchain",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "digital",
      "dollars",
      "finance",
      "franc",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 3591
  },
  {
    "name": "run_circle",
    "tags": ["body", "circle", "exercise", "human", "people", "person", "run", "running"],
    "popularity": 3588
  },
  {
    "name": "dry_cleaning",
    "tags": ["cleaning", "dry", "hanger", "hotel", "laundry", "places", "service", "towel"],
    "popularity": 3582
  },
  {
    "name": "edit_road",
    "tags": ["destination", "direction", "edit", "highway", "maps", "pen", "pencil", "road", "street", "traffic"],
    "popularity": 3578
  },
  {
    "name": "incomplete_circle",
    "tags": ["chart", "circle", "incomplete"],
    "popularity": 3576
  },
  {
    "name": "live_help",
    "tags": [
      "?",
      "assistance",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "help",
      "info",
      "information",
      "live",
      "message",
      "punctuation",
      "question mark",
      "recent",
      "restore",
      "speech",
      "support",
      "symbol"
    ],
    "popularity": 3574
  },
  {
    "name": "alarm_off",
    "tags": [
      "alarm",
      "alert",
      "bell",
      "clock",
      "disabled",
      "duration",
      "enabled",
      "notification",
      "off",
      "on",
      "slash",
      "time",
      "timer",
      "watch"
    ],
    "popularity": 3570
  },
  {
    "name": "airline_seat_recline_normal",
    "tags": [
      "airline",
      "body",
      "extra",
      "feet",
      "human",
      "leg",
      "legroom",
      "normal",
      "people",
      "person",
      "recline",
      "seat",
      "sitting",
      "space",
      "travel"
    ],
    "popularity": 3562
  },
  {
    "name": "perm_data_setting",
    "tags": ["data", "gear", "info", "information", "perm", "settings"],
    "popularity": 3556
  },
  {
    "name": "bedroom_parent",
    "tags": [
      "bed",
      "bedroom",
      "double",
      "full",
      "furniture",
      "home",
      "hotel",
      "house",
      "king",
      "night",
      "parent",
      "pillows",
      "queen",
      "rest",
      "room",
      "sizem master",
      "sleep"
    ],
    "popularity": 3542
  },
  {
    "name": "cottage",
    "tags": [
      "architecture",
      "beach",
      "cottage",
      "estate",
      "home",
      "house",
      "lake",
      "lodge",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling"
    ],
    "popularity": 3540
  },
  {
    "name": "do_disturb_alt",
    "tags": ["cancel", "close", "denied", "deny", "disturb", "do", "remove", "silence", "stop"],
    "popularity": 3537
  },
  {
    "name": "settings_input_hdmi",
    "tags": [
      "cable",
      "connection",
      "connectivity",
      "definition",
      "hdmi",
      "high",
      "input",
      "plug",
      "plugin",
      "points",
      "settings",
      "video",
      "wire"
    ],
    "popularity": 3537
  },
  {
    "name": "medical_information",
    "tags": ["badge", "card", "health", "id", "information", "medical", "services"],
    "popularity": 3529
  },
  {
    "name": "sensor_window",
    "tags": ["alarm", "security", "security system"],
    "popularity": 3526
  },
  {
    "name": "playlist_remove",
    "tags": ["-", "collection", "list", "minus", "music", "playlist", "remove"],
    "popularity": 3524
  },
  {
    "name": "location_off",
    "tags": ["destination", "direction", "location", "maps", "off", "pin", "place", "room", "stop"],
    "popularity": 3521
  },
  {
    "name": "edit_attributes",
    "tags": [
      "approve",
      "attribution",
      "check",
      "complete",
      "done",
      "edit",
      "mark",
      "ok",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 3518
  },
  {
    "name": "texture",
    "tags": ["diagonal", "lines", "pattern", "stripes", "texture"],
    "popularity": 3513
  },
  {
    "name": "edit_location_alt",
    "tags": ["alt", "edit", "location", "pen", "pencil", "pin"],
    "popularity": 3512
  },
  {
    "name": "table",
    "tags": ["database", "grid", "layout", "squares", "table"],
    "popularity": 3512
  },
  {
    "name": "perm_scan_wifi",
    "tags": [
      "alert",
      "announcement",
      "connection",
      "info",
      "information",
      "internet",
      "network",
      "perm",
      "scan",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 3502
  },
  {
    "name": "phonelink_setup",
    "tags": [
      "Android",
      "OS",
      "call",
      "chat",
      "device",
      "hardware",
      "iOS",
      "info",
      "mobile",
      "phone",
      "phonelink",
      "settings",
      "setup",
      "tablet",
      "text"
    ],
    "popularity": 3502
  },
  {
    "name": "camera_indoor",
    "tags": [
      "architecture",
      "building",
      "camera",
      "estate",
      "film",
      "filming",
      "home",
      "house",
      "image",
      "indoor",
      "inside",
      "motion",
      "nest",
      "picture",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "video",
      "videography"
    ],
    "popularity": 3500
  },
  {
    "name": "contact_page",
    "tags": [
      "account",
      "avatar",
      "contact",
      "data",
      "doc",
      "document",
      "drive",
      "face",
      "file",
      "folder",
      "folders",
      "human",
      "page",
      "people",
      "person",
      "profile",
      "sheet",
      "slide",
      "storage",
      "user",
      "writing"
    ],
    "popularity": 3496
  },
  {
    "name": "slow_motion_video",
    "tags": ["arrow", "control", "controls", "motion", "music", "play", "slow", "speed", "video"],
    "popularity": 3492
  },
  {
    "name": "groups_2",
    "tags": [
      "body",
      "club",
      "collaboration",
      "crowd",
      "gathering",
      "groups",
      "hair",
      "human",
      "meeting",
      "people",
      "person",
      "social",
      "teams"
    ],
    "popularity": 3491
  },
  {
    "name": "view_compact",
    "tags": ["compact", "grid", "layout", "pattern", "squares", "view"],
    "popularity": 3491
  },
  {
    "name": "duo",
    "tags": ["call", "chat", "conference", "device", "duo", "video"],
    "popularity": 3489
  },
  {
    "name": "hourglass_disabled",
    "tags": [
      "clock",
      "countdown",
      "disabled",
      "empty",
      "enabled",
      "hourglass",
      "loading",
      "minute",
      "minutes",
      "off",
      "on",
      "slash",
      "time",
      "wait",
      "waiting"
    ],
    "popularity": 3489
  },
  {
    "name": "corporate_fare",
    "tags": [
      "architecture",
      "building",
      "business",
      "corporate",
      "estate",
      "fare",
      "organization",
      "place",
      "real",
      "residence",
      "residential",
      "shelter"
    ],
    "popularity": 3482
  },
  {
    "name": "add_to_queue",
    "tags": [
      "+",
      "Android",
      "OS",
      "add",
      "chrome",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "new",
      "plus",
      "queue",
      "screen",
      "symbol",
      "to",
      "web",
      "window"
    ],
    "popularity": 3480
  },
  {
    "name": "support",
    "tags": ["assist", "buoy", "help", "life", "lifebuoy", "rescue", "safe", "safety", "support"],
    "popularity": 3472
  },
  {
    "name": "pie_chart_outline",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "outline",
      "pie",
      "statistics",
      "tracking"
    ],
    "popularity": 3470
  },
  {
    "name": "smart_toy",
    "tags": ["bot", "droid", "games", "robot", "smart", "toy"],
    "popularity": 3469
  },
  {
    "name": "church",
    "tags": ["christian", "christianity", "ideology", "religion", "spiritual", "worship"],
    "popularity": 3462
  },
  {
    "name": "next_week",
    "tags": ["arrow", "bag", "baggage", "briefcase", "business", "case", "next", "suitcase", "week"],
    "popularity": 3454
  },
  {
    "name": "forward",
    "tags": ["arrow", "forward", "mail", "message", "playback", "right", "sent"],
    "popularity": 3452
  },
  {
    "name": "location_pin",
    "tags": ["destination", "direction", "location", "maps", "pin", "place", "stop"],
    "popularity": 3436
  },
  {
    "name": "timer_off",
    "tags": [
      "alarm",
      "alert",
      "bell",
      "clock",
      "disabled",
      "duration",
      "enabled",
      "notification",
      "off",
      "on",
      "slash",
      "stop",
      "time",
      "timer",
      "watch"
    ],
    "popularity": 3426
  },
  {
    "name": "bluetooth_connected",
    "tags": ["bluetooth", "cast", "connect", "connection", "device", "paring", "streaming", "symbol", "wireless"],
    "popularity": 3421
  },
  {
    "name": "filter_list_off",
    "tags": ["alt", "disabled", "edit", "filter", "list", "off", "offline", "options", "refine", "sift", "slash"],
    "popularity": 3421
  },
  {
    "name": "timeline",
    "tags": ["data", "history", "line", "movement", "point", "points", "timeline", "tracking", "trending", "zigzag"],
    "popularity": 3419
  },
  {
    "name": "bedroom_baby",
    "tags": [
      "babies",
      "baby",
      "bedroom",
      "child",
      "children",
      "home",
      "horse",
      "house",
      "infant",
      "kid",
      "newborn",
      "rocking",
      "room",
      "toddler",
      "young"
    ],
    "popularity": 3415
  },
  {
    "name": "photo_size_select_actual",
    "tags": ["actual", "image", "mountain", "mountains", "photo", "photography", "picture", "select", "size"],
    "popularity": 3411
  },
  {
    "name": "downloading",
    "tags": [
      "arrow",
      "circle",
      "down",
      "download",
      "downloading",
      "downloads",
      "install",
      "pending",
      "progress",
      "upload"
    ],
    "popularity": 3405
  },
  {
    "name": "switch_access_shortcut_add",
    "tags": [
      "+",
      "access",
      "add",
      "arrow",
      "arrows",
      "direction",
      "navigation",
      "new",
      "north",
      "plus",
      "shortcut",
      "switch",
      "symbol",
      "up"
    ],
    "popularity": 3405
  },
  {
    "name": "skip_previous",
    "tags": ["arrow", "control", "controls", "music", "next", "play", "previous", "skip", "video"],
    "popularity": 3402
  },
  {
    "name": "short_text",
    "tags": ["brief", "comment", "doc", "document", "note", "short", "text", "write", "writing"],
    "popularity": 3399
  },
  {
    "name": "cell_tower",
    "tags": ["broadcast", "casting", "cell", "network", "signal", "tower", "transmitting", "wireless"],
    "popularity": 3392
  },
  {
    "name": "lightbulb_outline",
    "tags": ["alert", "announcement", "idea", "info", "information", "light", "lightbulb", "outline"],
    "popularity": 3391
  },
  {
    "name": "video_camera_back",
    "tags": [
      "back",
      "camera",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "rear",
      "video"
    ],
    "popularity": 3390
  },
  {
    "name": "format_indent_increase",
    "tags": [
      "align",
      "alignment",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "increase",
      "indent",
      "indentation",
      "paragraph",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 3389
  },
  {
    "name": "connected_tv",
    "tags": [
      "Android",
      "OS",
      "airplay",
      "chrome",
      "connect",
      "connected",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "screencast",
      "streaming",
      "television",
      "tv",
      "web",
      "window",
      "wireless"
    ],
    "popularity": 3388
  },
  {
    "name": "downhill_skiing",
    "tags": [
      "athlete",
      "athletic",
      "body",
      "downhill",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "people",
      "person",
      "ski social",
      "skiing",
      "snow",
      "sports",
      "travel",
      "winter"
    ],
    "popularity": 3386
  },
  {
    "name": "local_cafe",
    "tags": ["bottle", "cafe", "coffee", "cup", "drink", "food", "restaurant", "tea"],
    "popularity": 3386
  },
  {
    "name": "notification_important",
    "tags": [
      "!",
      "active",
      "alarm",
      "alert",
      "attention",
      "bell",
      "caution",
      "chime",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "notifications",
      "notify",
      "reminder",
      "ring",
      "sound",
      "symbol",
      "warning"
    ],
    "popularity": 3385
  },
  {
    "name": "bathroom",
    "tags": [
      "bath",
      "bathroom",
      "closet",
      "home",
      "house",
      "place",
      "plumbing",
      "room",
      "shower",
      "sprinkler",
      "wash",
      "water",
      "wc"
    ],
    "popularity": 3384
  },
  {
    "name": "diversity_1",
    "tags": [
      "committee",
      "diverse",
      "diversity",
      "family",
      "friends",
      "group",
      "groups",
      "heart",
      "humans",
      "network",
      "people",
      "persons",
      "social",
      "team"
    ],
    "popularity": 3384
  },
  {
    "name": "lock_outline",
    "tags": ["lock", "locked", "password", "privacy", "private", "protection", "safety", "secure", "security"],
    "popularity": 3380
  },
  {
    "name": "self_improvement",
    "tags": [
      "body",
      "calm",
      "care",
      "chi",
      "human",
      "improvement",
      "meditate",
      "meditation",
      "people",
      "person",
      "relax",
      "self",
      "sitting",
      "wellbeing",
      "yoga",
      "zen"
    ],
    "popularity": 3377
  },
  {
    "name": "settings_cell",
    "tags": ["Android", "OS", "cell", "device", "hardware", "iOS", "mobile", "phone", "settings", "tablet"],
    "popularity": 3377
  },
  {
    "name": "archive",
    "tags": ["archive", "inbox", "mail", "store"],
    "popularity": 3376
  },
  {
    "name": "kayaking",
    "tags": [
      "athlete",
      "athletic",
      "body",
      "canoe",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "kayak",
      "kayaking",
      "lake",
      "paddle",
      "paddling",
      "people",
      "person",
      "rafting",
      "river",
      "row",
      "social",
      "sports",
      "summer",
      "travel",
      "water"
    ],
    "popularity": 3373
  },
  {
    "name": "remember_me",
    "tags": [
      "Android",
      "OS",
      "avatar",
      "device",
      "hardware",
      "human",
      "iOS",
      "identity",
      "me",
      "mobile",
      "people",
      "person",
      "phone",
      "profile",
      "remember",
      "tablet",
      "user"
    ],
    "popularity": 3373
  },
  {
    "name": "app_blocking",
    "tags": [
      "Android",
      "OS",
      "app",
      "application",
      "block",
      "blocking",
      "cancel",
      "cell",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "stop",
      "stopped",
      "tablet"
    ],
    "popularity": 3372
  },
  {
    "name": "space_dashboard",
    "tags": [
      "cards",
      "dashboard",
      "format",
      "grid",
      "layout",
      "rectangle",
      "shapes",
      "space",
      "squares",
      "web",
      "website"
    ],
    "popularity": 3370
  },
  {
    "name": "settings_applications",
    "tags": [
      "application",
      "change",
      "details",
      "gear",
      "info",
      "information",
      "options",
      "personal",
      "service",
      "settings"
    ],
    "popularity": 3369
  },
  {
    "name": "elevator",
    "tags": ["body", "down", "elevator", "human", "people", "person", "up"],
    "popularity": 3368
  },
  {
    "name": "sensors_off",
    "tags": [
      "connection",
      "disabled",
      "enabled",
      "network",
      "off",
      "on",
      "scan",
      "sensors",
      "signal",
      "slash",
      "wireless"
    ],
    "popularity": 3368
  },
  {
    "name": "work_off",
    "tags": [
      "bag",
      "baggage",
      "briefcase",
      "business",
      "case",
      "disabled",
      "enabled",
      "job",
      "off",
      "on",
      "slash",
      "suitcase",
      "work"
    ],
    "popularity": 3363
  },
  {
    "name": "insert_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "insert",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 3346
  },
  {
    "name": "sports_soccer",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "entertainment",
      "exercise",
      "football",
      "game",
      "hobby",
      "soccer",
      "social",
      "sports"
    ],
    "popularity": 3344
  },
  {
    "name": "stop_circle",
    "tags": ["circle", "control", "controls", "music", "pause", "play", "square", "stop", "video"],
    "popularity": 3342
  },
  {
    "name": "moped",
    "tags": ["automobile", "bike", "car", "cars", "maps", "scooter", "transportation", "vehicle", "vespa"],
    "popularity": 3339
  },
  {
    "name": "phone_android",
    "tags": ["OS", "android", "cell", "device", "hardware", "iOS", "mobile", "phone", "tablet"],
    "popularity": 3337
  },
  {
    "name": "stay_primary_portrait",
    "tags": [
      "Android",
      "OS",
      "current",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "portrait",
      "primary",
      "stay",
      "tablet"
    ],
    "popularity": 3336
  },
  {
    "name": "wrong_location",
    "tags": [
      "cancel",
      "close",
      "destination",
      "direction",
      "exit",
      "location",
      "maps",
      "no",
      "pin",
      "place",
      "quit",
      "remove",
      "stop",
      "wrong",
      "x"
    ],
    "popularity": 3323
  },
  {
    "name": "content_paste",
    "tags": ["clipboard", "content", "copy", "cut", "doc", "document", "file", "multiple", "paste"],
    "popularity": 3321
  },
  {
    "name": "upload",
    "tags": ["arrow", "arrows", "download", "drive", "up", "upload"],
    "popularity": 3318
  },
  {
    "name": "stop",
    "tags": ["control", "controls", "music", "pause", "play", "square", "stop", "video"],
    "popularity": 3310
  },
  {
    "name": "currency_rupee",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "rupee",
      "shopping",
      "symbol"
    ],
    "popularity": 3309
  },
  {
    "name": "troubleshoot",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "find",
      "glass",
      "graph",
      "infographic",
      "line",
      "look",
      "magnify",
      "magnifying",
      "measure",
      "metrics",
      "search",
      "see",
      "statistics",
      "tracking",
      "troubleshoot"
    ],
    "popularity": 3307
  },
  {
    "name": "medical_services",
    "tags": ["aid", "bag", "briefcase", "emergency", "first", "kit", "medical", "medicine", "services"],
    "popularity": 3304
  },
  {
    "name": "home_work",
    "tags": [
      "architecture",
      "building",
      "estate",
      "home",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "work"
    ],
    "popularity": 3302
  },
  {
    "name": "accessibility_new",
    "tags": ["accessibility", "accessible", "body", "handicap", "help", "human", "new", "people", "person"],
    "popularity": 3300
  },
  {
    "name": "directions_bus",
    "tags": ["automobile", "bus", "car", "cars", "directions", "maps", "public", "transportation", "vehicle"],
    "popularity": 3299
  },
  {
    "name": "help_center",
    "tags": [
      "?",
      "assistance",
      "center",
      "help",
      "info",
      "information",
      "punctuation",
      "question mark",
      "recent",
      "restore",
      "support",
      "symbol"
    ],
    "popularity": 3299
  },
  {
    "name": "picture_in_picture_alt",
    "tags": [
      "chat",
      "crop",
      "cropped",
      "overlap",
      "photo",
      "picture",
      "pip",
      "position",
      "shape",
      "sizes",
      "talktrack"
    ],
    "popularity": 3296
  },
  {
    "name": "public_off",
    "tags": [
      "disabled",
      "earth",
      "enabled",
      "global",
      "globe",
      "map",
      "network",
      "off",
      "on",
      "planet",
      "public",
      "slash",
      "social",
      "space",
      "web",
      "world"
    ],
    "popularity": 3292
  },
  {
    "name": "car_repair",
    "tags": ["automobile", "car", "cars", "maps", "repair", "transportation", "vehicle"],
    "popularity": 3288
  },
  {
    "name": "compare_arrows",
    "tags": ["arrow", "arrows", "collide", "compare", "direction", "left", "pressure", "push", "right", "together"],
    "popularity": 3288
  },
  {
    "name": "nfc",
    "tags": ["communication", "data", "field", "mobile", "near", "nfc", "wireless"],
    "popularity": 3288
  },
  {
    "name": "chair_alt",
    "tags": ["cahir", "furniture", "home", "house", "kitchen", "lounging", "seating", "table"],
    "popularity": 3283
  },
  {
    "name": "line_style",
    "tags": ["dash", "dotted", "line", "rule", "spacing", "style"],
    "popularity": 3278
  },
  {
    "name": "airplay",
    "tags": ["airplay", "arrow", "connect", "control", "desktop", "device", "display", "monitor", "screen", "signal"],
    "popularity": 3277
  },
  {
    "name": "pattern",
    "tags": ["key", "login", "password", "pattern", "pin", "security", "star", "unlock"],
    "popularity": 3267
  },
  {
    "name": "single_bed",
    "tags": [
      "bed",
      "bedroom",
      "double",
      "furniture",
      "home",
      "hotel",
      "house",
      "king",
      "night",
      "pillows",
      "queen",
      "rest",
      "room",
      "single",
      "sleep",
      "twin"
    ],
    "popularity": 3265
  },
  {
    "name": "transform",
    "tags": ["adjust", "crop", "edit", "editing", "image", "photo", "picture", "transform"],
    "popularity": 3265
  },
  {
    "name": "bookmarks",
    "tags": [
      "bookmark",
      "bookmarks",
      "favorite",
      "label",
      "layers",
      "library",
      "multiple",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "stack",
      "tag"
    ],
    "popularity": 3261
  },
  {
    "name": "local_movies",
    "tags": [],
    "popularity": 3254
  },
  {
    "name": "redo",
    "tags": ["arrow", "backward", "forward", "next", "redo", "repeat", "rotate", "undo"],
    "popularity": 3252
  },
  {
    "name": "repeat_one",
    "tags": [
      "1",
      "arrow",
      "arrows",
      "control",
      "controls",
      "digit",
      "media",
      "music",
      "number",
      "one",
      "repeat",
      "symbol",
      "video"
    ],
    "popularity": 3251
  },
  {
    "name": "difference",
    "tags": [
      "compare",
      "content",
      "copy",
      "cut",
      "diff",
      "difference",
      "doc",
      "document",
      "duplicate",
      "file",
      "multiple",
      "past"
    ],
    "popularity": 3250
  },
  {
    "name": "swap_calls",
    "tags": ["arrow", "arrows", "calls", "device", "direction", "mobile", "share", "swap"],
    "popularity": 3249
  },
  {
    "name": "do_not_disturb_alt",
    "tags": ["cancel", "close", "denied", "deny", "disturb", "do", "remove", "silence", "stop"],
    "popularity": 3247
  },
  {
    "name": "perm_device_information",
    "tags": [
      "Android",
      "OS",
      "alert",
      "announcement",
      "device",
      "hardware",
      "i",
      "iOS",
      "info",
      "information",
      "mobile",
      "perm",
      "phone",
      "tablet"
    ],
    "popularity": 3243
  },
  {
    "name": "mode_standby",
    "tags": ["disturb", "mode", "power", "sleep", "standby", "target"],
    "popularity": 3242
  },
  {
    "name": "publish",
    "tags": ["arrow", "cloud", "file", "import", "publish", "up", "upload"],
    "popularity": 3241
  },
  {
    "name": "wash",
    "tags": ["bathroom", "clean", "fingers", "gesture", "hand", "wash", "wc"],
    "popularity": 3241
  },
  {
    "name": "remove_moderator",
    "tags": [
      "certified",
      "disabled",
      "enabled",
      "moderator",
      "off",
      "on",
      "privacy",
      "private",
      "protect",
      "protection",
      "remove",
      "security",
      "shield",
      "slash",
      "verified"
    ],
    "popularity": 3240
  },
  {
    "name": "smoking_rooms",
    "tags": ["allowed", "cigarette", "places", "rooms", "smoke", "smoking", "tobacco", "zone"],
    "popularity": 3237
  },
  {
    "name": "wallet",
    "tags": [],
    "popularity": 3237
  },
  {
    "name": "equalizer",
    "tags": [
      "adjustment",
      "analytics",
      "chart",
      "data",
      "equalizer",
      "graph",
      "measure",
      "metrics",
      "music",
      "noise",
      "sound",
      "static",
      "statistics",
      "tracking",
      "volume"
    ],
    "popularity": 3235
  },
  {
    "name": "layers",
    "tags": [
      "arrange",
      "disabled",
      "enabled",
      "interaction",
      "layers",
      "maps",
      "off",
      "on",
      "overlay",
      "pages",
      "slash"
    ],
    "popularity": 3232
  },
  {
    "name": "show_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "line",
      "measure",
      "metrics",
      "presentation",
      "show chart",
      "statistics",
      "tracking"
    ],
    "popularity": 3231
  },
  {
    "name": "workspaces",
    "tags": ["circles", "collaboration", "dot", "filled", "group", "outline", "space", "team", "work", "workspaces"],
    "popularity": 3231
  },
  {
    "name": "zoom_out",
    "tags": [
      "find",
      "glass",
      "look",
      "magnify",
      "magnifying",
      "minus",
      "negative",
      "out",
      "scale",
      "search",
      "see",
      "size",
      "small",
      "smaller",
      "zoom"
    ],
    "popularity": 3228
  },
  {
    "name": "arrow_left",
    "tags": [
      "app",
      "application",
      "arrow",
      "components",
      "direction",
      "interface",
      "left",
      "navigation",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 3225
  },
  {
    "name": "door_sliding",
    "tags": [
      "auto",
      "automatic",
      "door",
      "doorway",
      "double",
      "entrance",
      "exit",
      "glass",
      "home",
      "house",
      "sliding",
      "two"
    ],
    "popularity": 3222
  },
  {
    "name": "subscriptions",
    "tags": ["enroll", "list", "media", "order", "play", "signup", "subscribe", "subscriptions"],
    "popularity": 3215
  },
  {
    "name": "group_remove",
    "tags": [
      "accounts",
      "committee",
      "face",
      "family",
      "friends",
      "group",
      "humans",
      "network",
      "people",
      "persons",
      "profiles",
      "remove",
      "social",
      "team",
      "users"
    ],
    "popularity": 3212
  },
  {
    "name": "currency_yen",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol",
      "yen"
    ],
    "popularity": 3211
  },
  {
    "name": "psychology_alt",
    "tags": [
      "?",
      "assistance",
      "behavior",
      "body",
      "brain",
      "cognitive",
      "function",
      "gear",
      "head",
      "help",
      "human",
      "info",
      "information",
      "intellectual",
      "mental",
      "mind",
      "people",
      "person",
      "preferences",
      "psychiatric",
      "psychology",
      "punctuation",
      "question mark",
      "science",
      "settings",
      "social",
      "support",
      "symbol",
      "therapy",
      "thinking",
      "thoughts"
    ],
    "popularity": 3206
  },
  {
    "name": "brightness_high",
    "tags": ["auto", "brightness", "control", "high", "mobile", "monitor", "phone", "sun"],
    "popularity": 3205
  },
  {
    "name": "skateboarding",
    "tags": [
      "athlete",
      "athletic",
      "body",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "people",
      "person",
      "skate",
      "skateboarder",
      "skateboarding",
      "social",
      "sports"
    ],
    "popularity": 3203
  },
  {
    "name": "bed",
    "tags": [
      "bed",
      "bedroom",
      "double",
      "full",
      "furniture",
      "home",
      "hotel",
      "house",
      "king",
      "night",
      "pillows",
      "queen",
      "rest",
      "room",
      "size",
      "sleep"
    ],
    "popularity": 3192
  },
  {
    "name": "cabin",
    "tags": [
      "architecture",
      "cabin",
      "camping",
      "cottage",
      "estate",
      "home",
      "house",
      "log",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling",
      "wood"
    ],
    "popularity": 3189
  },
  {
    "name": "camera_outdoor",
    "tags": [
      "architecture",
      "building",
      "camera",
      "estate",
      "film",
      "filming",
      "home",
      "house",
      "image",
      "motion",
      "nest",
      "outdoor",
      "outside",
      "picture",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "video",
      "videography"
    ],
    "popularity": 3181
  },
  {
    "name": "tablet_android",
    "tags": ["OS", "android", "device", "hardware", "iOS", "ipad", "mobile", "tablet", "web"],
    "popularity": 3181
  },
  {
    "name": "motion_photos_on",
    "tags": ["animation", "circle", "disabled", "enabled", "motion", "off", "on", "photos", "play", "slash", "video"],
    "popularity": 3179
  },
  {
    "name": "satellite",
    "tags": [
      "bluetooth",
      "connect",
      "connection",
      "connectivity",
      "data",
      "device",
      "image",
      "internet",
      "landscape",
      "location",
      "maps",
      "mountain",
      "mountains",
      "network",
      "photo",
      "photography",
      "picture",
      "satellite",
      "scan",
      "service",
      "signal",
      "symbol",
      "wireless-- wifi"
    ],
    "popularity": 3177
  },
  {
    "name": "video_library",
    "tags": ["arrow", "collection", "library", "play", "video"],
    "popularity": 3177
  },
  {
    "name": "vaccines",
    "tags": [
      "aid",
      "covid",
      "doctor",
      "drug",
      "emergency",
      "hospital",
      "immunity",
      "injection",
      "medical",
      "medication",
      "medicine",
      "needle",
      "pharmacy",
      "sick",
      "syringe",
      "vaccination",
      "vaccines",
      "vial"
    ],
    "popularity": 3176
  },
  {
    "name": "co2",
    "tags": ["carbon", "chemical", "co2", "dioxide", "gas"],
    "popularity": 3175
  },
  {
    "name": "house_siding",
    "tags": [
      "architecture",
      "building",
      "construction",
      "estate",
      "exterior",
      "facade",
      "home",
      "house",
      "real",
      "residential",
      "siding"
    ],
    "popularity": 3167
  },
  {
    "name": "memory",
    "tags": ["card", "chip", "digital", "memory", "micro", "processor", "sd", "storage"],
    "popularity": 3164
  },
  {
    "name": "pan_tool_alt",
    "tags": ["fingers", "gesture", "hand", "hands", "human", "move", "pan", "scan", "stop", "tool"],
    "popularity": 3161
  },
  {
    "name": "local_activity",
    "tags": ["activity", "event", "event ticket", "local", "star", "things", "ticket"],
    "popularity": 3159
  },
  {
    "name": "strikethrough_s",
    "tags": [
      "alphabet",
      "character",
      "cross",
      "doc",
      "edit",
      "editing",
      "editor",
      "font",
      "letter",
      "out",
      "s",
      "sheet",
      "spreadsheet",
      "strikethrough",
      "styles",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 3158
  },
  {
    "name": "keyboard_arrow_right",
    "tags": ["arrow", "arrows", "keyboard", "right"],
    "popularity": 3153
  },
  {
    "name": "door_back",
    "tags": ["back", "closed", "door", "doorway", "entrance", "exit", "home", "house", "way"],
    "popularity": 3152
  },
  {
    "name": "forward_to_inbox",
    "tags": [
      "arrow",
      "arrows",
      "directions",
      "email",
      "envelop",
      "forward",
      "inbox",
      "letter",
      "mail",
      "message",
      "navigation",
      "outgoing",
      "right",
      "send",
      "to"
    ],
    "popularity": 3150
  },
  {
    "name": "notifications_paused",
    "tags": [
      "active",
      "alarm",
      "alert",
      "bell",
      "chime",
      "ignore",
      "notifications",
      "notify",
      "paused",
      "quiet",
      "reminder",
      "ring --- pause",
      "sleep",
      "snooze",
      "sound",
      "z",
      "zzz"
    ],
    "popularity": 3146
  },
  {
    "name": "directions_boat_filled",
    "tags": [
      "automobile",
      "boat",
      "car",
      "cars",
      "direction",
      "directions",
      "ferry",
      "filled",
      "maps",
      "public",
      "transportation",
      "vehicle"
    ],
    "popularity": 3137
  },
  {
    "name": "call_to_action",
    "tags": [
      "action",
      "alert",
      "bar",
      "call",
      "components",
      "cta",
      "design",
      "info",
      "information",
      "interface",
      "layout",
      "message",
      "notification",
      "screen",
      "site",
      "to",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 3134
  },
  {
    "name": "euro",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "euro",
      "euros",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 3131
  },
  {
    "name": "energy_savings_leaf",
    "tags": ["eco", "energy", "leaf", "leaves", "nest", "savings", "usage"],
    "popularity": 3126
  },
  {
    "name": "work_history",
    "tags": [
      "back",
      "backwards",
      "bag",
      "baggage",
      "briefcase",
      "business",
      "case",
      "clock",
      "date",
      "history",
      "job",
      "pending",
      "recent",
      "schedule",
      "suitcase",
      "time",
      "updates",
      "work"
    ],
    "popularity": 3122
  },
  {
    "name": "photo_camera_front",
    "tags": [
      "account",
      "camera",
      "face",
      "front",
      "human",
      "image",
      "people",
      "person",
      "photo",
      "photography",
      "picture",
      "portrait",
      "profile",
      "user"
    ],
    "popularity": 3120
  },
  {
    "name": "subtitles_off",
    "tags": [
      "accessibility",
      "accessible",
      "caption",
      "cc",
      "closed",
      "disabled",
      "enabled",
      "language",
      "off",
      "on",
      "slash",
      "subtitle",
      "subtitles",
      "translate",
      "video"
    ],
    "popularity": 3119
  },
  {
    "name": "vertical_align_center",
    "tags": [
      "align",
      "alignment",
      "arrow",
      "center",
      "doc",
      "down",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "up",
      "vertical",
      "writing"
    ],
    "popularity": 3115
  },
  {
    "name": "rotate_90_degrees_ccw",
    "tags": [
      "90",
      "arrow",
      "arrows",
      "ccw",
      "degrees",
      "direction",
      "edit",
      "editing",
      "image",
      "photo",
      "rotate",
      "turn"
    ],
    "popularity": 3106
  },
  {
    "name": "hot_tub",
    "tags": [
      "bath",
      "bathing",
      "bathroom",
      "bathtub",
      "hot",
      "hotel",
      "human",
      "jacuzzi",
      "person",
      "shower",
      "spa",
      "steam",
      "travel",
      "tub",
      "water"
    ],
    "popularity": 3103
  },
  {
    "name": "percent",
    "tags": ["math", "number", "percent", "symbol"],
    "popularity": 3103
  },
  {
    "name": "join_full",
    "tags": ["circle", "combine", "command", "join", "left", "outer", "overlap", "right", "sql"],
    "popularity": 3099
  },
  {
    "name": "compost",
    "tags": [
      "bio",
      "compost",
      "compostable",
      "decomposable",
      "decompose",
      "eco",
      "green",
      "leaf",
      "leafs",
      "nature",
      "organic",
      "plant",
      "recycle",
      "sustainability",
      "sustainable"
    ],
    "popularity": 3098
  },
  {
    "name": "battery_saver",
    "tags": ["+", "add", "battery", "charge", "charging", "new", "plus", "power", "saver", "symbol"],
    "popularity": 3097
  },
  {
    "name": "battery_5_bar",
    "tags": ["5", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 3095
  },
  {
    "name": "living",
    "tags": [
      "chair",
      "comfort",
      "couch",
      "decoration",
      "furniture",
      "home",
      "house",
      "living",
      "lounging",
      "loveseat",
      "room",
      "seat",
      "seating",
      "sofa"
    ],
    "popularity": 3095
  },
  {
    "name": "update_disabled",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "clock",
      "date",
      "disabled",
      "enabled",
      "forward",
      "history",
      "load",
      "off",
      "on",
      "refresh",
      "reverse",
      "rotate",
      "schedule",
      "slash",
      "time",
      "update"
    ],
    "popularity": 3092
  },
  {
    "name": "play_lesson",
    "tags": [
      "audio",
      "book",
      "bookmark",
      "digital",
      "ebook",
      "lesson",
      "multimedia",
      "play",
      "play lesson",
      "read",
      "reading",
      "ribbon"
    ],
    "popularity": 3084
  },
  {
    "name": "meeting_room",
    "tags": [
      "building",
      "door",
      "doorway",
      "entrance",
      "home",
      "house",
      "interior",
      "meeting",
      "office",
      "open",
      "places",
      "room"
    ],
    "popularity": 3083
  },
  {
    "name": "format_color_reset",
    "tags": [
      "clear",
      "color",
      "disabled",
      "doc",
      "droplet",
      "edit",
      "editing",
      "editor",
      "enabled",
      "fill",
      "format",
      "off",
      "on",
      "paint",
      "reset",
      "sheet",
      "slash",
      "spreadsheet",
      "style",
      "text",
      "type",
      "water",
      "writing"
    ],
    "popularity": 3074
  },
  {
    "name": "person_remove_alt_1",
    "tags": [],
    "popularity": 3070
  },
  {
    "name": "cast_connected",
    "tags": [
      "Android",
      "OS",
      "airplay",
      "cast",
      "chrome",
      "connect",
      "connected",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "screencast",
      "streaming",
      "television",
      "tv",
      "web",
      "window",
      "wireless"
    ],
    "popularity": 3063
  },
  {
    "name": "looks_5",
    "tags": ["5", "digit", "looks", "numbers", "square", "symbol"],
    "popularity": 3062
  },
  {
    "name": "align_horizontal_left",
    "tags": [
      "align",
      "alignment",
      "format",
      "horizontal",
      "layout",
      "left",
      "lines",
      "paragraph",
      "rule",
      "rules",
      "style",
      "text"
    ],
    "popularity": 3061
  },
  {
    "name": "boy",
    "tags": ["body", "boy", "gender", "human", "male", "man", "people", "person", "social", "symbol"],
    "popularity": 3059
  },
  {
    "name": "snooze",
    "tags": ["alarm", "bell", "clock", "duration", "notification", "snooze", "time", "timer", "watch", "z"],
    "popularity": 3057
  },
  {
    "name": "voicemail",
    "tags": ["call", "device", "message", "missed", "mobile", "phone", "recording", "voice", "voicemail"],
    "popularity": 3053
  },
  {
    "name": "mic_external_on",
    "tags": ["audio", "disabled", "enabled", "external", "mic", "microphone", "off", "on", "slash", "sound", "voice"],
    "popularity": 3052
  },
  {
    "name": "move_up",
    "tags": ["arrow", "direction", "jump", "move", "navigation", "transfer", "up"],
    "popularity": 3037
  },
  {
    "name": "countertops",
    "tags": ["counter", "countertops", "home", "house", "kitchen", "sink", "table", "tops"],
    "popularity": 3036
  },
  {
    "name": "dangerous",
    "tags": ["broken", "danger", "dangerous", "fix", "no", "sign", "stop", "update", "warning", "wrong", "x"],
    "popularity": 3035
  },
  {
    "name": "supervised_user_circle",
    "tags": [
      "account",
      "avatar",
      "circle",
      "control",
      "face",
      "human",
      "parental",
      "parents",
      "people",
      "person",
      "profile",
      "supervised",
      "supervisor",
      "user"
    ],
    "popularity": 3033
  },
  {
    "name": "javascript",
    "tags": [
      "alphabet",
      "brackets",
      "character",
      "code",
      "css",
      "develop",
      "developer",
      "engineer",
      "engineering",
      "font",
      "html",
      "javascript",
      "letter",
      "platform",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 3025
  },
  {
    "name": "app_shortcut",
    "tags": [
      "app",
      "bookmarked",
      "favorite",
      "highlight",
      "important",
      "marked",
      "mobile",
      "save",
      "saved",
      "shortcut",
      "software",
      "special",
      "star"
    ],
    "popularity": 3022
  },
  {
    "name": "safety_divider",
    "tags": ["apart", "distance", "divider", "safety", "separate", "social", "space"],
    "popularity": 3021
  },
  {
    "name": "fast_forward",
    "tags": ["control", "fast", "forward", "media", "music", "play", "speed", "time", "tv", "video"],
    "popularity": 3019
  },
  {
    "name": "sync_disabled",
    "tags": [
      "360",
      "around",
      "arrow",
      "arrows",
      "direction",
      "disabled",
      "enabled",
      "inprogress",
      "load",
      "loading refresh",
      "off",
      "on",
      "renew",
      "rotate",
      "slash",
      "sync",
      "turn"
    ],
    "popularity": 3015
  },
  {
    "name": "credit_score",
    "tags": [
      "approve",
      "bill",
      "card",
      "cash",
      "check",
      "coin",
      "commerce",
      "complete",
      "cost",
      "credit",
      "currency",
      "dollars",
      "done",
      "finance",
      "loan",
      "mark",
      "money",
      "ok",
      "online",
      "pay",
      "payment",
      "score",
      "select",
      "symbol",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 3012
  },
  {
    "name": "keyboard",
    "tags": ["computer", "device", "hardware", "input", "keyboard", "keypad", "letter", "office", "text", "type"],
    "popularity": 3008
  },
  {
    "name": "attachment",
    "tags": ["attach", "attachment", "clip", "compose", "file", "image", "link"],
    "popularity": 3006
  },
  {
    "name": "forest",
    "tags": ["forest", "jungle", "nature", "plantation", "plants", "trees", "woodland"],
    "popularity": 3003
  },
  {
    "name": "ac_unit",
    "tags": [
      "ac",
      "air",
      "cold",
      "conditioner",
      "flake",
      "snow",
      "snowflake",
      "temperature",
      "unit",
      "weather",
      "winter"
    ],
    "popularity": 2999
  },
  {
    "name": "html",
    "tags": [
      "alphabet",
      "brackets",
      "character",
      "code",
      "css",
      "develop",
      "developer",
      "engineer",
      "engineering",
      "font",
      "html",
      "letter",
      "platform",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 2996
  },
  {
    "name": "tram",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "maps",
      "public",
      "rail",
      "subway",
      "train",
      "tram",
      "transportation",
      "vehicle"
    ],
    "popularity": 2994
  },
  {
    "name": "storm",
    "tags": ["forecast", "hurricane", "storm", "temperature", "twister", "weather", "wind"],
    "popularity": 2992
  },
  {
    "name": "collections_bookmark",
    "tags": [
      "album",
      "archive",
      "bookmark",
      "collections",
      "favorite",
      "gallery",
      "label",
      "library",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "stack",
      "tag"
    ],
    "popularity": 2988
  },
  {
    "name": "interests",
    "tags": ["circle", "heart", "interests", "shapes", "social", "square", "triangle"],
    "popularity": 2975
  },
  {
    "name": "imagesmode",
    "tags": ["image", "mode", "mountain", "mountains", "photo", "photography", "picture"],
    "popularity": 2974
  },
  {
    "name": "laptop_windows",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "device",
      "display",
      "hardware",
      "iOS",
      "laptop",
      "mac",
      "monitor",
      "screen",
      "web",
      "window",
      "windows"
    ],
    "popularity": 2974
  },
  {
    "name": "data_saver_off",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "donut",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "off",
      "on",
      "ring",
      "saver",
      "statistics",
      "tracking"
    ],
    "popularity": 2971
  },
  {
    "name": "live_tv",
    "tags": [
      "Android",
      "OS",
      "antennas hardware",
      "chrome",
      "desktop",
      "device",
      "iOS",
      "live",
      "mac",
      "monitor",
      "movie",
      "play",
      "stream",
      "television",
      "tv",
      "web",
      "window"
    ],
    "popularity": 2966
  },
  {
    "name": "share_location",
    "tags": ["destination", "direction", "gps", "location", "maps", "pin", "place", "share", "stop", "tracking"],
    "popularity": 2966
  },
  {
    "name": "token",
    "tags": ["badge", "hexagon", "mark", "shield", "sign", "symbol"],
    "popularity": 2958
  },
  {
    "name": "recommend",
    "tags": [
      "approved",
      "circle",
      "confirm",
      "favorite",
      "gesture",
      "hand",
      "like",
      "reaction",
      "recommend",
      "social",
      "support",
      "thumbs",
      "up",
      "well"
    ],
    "popularity": 2957
  },
  {
    "name": "doorbell",
    "tags": ["alarm", "bell", "door", "doorbell", "home", "house", "ringing"],
    "popularity": 2956
  },
  {
    "name": "outgoing_mail",
    "tags": [
      "arrow",
      "arrows",
      "directions",
      "email",
      "envelop",
      "forward",
      "inbox",
      "letter",
      "mail",
      "message",
      "navigation",
      "outgoing",
      "right",
      "send",
      "to"
    ],
    "popularity": 2956
  },
  {
    "name": "hd",
    "tags": [
      "alphabet",
      "character",
      "definition",
      "display",
      "font",
      "hd",
      "high",
      "letter",
      "movie",
      "movies",
      "resolution",
      "screen",
      "symbol",
      "text",
      "tv",
      "type"
    ],
    "popularity": 2955
  },
  {
    "name": "file_download_off",
    "tags": [
      "arrow",
      "disabled",
      "down",
      "download",
      "drive",
      "enabled",
      "export",
      "file",
      "install",
      "off",
      "on",
      "save",
      "slash",
      "upload"
    ],
    "popularity": 2952
  },
  {
    "name": "soup_kitchen",
    "tags": ["breakfast", "brunch", "dining", "food", "kitchen", "lunch", "meal", "soup"],
    "popularity": 2948
  },
  {
    "name": "swipe_left",
    "tags": [
      "arrow",
      "arrows",
      "finger",
      "hand",
      "hit",
      "left",
      "navigation",
      "reject",
      "strike",
      "swing",
      "swipe",
      "take"
    ],
    "popularity": 2948
  },
  {
    "name": "all_inclusive",
    "tags": [
      "all",
      "endless",
      "forever",
      "inclusive",
      "infinity",
      "loop",
      "mobius",
      "neverending",
      "strip",
      "sustainability",
      "sustainable"
    ],
    "popularity": 2946
  },
  {
    "name": "apps_outage",
    "tags": [
      "all",
      "applications",
      "apps",
      "circles",
      "collection",
      "components",
      "dots",
      "grid",
      "interface",
      "outage",
      "squares",
      "ui",
      "ux"
    ],
    "popularity": 2944
  },
  {
    "name": "assignment_ind",
    "tags": [
      "account",
      "assignment",
      "clipboard",
      "doc",
      "document",
      "face",
      "ind",
      "people",
      "person",
      "profile",
      "user"
    ],
    "popularity": 2944
  },
  {
    "name": "breakfast_dining",
    "tags": ["bakery", "bread", "breakfast", "butter", "dining", "food", "toast"],
    "popularity": 2941
  },
  {
    "name": "taxi_alert",
    "tags": [
      "!",
      "alert",
      "attention",
      "automobile",
      "cab",
      "car",
      "cars",
      "caution",
      "danger",
      "direction",
      "error",
      "exclamation",
      "important",
      "lyft",
      "maps",
      "mark",
      "notification",
      "public",
      "symbol",
      "taxi",
      "transportation",
      "uber",
      "vehicle",
      "warning",
      "yellow"
    ],
    "popularity": 2940
  },
  {
    "name": "voice_over_off",
    "tags": [
      "account",
      "disabled",
      "enabled",
      "face",
      "human",
      "off",
      "on",
      "over",
      "people",
      "person",
      "profile",
      "recording",
      "slash",
      "speak",
      "speaking",
      "speech",
      "transcript",
      "user",
      "voice"
    ],
    "popularity": 2937
  },
  {
    "name": "abc",
    "tags": ["alphabet", "character", "font", "letter", "symbol", "text", "type"],
    "popularity": 2935
  },
  {
    "name": "gradient",
    "tags": [
      "color",
      "edit",
      "editing",
      "effect",
      "filter",
      "gradient",
      "image",
      "images",
      "photography",
      "picture",
      "pictures"
    ],
    "popularity": 2931
  },
  {
    "name": "brightness_medium",
    "tags": ["auto", "brightness", "control", "medium", "mobile", "monitor", "phone", "sun"],
    "popularity": 2926
  },
  {
    "name": "water_damage",
    "tags": [
      "architecture",
      "building",
      "damage",
      "drop",
      "droplet",
      "estate",
      "house",
      "leak",
      "plumbing",
      "real",
      "residence",
      "residential",
      "shelter",
      "water"
    ],
    "popularity": 2918
  },
  {
    "name": "train",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "maps",
      "public",
      "rail",
      "subway",
      "train",
      "transportation",
      "vehicle"
    ],
    "popularity": 2904
  },
  {
    "name": "switch_access_shortcut",
    "tags": [
      "access",
      "arrow",
      "arrows",
      "direction",
      "navigation",
      "new",
      "north",
      "shortcut",
      "switch",
      "symbol",
      "up"
    ],
    "popularity": 2903
  },
  {
    "name": "emergency",
    "tags": ["asterisk", "clinic", "emergency", "health", "hospital", "maps", "medical", "symbol"],
    "popularity": 2897
  },
  {
    "name": "barcode_scanner",
    "tags": ["barcode", "ecommerce", "price", "scan", "shop", "shopping", "tag"],
    "popularity": 2894
  },
  {
    "name": "data_saver_on",
    "tags": [
      "+",
      "add",
      "analytics",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "new",
      "on",
      "plus",
      "ring",
      "saver",
      "statistics",
      "symbol",
      "tracking"
    ],
    "popularity": 2892
  },
  {
    "name": "directions_bike",
    "tags": [
      "bicycle",
      "bike",
      "direction",
      "directions",
      "human",
      "maps",
      "person",
      "public",
      "route",
      "transportation"
    ],
    "popularity": 2891
  },
  {
    "name": "laptop_mac",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "device",
      "display",
      "hardware",
      "iOS",
      "laptop",
      "mac",
      "monitor",
      "screen",
      "web",
      "window"
    ],
    "popularity": 2889
  },
  {
    "name": "diversity_2",
    "tags": [
      "committee",
      "diverse",
      "diversity",
      "family",
      "friends",
      "group",
      "groups",
      "heart",
      "humans",
      "network",
      "people",
      "persons",
      "social",
      "team"
    ],
    "popularity": 2888
  },
  {
    "name": "waving_hand",
    "tags": ["bye", "fingers", "gesture", "goodbye", "greetings", "hand", "hello", "palm", "wave", "waving"],
    "popularity": 2888
  },
  {
    "name": "domain_add",
    "tags": [
      "+",
      "add",
      "apartment",
      "architecture",
      "building",
      "business",
      "domain",
      "estate",
      "home",
      "new",
      "place",
      "plus",
      "real",
      "residence",
      "residential",
      "shelter",
      "symbol",
      "web",
      "www"
    ],
    "popularity": 2879
  },
  {
    "name": "playlist_add",
    "tags": ["+", "add", "collection", "list", "music", "new", "playlist", "plus", "symbol"],
    "popularity": 2879
  },
  {
    "name": "brightness_low",
    "tags": ["auto", "brightness", "control", "low", "mobile", "monitor", "phone", "sun"],
    "popularity": 2874
  },
  {
    "name": "fitbit",
    "tags": ["athlete", "athletic", "exercise", "fitbit", "fitness", "hobby", "logo"],
    "popularity": 2874
  },
  {
    "name": "chair",
    "tags": [
      "chair",
      "comfort",
      "couch",
      "decoration",
      "furniture",
      "home",
      "house",
      "living",
      "lounging",
      "loveseat",
      "room",
      "seat",
      "seating",
      "sofa"
    ],
    "popularity": 2871
  },
  {
    "name": "hexagon",
    "tags": ["hexagon", "shape", "six sides"],
    "popularity": 2870
  },
  {
    "name": "signpost",
    "tags": ["arrow", "direction", "left", "maps", "right", "signal", "signs", "street", "traffic"],
    "popularity": 2869
  },
  {
    "name": "fire_extinguisher",
    "tags": ["emergency", "extinguisher", "fire", "water"],
    "popularity": 2868
  },
  {
    "name": "headset_mic",
    "tags": [
      "accessory",
      "audio",
      "chat",
      "device",
      "ear",
      "earphone",
      "headphones",
      "headset",
      "listen",
      "mic",
      "music",
      "sound",
      "talk"
    ],
    "popularity": 2864
  },
  {
    "name": "signal_wifi_0_bar",
    "tags": [
      "0",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 2861
  },
  {
    "name": "device_unknown",
    "tags": [
      "?",
      "Android",
      "OS",
      "assistance",
      "cell",
      "device",
      "hardware",
      "help",
      "iOS",
      "info",
      "information",
      "mobile",
      "phone",
      "punctuation",
      "question mark",
      "support",
      "symbol",
      "tablet",
      "unknown"
    ],
    "popularity": 2860
  },
  {
    "name": "rule",
    "tags": [
      "approve",
      "check",
      "complete",
      "done",
      "incomplete",
      "line",
      "mark",
      "missing",
      "no",
      "ok",
      "rule",
      "select",
      "tick",
      "validate",
      "verified",
      "wrong",
      "x",
      "yes"
    ],
    "popularity": 2857
  },
  {
    "name": "person_remove",
    "tags": [
      "account",
      "avatar",
      "delete",
      "face",
      "human",
      "minus",
      "people",
      "person",
      "profile",
      "remove",
      "unfriend",
      "user"
    ],
    "popularity": 2855
  },
  {
    "name": "format_list_numbered",
    "tags": [
      "align",
      "alignment",
      "digit",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "notes",
      "number",
      "numbered",
      "sheet",
      "spreadsheet",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 2853
  },
  {
    "name": "sunny",
    "tags": ["climate", "hot", "summer", "sun", "sunny", "temperature", "warm", "weather"],
    "popularity": 2848
  },
  {
    "name": "north_east",
    "tags": ["arrow", "east", "maps", "navigation", "noth", "right", "up"],
    "popularity": 2843
  },
  {
    "name": "closed_caption_off",
    "tags": [
      "accessible",
      "alphabet",
      "caption",
      "cc",
      "character",
      "closed",
      "decoder",
      "font",
      "language",
      "letter",
      "media",
      "movies",
      "off",
      "outline",
      "subtitle",
      "subtitles",
      "symbol",
      "text",
      "tv",
      "type"
    ],
    "popularity": 2842
  },
  {
    "name": "bedroom_child",
    "tags": [
      "bed",
      "bedroom",
      "child",
      "children",
      "furniture",
      "home",
      "hotel",
      "house",
      "kid",
      "night",
      "pillows",
      "rest",
      "room",
      "size",
      "sleep",
      "twin",
      "young"
    ],
    "popularity": 2840
  },
  {
    "name": "bluetooth_searching",
    "tags": ["bluetooth", "connection", "device", "paring", "search", "searching", "symbol"],
    "popularity": 2839
  },
  {
    "name": "tap_and_play",
    "tags": [
      "Android",
      "OS wifi",
      "cell",
      "connection",
      "device",
      "hardware",
      "iOS",
      "internet",
      "mobile",
      "network",
      "phone",
      "play",
      "signal",
      "tablet",
      "tap",
      "to",
      "wireless"
    ],
    "popularity": 2837
  },
  {
    "name": "private_connectivity",
    "tags": [
      "connectivity",
      "lock",
      "locked",
      "password",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security"
    ],
    "popularity": 2835
  },
  {
    "name": "content_paste_off",
    "tags": ["clipboard", "content", "disabled", "doc", "document", "enabled", "file", "off", "on", "paste", "slash"],
    "popularity": 2832
  },
  {
    "name": "grid_4x4",
    "tags": ["4", "by", "grid", "layout", "lines", "space"],
    "popularity": 2830
  },
  {
    "name": "keyboard_arrow_up",
    "tags": ["arrow", "arrows", "keyboard", "up"],
    "popularity": 2830
  },
  {
    "name": "wc",
    "tags": ["bathroom", "closet", "female", "male", "man", "restroom", "room", "wash", "water", "wc", "women"],
    "popularity": 2829
  },
  {
    "name": "network_cell",
    "tags": ["cell", "cellular", "data", "internet", "mobile", "network", "phone", "speed", "wifi", "wireless"],
    "popularity": 2827
  },
  {
    "name": "charging_station",
    "tags": [
      "Android",
      "OS",
      "battery",
      "bolt",
      "cell",
      "charging",
      "device",
      "electric",
      "hardware",
      "iOS",
      "lightning",
      "mobile",
      "phone",
      "station",
      "tablet",
      "thunderbolt"
    ],
    "popularity": 2826
  },
  {
    "name": "screenshot",
    "tags": [
      "Android",
      "OS",
      "cell",
      "crop",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "screen",
      "screenshot",
      "tablet"
    ],
    "popularity": 2822
  },
  {
    "name": "tv",
    "tags": ["device", "display", "monitor", "screen", "screencast", "stream", "television", "tv", "video", "wireless"],
    "popularity": 2822
  },
  {
    "name": "repeat_on",
    "tags": ["arrow", "arrows", "control", "controls", "media", "music", "on", "repeat", "video"],
    "popularity": 2821
  },
  {
    "name": "mark_email_unread",
    "tags": [
      "check",
      "circle",
      "email",
      "envelop",
      "letter",
      "mail",
      "mark",
      "message",
      "note",
      "notification",
      "send",
      "unread"
    ],
    "popularity": 2819
  },
  {
    "name": "reviews",
    "tags": [
      "bubble",
      "chat",
      "comment",
      "communicate",
      "feedback",
      "message",
      "rate",
      "rating",
      "recommendation",
      "reviews",
      "speech"
    ],
    "popularity": 2819
  },
  {
    "name": "carpenter",
    "tags": ["building", "carpenter", "construction", "cutting", "handyman", "repair", "saw", "tool"],
    "popularity": 2814
  },
  {
    "name": "arrow_circle_down",
    "tags": ["arrow", "circle", "direction", "down", "navigation"],
    "popularity": 2813
  },
  {
    "name": "assistant_photo",
    "tags": ["assistant", "flag", "photo", "recommendation", "smart", "star", "suggestion"],
    "popularity": 2813
  },
  {
    "name": "replay_30",
    "tags": [
      "30",
      "arrow",
      "arrows",
      "control",
      "controls",
      "digit",
      "music",
      "number",
      "refresh",
      "renew",
      "repeat",
      "replay",
      "symbol",
      "thirty",
      "video"
    ],
    "popularity": 2812
  },
  {
    "name": "mobiledata_off",
    "tags": [
      "arrow",
      "data",
      "disabled",
      "down",
      "enabled",
      "internet",
      "mobile",
      "network",
      "off",
      "on",
      "slash",
      "speed",
      "up",
      "wifi",
      "wireless"
    ],
    "popularity": 2811
  },
  {
    "name": "fullscreen_exit",
    "tags": [
      "adjust",
      "app",
      "application",
      "components",
      "exit",
      "full",
      "fullscreen",
      "interface",
      "screen",
      "site",
      "size",
      "ui",
      "ux",
      "view",
      "web",
      "website"
    ],
    "popularity": 2809
  },
  {
    "name": "sort_by_alpha",
    "tags": [
      "alphabet",
      "alphabetize",
      "az",
      "by alpha",
      "character",
      "font",
      "letter",
      "list",
      "order",
      "organize",
      "sort",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 2803
  },
  {
    "name": "assignment_turned_in",
    "tags": [
      "approve",
      "assignment",
      "check",
      "clipboard",
      "complete",
      "doc",
      "document",
      "done",
      "in",
      "mark",
      "ok",
      "select",
      "tick",
      "turn",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 2799
  },
  {
    "name": "atm",
    "tags": [
      "alphabet",
      "atm",
      "automated",
      "bill",
      "card",
      "cart",
      "cash",
      "character",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "font",
      "letter",
      "machine",
      "money",
      "online",
      "pay",
      "payment",
      "shopping",
      "symbol",
      "teller",
      "text",
      "type"
    ],
    "popularity": 2799
  },
  {
    "name": "delete_sweep",
    "tags": ["bin", "can", "delete", "garbage", "remove", "sweep", "trash"],
    "popularity": 2797
  },
  {
    "name": "rv_hookup",
    "tags": [
      "arrow",
      "attach",
      "automobile",
      "automotive",
      "back",
      "car",
      "cars",
      "connect",
      "direction",
      "hookup",
      "left",
      "maps",
      "public",
      "right",
      "rv",
      "trailer",
      "transportation",
      "travel",
      "truck",
      "van",
      "vehicle"
    ],
    "popularity": 2794
  },
  {
    "name": "lan",
    "tags": ["computer", "connection", "data", "internet", "lan", "network", "service"],
    "popularity": 2793
  },
  {
    "name": "offline_share",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "cell",
      "connect",
      "device",
      "direction",
      "hardware",
      "iOS",
      "link",
      "mobile",
      "multiple",
      "offline",
      "phone",
      "right",
      "share",
      "tablet"
    ],
    "popularity": 2792
  },
  {
    "name": "indeterminate_check_box",
    "tags": [
      "app",
      "application",
      "box",
      "button",
      "check",
      "components",
      "control",
      "design",
      "form",
      "indeterminate",
      "interface",
      "screen",
      "select",
      "selected",
      "selection",
      "site",
      "square",
      "toggle",
      "ui",
      "undetermined",
      "ux",
      "web",
      "website"
    ],
    "popularity": 2789
  },
  {
    "name": "lightbulb_circle",
    "tags": ["alert", "announcement", "idea", "info", "information", "light", "lightbulb"],
    "popularity": 2787
  },
  {
    "name": "settings_input_svideo",
    "tags": [
      "cable",
      "connection",
      "connectivity",
      "definition",
      "input",
      "plug",
      "plugin",
      "points",
      "settings",
      "standard",
      "svideo",
      "video"
    ],
    "popularity": 2783
  },
  {
    "name": "wb_twilight",
    "tags": ["balance", "light", "lighting", "noon", "sun", "sunset", "twilight", "wb", "white"],
    "popularity": 2779
  },
  {
    "name": "baby_changing_station",
    "tags": [
      "babies",
      "baby",
      "bathroom",
      "body",
      "changing",
      "child",
      "children",
      "father",
      "human",
      "infant",
      "kids",
      "mother",
      "newborn",
      "people",
      "person",
      "station",
      "toddler",
      "wc",
      "young"
    ],
    "popularity": 2771
  },
  {
    "name": "sports_cricket",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "bat",
      "cricket",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "social",
      "sports"
    ],
    "popularity": 2771
  },
  {
    "name": "currency_pound",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "pound",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 2770
  },
  {
    "name": "change_history",
    "tags": ["change", "history", "shape", "triangle"],
    "popularity": 2766
  },
  {
    "name": "ad_units",
    "tags": [
      "Android",
      "OS",
      "ad",
      "banner",
      "cell",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "notification",
      "notifications",
      "phone",
      "tablet",
      "top",
      "units"
    ],
    "popularity": 2762
  },
  {
    "name": "soap",
    "tags": ["bathroom", "clean", "fingers", "gesture", "hand", "soap", "wash", "wc"],
    "popularity": 2760
  },
  {
    "name": "no_encryption",
    "tags": ["disabled", "enabled", "encryption", "lock", "no", "off", "on", "password", "safety", "security", "slash"],
    "popularity": 2759
  },
  {
    "name": "table_bar",
    "tags": ["bar", "cafe", "round", "table"],
    "popularity": 2759
  },
  {
    "name": "contrast",
    "tags": [
      "black",
      "contrast",
      "edit",
      "editing",
      "effect",
      "filter",
      "grayscale",
      "image",
      "images",
      "photography",
      "picture",
      "pictures",
      "settings",
      "white"
    ],
    "popularity": 2756
  },
  {
    "name": "nature",
    "tags": ["forest", "nature", "outdoor", "outside", "park", "tree", "wilderness"],
    "popularity": 2754
  },
  {
    "name": "priority",
    "tags": ["approve", "check", "complete", "done", "filled", "ok", "priority", "select", "tick", "yes"],
    "popularity": 2751
  },
  {
    "name": "browser_updated",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "browser",
      "chrome",
      "desktop",
      "device",
      "display",
      "download",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "updated",
      "web",
      "window"
    ],
    "popularity": 2750
  },
  {
    "name": "pie_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "pie",
      "statistics",
      "tracking"
    ],
    "popularity": 2750
  },
  {
    "name": "add_location",
    "tags": [
      "+",
      "add",
      "destination",
      "direction",
      "location",
      "maps",
      "new",
      "pin",
      "place",
      "plus",
      "stop",
      "symbol"
    ],
    "popularity": 2745
  },
  {
    "name": "subway",
    "tags": [
      "automobile",
      "bike",
      "car",
      "cars",
      "maps",
      "rail",
      "scooter",
      "subway",
      "train",
      "transportation",
      "travel",
      "tunnel",
      "underground",
      "vehicle",
      "vespa"
    ],
    "popularity": 2745
  },
  {
    "name": "multiline_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "line",
      "measure",
      "metrics",
      "multiple",
      "statistics",
      "tracking"
    ],
    "popularity": 2737
  },
  {
    "name": "tag",
    "tags": ["hash", "hashtag", "key", "media", "number", "pound", "social", "tag", "trend"],
    "popularity": 2737
  },
  {
    "name": "hourglass_top",
    "tags": ["countdown", "half", "hourglass", "loading", "minute", "minutes", "time", "top", "wait", "waiting"],
    "popularity": 2735
  },
  {
    "name": "loyalty",
    "tags": [
      "benefits",
      "card",
      "credit",
      "heart",
      "loyalty",
      "membership",
      "miles",
      "points",
      "program",
      "subscription",
      "tag",
      "travel",
      "trip"
    ],
    "popularity": 2735
  },
  {
    "name": "contact_phone",
    "tags": [
      "account",
      "avatar",
      "call",
      "communicate",
      "contact",
      "face",
      "human",
      "info",
      "information",
      "message",
      "mobile",
      "people",
      "person",
      "phone",
      "profile",
      "user"
    ],
    "popularity": 2733
  },
  {
    "name": "rectangle",
    "tags": ["four sides", "parallelograms", "polygons", "quadrilaterals", "recangle", "shape"],
    "popularity": 2732
  },
  {
    "name": "mode_comment",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "mode comment", "speech"],
    "popularity": 2730
  },
  {
    "name": "transit_enterexit",
    "tags": ["arrow", "direction", "enterexit", "maps", "navigation", "route", "transit", "transportation"],
    "popularity": 2726
  },
  {
    "name": "group_off",
    "tags": [
      "body",
      "club",
      "collaboration",
      "crowd",
      "gathering",
      "group",
      "human",
      "meeting",
      "off",
      "people",
      "person",
      "social",
      "teams"
    ],
    "popularity": 2721
  },
  {
    "name": "call_merge",
    "tags": ["arrow", "call", "device", "merge", "mobile"],
    "popularity": 2703
  },
  {
    "name": "hide_image",
    "tags": [
      "disabled",
      "enabled",
      "hide",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "off",
      "on",
      "photo",
      "photography",
      "picture",
      "slash"
    ],
    "popularity": 2700
  },
  {
    "name": "first_page",
    "tags": ["arrow", "back", "chevron", "first", "left", "page", "rewind"],
    "popularity": 2698
  },
  {
    "name": "inbox",
    "tags": ["archive", "email", "inbox", "incoming", "mail", "message"],
    "popularity": 2697
  },
  {
    "name": "bluetooth_disabled",
    "tags": [
      "bluetooth",
      "cast",
      "connect",
      "connection",
      "device",
      "disabled",
      "enabled",
      "off",
      "offline",
      "on",
      "paring",
      "slash",
      "streaming",
      "symbol",
      "wireless"
    ],
    "popularity": 2696
  },
  {
    "name": "medication",
    "tags": ["doctor", "drug", "emergency", "hospital", "medication", "medicine", "pharmacy", "pills", "prescription"],
    "popularity": 2692
  },
  {
    "name": "shield_moon",
    "tags": [
      "certified",
      "do not disturb",
      "moon",
      "night",
      "privacy",
      "private",
      "protect",
      "protection",
      "security",
      "shield",
      "verified"
    ],
    "popularity": 2690
  },
  {
    "name": "music_off",
    "tags": [
      "audio",
      "audiotrack",
      "disabled",
      "enabled",
      "key",
      "music",
      "note",
      "off",
      "on",
      "slash",
      "sound",
      "track"
    ],
    "popularity": 2689
  },
  {
    "name": "sd_card",
    "tags": ["camera", "card", "digital", "memory", "photos", "sd", "secure", "storage"],
    "popularity": 2689
  },
  {
    "name": "sentiment_neutral",
    "tags": [
      "emotionless",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "fine",
      "indifference",
      "mood",
      "neutral",
      "okay",
      "person",
      "sentiment",
      "survey"
    ],
    "popularity": 2681
  },
  {
    "name": "flip_to_back",
    "tags": ["arrange", "arrangement", "back", "flip", "format", "front", "layout", "move", "order", "sort", "to"],
    "popularity": 2679
  },
  {
    "name": "flash_on",
    "tags": [
      "bolt",
      "disabled",
      "electric",
      "enabled",
      "fast",
      "flash",
      "lightning",
      "off",
      "on",
      "slash",
      "thunderbolt"
    ],
    "popularity": 2673
  },
  {
    "name": "exposure_plus_1",
    "tags": [
      "1",
      "add",
      "brightness",
      "contrast",
      "digit",
      "edit",
      "editing",
      "effect",
      "exposure",
      "image",
      "number",
      "photo",
      "photography",
      "plus",
      "settings",
      "symbol"
    ],
    "popularity": 2668
  },
  {
    "name": "solar_power",
    "tags": ["eco", "energy", "heat", "nest", "power", "solar", "sun", "sunny"],
    "popularity": 2663
  },
  {
    "name": "air",
    "tags": ["air", "blowing", "breeze", "flow", "wave", "weather", "wind"],
    "popularity": 2662
  },
  {
    "name": "join_inner",
    "tags": ["circle", "command", "inner", "join", "matching", "overlap", "sql", "values"],
    "popularity": 2662
  },
  {
    "name": "view_array",
    "tags": ["array", "design", "format", "grid", "layout", "view", "website"],
    "popularity": 2654
  },
  {
    "name": "straight",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "maps",
      "navigation",
      "path",
      "route",
      "sign",
      "straight",
      "traffic",
      "up"
    ],
    "popularity": 2653
  },
  {
    "name": "table_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic grid",
      "measure",
      "metrics",
      "statistics",
      "table",
      "tracking"
    ],
    "popularity": 2647
  },
  {
    "name": "merge",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "maps",
      "merge",
      "navigation",
      "path",
      "route",
      "sign",
      "traffic"
    ],
    "popularity": 2646
  },
  {
    "name": "sports_mma",
    "tags": [
      "arts",
      "athlete",
      "athletic",
      "boxing",
      "combat",
      "entertainment",
      "exercise",
      "fighting",
      "game",
      "glove",
      "hobby",
      "martial",
      "mixed",
      "mma",
      "social",
      "sports"
    ],
    "popularity": 2642
  },
  {
    "name": "group_work",
    "tags": ["alliance", "collaboration", "group", "partnership", "team", "teamwork", "together", "work"],
    "popularity": 2640
  },
  {
    "name": "video_call",
    "tags": [
      "+",
      "add",
      "call",
      "camera",
      "chat",
      "conference",
      "film",
      "filming",
      "hardware",
      "image",
      "motion",
      "new",
      "picture",
      "plus",
      "symbol",
      "video",
      "videography"
    ],
    "popularity": 2629
  },
  {
    "name": "exclamation",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "high",
      "important",
      "mark",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 2628
  },
  {
    "name": "diversity_2",
    "tags": [
      "committee",
      "diverse",
      "diversity",
      "family",
      "friends",
      "group",
      "groups",
      "heart",
      "humans",
      "network",
      "people",
      "persons",
      "social",
      "team"
    ],
    "popularity": 2627
  },
  {
    "name": "fastfood",
    "tags": ["drink", "fastfood", "food", "hamburger", "maps", "meal", "places"],
    "popularity": 2627
  },
  {
    "name": "sentiment_very_dissatisfied",
    "tags": [
      "angry",
      "disappointed",
      "dislike",
      "dissatisfied",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "mood",
      "person",
      "sad",
      "sentiment",
      "sorrow",
      "survey",
      "unhappy",
      "unsatisfied",
      "upset",
      "very"
    ],
    "popularity": 2627
  },
  {
    "name": "phone_missed",
    "tags": ["arrow", "call", "cell", "contact", "device", "hardware", "missed", "mobile", "phone", "telephone"],
    "popularity": 2626
  },
  {
    "name": "wb_sunny",
    "tags": ["balance", "bright", "light", "lighting", "sun", "sunny", "wb", "white"],
    "popularity": 2626
  },
  {
    "name": "swipe_right",
    "tags": [
      "accept",
      "arrows",
      "direction",
      "finger",
      "hands",
      "hit",
      "navigation",
      "right",
      "strike",
      "swing",
      "swpie",
      "take"
    ],
    "popularity": 2624
  },
  {
    "name": "mobile_screen_share",
    "tags": [
      "Android",
      "OS",
      "cast",
      "cell",
      "device",
      "hardware",
      "iOS",
      "mirror",
      "mobile",
      "monitor",
      "phone",
      "screen",
      "screencast",
      "share",
      "stream",
      "streaming",
      "tablet",
      "tv",
      "wireless"
    ],
    "popularity": 2620
  },
  {
    "name": "brunch_dining",
    "tags": ["breakfast", "brunch", "champagne", "dining", "drink", "food", "lunch", "meal"],
    "popularity": 2619
  },
  {
    "name": "drafts",
    "tags": ["document", "draft", "drafts", "email", "file", "letter", "mail", "message", "read"],
    "popularity": 2618
  },
  {
    "name": "auto_mode",
    "tags": [
      "ai",
      "around",
      "arrow",
      "arrows",
      "artificial",
      "auto",
      "automatic",
      "automation",
      "custom",
      "direction",
      "genai",
      "inprogress",
      "intelligence",
      "load",
      "loading refresh",
      "magic",
      "mode",
      "navigation",
      "nest",
      "renew",
      "rotate",
      "smart",
      "spark",
      "sparkle",
      "star",
      "turn"
    ],
    "popularity": 2617
  },
  {
    "name": "thermostat_auto",
    "tags": ["A", "auto", "celsius", "fahrenheit", "meter", "temp", "temperature", "thermometer", "thermostat"],
    "popularity": 2615
  },
  {
    "name": "featured_video",
    "tags": ["advertised", "advertisement", "featured", "highlighted", "recommended", "video", "watch"],
    "popularity": 2613
  },
  {
    "name": "outgoing_mail",
    "tags": [
      "arrow",
      "arrows",
      "directions",
      "email",
      "envelop",
      "forward",
      "inbox",
      "letter",
      "mail",
      "message",
      "navigation",
      "outgoing",
      "right",
      "send",
      "to"
    ],
    "popularity": 2612
  },
  {
    "name": "crop_16_9",
    "tags": [
      "16",
      "9",
      "adjust",
      "adjustments",
      "area",
      "by",
      "crop",
      "edit",
      "editing",
      "frame",
      "image",
      "images",
      "photo",
      "photos",
      "rectangle",
      "settings",
      "size",
      "square"
    ],
    "popularity": 2610
  },
  {
    "name": "open_in_new_off",
    "tags": ["arrow", "box", "disabled", "enabled", "export", "in", "new", "off", "on", "open", "slash", "window"],
    "popularity": 2610
  },
  {
    "name": "install_desktop",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "desktop",
      "device",
      "display",
      "fix",
      "hardware",
      "iOS",
      "install",
      "mac",
      "monitor",
      "place",
      "pwa",
      "screen",
      "web",
      "window"
    ],
    "popularity": 2608
  },
  {
    "name": "move_down",
    "tags": ["arrow", "direction", "down", "jump", "move", "navigation", "transfer"],
    "popularity": 2605
  },
  {
    "name": "pin",
    "tags": [
      "1",
      "2",
      "3",
      "digit",
      "key",
      "login",
      "logout",
      "number",
      "password",
      "pattern",
      "pin",
      "security",
      "star",
      "symbol",
      "unlock"
    ],
    "popularity": 2603
  },
  {
    "name": "android",
    "tags": ["android", "character", "logo", "mascot", "toy"],
    "popularity": 2602
  },
  {
    "name": "hdr_auto",
    "tags": [
      "A",
      "alphabet",
      "auto",
      "camera",
      "character",
      "circle",
      "dynamic",
      "font",
      "hdr",
      "high",
      "letter",
      "photo",
      "range",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 2602
  },
  {
    "name": "event_upcoming",
    "tags": ["arrow", "calendar", "date", "event", "month", "reminder", "right", "schedule", "time", "upcoming"],
    "popularity": 2596
  },
  {
    "name": "storage",
    "tags": ["computer", "data", "drive", "memory", "storage"],
    "popularity": 2595
  },
  {
    "name": "phonelink_erase",
    "tags": [
      "Android",
      "OS",
      "cancel",
      "cell",
      "close",
      "connection",
      "device",
      "erase",
      "exit",
      "hardware",
      "iOS",
      "mobile",
      "no",
      "phone",
      "phonelink",
      "remove",
      "stop",
      "tablet",
      "x"
    ],
    "popularity": 2592
  },
  {
    "name": "keyboard_double_arrow_up",
    "tags": ["arrow", "arrows", "direction", "double", "multiple", "navigation", "up"],
    "popularity": 2589
  },
  {
    "name": "ssid_chart",
    "tags": ["chart", "graph", "lines", "network", "ssid", "wifi"],
    "popularity": 2588
  },
  {
    "name": "smoke_free",
    "tags": [
      "cigarette",
      "disabled",
      "enabled",
      "free",
      "never",
      "no",
      "off",
      "on",
      "places",
      "prohibited",
      "slash",
      "smoke",
      "smoking",
      "tobacco",
      "warning",
      "zone"
    ],
    "popularity": 2584
  },
  {
    "name": "view_timeline",
    "tags": ["grid", "layout", "pattern", "squares", "timeline", "view"],
    "popularity": 2582
  },
  {
    "name": "security_update_good",
    "tags": [
      "Android",
      "OS",
      "checkmark",
      "device",
      "good",
      "hardware",
      "iOS",
      "mobile",
      "ok",
      "phone",
      "security",
      "tablet",
      "tick",
      "update"
    ],
    "popularity": 2575
  },
  {
    "name": "device_thermostat",
    "tags": ["celsius", "device", "fahrenheit", "meter", "temp", "temperature", "thermometer", "thermostat"],
    "popularity": 2574
  },
  {
    "name": "shutter_speed",
    "tags": [
      "aperture",
      "camera",
      "duration",
      "image",
      "lens",
      "photo",
      "photography",
      "photos",
      "picture",
      "setting",
      "shutter",
      "speed",
      "stop",
      "time",
      "timer",
      "watch"
    ],
    "popularity": 2573
  },
  {
    "name": "nordic_walking",
    "tags": [
      "athlete",
      "athletic",
      "body",
      "entertainment",
      "exercise",
      "hiking",
      "hobby",
      "human",
      "nordic",
      "people",
      "person",
      "social",
      "sports",
      "travel",
      "walker",
      "walking"
    ],
    "popularity": 2572
  },
  {
    "name": "keyboard_hide",
    "tags": ["arrow", "computer", "device", "down", "hardware", "hide", "input", "keyboard", "keypad", "text"],
    "popularity": 2571
  },
  {
    "name": "front_hand",
    "tags": ["fingers", "front", "gesture", "hand", "hello", "palm", "stop"],
    "popularity": 2569
  },
  {
    "name": "filter_2",
    "tags": [
      "2",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 2568
  },
  {
    "name": "exposure",
    "tags": [
      "add",
      "brightness",
      "contrast",
      "edit",
      "editing",
      "effect",
      "exposure",
      "image",
      "minus",
      "photo",
      "photography",
      "picture",
      "plus",
      "settings",
      "subtract"
    ],
    "popularity": 2566
  },
  {
    "name": "biotech",
    "tags": ["biotech", "chemistry", "laboratory", "microscope", "research", "science", "technology"],
    "popularity": 2565
  },
  {
    "name": "battery_4_bar",
    "tags": ["4", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 2562
  },
  {
    "name": "camera",
    "tags": ["aperture", "camera", "lens", "photo", "photography", "picture", "shutter"],
    "popularity": 2562
  },
  {
    "name": "photo_album",
    "tags": [
      "album",
      "archive",
      "bookmark",
      "image",
      "label",
      "library",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "ribbon",
      "save",
      "tag"
    ],
    "popularity": 2561
  },
  {
    "name": "swipe_up",
    "tags": [
      "arrows",
      "direction",
      "disable",
      "enable",
      "finger",
      "hands",
      "hit",
      "navigation",
      "strike",
      "swing",
      "swpie",
      "take",
      "up"
    ],
    "popularity": 2558
  },
  {
    "name": "umbrella",
    "tags": ["beach", "protection", "rain", "sun", "sunny", "umbrella"],
    "popularity": 2557
  },
  {
    "name": "score",
    "tags": [
      "2k",
      "alphabet",
      "analytics",
      "bar",
      "bars",
      "character",
      "chart",
      "data",
      "diagram",
      "digit",
      "font",
      "graph",
      "infographic",
      "letter",
      "measure",
      "metrics",
      "number",
      "score",
      "statistics",
      "symbol",
      "text",
      "tracking",
      "type"
    ],
    "popularity": 2553
  },
  {
    "name": "sports_martial_arts",
    "tags": [
      "arts",
      "athlete",
      "athletic",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "karate",
      "martial",
      "people",
      "person",
      "social",
      "sports"
    ],
    "popularity": 2541
  },
  {
    "name": "sports_golf",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "club",
      "entertainment",
      "exercise",
      "game",
      "golf",
      "golfer",
      "golfing",
      "hobby",
      "social",
      "sports"
    ],
    "popularity": 2540
  },
  {
    "name": "battery_unknown",
    "tags": [
      "?",
      "assistance",
      "battery",
      "cell",
      "charge",
      "help",
      "info",
      "information",
      "mobile",
      "power",
      "punctuation",
      "question mark",
      "support",
      "symbol",
      "unknown"
    ],
    "popularity": 2531
  },
  {
    "name": "all_out",
    "tags": ["all", "circle", "out", "shape"],
    "popularity": 2529
  },
  {
    "name": "rss_feed",
    "tags": [
      "application",
      "blog",
      "connection",
      "data",
      "feed",
      "internet",
      "network",
      "rss",
      "service",
      "signal",
      "website",
      "wifi",
      "wireless"
    ],
    "popularity": 2521
  },
  {
    "name": "border_all",
    "tags": [
      "all",
      "border",
      "doc",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "writing"
    ],
    "popularity": 2517
  },
  {
    "name": "wifi_calling_3",
    "tags": [
      "3",
      "calling",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "speed",
      "wifi",
      "wireless"
    ],
    "popularity": 2517
  },
  {
    "name": "filter_tilt_shift",
    "tags": [
      "blur",
      "center",
      "edit",
      "editing",
      "effect",
      "filter",
      "focus",
      "image",
      "images",
      "photography",
      "picture",
      "pictures",
      "shift",
      "tilt"
    ],
    "popularity": 2513
  },
  {
    "name": "hvac",
    "tags": ["air", "conditioning", "heating", "hvac", "ventilation"],
    "popularity": 2512
  },
  {
    "name": "electric_bike",
    "tags": ["bike", "electric", "electricity", "maps", "scooter", "transportation", "travel", "vespa"],
    "popularity": 2506
  },
  {
    "name": "build_circle",
    "tags": ["adjust", "build", "circle", "fix", "repair", "tool", "wrench"],
    "popularity": 2505
  },
  {
    "name": "coffee",
    "tags": ["beverage", "coffee", "cup", "drink", "mug", "plate", "set", "tea"],
    "popularity": 2502
  },
  {
    "name": "hotel",
    "tags": ["body", "hotel", "human", "people", "person", "sleep", "stay", "travel", "trip"],
    "popularity": 2499
  },
  {
    "name": "settings_backup_restore",
    "tags": ["arrow", "back", "backup", "backwards", "refresh", "restore", "reverse", "rotate", "settings"],
    "popularity": 2499
  },
  {
    "name": "arrow_drop_down_circle",
    "tags": [
      "app",
      "application",
      "arrow",
      "circle",
      "components",
      "direction",
      "down",
      "drop",
      "interface",
      "navigation",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 2495
  },
  {
    "name": "assistant_navigation",
    "tags": [
      "assistant",
      "destination",
      "direction",
      "location",
      "maps",
      "navigation",
      "pin",
      "place",
      "stop",
      "straight",
      "up"
    ],
    "popularity": 2493
  },
  {
    "name": "hourglass_bottom",
    "tags": ["bottom", "countdown", "half", "hourglass", "loading", "minute", "minutes", "time", "wait", "waiting"],
    "popularity": 2491
  },
  {
    "name": "psychology_alt",
    "tags": [
      "?",
      "assistance",
      "behavior",
      "body",
      "brain",
      "cognitive",
      "function",
      "gear",
      "head",
      "help",
      "human",
      "info",
      "information",
      "intellectual",
      "mental",
      "mind",
      "people",
      "person",
      "preferences",
      "psychiatric",
      "psychology",
      "punctuation",
      "question mark",
      "science",
      "settings",
      "social",
      "support",
      "symbol",
      "therapy",
      "thinking",
      "thoughts"
    ],
    "popularity": 2490
  },
  {
    "name": "shuffle_on",
    "tags": ["arrow", "arrows", "control", "controls", "music", "on", "random", "shuffle", "video"],
    "popularity": 2490
  },
  {
    "name": "warehouse",
    "tags": ["garage", "industry", "manufacturing", "storage", "warehouse"],
    "popularity": 2484
  },
  {
    "name": "electric_bolt",
    "tags": ["bolt", "electric", "energy", "fast", "lightning", "nest", "thunderbolt"],
    "popularity": 2483
  },
  {
    "name": "navigation",
    "tags": ["destination", "direction", "location", "maps", "navigation", "pin", "place", "point", "stop"],
    "popularity": 2483
  },
  {
    "name": "scanner",
    "tags": ["copy", "device", "hardware", "machine", "scan", "scanner"],
    "popularity": 2479
  },
  {
    "name": "sync_problem",
    "tags": [
      "!",
      "360",
      "alert",
      "around",
      "arrow",
      "arrows",
      "attention",
      "caution",
      "danger",
      "direction",
      "error",
      "exclamation",
      "important",
      "inprogress",
      "load",
      "loading refresh",
      "mark",
      "notification",
      "problem",
      "renew",
      "rotate",
      "symbol",
      "sync",
      "turn",
      "warning"
    ],
    "popularity": 2475
  },
  {
    "name": "shop_2",
    "tags": ["2", "add", "arrow", "buy", "cart", "google", "play", "purchase", "shop", "shopping"],
    "popularity": 2467
  },
  {
    "name": "signal_wifi_off",
    "tags": [
      "cell",
      "cellular",
      "data",
      "disabled",
      "enabled",
      "internet",
      "mobile",
      "network",
      "off",
      "on",
      "phone",
      "signal",
      "slash",
      "speed",
      "wifi",
      "wireless"
    ],
    "popularity": 2465
  },
  {
    "name": "girl",
    "tags": [
      "body",
      "female",
      "gender",
      "girl",
      "human",
      "lady",
      "people",
      "person",
      "social",
      "symbol",
      "woman",
      "women"
    ],
    "popularity": 2462
  },
  {
    "name": "copyright",
    "tags": ["alphabet", "c", "character", "copyright", "emblem", "font", "legal", "letter", "owner", "symbol", "text"],
    "popularity": 2460
  },
  {
    "name": "hdr_strong",
    "tags": ["circles", "dots", "dynamic", "enhance", "hdr", "high", "range", "strong"],
    "popularity": 2455
  },
  {
    "name": "battery_full",
    "tags": ["0", "bar", "battery", "cell", "charge", "full", "mobile", "power"],
    "popularity": 2451
  },
  {
    "name": "cruelty_free",
    "tags": [
      "animal",
      "bunny",
      "cruelty",
      "eco",
      "free",
      "nature",
      "rabbit",
      "social",
      "sustainability",
      "sustainable",
      "testing"
    ],
    "popularity": 2451
  },
  {
    "name": "person_pin",
    "tags": [
      "account",
      "avatar",
      "destination",
      "direction",
      "face",
      "human",
      "location",
      "maps",
      "people",
      "person",
      "pin",
      "place",
      "profile",
      "stop",
      "user"
    ],
    "popularity": 2449
  },
  {
    "name": "mark_email_read",
    "tags": [
      "approve",
      "check",
      "complete",
      "done",
      "email",
      "envelop",
      "letter",
      "mail",
      "mark",
      "message",
      "note",
      "ok",
      "read",
      "select",
      "send",
      "sent",
      "tick",
      "yes"
    ],
    "popularity": 2446
  },
  {
    "name": "straighten",
    "tags": ["length", "measure", "measurement", "ruler", "size", "straighten"],
    "popularity": 2443
  },
  {
    "name": "battery_0_bar",
    "tags": ["0", "bar", "battery", "cell", "charge", "full", "mobile", "power"],
    "popularity": 2434
  },
  {
    "name": "directions_transit",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "directions",
      "maps",
      "public",
      "rail",
      "subway",
      "train",
      "transit",
      "transportation",
      "vehicle"
    ],
    "popularity": 2434
  },
  {
    "name": "looks_one",
    "tags": ["1", "digit", "looks", "numbers", "square", "symbol"],
    "popularity": 2431
  },
  {
    "name": "wysiwyg",
    "tags": [
      "composer",
      "mode",
      "screen",
      "site",
      "software",
      "system",
      "text",
      "view",
      "visibility",
      "web",
      "website",
      "window",
      "wysiwyg"
    ],
    "popularity": 2428
  },
  {
    "name": "api",
    "tags": ["api", "developer", "development", "enterprise", "software"],
    "popularity": 2427
  },
  {
    "name": "clear_all",
    "tags": ["all", "clear", "doc", "document", "format", "lines", "list"],
    "popularity": 2423
  },
  {
    "name": "man",
    "tags": ["boy", "gender", "male", "man", "social", "symbol"],
    "popularity": 2419
  },
  {
    "name": "repeat",
    "tags": ["arrow", "arrows", "control", "controls", "media", "music", "repeat", "video"],
    "popularity": 2418
  },
  {
    "name": "sticky_note_2",
    "tags": ["2", "bookmark", "mark", "message", "note", "paper", "sticky", "text", "writing"],
    "popularity": 2416
  },
  {
    "name": "vrpano",
    "tags": [
      "angle",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "panorama",
      "photo",
      "photography",
      "picture",
      "view",
      "vrpano",
      "wide"
    ],
    "popularity": 2412
  },
  {
    "name": "label_off",
    "tags": [
      "disabled",
      "enabled",
      "favorite",
      "indent",
      "label",
      "library",
      "mail",
      "off",
      "on",
      "remember",
      "save",
      "slash",
      "stamp",
      "sticker",
      "tag",
      "wing"
    ],
    "popularity": 2411
  },
  {
    "name": "pan_tool",
    "tags": ["fingers", "gesture", "hand", "hands", "human", "move", "pan", "scan", "stop", "tool"],
    "popularity": 2410
  },
  {
    "name": "forward_30",
    "tags": [
      "30",
      "arrow",
      "control",
      "controls",
      "digit",
      "fast",
      "forward",
      "music",
      "number",
      "seconds",
      "symbol",
      "video"
    ],
    "popularity": 2409
  },
  {
    "name": "looks",
    "tags": ["circle", "half", "looks", "rainbow"],
    "popularity": 2408
  },
  {
    "name": "conversion_path",
    "tags": ["ads", "analytics", "attribution", "connecting", "conversion", "dots", "line", "path"],
    "popularity": 2407
  },
  {
    "name": "medical_information",
    "tags": ["badge", "card", "health", "id", "information", "medical", "services"],
    "popularity": 2407
  },
  {
    "name": "5g",
    "tags": [
      "5g",
      "alphabet",
      "cellular",
      "character",
      "data",
      "digit",
      "font",
      "letter",
      "mobile",
      "network",
      "number",
      "phone",
      "signal",
      "speed",
      "symbol",
      "text",
      "type",
      "wifi"
    ],
    "popularity": 2406
  },
  {
    "name": "tablet",
    "tags": ["Android", "OS", "device", "hardware", "iOS", "ipad", "mobile", "tablet", "web"],
    "popularity": 2403
  },
  {
    "name": "mouse",
    "tags": ["click", "computer", "cursor", "device", "hardware", "mouse", "wireless"],
    "popularity": 2402
  },
  {
    "name": "airline_seat_recline_extra",
    "tags": [
      "airline",
      "body",
      "extra",
      "feet",
      "human",
      "leg",
      "legroom",
      "people",
      "person",
      "seat",
      "sitting",
      "space",
      "travel"
    ],
    "popularity": 2397
  },
  {
    "name": "barcode",
    "tags": ["barcode", "ecommerce", "price", "scan", "shop", "shopping", "tag"],
    "popularity": 2397
  },
  {
    "name": "dashboard_customize",
    "tags": ["cards", "customize", "dashboard", "format", "layout", "rectangle", "shapes", "square", "web", "website"],
    "popularity": 2393
  },
  {
    "name": "text_fields",
    "tags": [
      "T",
      "add",
      "alphabet",
      "character",
      "field",
      "fields",
      "font",
      "input",
      "letter",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 2391
  },
  {
    "name": "linked_camera",
    "tags": [
      "camera",
      "connect",
      "connection",
      "lens",
      "linked",
      "network",
      "photo",
      "photography",
      "picture",
      "signal",
      "signals",
      "sync",
      "wireless"
    ],
    "popularity": 2388
  },
  {
    "name": "paragliding",
    "tags": [
      "athlete",
      "athletic",
      "body",
      "entertainment",
      "exercise",
      "fly",
      "gliding",
      "hobby",
      "human",
      "parachute",
      "paragliding",
      "people",
      "person",
      "sky",
      "skydiving",
      "social",
      "sports",
      "travel"
    ],
    "popularity": 2379
  },
  {
    "name": "density_medium",
    "tags": ["density", "horizontal", "lines", "medium", "rule", "rules"],
    "popularity": 2377
  },
  {
    "name": "density_small",
    "tags": ["density", "horizontal", "lines", "rule", "rules", "small"],
    "popularity": 2372
  },
  {
    "name": "settings_system_daydream",
    "tags": ["backup", "cloud", "daydream", "drive", "settings", "storage", "system"],
    "popularity": 2371
  },
  {
    "name": "coronavirus",
    "tags": ["19", "bacteria", "coronavirus", "covid", "disease", "germs", "illness", "sick", "social"],
    "popularity": 2370
  },
  {
    "name": "format_indent_decrease",
    "tags": [
      "align",
      "alignment",
      "decrease",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "indent",
      "indentation",
      "paragraph",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 2370
  },
  {
    "name": "crisis_alert",
    "tags": [
      "!",
      "alert",
      "attention",
      "bullseye",
      "caution",
      "crisis",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "symbol",
      "target",
      "warning"
    ],
    "popularity": 2369
  },
  {
    "name": "electric_scooter",
    "tags": ["bike", "electric", "maps", "scooter", "transportation", "vehicle", "vespa"],
    "popularity": 2368
  },
  {
    "name": "balance",
    "tags": [
      "balance",
      "equal",
      "equity",
      "impartiality",
      "justice",
      "parity",
      "stability. equilibrium",
      "steadiness",
      "symmetry"
    ],
    "popularity": 2366
  },
  {
    "name": "brightness_3",
    "tags": ["3", "brightness", "circle", "control", "crescent", "level", "moon", "screen"],
    "popularity": 2364
  },
  {
    "name": "tapas",
    "tags": ["appetizer", "brunch", "dinner", "food", "lunch", "restaurant", "snack", "tapas"],
    "popularity": 2360
  },
  {
    "name": "hotel_class",
    "tags": [
      "achievement",
      "bookmark",
      "class",
      "favorite",
      "highlight",
      "hotel",
      "important",
      "marked",
      "rank",
      "ranking",
      "rate",
      "rating",
      "reward",
      "save",
      "saved",
      "shape",
      "special",
      "star"
    ],
    "popularity": 2357
  },
  {
    "name": "heart_plus",
    "tags": ["+", "add", "appreciate", "favorite", "like", "love", "new", "plus", "remember", "save"],
    "popularity": 2353
  },
  {
    "name": "volume_mute",
    "tags": ["audio", "control", "music", "mute", "sound", "speaker", "tv", "volume"],
    "popularity": 2353
  },
  {
    "name": "local_parking",
    "tags": [
      "alphabet",
      "auto",
      "car",
      "character",
      "font",
      "garage",
      "letter",
      "local",
      "park",
      "parking",
      "symbol",
      "text",
      "type",
      "vehicle"
    ],
    "popularity": 2352
  },
  {
    "name": "circle_notifications",
    "tags": [
      "active",
      "alarm",
      "alert",
      "bell",
      "chime",
      "circle",
      "notifications",
      "notify",
      "reminder",
      "ring",
      "sound"
    ],
    "popularity": 2351
  },
  {
    "name": "tab_unselected",
    "tags": [
      "browser",
      "computer",
      "document",
      "documents",
      "folder",
      "internet",
      "tab",
      "tabs",
      "unselected",
      "web",
      "website",
      "window",
      "windows"
    ],
    "popularity": 2346
  },
  {
    "name": "blur_circular",
    "tags": ["blur", "circle", "circular", "dots", "edit", "editing", "effect", "enhance", "filter"],
    "popularity": 2345
  },
  {
    "name": "assignment_add",
    "tags": [
      "+",
      "add",
      "assignment",
      "clipboard",
      "doc",
      "document",
      "new",
      "note",
      "plus",
      "quick",
      "symbol",
      "text",
      "writing"
    ],
    "popularity": 2342
  },
  {
    "name": "child_care",
    "tags": ["babies", "baby", "care", "child", "children", "face", "infant", "kids", "newborn", "toddler", "young"],
    "popularity": 2341
  },
  {
    "name": "add_reaction",
    "tags": [
      "+",
      "add",
      "emoji",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "glad",
      "happiness",
      "happy",
      "icon",
      "icons",
      "insert",
      "like",
      "mood",
      "new",
      "person",
      "pleased",
      "plus",
      "smile",
      "smiling",
      "social",
      "survey",
      "symbol"
    ],
    "popularity": 2340
  },
  {
    "name": "home_repair_service",
    "tags": [
      "box",
      "equipment",
      "fix",
      "home",
      "kit",
      "mechanic",
      "repair",
      "repairing",
      "service",
      "tool",
      "toolbox",
      "tools",
      "workshop"
    ],
    "popularity": 2340
  },
  {
    "name": "person_add_disabled",
    "tags": [
      "+",
      "account",
      "add",
      "disabled",
      "enabled",
      "face",
      "human",
      "new",
      "off",
      "offline",
      "on",
      "people",
      "person",
      "plus",
      "profile",
      "slash",
      "symbol",
      "user"
    ],
    "popularity": 2340
  },
  {
    "name": "rounded_corner",
    "tags": ["adjust", "corner", "edit", "rounded", "shape", "square", "transform"],
    "popularity": 2339
  },
  {
    "name": "music_video",
    "tags": ["band", "music", "recording", "screen", "tv", "video", "watch"],
    "popularity": 2336
  },
  {
    "name": "rice_bowl",
    "tags": ["bowl", "dinner", "food", "lunch", "meal", "restaurant", "rice"],
    "popularity": 2336
  },
  {
    "name": "playlist_add_circle",
    "tags": [
      "add",
      "album",
      "artist",
      "audio",
      "cd",
      "check",
      "circle",
      "collection",
      "list",
      "mark",
      "music",
      "playlist",
      "record",
      "sound",
      "track"
    ],
    "popularity": 2334
  },
  {
    "name": "looks_6",
    "tags": ["6", "digit", "looks", "numbers", "square", "symbol"],
    "popularity": 2333
  },
  {
    "name": "thunderstorm",
    "tags": [
      "bolt",
      "climate",
      "cloud",
      "cloudy",
      "lightning",
      "rain",
      "rainfall",
      "rainstorm",
      "storm",
      "thunder",
      "thunderstorm",
      "weather"
    ],
    "popularity": 2333
  },
  {
    "name": "do_not_touch",
    "tags": ["disabled", "do", "enabled", "fingers", "gesture", "hand", "not", "off", "on", "slash", "touch"],
    "popularity": 2331
  },
  {
    "name": "sensors",
    "tags": ["connection", "network", "scan", "sensors", "signal", "wireless"],
    "popularity": 2331
  },
  {
    "name": "reorder",
    "tags": ["format", "lines", "list", "order", "reorder", "stacked"],
    "popularity": 2327
  },
  {
    "name": "rocket",
    "tags": ["rocket", "space", "spaceship"],
    "popularity": 2326
  },
  {
    "name": "domain_disabled",
    "tags": [
      "apartment",
      "architecture",
      "building",
      "business",
      "company",
      "disabled",
      "domain",
      "enabled",
      "estate",
      "home",
      "internet",
      "maps",
      "off",
      "office",
      "offline",
      "on",
      "place",
      "real",
      "residence",
      "residential",
      "slash",
      "web",
      "website"
    ],
    "popularity": 2317
  },
  {
    "name": "integration_instructions",
    "tags": [
      "brackets",
      "clipboard",
      "code",
      "css",
      "develop",
      "developer",
      "doc",
      "document",
      "engineer",
      "engineering clipboard",
      "html",
      "instructions",
      "integration",
      "platform"
    ],
    "popularity": 2312
  },
  {
    "name": "flash_auto",
    "tags": ["a", "auto", "bolt", "electric", "fast", "flash", "lightning", "thunderbolt"],
    "popularity": 2308
  },
  {
    "name": "format_bold",
    "tags": [
      "B",
      "alphabet",
      "bold",
      "character",
      "doc",
      "edit",
      "editing",
      "editor",
      "font",
      "format",
      "letter",
      "sheet",
      "spreadsheet",
      "styles",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 2304
  },
  {
    "name": "route",
    "tags": ["directions", "maps", "path", "route", "sign", "traffic"],
    "popularity": 2304
  },
  {
    "name": "text_increase",
    "tags": [
      "+",
      "add",
      "alphabet",
      "character",
      "font",
      "increase",
      "letter",
      "new",
      "plus",
      "resize",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 2304
  },
  {
    "name": "queue_play_next",
    "tags": [
      "+",
      "add",
      "arrow",
      "desktop",
      "device",
      "display",
      "hardware",
      "monitor",
      "new",
      "next",
      "play",
      "plus",
      "queue",
      "screen",
      "steam",
      "symbol",
      "tv"
    ],
    "popularity": 2300
  },
  {
    "name": "6_ft_apart",
    "tags": ["6", "apart", "body", "covid", "distance", "feet", "ft", "human", "people", "person", "social"],
    "popularity": 2298
  },
  {
    "name": "battery_6_bar",
    "tags": ["6", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 2298
  },
  {
    "name": "signal_wifi_bad",
    "tags": [
      "bad",
      "bar",
      "cancel",
      "cell",
      "cellular",
      "close",
      "data",
      "exit",
      "internet",
      "mobile",
      "network",
      "no",
      "phone",
      "quit",
      "remove",
      "signal",
      "stop",
      "wifi",
      "wireless",
      "x"
    ],
    "popularity": 2298
  },
  {
    "name": "manage_history",
    "tags": [
      "application",
      "arrow",
      "back",
      "backwards",
      "change",
      "clock",
      "date",
      "details",
      "gear",
      "history",
      "options",
      "refresh",
      "renew",
      "reverse",
      "rotate",
      "schedule",
      "settings",
      "time",
      "turn"
    ],
    "popularity": 2297
  },
  {
    "name": "wifi_off",
    "tags": [
      "connection",
      "data",
      "disabled",
      "enabled",
      "internet",
      "network",
      "off",
      "offline",
      "on",
      "scan",
      "service",
      "signal",
      "slash",
      "wifi",
      "wireless"
    ],
    "popularity": 2297
  },
  {
    "name": "party_mode",
    "tags": ["camera", "lens", "mode", "party", "photo", "photography", "picture"],
    "popularity": 2295
  },
  {
    "name": "snowboarding",
    "tags": [
      "athlete",
      "athletic",
      "body",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "people",
      "person",
      "snow",
      "snowboarding",
      "social",
      "sports",
      "travel",
      "winter"
    ],
    "popularity": 2289
  },
  {
    "name": "data_thresholding",
    "tags": ["data", "hidden", "privacy", "thresholding", "thresold"],
    "popularity": 2288
  },
  {
    "name": "landscape",
    "tags": ["image", "landscape", "mountain", "mountains", "nature", "photo", "photography", "picture"],
    "popularity": 2288
  },
  {
    "name": "connecting_airports",
    "tags": [
      "airplane",
      "airplanes",
      "airport",
      "airports",
      "connecting",
      "flight",
      "plane",
      "transportation",
      "travel",
      "trip"
    ],
    "popularity": 2284
  },
  {
    "name": "format_clear",
    "tags": [
      "T",
      "alphabet",
      "character",
      "clear",
      "disabled",
      "doc",
      "edit",
      "editing",
      "editor",
      "enabled",
      "font",
      "format",
      "letter",
      "off",
      "on",
      "sheet",
      "slash",
      "spreadsheet",
      "style",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 2284
  },
  {
    "name": "find_in_page",
    "tags": [
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "find",
      "folder",
      "folders",
      "glass",
      "in",
      "look",
      "magnify",
      "magnifying",
      "page",
      "paper",
      "search",
      "see",
      "sheet",
      "slide",
      "writing"
    ],
    "popularity": 2283
  },
  {
    "name": "bus_alert",
    "tags": [
      "!",
      "alert",
      "attention",
      "automobile",
      "bus",
      "car",
      "cars",
      "caution",
      "danger",
      "error",
      "exclamation",
      "important",
      "maps",
      "mark",
      "notification",
      "symbol",
      "transportation",
      "vehicle",
      "warning"
    ],
    "popularity": 2282
  },
  {
    "name": "folder_delete",
    "tags": [
      "bin",
      "can",
      "data",
      "delete",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "garbage",
      "remove",
      "sheet",
      "slide",
      "storage",
      "trash"
    ],
    "popularity": 2281
  },
  {
    "name": "filter_alt_off",
    "tags": ["alt", "disabled", "edit", "filter", "funnel", "off", "offline", "options", "refine", "sift", "slash"],
    "popularity": 2280
  },
  {
    "name": "expand",
    "tags": ["arrow", "arrows", "compress", "enlarge", "expand", "grow", "move", "push", "together"],
    "popularity": 2277
  },
  {
    "name": "local_hospital",
    "tags": ["911", "aid", "cross", "emergency", "first", "hospital", "local", "medicine"],
    "popularity": 2275
  },
  {
    "name": "motion_photos_auto",
    "tags": [
      "A",
      "alphabet",
      "animation",
      "auto",
      "automatic",
      "character",
      "circle",
      "font",
      "gif",
      "letter",
      "live",
      "motion",
      "photos",
      "symbol",
      "text",
      "type",
      "video"
    ],
    "popularity": 2274
  },
  {
    "name": "text_rotate_vertical",
    "tags": [
      "A",
      "alphabet",
      "arrow",
      "character",
      "down",
      "field",
      "font",
      "letter",
      "move",
      "rotate",
      "symbol",
      "text",
      "type",
      "vertical"
    ],
    "popularity": 2271
  },
  {
    "name": "space_bar",
    "tags": ["bar", "keyboard", "line", "space"],
    "popularity": 2265
  },
  {
    "name": "audio_file",
    "tags": ["audio", "doc", "document", "key", "music", "note", "sound", "track"],
    "popularity": 2264
  },
  {
    "name": "crop_portrait",
    "tags": [
      "adjust",
      "adjustments",
      "area",
      "crop",
      "edit",
      "editing",
      "frame",
      "image",
      "images",
      "photo",
      "photos",
      "portrait",
      "rectangle",
      "settings",
      "size",
      "square"
    ],
    "popularity": 2263
  },
  {
    "name": "track_changes",
    "tags": ["bullseye", "changes", "circle", "evolve", "lines", "movement", "rotate", "shift", "target", "track"],
    "popularity": 2263
  },
  {
    "name": "filter_list_alt",
    "tags": ["change", "edit", "filter", "funnel", "list. alt"],
    "popularity": 2258
  },
  {
    "name": "last_page",
    "tags": [
      "app",
      "application",
      "arrow",
      "chevron",
      "components",
      "end",
      "forward",
      "interface",
      "last",
      "page",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 2257
  },
  {
    "name": "replay_5",
    "tags": [
      "5",
      "arrow",
      "arrows",
      "control",
      "controls",
      "digit",
      "five",
      "music",
      "number",
      "refresh",
      "renew",
      "repeat",
      "replay",
      "symbol",
      "video"
    ],
    "popularity": 2256
  },
  {
    "name": "south",
    "tags": ["arrow", "directional", "down", "maps", "navigation", "south"],
    "popularity": 2253
  },
  {
    "name": "local_car_wash",
    "tags": ["automobile", "car", "cars", "local", "maps", "transportation", "travel", "vehicle", "wash"],
    "popularity": 2251
  },
  {
    "name": "local_police",
    "tags": ["911", "badge", "law", "local", "officer", "police", "protect", "protection", "security", "shield"],
    "popularity": 2251
  },
  {
    "name": "access_alarms",
    "tags": [],
    "popularity": 2249
  },
  {
    "name": "point_of_sale",
    "tags": [
      "checkout",
      "cost",
      "machine",
      "merchant",
      "money",
      "of",
      "pay",
      "payment",
      "point",
      "pos",
      "retail",
      "sale",
      "system",
      "transaction"
    ],
    "popularity": 2249
  },
  {
    "name": "egg",
    "tags": ["breakfast", "brunch", "egg", "food"],
    "popularity": 2247
  },
  {
    "name": "tty",
    "tags": [
      "call",
      "cell",
      "contact",
      "deaf",
      "device",
      "hardware",
      "impaired",
      "mobile",
      "phone",
      "speech",
      "talk",
      "telephone",
      "text",
      "tty"
    ],
    "popularity": 2245
  },
  {
    "name": "water",
    "tags": ["aqua", "beach", "lake", "ocean", "river", "water", "waves", "weather"],
    "popularity": 2245
  },
  {
    "name": "female",
    "tags": ["female", "gender", "girl", "lady", "social", "symbol", "woman", "women"],
    "popularity": 2236
  },
  {
    "name": "trending_down",
    "tags": [
      "analytics",
      "arrow",
      "data",
      "diagram",
      "down",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "movement",
      "rate",
      "rating",
      "statistics",
      "tracking",
      "trending"
    ],
    "popularity": 2234
  },
  {
    "name": "call_missed_outgoing",
    "tags": ["arrow", "call", "device", "missed", "mobile", "outgoing"],
    "popularity": 2233
  },
  {
    "name": "subdirectory_arrow_right",
    "tags": ["arrow", "directory", "down", "navigation", "right", "sub", "subdirectory"],
    "popularity": 2232
  },
  {
    "name": "local_hotel",
    "tags": ["body", "hotel", "human", "local", "people", "person", "sleep", "stay", "travel", "trip"],
    "popularity": 2231
  },
  {
    "name": "text_snippet",
    "tags": ["data", "doc", "document", "file", "note", "notes", "snippet", "storage", "text", "writing"],
    "popularity": 2228
  },
  {
    "name": "web_asset",
    "tags": [
      "-website",
      "app",
      "application desktop",
      "asset",
      "browser",
      "design",
      "download",
      "image",
      "interface",
      "internet",
      "layout",
      "screen",
      "site",
      "ui",
      "ux",
      "video",
      "web",
      "website",
      "window",
      "www"
    ],
    "popularity": 2226
  },
  {
    "name": "balcony",
    "tags": [
      "architecture",
      "balcony",
      "doors",
      "estate",
      "home",
      "house",
      "maps",
      "out",
      "outside",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "terrace",
      "window"
    ],
    "popularity": 2225
  },
  {
    "name": "bluetooth",
    "tags": ["bluetooth", "cast", "connect", "connection", "device", "paring", "streaming", "symbol", "wireless"],
    "popularity": 2225
  },
  {
    "name": "kitesurfing",
    "tags": [
      "athlete",
      "athletic",
      "beach",
      "body",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "kitesurfing",
      "people",
      "person",
      "social",
      "sports",
      "surf",
      "travel",
      "water"
    ],
    "popularity": 2225
  },
  {
    "name": "note",
    "tags": [
      "bookmark",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "message",
      "note",
      "page",
      "paper",
      "plus",
      "sheet",
      "slide",
      "symbol",
      "writing"
    ],
    "popularity": 2218
  },
  {
    "name": "unfold_less",
    "tags": [
      "arrow",
      "arrows",
      "chevron",
      "collapse",
      "direction",
      "expand",
      "expandable",
      "inward",
      "less",
      "list",
      "navigation",
      "unfold",
      "up"
    ],
    "popularity": 2211
  },
  {
    "name": "accessible",
    "tags": ["accessibility", "accessible", "body", "handicap", "help", "human", "people", "person", "wheelchair"],
    "popularity": 2210
  },
  {
    "name": "family_restroom",
    "tags": ["bathroom", "child", "children", "family", "father", "kids", "mother", "parents", "restroom", "wc"],
    "popularity": 2203
  },
  {
    "name": "mode_of_travel",
    "tags": [
      "arrow",
      "destination",
      "direction",
      "location",
      "maps",
      "mode",
      "of",
      "pin",
      "place",
      "stop",
      "transportation",
      "travel",
      "trip"
    ],
    "popularity": 2201
  },
  {
    "name": "document_scanner",
    "tags": [
      "article",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "notes",
      "page",
      "paper",
      "scan",
      "scanner",
      "sheet",
      "slide",
      "text",
      "writing"
    ],
    "popularity": 2199
  },
  {
    "name": "arrow_outward",
    "tags": [
      "app",
      "application",
      "arrow",
      "arrows",
      "components",
      "direction",
      "forward",
      "interface",
      "navigation",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 2197
  },
  {
    "name": "speaker_phone",
    "tags": [
      "Android",
      "OS",
      "cell",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "sound",
      "speaker",
      "tablet",
      "volume"
    ],
    "popularity": 2194
  },
  {
    "name": "airport_shuttle",
    "tags": [
      "airport",
      "automobile",
      "car",
      "cars",
      "commercial",
      "delivery",
      "direction",
      "maps",
      "mini",
      "public",
      "shuttle",
      "transport",
      "transportation",
      "travel",
      "truck",
      "van",
      "vehicle"
    ],
    "popularity": 2192
  },
  {
    "name": "sports_gymnastics",
    "tags": ["athlete", "athletic", "entertainment", "exercise", "gymnastics", "hobby", "social", "sports"],
    "popularity": 2190
  },
  {
    "name": "download_done",
    "tags": [
      "arrow",
      "arrows",
      "check",
      "done",
      "down",
      "download",
      "downloads",
      "drive",
      "install",
      "installed",
      "ok",
      "tick",
      "upload"
    ],
    "popularity": 2189
  },
  {
    "name": "drive_file_move_rtl",
    "tags": [
      "arrow",
      "arrows",
      "data",
      "direction",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "left",
      "move",
      "rtl",
      "sheet",
      "side",
      "slide",
      "storage"
    ],
    "popularity": 2188
  },
  {
    "name": "no_food",
    "tags": ["disabled", "drink", "enabled", "fastfood", "food", "hamburger", "meal", "no", "off", "on", "slash"],
    "popularity": 2188
  },
  {
    "name": "brightness_2",
    "tags": ["2", "brightness", "circle", "control", "crescent", "level", "moon", "screen"],
    "popularity": 2187
  },
  {
    "name": "format_line_spacing",
    "tags": [
      "align",
      "alignment",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "line",
      "sheet",
      "spacing",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 2187
  },
  {
    "name": "cell_wifi",
    "tags": [
      "cell",
      "connection",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 2183
  },
  {
    "name": "explore_off",
    "tags": [
      "compass",
      "destination",
      "direction",
      "disabled",
      "east",
      "enabled",
      "explore",
      "location",
      "maps",
      "needle",
      "north",
      "off",
      "on",
      "slash",
      "south",
      "travel",
      "west"
    ],
    "popularity": 2183
  },
  {
    "name": "upgrade",
    "tags": ["arrow", "export", "instal", "line", "replace", "up", "update", "upgrade"],
    "popularity": 2182
  },
  {
    "name": "iso",
    "tags": [
      "add",
      "edit",
      "editing",
      "effect",
      "image",
      "iso",
      "minus",
      "photography",
      "picture",
      "plus",
      "sensor",
      "shutter",
      "speed",
      "subtract"
    ],
    "popularity": 2178
  },
  {
    "name": "shuffle",
    "tags": ["arrow", "arrows", "control", "controls", "music", "random", "shuffle", "video"],
    "popularity": 2177
  },
  {
    "name": "photo_filter",
    "tags": [
      "ai",
      "artificial",
      "automatic",
      "automation",
      "custom",
      "filter",
      "filters",
      "genai",
      "image",
      "intelligence",
      "magic",
      "photo",
      "photography",
      "picture",
      "smart",
      "spark",
      "sparkle",
      "star"
    ],
    "popularity": 2176
  },
  {
    "name": "pedal_bike",
    "tags": [
      "automobile",
      "bicycle",
      "bike",
      "car",
      "cars",
      "direction",
      "human",
      "maps",
      "pedal",
      "public",
      "route",
      "scooter",
      "transportation",
      "vehicle",
      "vespa"
    ],
    "popularity": 2173
  },
  {
    "name": "commit",
    "tags": ["accomplish", "bind", "circle", "commit", "dedicate", "execute", "line", "perform", "pledge"],
    "popularity": 2169
  },
  {
    "name": "potted_plant",
    "tags": ["houseplant", "leaf", "leaves", "plant", "pot", "potted"],
    "popularity": 2169
  },
  {
    "name": "zoom_out_map",
    "tags": ["arrow", "arrows", "destination", "location", "maps", "move", "out", "place", "stop", "zoom"],
    "popularity": 2169
  },
  {
    "name": "price_check",
    "tags": [
      "approve",
      "bill",
      "card",
      "cash",
      "check",
      "coin",
      "commerce",
      "complete",
      "cost",
      "credit",
      "currency",
      "dollars",
      "done",
      "finance",
      "mark",
      "money",
      "ok",
      "online",
      "pay",
      "payment",
      "price",
      "select",
      "shopping",
      "symbol",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 2168
  },
  {
    "name": "spoke",
    "tags": ["connection", "network", "radius", "spoke"],
    "popularity": 2168
  },
  {
    "name": "tonality",
    "tags": ["circle", "edit", "editing", "filter", "image", "photography", "picture", "tonality"],
    "popularity": 2166
  },
  {
    "name": "link_off",
    "tags": [
      "attached",
      "chain",
      "clip",
      "connection",
      "disabled",
      "enabled",
      "link",
      "linked",
      "links",
      "multimedia",
      "off",
      "on",
      "slash",
      "url"
    ],
    "popularity": 2163
  },
  {
    "name": "desktop_access_disabled",
    "tags": [
      "Android",
      "OS",
      "access",
      "chrome",
      "desktop",
      "device",
      "disabled",
      "display",
      "enabled",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "off",
      "offline",
      "on",
      "screen",
      "slash",
      "web",
      "window"
    ],
    "popularity": 2162
  },
  {
    "name": "houseboat",
    "tags": [
      "architecture",
      "beach",
      "boat",
      "estate",
      "floating",
      "home",
      "house",
      "houseboat",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "sea",
      "stay",
      "traveling",
      "vacation"
    ],
    "popularity": 2157
  },
  {
    "name": "polyline",
    "tags": ["compose", "create", "design", "draw", "line", "polyline", "vector"],
    "popularity": 2154
  },
  {
    "name": "location_searching",
    "tags": [
      "destination",
      "direction",
      "location",
      "maps",
      "pin",
      "place",
      "pointer",
      "searching",
      "stop",
      "tracking"
    ],
    "popularity": 2150
  },
  {
    "name": "fence",
    "tags": ["backyard", "barrier", "boundaries", "boundary", "fence", "home", "house", "protection", "yard"],
    "popularity": 2146
  },
  {
    "name": "local_florist",
    "tags": ["florist", "flower", "local", "shop"],
    "popularity": 2143
  },
  {
    "name": "photo_size_select_small",
    "tags": [
      "adjust",
      "album",
      "edit",
      "editing",
      "image",
      "large",
      "library",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "select",
      "size",
      "small"
    ],
    "popularity": 2143
  },
  {
    "name": "signal_wifi_connected_no_internet_4",
    "tags": [
      "4",
      "cell",
      "cellular",
      "connected",
      "data",
      "internet",
      "mobile",
      "network",
      "no",
      "offline",
      "phone",
      "signal",
      "wifi",
      "wireless",
      "x"
    ],
    "popularity": 2140
  },
  {
    "name": "horizontal_distribute",
    "tags": [
      "alignment",
      "distribute",
      "format",
      "horizontal",
      "layout",
      "lines",
      "paragraph",
      "rule",
      "rules",
      "style",
      "text"
    ],
    "popularity": 2138
  },
  {
    "name": "bookmark_add",
    "tags": ["+", "add", "bookmark", "favorite", "plus", "remember", "ribbon", "save", "symbol"],
    "popularity": 2136
  },
  {
    "name": "euro_symbol",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "euro",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "symbol"
    ],
    "popularity": 2136
  },
  {
    "name": "battery_3_bar",
    "tags": ["3", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 2135
  },
  {
    "name": "lock_reset",
    "tags": [
      "around",
      "inprogress",
      "load",
      "loading refresh",
      "lock",
      "locked",
      "password",
      "privacy",
      "private",
      "protection",
      "renew",
      "rotate",
      "safety",
      "secure",
      "security",
      "turn"
    ],
    "popularity": 2134
  },
  {
    "name": "mic_off",
    "tags": [
      "audio",
      "disabled",
      "enabled",
      "hear",
      "hearing",
      "mic",
      "microphone",
      "noise",
      "off",
      "on",
      "record",
      "recording",
      "slash",
      "sound",
      "voice"
    ],
    "popularity": 2131
  },
  {
    "name": "input",
    "tags": ["arrow", "box", "download", "input", "login", "move", "right"],
    "popularity": 2129
  },
  {
    "name": "report_off",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "disabled",
      "enabled",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "octagon",
      "off",
      "offline",
      "on",
      "report",
      "slash",
      "symbol",
      "warning"
    ],
    "popularity": 2128
  },
  {
    "name": "arrow_outward",
    "tags": [
      "app",
      "application",
      "arrow",
      "arrows",
      "components",
      "direction",
      "forward",
      "interface",
      "navigation",
      "right",
      "screen",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 2127
  },
  {
    "name": "123",
    "tags": ["1", "2", "3", "digit", "number", "symbol"],
    "popularity": 2123
  },
  {
    "name": "rainy",
    "tags": ["climate", "cloud", "cloudy", "rain", "rainfall", "showers", "snow", "temperature", "weather"],
    "popularity": 2117
  },
  {
    "name": "emoji_nature",
    "tags": [
      "animal",
      "bee",
      "bug",
      "daisy",
      "emoji",
      "flower",
      "insect",
      "ladybug",
      "nature",
      "petals",
      "spring",
      "summer"
    ],
    "popularity": 2115
  },
  {
    "name": "filter_hdr",
    "tags": [
      "camera",
      "edit",
      "editing",
      "effect",
      "filter",
      "hdr",
      "image",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture"
    ],
    "popularity": 2112
  },
  {
    "name": "crop_7_5",
    "tags": [
      "5",
      "7",
      "adjust",
      "adjustments",
      "area",
      "by",
      "crop",
      "editing",
      "frame",
      "image",
      "images",
      "photo",
      "photos",
      "rectangle",
      "settings",
      "size",
      "square"
    ],
    "popularity": 2110
  },
  {
    "name": "hiking",
    "tags": [
      "backpacking",
      "bag",
      "climbing",
      "duffle",
      "hiking",
      "mountain",
      "social",
      "sports",
      "stick",
      "trail",
      "travel",
      "walking"
    ],
    "popularity": 2108
  },
  {
    "name": "groups_3",
    "tags": [
      "abstract",
      "body",
      "club",
      "collaboration",
      "crowd",
      "gathering",
      "groups",
      "human",
      "meeting",
      "people",
      "person",
      "social",
      "teams"
    ],
    "popularity": 2106
  },
  {
    "name": "align_vertical_bottom",
    "tags": [
      "align",
      "alignment",
      "bottom",
      "format",
      "layout",
      "lines",
      "paragraph",
      "rule",
      "rules",
      "style",
      "text",
      "vertical"
    ],
    "popularity": 2104
  },
  {
    "name": "art_track",
    "tags": [
      "album",
      "art",
      "artist",
      "audio",
      "image",
      "music",
      "photo",
      "photography",
      "picture",
      "sound",
      "track",
      "tracks"
    ],
    "popularity": 2104
  },
  {
    "name": "location_away",
    "tags": [
      "account",
      "architecture",
      "avatar",
      "away",
      "building",
      "estate",
      "face",
      "home",
      "house",
      "human",
      "location",
      "people",
      "person",
      "place",
      "profile",
      "real",
      "residence",
      "residential",
      "user"
    ],
    "popularity": 2099
  },
  {
    "name": "text_rotation_none",
    "tags": [
      "A",
      "alphabet",
      "arrow",
      "character",
      "field",
      "font",
      "letter",
      "move",
      "none",
      "rotate",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 2099
  },
  {
    "name": "barcode_reader",
    "tags": [
      "barcode",
      "ecommerce",
      "handheld",
      "machine",
      "price",
      "reader",
      "scan",
      "scanner",
      "shop",
      "shopping",
      "tag"
    ],
    "popularity": 2097
  },
  {
    "name": "battery_charging_full",
    "tags": ["battery", "bolt", "cell", "charge", "charging", "full", "lightening", "mobile", "power", "thunderbolt"],
    "popularity": 2092
  },
  {
    "name": "event_busy",
    "tags": [
      "busy",
      "calendar",
      "cancel",
      "close",
      "date",
      "event",
      "exit",
      "no",
      "remove",
      "schedule",
      "stop",
      "time",
      "unavailable",
      "x"
    ],
    "popularity": 2087
  },
  {
    "name": "imagesearch_roller",
    "tags": ["art", "image", "imagesearch", "paint", "roller", "search"],
    "popularity": 2085
  },
  {
    "name": "stop_screen_share",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "cast",
      "chrome",
      "device",
      "disabled",
      "display",
      "enabled",
      "hardware",
      "iOS",
      "laptop",
      "mac",
      "mirror",
      "monitor",
      "off",
      "offline",
      "on",
      "screen",
      "share",
      "slash",
      "steam",
      "stop",
      "streaming",
      "web",
      "window"
    ],
    "popularity": 2085
  },
  {
    "name": "swipe_left",
    "tags": [
      "arrow",
      "arrows",
      "finger",
      "hand",
      "hit",
      "left",
      "navigation",
      "reject",
      "strike",
      "swing",
      "swipe",
      "take"
    ],
    "popularity": 2085
  },
  {
    "name": "schema",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "flow",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "schema",
      "squares",
      "statistics",
      "tracking"
    ],
    "popularity": 2081
  },
  {
    "name": "install_mobile",
    "tags": ["Android", "OS", "cell", "device", "hardware", "iOS", "install", "mobile", "phone", "pwa", "tablet"],
    "popularity": 2079
  },
  {
    "name": "stadium",
    "tags": ["activity", "amphitheater", "arena", "coliseum", "event", "local", "stadium", "star", "things", "ticket"],
    "popularity": 2076
  },
  {
    "name": "interpreter_mode",
    "tags": ["interpreter", "language", "microphone", "mode", "person", "speaking", "symbol"],
    "popularity": 2073
  },
  {
    "name": "timelapse",
    "tags": ["duration", "motion", "photo", "time", "timelapse", "timer", "video"],
    "popularity": 2073
  },
  {
    "name": "castle",
    "tags": ["castle", "fort", "fortress", "mansion", "palace"],
    "popularity": 2071
  },
  {
    "name": "video_file",
    "tags": [
      "camera",
      "doc",
      "document",
      "film",
      "filming",
      "hardware",
      "image",
      "motion",
      "picture",
      "video",
      "videography"
    ],
    "popularity": 2069
  },
  {
    "name": "rotate_90_degrees_cw",
    "tags": [
      "90",
      "arrow",
      "arrows",
      "ccw",
      "degrees",
      "direction",
      "edit",
      "editing",
      "image",
      "photo",
      "rotate",
      "turn"
    ],
    "popularity": 2068
  },
  {
    "name": "bento",
    "tags": ["bento", "box", "dinner", "food", "lunch", "meal", "restaurant", "takeout"],
    "popularity": 2064
  },
  {
    "name": "mms",
    "tags": [
      "bubble",
      "chat",
      "comment",
      "communicate",
      "feedback",
      "image",
      "landscape",
      "message",
      "mms",
      "mountain",
      "mountains",
      "multimedia",
      "photo",
      "photography",
      "picture",
      "speech"
    ],
    "popularity": 2064
  },
  {
    "name": "aod",
    "tags": [
      "Android",
      "OS",
      "always",
      "aod",
      "device",
      "display",
      "hardware",
      "homescreen",
      "iOS",
      "mobile",
      "on",
      "phone",
      "tablet"
    ],
    "popularity": 2062
  },
  {
    "name": "wheelchair_pickup",
    "tags": ["accessibility", "accessible", "body", "handicap", "help", "human", "person", "pickup", "wheelchair"],
    "popularity": 2059
  },
  {
    "name": "access_alarm",
    "tags": [],
    "popularity": 2056
  },
  {
    "name": "crop_rotate",
    "tags": [
      "adjust",
      "adjustments",
      "area",
      "arrow",
      "arrows",
      "crop",
      "edit",
      "editing",
      "frame",
      "image",
      "images",
      "photo",
      "photos",
      "rotate",
      "settings",
      "size",
      "turn"
    ],
    "popularity": 2056
  },
  {
    "name": "hearing_disabled",
    "tags": [
      "accessibility",
      "accessible",
      "aid",
      "disabled",
      "ear",
      "enabled",
      "handicap",
      "hearing",
      "help",
      "impaired",
      "listen",
      "off",
      "on",
      "slash",
      "sound",
      "volume"
    ],
    "popularity": 2056
  },
  {
    "name": "beach_access",
    "tags": ["access", "beach", "places", "summer", "sunny", "umbrella"],
    "popularity": 2052
  },
  {
    "name": "person_off",
    "tags": [
      "account",
      "avatar",
      "disabled",
      "enabled",
      "face",
      "human",
      "off",
      "on",
      "people",
      "person",
      "profile",
      "slash",
      "user"
    ],
    "popularity": 2051
  },
  {
    "name": "checklist_rtl",
    "tags": [
      "align",
      "alignment",
      "approve",
      "check",
      "checklist",
      "complete",
      "doc",
      "done",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "mark",
      "notes",
      "ok",
      "rtl",
      "select",
      "sheet",
      "spreadsheet",
      "text",
      "tick",
      "type",
      "validate",
      "verified",
      "writing",
      "yes"
    ],
    "popularity": 2050
  },
  {
    "name": "keyboard_arrow_left",
    "tags": ["arrow", "arrows", "keyboard", "left"],
    "popularity": 2046
  },
  {
    "name": "calendar_add_on",
    "tags": [],
    "popularity": 2043
  },
  {
    "name": "directions_boat",
    "tags": [
      "automobile",
      "boat",
      "car",
      "cars",
      "direction",
      "directions",
      "ferry",
      "maps",
      "public",
      "transportation",
      "vehicle"
    ],
    "popularity": 2043
  },
  {
    "name": "forward_5",
    "tags": [
      "10",
      "5",
      "arrow",
      "control",
      "controls",
      "digit",
      "fast",
      "forward",
      "music",
      "number",
      "seconds",
      "symbol",
      "video"
    ],
    "popularity": 2040
  },
  {
    "name": "crisis_alert",
    "tags": [
      "!",
      "alert",
      "attention",
      "bullseye",
      "caution",
      "crisis",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "notification",
      "symbol",
      "target",
      "warning"
    ],
    "popularity": 2039
  },
  {
    "name": "view_kanban",
    "tags": ["grid", "kanban", "layout", "pattern", "squares", "view"],
    "popularity": 2037
  },
  {
    "name": "add_to_home_screen",
    "tags": [
      "Android",
      "OS",
      "add to",
      "arrow",
      "cell",
      "device",
      "hardware",
      "home",
      "iOS",
      "mobile",
      "phone",
      "screen",
      "tablet",
      "up"
    ],
    "popularity": 2036
  },
  {
    "name": "not_accessible",
    "tags": ["accessibility", "accessible", "body", "handicap", "help", "human", "not", "person", "wheelchair"],
    "popularity": 2036
  },
  {
    "name": "candlestick_chart",
    "tags": [
      "analytics",
      "candlestick",
      "chart",
      "data",
      "diagram",
      "finance",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 2035
  },
  {
    "name": "signal_cellular_0_bar",
    "tags": [
      "0",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "signal",
      "speed",
      "wifi",
      "wireless"
    ],
    "popularity": 2034
  },
  {
    "name": "add_business",
    "tags": [
      "+",
      "add",
      "bill",
      "building",
      "business",
      "card",
      "cash",
      "coin",
      "commerce",
      "company",
      "credit",
      "currency",
      "dollars",
      "market",
      "money",
      "new",
      "online",
      "pay",
      "payment",
      "plus",
      "shop",
      "shopping",
      "store",
      "storefront",
      "symbol"
    ],
    "popularity": 2033
  },
  {
    "name": "photo_size_select_large",
    "tags": [
      "adjust",
      "album",
      "edit",
      "editing",
      "image",
      "large",
      "library",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "select",
      "size"
    ],
    "popularity": 2031
  },
  {
    "name": "cookie",
    "tags": ["biscuit", "cookies", "data", "dessert", "wafer"],
    "popularity": 2025
  },
  {
    "name": "filter_3",
    "tags": [
      "3",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 2024
  },
  {
    "name": "add_comment",
    "tags": [
      "+",
      "add",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "feedback",
      "message",
      "new",
      "plus",
      "speech",
      "symbol"
    ],
    "popularity": 2023
  },
  {
    "name": "snowshoeing",
    "tags": [
      "body",
      "human",
      "people",
      "person",
      "snow",
      "snowshoe",
      "snowshoeing",
      "sports",
      "travel",
      "walking",
      "winter"
    ],
    "popularity": 2023
  },
  {
    "name": "dvr",
    "tags": [
      "Android",
      "OS",
      "audio",
      "chrome",
      "computer",
      "desktop",
      "device",
      "display",
      "dvr",
      "electronic",
      "hardware",
      "iOS",
      "list",
      "mac",
      "monitor",
      "record",
      "recorder",
      "screen",
      "tv",
      "video",
      "web",
      "window"
    ],
    "popularity": 2022
  },
  {
    "name": "flashlight_off",
    "tags": ["disabled", "enabled", "flash", "flashlight", "light", "off", "on", "slash"],
    "popularity": 2022
  },
  {
    "name": "align_horizontal_center",
    "tags": [
      "align",
      "alignment",
      "center",
      "format",
      "horizontal",
      "layout",
      "lines",
      "paragraph",
      "rule",
      "rules",
      "style",
      "text"
    ],
    "popularity": 2018
  },
  {
    "name": "connect_without_contact",
    "tags": ["communicating", "connect", "contact", "distance", "people", "signal", "social", "socialize", "without"],
    "popularity": 2013
  },
  {
    "name": "phone_enabled",
    "tags": ["call", "cell", "contact", "device", "enabled", "hardware", "mobile", "phone", "telephone"],
    "popularity": 2011
  },
  {
    "name": "woman",
    "tags": ["female", "gender", "girl", "lady", "social", "symbol", "woman", "women"],
    "popularity": 2011
  },
  {
    "name": "local_bar",
    "tags": ["alcohol", "bar", "bottle", "club", "cocktail", "drink", "food", "liquor", "local", "wine"],
    "popularity": 2008
  },
  {
    "name": "thermostat",
    "tags": ["climate", "forecast", "temperature", "thermostat", "weather"],
    "popularity": 2008
  },
  {
    "name": "laptop_chromebook",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "chromebook",
      "device",
      "display",
      "hardware",
      "iOS",
      "laptop",
      "mac chromebook",
      "monitor",
      "screen",
      "web",
      "window"
    ],
    "popularity": 2004
  },
  {
    "name": "print_disabled",
    "tags": ["disabled", "enabled", "off", "on", "paper", "print", "printer", "slash"],
    "popularity": 2004
  },
  {
    "name": "add_card",
    "tags": [
      "+",
      "add",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "new",
      "online",
      "pay",
      "payment",
      "plus",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 1999
  },
  {
    "name": "iron",
    "tags": ["appliance", "clothes", "electric", "iron", "ironing", "machine", "object"],
    "popularity": 1999
  },
  {
    "name": "swipe_down",
    "tags": [
      "arrows",
      "direction",
      "disable",
      "down",
      "enable",
      "finger",
      "hands",
      "hit",
      "navigation",
      "strike",
      "swing",
      "swpie",
      "take"
    ],
    "popularity": 1997
  },
  {
    "name": "face_6",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 1996
  },
  {
    "name": "security_update",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "device",
      "down",
      "download",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "security",
      "tablet",
      "update"
    ],
    "popularity": 1995
  },
  {
    "name": "more_time",
    "tags": ["+", "add", "clock", "date", "more", "new", "plus", "schedule", "symbol", "time"],
    "popularity": 1992
  },
  {
    "name": "pool",
    "tags": [
      "athlete",
      "athletic",
      "beach",
      "body",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "ocean",
      "people",
      "person",
      "places",
      "pool",
      "sea",
      "sports",
      "swim",
      "swimming",
      "water"
    ],
    "popularity": 1989
  },
  {
    "name": "css",
    "tags": [
      "alphabet",
      "brackets",
      "character",
      "code",
      "css",
      "develop",
      "developer",
      "engineer",
      "engineering",
      "font",
      "html",
      "letter",
      "platform",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1987
  },
  {
    "name": "speaker_group",
    "tags": [
      "box",
      "electronic",
      "group",
      "loud",
      "multiple",
      "music",
      "sound",
      "speaker",
      "stereo",
      "system",
      "video"
    ],
    "popularity": 1985
  },
  {
    "name": "exposure_zero",
    "tags": [
      "0",
      "brightness",
      "contrast",
      "digit",
      "edit",
      "editing",
      "effect",
      "exposure",
      "image",
      "number",
      "photo",
      "photography",
      "settings",
      "symbol",
      "zero"
    ],
    "popularity": 1983
  },
  {
    "name": "west",
    "tags": ["arrow", "directional", "left", "maps", "navigation", "west"],
    "popularity": 1981
  },
  {
    "name": "other_houses",
    "tags": [
      "architecture",
      "cottage",
      "estate",
      "home",
      "house",
      "houses",
      "maps",
      "other",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling"
    ],
    "popularity": 1979
  },
  {
    "name": "streetview",
    "tags": ["maps", "street", "streetview", "view"],
    "popularity": 1978
  },
  {
    "name": "flutter_dash",
    "tags": ["bird", "dash", "flutter", "mascot"],
    "popularity": 1977
  },
  {
    "name": "pin_invoke",
    "tags": ["action", "arrow", "dot", "invoke", "pin"],
    "popularity": 1976
  },
  {
    "name": "slideshow",
    "tags": ["movie", "photos", "play", "slideshow", "square", "video", "view"],
    "popularity": 1975
  },
  {
    "name": "mood_bad",
    "tags": [
      "bad",
      "disappointment",
      "dislike",
      "emoji",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "mood",
      "person",
      "rating",
      "social",
      "survey",
      "unhappiness",
      "unhappy",
      "unpleased",
      "unsmile",
      "unsmiling"
    ],
    "popularity": 1974
  },
  {
    "name": "call_missed",
    "tags": ["arrow", "call", "device", "missed", "mobile"],
    "popularity": 1973
  },
  {
    "name": "hdr_weak",
    "tags": ["circles", "dots", "dynamic", "enhance", "hdr", "high", "range", "weak"],
    "popularity": 1973
  },
  {
    "name": "bungalow",
    "tags": [
      "architecture",
      "bungalow",
      "cottage",
      "estate",
      "home",
      "house",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling"
    ],
    "popularity": 1972
  },
  {
    "name": "model_training",
    "tags": [
      "arrow",
      "bulb",
      "idea",
      "inprogress",
      "light",
      "load",
      "loading",
      "model",
      "refresh",
      "renew",
      "restore",
      "reverse",
      "rotate",
      "training"
    ],
    "popularity": 1971
  },
  {
    "name": "note_alt",
    "tags": ["alt", "clipboard", "document", "file", "memo", "note", "page", "paper", "writing"],
    "popularity": 1968
  },
  {
    "name": "male",
    "tags": ["boy", "gender", "male", "man", "social", "symbol"],
    "popularity": 1962
  },
  {
    "name": "saved_search",
    "tags": ["find", "glass", "important", "look", "magnify", "magnifying", "marked", "saved", "search", "see", "star"],
    "popularity": 1961
  },
  {
    "name": "graphic_eq",
    "tags": [
      "audio",
      "detect",
      "detection",
      "eq",
      "equalizer",
      "graphic",
      "music",
      "noise",
      "recording",
      "sound",
      "voice"
    ],
    "popularity": 1960
  },
  {
    "name": "back_hand",
    "tags": ["back", "fingers", "gesture", "hand", "raised"],
    "popularity": 1959
  },
  {
    "name": "gps_off",
    "tags": [
      "destination",
      "direction",
      "disabled",
      "enabled",
      "gps",
      "location",
      "maps",
      "not fixed",
      "off",
      "offline",
      "on",
      "place",
      "pointer",
      "slash",
      "tracking"
    ],
    "popularity": 1956
  },
  {
    "name": "sports_hockey",
    "tags": [
      "athlete",
      "athletic",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "hockey",
      "social",
      "sports",
      "sticks"
    ],
    "popularity": 1947
  },
  {
    "name": "currency_ruble",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "ruble",
      "shopping",
      "symbol"
    ],
    "popularity": 1942
  },
  {
    "name": "keyboard_return",
    "tags": ["arrow", "back", "keyboard", "left", "return"],
    "popularity": 1942
  },
  {
    "name": "ice_skating",
    "tags": [
      "athlete",
      "athletic",
      "entertainment",
      "exercise",
      "hobby",
      "ice",
      "shoe",
      "skates",
      "skating",
      "social",
      "sports",
      "travel"
    ],
    "popularity": 1941
  },
  {
    "name": "keyboard_capslock",
    "tags": ["arrow", "capslock", "keyboard", "up"],
    "popularity": 1941
  },
  {
    "name": "camera_front",
    "tags": [
      "body",
      "camera",
      "front",
      "human",
      "lens",
      "mobile",
      "person",
      "phone",
      "photography",
      "portrait",
      "selfie"
    ],
    "popularity": 1940
  },
  {
    "name": "save_as",
    "tags": [
      "compose",
      "create",
      "data",
      "disk",
      "document",
      "draft",
      "drive",
      "edit",
      "editing",
      "file",
      "floppy",
      "input",
      "multimedia",
      "pen",
      "pencil",
      "save",
      "storage",
      "write",
      "writing"
    ],
    "popularity": 1938
  },
  {
    "name": "earbuds",
    "tags": ["accessory", "audio", "earbuds", "earphone", "headphone", "listen", "music", "sound"],
    "popularity": 1937
  },
  {
    "name": "local_gas_station",
    "tags": ["auto", "car", "gas", "local", "oil", "station", "vehicle"],
    "popularity": 1936
  },
  {
    "name": "speaker_notes",
    "tags": [
      "bubble",
      "chat",
      "comment",
      "communicate",
      "format",
      "list",
      "message",
      "notes",
      "speaker",
      "speech",
      "text"
    ],
    "popularity": 1935
  },
  {
    "name": "join_left",
    "tags": ["circle", "command", "join", "left", "matching", "overlap", "sql", "values"],
    "popularity": 1933
  },
  {
    "name": "edit_document",
    "tags": [
      "compose",
      "create",
      "doc",
      "document",
      "draft",
      "drive",
      "edit",
      "editing",
      "file",
      "folder",
      "folders",
      "input",
      "page",
      "paper",
      "pen",
      "pencil",
      "write",
      "writing"
    ],
    "popularity": 1929
  },
  {
    "name": "vertical_distribute",
    "tags": [
      "alignment",
      "distribute",
      "format",
      "layout",
      "lines",
      "paragraph",
      "rule",
      "rules",
      "style",
      "text",
      "vertical"
    ],
    "popularity": 1928
  },
  {
    "name": "web_stories",
    "tags": ["google", "images", "logo", "stories", "web"],
    "popularity": 1927
  },
  {
    "name": "g_translate",
    "tags": [
      "emblem",
      "g",
      "google",
      "language",
      "logo",
      "mark",
      "speaking",
      "speech",
      "translate",
      "translator",
      "words"
    ],
    "popularity": 1925
  },
  {
    "name": "signal_wifi_statusbar_null",
    "tags": [
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "null",
      "phone",
      "signal",
      "speed",
      "statusbar",
      "wifi",
      "wireless"
    ],
    "popularity": 1925
  },
  {
    "name": "align_horizontal_right",
    "tags": [
      "align",
      "alignment",
      "format",
      "horizontal",
      "layout",
      "lines",
      "paragraph",
      "right",
      "rule",
      "rules",
      "style",
      "text"
    ],
    "popularity": 1919
  },
  {
    "name": "bedtime",
    "tags": ["bedtime", "nightime", "sleep"],
    "popularity": 1919
  },
  {
    "name": "lock_person",
    "tags": [],
    "popularity": 1919
  },
  {
    "name": "card_membership",
    "tags": [
      "bill",
      "bookmark",
      "card",
      "cash",
      "certificate",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "loyalty",
      "membership",
      "money",
      "online",
      "pay",
      "payment",
      "shopping",
      "subscription"
    ],
    "popularity": 1915
  },
  {
    "name": "park",
    "tags": ["attraction", "fresh", "local", "nature", "outside", "park", "plant", "tree"],
    "popularity": 1915
  },
  {
    "name": "backup",
    "tags": ["arrow", "backup", "cloud", "data", "drive", "files folders", "storage", "up", "upload"],
    "popularity": 1914
  },
  {
    "name": "cloud_sync",
    "tags": [
      "app",
      "application",
      "around",
      "backup",
      "cloud",
      "connection",
      "drive",
      "files",
      "folders",
      "inprogress",
      "internet",
      "load",
      "loading refresh",
      "network",
      "renew",
      "rotate",
      "sky",
      "storage",
      "turn",
      "upload"
    ],
    "popularity": 1913
  },
  {
    "name": "checkroom",
    "tags": ["checkroom", "closet", "clothes", "coat check", "hanger"],
    "popularity": 1912
  },
  {
    "name": "crop_5_4",
    "tags": [
      "4",
      "5",
      "adjust",
      "adjustments",
      "area",
      "by",
      "crop",
      "edit",
      "editing settings",
      "frame",
      "image",
      "images",
      "photo",
      "photos",
      "rectangle",
      "size",
      "square"
    ],
    "popularity": 1911
  },
  {
    "name": "perm_phone_msg",
    "tags": [
      "bubble",
      "call",
      "cell",
      "chat",
      "comment",
      "communicate",
      "contact",
      "device",
      "message",
      "msg",
      "perm",
      "phone",
      "recording",
      "speech",
      "telephone",
      "voice"
    ],
    "popularity": 1911
  },
  {
    "name": "communication",
    "tags": ["communication", "feedback", "message", "nest", "people", "speech"],
    "popularity": 1908
  },
  {
    "name": "system_update_alt",
    "tags": ["arrow", "down", "download", "export", "system", "update"],
    "popularity": 1908
  },
  {
    "name": "emergency_home",
    "tags": [
      "alert",
      "attention",
      "caution",
      "danger",
      "emergency",
      "error",
      "exclamation",
      "home",
      "house",
      "important",
      "mark",
      "nest",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 1907
  },
  {
    "name": "format_strikethrough",
    "tags": [
      "alphabet",
      "character",
      "doc",
      "edit",
      "editing",
      "editor",
      "font",
      "format",
      "letter",
      "sheet",
      "spreadsheet",
      "strikethrough",
      "style",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1907
  },
  {
    "name": "explicit",
    "tags": [
      "adult",
      "alphabet",
      "character",
      "content",
      "e",
      "explicit",
      "font",
      "language",
      "letter",
      "media",
      "movies",
      "music",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1901
  },
  {
    "name": "extension_off",
    "tags": [
      "disabled",
      "enabled",
      "extended",
      "extension",
      "jigsaw",
      "off",
      "on",
      "piece",
      "puzzle",
      "shape",
      "slash"
    ],
    "popularity": 1899
  },
  {
    "name": "groups_2",
    "tags": [
      "body",
      "club",
      "collaboration",
      "crowd",
      "gathering",
      "groups",
      "hair",
      "human",
      "meeting",
      "people",
      "person",
      "social",
      "teams"
    ],
    "popularity": 1899
  },
  {
    "name": "solar_power",
    "tags": ["eco", "energy", "heat", "nest", "power", "solar", "sun", "sunny"],
    "popularity": 1896
  },
  {
    "name": "safety_check",
    "tags": [
      "certified",
      "check",
      "clock",
      "privacy",
      "private",
      "protect",
      "protection",
      "safety",
      "schedule",
      "security",
      "shield",
      "time",
      "verified"
    ],
    "popularity": 1894
  },
  {
    "name": "maps_ugc",
    "tags": [
      "+",
      "add",
      "bubble",
      "comment",
      "communicate",
      "feedback",
      "maps",
      "message",
      "new",
      "plus",
      "speech",
      "symbol",
      "ugc"
    ],
    "popularity": 1893
  },
  {
    "name": "place_item",
    "tags": ["arrow", "arrows", "direction", "down", "drop", "item", "move", "place", "put"],
    "popularity": 1892
  },
  {
    "name": "thunderstorm",
    "tags": [
      "bolt",
      "climate",
      "cloud",
      "cloudy",
      "lightning",
      "rain",
      "rainfall",
      "rainstorm",
      "storm",
      "thunder",
      "thunderstorm",
      "weather"
    ],
    "popularity": 1890
  },
  {
    "name": "south_america",
    "tags": ["continent", "landscape", "place", "region", "south america"],
    "popularity": 1889
  },
  {
    "name": "luggage",
    "tags": ["airport", "bag", "baggage", "carry", "flight", "hotel", "luggage", "on", "suitcase", "travel", "trip"],
    "popularity": 1888
  },
  {
    "name": "sd_storage",
    "tags": ["camera", "card", "data", "digital", "memory", "sd", "secure", "storage"],
    "popularity": 1887
  },
  {
    "name": "privacy_tip",
    "tags": [
      "alert",
      "announcement",
      "assistance",
      "certified",
      "details",
      "help",
      "i",
      "info",
      "information",
      "privacy",
      "private",
      "protect",
      "protection",
      "security",
      "service",
      "shield",
      "support",
      "tip",
      "verified"
    ],
    "popularity": 1884
  },
  {
    "name": "sports_rugby",
    "tags": ["athlete", "athletic", "ball", "entertainment", "exercise", "game", "hobby", "rugby", "social", "sports"],
    "popularity": 1884
  },
  {
    "name": "perm_camera_mic",
    "tags": ["camera", "image", "microphone", "min", "perm", "photo", "photography", "picture", "speaker"],
    "popularity": 1883
  },
  {
    "name": "rotate_right",
    "tags": [
      "around",
      "arrow",
      "direction",
      "inprogress",
      "load",
      "loading refresh",
      "renew",
      "right",
      "rotate",
      "turn"
    ],
    "popularity": 1883
  },
  {
    "name": "grid_on",
    "tags": ["collage", "disabled", "enabled", "grid", "image", "layout", "off", "on", "slash", "view"],
    "popularity": 1882
  },
  {
    "name": "currency_bitcoin",
    "tags": [
      "bill",
      "blockchain",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "digital",
      "dollars",
      "finance",
      "franc",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 1880
  },
  {
    "name": "hearing",
    "tags": [
      "accessibility",
      "accessible",
      "aid",
      "ear",
      "handicap",
      "hearing",
      "help",
      "impaired",
      "listen",
      "sound",
      "volume"
    ],
    "popularity": 1878
  },
  {
    "name": "pause_presentation",
    "tags": [
      "app",
      "application desktop",
      "device",
      "pause",
      "present",
      "presentation",
      "screen",
      "share",
      "site",
      "slides",
      "web",
      "website",
      "window",
      "www"
    ],
    "popularity": 1877
  },
  {
    "name": "mark_unread_chat_alt",
    "tags": [
      "bubble",
      "chat",
      "circle",
      "comment",
      "communicate",
      "mark",
      "message",
      "notification",
      "speech",
      "unread"
    ],
    "popularity": 1874
  },
  {
    "name": "architecture",
    "tags": ["architecture", "art", "compass", "design", "draw", "drawing", "engineering", "geometric", "tool"],
    "popularity": 1873
  },
  {
    "name": "maximize",
    "tags": [
      "app",
      "application",
      "components",
      "design",
      "interface",
      "line",
      "maximize",
      "screen",
      "shape",
      "site",
      "ui",
      "ux",
      "web",
      "website"
    ],
    "popularity": 1871
  },
  {
    "name": "4g_mobiledata",
    "tags": [
      "4g",
      "alphabet",
      "cellular",
      "character",
      "digit",
      "font",
      "letter",
      "mobile",
      "mobiledata",
      "network",
      "number",
      "phone",
      "signal",
      "speed",
      "symbol",
      "text",
      "type",
      "wifi"
    ],
    "popularity": 1868
  },
  {
    "name": "javascript",
    "tags": [
      "alphabet",
      "brackets",
      "character",
      "code",
      "css",
      "develop",
      "developer",
      "engineer",
      "engineering",
      "font",
      "html",
      "javascript",
      "letter",
      "platform",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1868
  },
  {
    "name": "accessibility",
    "tags": ["accessibility", "accessible", "body", "handicap", "help", "human", "people", "person"],
    "popularity": 1867
  },
  {
    "name": "pinch",
    "tags": [
      "arrow",
      "arrows",
      "compress",
      "direction",
      "finger",
      "grasp",
      "hand",
      "navigation",
      "nip",
      "pinch",
      "squeeze",
      "tweak"
    ],
    "popularity": 1867
  },
  {
    "name": "search_off",
    "tags": [
      "cancel",
      "close",
      "disabled",
      "enabled",
      "find",
      "glass",
      "look",
      "magnify",
      "magnifying",
      "off",
      "on",
      "search",
      "see",
      "slash",
      "stop",
      "x"
    ],
    "popularity": 1867
  },
  {
    "name": "spatial_audio_off",
    "tags": ["audio", "disabled", "enabled", "music", "note", "off", "offline", "on", "slash", "sound", "spatial"],
    "popularity": 1866
  },
  {
    "name": "alarm_on",
    "tags": [
      "alarm",
      "alert",
      "bell",
      "clock",
      "disabled",
      "duration",
      "enabled",
      "notification",
      "off",
      "on",
      "slash",
      "time",
      "timer",
      "watch"
    ],
    "popularity": 1865
  },
  {
    "name": "dynamic_feed",
    "tags": ["'mail_outline'", "'markunread'. Keep 'mail' and remove others.", "Duplicate of 'email'"],
    "popularity": 1865
  },
  {
    "name": "superscript",
    "tags": [
      "2",
      "doc",
      "edit",
      "editing",
      "editor",
      "gmail",
      "novitas",
      "sheet",
      "spreadsheet",
      "style",
      "superscript",
      "symbol",
      "text",
      "writing",
      "x"
    ],
    "popularity": 1864
  },
  {
    "name": "output",
    "tags": [],
    "popularity": 1863
  },
  {
    "name": "grass",
    "tags": ["backyard", "fodder", "grass", "ground", "home", "lawn", "plant", "turf", "yard"],
    "popularity": 1857
  },
  {
    "name": "crop_square",
    "tags": [
      "adjust",
      "adjustments",
      "app",
      "application",
      "area",
      "components",
      "crop",
      "design",
      "edit",
      "editing",
      "expand",
      "frame",
      "image",
      "images",
      "interface",
      "open",
      "photo",
      "photos",
      "rectangle",
      "screen",
      "settings",
      "shape",
      "shapes",
      "site",
      "size",
      "square",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 1855
  },
  {
    "name": "library_music",
    "tags": ["add", "album", "collection", "library", "music", "song", "sounds"],
    "popularity": 1854
  },
  {
    "name": "table_rows",
    "tags": ["grid", "layout", "lines", "rows", "stacked", "table"],
    "popularity": 1854
  },
  {
    "name": "pageview",
    "tags": ["doc", "document", "find", "glass", "magnifying", "page", "paper", "search", "view"],
    "popularity": 1852
  },
  {
    "name": "perm_media",
    "tags": [
      "collection",
      "data",
      "doc",
      "document",
      "file",
      "folder",
      "folders",
      "image",
      "landscape",
      "media",
      "mountain",
      "mountains",
      "perm",
      "photo",
      "photography",
      "picture",
      "storage"
    ],
    "popularity": 1848
  },
  {
    "name": "swipe_up",
    "tags": [
      "arrows",
      "direction",
      "disable",
      "enable",
      "finger",
      "hands",
      "hit",
      "navigation",
      "strike",
      "swing",
      "swpie",
      "take",
      "up"
    ],
    "popularity": 1848
  },
  {
    "name": "fit_screen",
    "tags": ["enlarge", "fit", "format", "layout", "reduce", "scale", "screen", "size"],
    "popularity": 1846
  },
  {
    "name": "select_all",
    "tags": ["all", "select", "selection", "square", "tool"],
    "popularity": 1844
  },
  {
    "name": "grid_3x3",
    "tags": ["3", "grid", "layout", "line", "space"],
    "popularity": 1839
  },
  {
    "name": "cloud_done",
    "tags": [
      "app",
      "application",
      "approve",
      "backup",
      "check",
      "cloud",
      "complete",
      "connection",
      "done",
      "drive",
      "files",
      "folders",
      "internet",
      "mark",
      "network",
      "ok",
      "select",
      "sky",
      "storage",
      "tick",
      "upload",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 1836
  },
  {
    "name": "filter_frames",
    "tags": [
      "boarders",
      "border",
      "camera",
      "center",
      "edit",
      "editing",
      "effect",
      "filter",
      "filters",
      "focus",
      "frame",
      "frames",
      "image",
      "options",
      "photo",
      "photography",
      "picture"
    ],
    "popularity": 1835
  },
  {
    "name": "battery_1_bar",
    "tags": ["1", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 1834
  },
  {
    "name": "playlist_add_check",
    "tags": [
      "add",
      "approve",
      "check",
      "collection",
      "complete",
      "done",
      "list",
      "mark",
      "music",
      "ok",
      "playlist",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 1828
  },
  {
    "name": "podcasts",
    "tags": ["broadcast", "casting", "network", "podcasts", "signal", "transmitting", "wireless"],
    "popularity": 1826
  },
  {
    "name": "watch",
    "tags": ["Android", "OS", "ar", "clock", "gadget", "iOS", "time", "vr", "watch", "wearables", "web", "wristwatch"],
    "popularity": 1817
  },
  {
    "name": "burst_mode",
    "tags": [
      "burst",
      "image",
      "landscape",
      "mode",
      "mountain",
      "mountains",
      "multiple",
      "photo",
      "photography",
      "picture"
    ],
    "popularity": 1815
  },
  {
    "name": "directions_subway",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "directions",
      "maps",
      "public",
      "rail",
      "subway",
      "train",
      "transportation",
      "vehicle"
    ],
    "popularity": 1814
  },
  {
    "name": "reset_tv",
    "tags": ["arrow", "device", "hardware", "monitor", "reset", "television", "tv"],
    "popularity": 1812
  },
  {
    "name": "elderly_woman",
    "tags": [
      "body",
      "cane",
      "elderly",
      "female",
      "gender",
      "girl",
      "human",
      "lady",
      "old",
      "people",
      "person",
      "senior",
      "social",
      "symbol",
      "woman",
      "women"
    ],
    "popularity": 1811
  },
  {
    "name": "home_app_logo",
    "tags": ["app", "home", "house", "logo", "nest"],
    "popularity": 1809
  },
  {
    "name": "partly_cloudy_day",
    "tags": ["climate", "cloud", "sun", "sunny", "temperature", "weather"],
    "popularity": 1809
  },
  {
    "name": "swipe_vertical",
    "tags": [
      "arrows",
      "direction",
      "finger",
      "hands",
      "hit",
      "navigation",
      "strike",
      "swing",
      "swpie",
      "take",
      "verticle"
    ],
    "popularity": 1807
  },
  {
    "name": "cleaning_services",
    "tags": ["clean", "cleaning", "dust", "services", "sweep"],
    "popularity": 1802
  },
  {
    "name": "assured_workload",
    "tags": [
      "assured",
      "compliance",
      "confidential",
      "federal",
      "government",
      "secure",
      "sensitive regulatory",
      "workload"
    ],
    "popularity": 1799
  },
  {
    "name": "4k",
    "tags": [
      "4000",
      "4K",
      "alphabet",
      "character",
      "digit",
      "display",
      "font",
      "letter",
      "number",
      "pixel",
      "pixels",
      "resolution",
      "symbol",
      "text",
      "type",
      "video"
    ],
    "popularity": 1798
  },
  {
    "name": "medication_liquid",
    "tags": [
      "+",
      "bottle",
      "doctor",
      "drug",
      "health",
      "hospital",
      "liquid",
      "medications",
      "medicine",
      "pharmacy",
      "spoon",
      "vessel"
    ],
    "popularity": 1797
  },
  {
    "name": "title",
    "tags": ["T", "alphabet", "character", "font", "header", "letter", "subject", "symbol", "text", "title", "type"],
    "popularity": 1797
  },
  {
    "name": "chalet",
    "tags": [
      "architecture",
      "chalet",
      "cottage",
      "estate",
      "home",
      "house",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling"
    ],
    "popularity": 1795
  },
  {
    "name": "punch_clock",
    "tags": ["clock", "date", "punch", "schedule", "time", "timer", "timesheet"],
    "popularity": 1795
  },
  {
    "name": "headset_off",
    "tags": [
      "accessory",
      "audio",
      "chat",
      "device",
      "disabled",
      "ear",
      "earphone",
      "enabled",
      "headphones",
      "headset",
      "listen",
      "mic",
      "music",
      "off",
      "on",
      "slash",
      "sound",
      "talk"
    ],
    "popularity": 1786
  },
  {
    "name": "face_3",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 1785
  },
  {
    "name": "fiber_smart_record",
    "tags": ["circle", "dot", "fiber", "play", "record", "smart", "watch"],
    "popularity": 1782
  },
  {
    "name": "local_atm",
    "tags": [
      "atm",
      "bill",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "local",
      "money",
      "online",
      "pay",
      "payment",
      "shopping",
      "symbol"
    ],
    "popularity": 1782
  },
  {
    "name": "thumbs_up_down",
    "tags": ["dislike", "down", "favorite", "fingers", "gesture", "hands", "like", "rate", "rating", "thumbs", "up"],
    "popularity": 1782
  },
  {
    "name": "oil_barrel",
    "tags": ["barrel", "droplet", "gas", "gasoline", "nest", "oil", "water"],
    "popularity": 1781
  },
  {
    "name": "co_present",
    "tags": ["arrow", "co-present", "presentation", "screen", "share", "site", "slides", "togather", "web", "website"],
    "popularity": 1777
  },
  {
    "name": "crib",
    "tags": [
      "babies",
      "baby",
      "bassinet",
      "bed",
      "child",
      "children",
      "cradle",
      "crib",
      "infant",
      "kid",
      "newborn",
      "sleeping",
      "toddler"
    ],
    "popularity": 1776
  },
  {
    "name": "package",
    "tags": [
      "box",
      "boxes",
      "delivery",
      "mail",
      "package",
      "packages",
      "parcel",
      "post",
      "postal",
      "send",
      "shipment",
      "shipping",
      "stamp"
    ],
    "popularity": 1776
  },
  {
    "name": "margin",
    "tags": ["design", "layout", "margin", "padding", "size", "square"],
    "popularity": 1773
  },
  {
    "name": "brightness_auto",
    "tags": ["A", "auto", "brightness", "control", "display", "level", "mobile", "monitor", "phone", "screen", "sun"],
    "popularity": 1772
  },
  {
    "name": "mosque",
    "tags": ["ideology", "islam", "islamic", "masjid", "muslim", "religion", "spiritual", "worship"],
    "popularity": 1772
  },
  {
    "name": "video_label",
    "tags": ["label", "screen", "video", "window"],
    "popularity": 1772
  },
  {
    "name": "wind_power",
    "tags": ["eco", "energy", "nest", "power", "wind", "windy"],
    "popularity": 1771
  },
  {
    "name": "360",
    "tags": ["360", "arrow", "av", "camera", "direction", "rotate", "rotation", "vr"],
    "popularity": 1766
  },
  {
    "name": "shower",
    "tags": [
      "bath",
      "bathroom",
      "closet",
      "home",
      "house",
      "place",
      "plumbing",
      "room",
      "shower",
      "sprinkler",
      "wash",
      "water",
      "wc"
    ],
    "popularity": 1764
  },
  {
    "name": "compass_calibration",
    "tags": [
      "calibration",
      "compass",
      "connection",
      "internet",
      "location",
      "maps",
      "network",
      "refresh",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 1763
  },
  {
    "name": "dialer_sip",
    "tags": [
      "alphabet",
      "call",
      "cell",
      "character",
      "contact",
      "device",
      "dialer",
      "font",
      "hardware",
      "initiation",
      "internet",
      "letter",
      "mobile",
      "over",
      "phone",
      "protocol",
      "routing",
      "session",
      "sip",
      "symbol",
      "telephone",
      "text",
      "type",
      "voice"
    ],
    "popularity": 1758
  },
  {
    "name": "pin_end",
    "tags": ["action", "arrow", "dot", "end", "pin"],
    "popularity": 1757
  },
  {
    "name": "camera_roll",
    "tags": ["camera", "film", "image", "library", "photo", "photography", "roll"],
    "popularity": 1756
  },
  {
    "name": "dynamic_form",
    "tags": [
      "bolt",
      "code",
      "dynamic",
      "electric",
      "fast",
      "form",
      "lightning",
      "lists",
      "questionnaire",
      "thunderbolt"
    ],
    "popularity": 1745
  },
  {
    "name": "disc_full",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "cd",
      "danger",
      "disc",
      "error",
      "exclamation",
      "full",
      "important",
      "mark",
      "music",
      "notification",
      "storage",
      "symbol",
      "warning"
    ],
    "popularity": 1744
  },
  {
    "name": "liquor",
    "tags": ["alcohol", "bar", "bottle", "club", "cocktail", "drink", "food", "liquor", "party", "store", "wine"],
    "popularity": 1743
  },
  {
    "name": "hide_source",
    "tags": ["circle", "disabled", "enabled", "hide", "off", "offline", "on", "shape", "slash", "source"],
    "popularity": 1738
  },
  {
    "name": "car_crash",
    "tags": [
      "accident",
      "automobile",
      "car",
      "cars",
      "collision",
      "crash",
      "direction",
      "maps",
      "public",
      "transportation",
      "vehicle"
    ],
    "popularity": 1733
  },
  {
    "name": "power",
    "tags": ["charge", "cord", "electric", "electrical", "outlet", "plug", "power"],
    "popularity": 1733
  },
  {
    "name": "price_change",
    "tags": [
      "arrows",
      "bill",
      "card",
      "cash",
      "change",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "down",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol",
      "up"
    ],
    "popularity": 1728
  },
  {
    "name": "noise_aware",
    "tags": ["audio", "aware", "cancellation", "music", "noise", "note", "sound"],
    "popularity": 1727
  },
  {
    "name": "signal_cellular_connected_no_internet_4_bar",
    "tags": [
      "!",
      "4",
      "alert",
      "attention",
      "bar",
      "caution",
      "cell",
      "cellular",
      "connected",
      "danger",
      "data",
      "error",
      "exclamation",
      "important",
      "internet",
      "mark",
      "mobile",
      "network",
      "no",
      "notification",
      "phone",
      "signal",
      "symbol",
      "warning",
      "wifi",
      "wireless"
    ],
    "popularity": 1726
  },
  {
    "name": "wifi_lock",
    "tags": [
      "cellular",
      "connection",
      "data",
      "internet",
      "lock",
      "locked",
      "mobile",
      "network",
      "password",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 1722
  },
  {
    "name": "invert_colors_off",
    "tags": [
      "colors",
      "disabled",
      "drop",
      "droplet",
      "enabled",
      "hue",
      "invert",
      "inverted",
      "off",
      "offline",
      "on",
      "opacity",
      "palette",
      "slash",
      "tone",
      "water"
    ],
    "popularity": 1719
  },
  {
    "name": "table_view",
    "tags": ["format", "grid", "group", "layout", "multiple", "table", "view"],
    "popularity": 1717
  },
  {
    "name": "sledding",
    "tags": [
      "athlete",
      "athletic",
      "body",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "people",
      "person",
      "sled",
      "sledding",
      "sledge",
      "snow",
      "social",
      "sports",
      "travel",
      "winter"
    ],
    "popularity": 1716
  },
  {
    "name": "nightlight",
    "tags": ["dark", "disturb", "mode", "moon", "night", "nightlight", "sleep"],
    "popularity": 1715
  },
  {
    "name": "logo_dev",
    "tags": ["dev", "dev.to", "logo"],
    "popularity": 1714
  },
  {
    "name": "comments_disabled",
    "tags": [
      "bubble",
      "chat",
      "comment",
      "comments",
      "communicate",
      "disabled",
      "enabled",
      "feedback",
      "message",
      "off",
      "offline",
      "on",
      "slash",
      "speech"
    ],
    "popularity": 1707
  },
  {
    "name": "data_array",
    "tags": ["array", "brackets", "code", "coder", "data", "parentheses"],
    "popularity": 1707
  },
  {
    "name": "electrical_services",
    "tags": ["charge", "cord", "electric", "electrical", "plug", "power", "services", "wire"],
    "popularity": 1707
  },
  {
    "name": "notifications_off",
    "tags": [
      "active",
      "alarm",
      "alert",
      "bell",
      "chime",
      "disabled",
      "enabled",
      "notifications",
      "notify",
      "off",
      "offline",
      "on",
      "reminder",
      "ring",
      "slash",
      "sound"
    ],
    "popularity": 1703
  },
  {
    "name": "content_cut",
    "tags": ["content", "copy", "cut", "doc", "document", "file", "paste", "scissors", "trim"],
    "popularity": 1702
  },
  {
    "name": "two_wheeler",
    "tags": [
      "automobile",
      "bike",
      "car",
      "cars",
      "direction",
      "maps",
      "motorcycle",
      "public",
      "scooter",
      "sport",
      "transportation",
      "travel",
      "two wheeler",
      "vehicle"
    ],
    "popularity": 1698
  },
  {
    "name": "view_cozy",
    "tags": ["comfy", "cozy", "design", "format", "layout", "view", "web"],
    "popularity": 1697
  },
  {
    "name": "label_important",
    "tags": [
      "favorite",
      "important",
      "indent",
      "label",
      "library",
      "mail",
      "remember",
      "save",
      "stamp",
      "sticker",
      "tag",
      "wing"
    ],
    "popularity": 1695
  },
  {
    "name": "north",
    "tags": ["arrow", "directional", "maps", "navigation", "north", "up"],
    "popularity": 1692
  },
  {
    "name": "call_end",
    "tags": ["call", "cell", "contact", "device", "end", "hardware", "mobile", "phone", "telephone"],
    "popularity": 1691
  },
  {
    "name": "topic",
    "tags": ["data", "doc", "document", "drive", "file", "folder", "sheet", "slide", "storage", "topic"],
    "popularity": 1686
  },
  {
    "name": "electric_rickshaw",
    "tags": [
      "automobile",
      "car",
      "cars",
      "electric",
      "india",
      "maps",
      "rickshaw",
      "transportation",
      "truck",
      "vehicle"
    ],
    "popularity": 1685
  },
  {
    "name": "notes",
    "tags": ["comment", "doc", "document", "note", "notes", "text", "write", "writing"],
    "popularity": 1685
  },
  {
    "name": "perm_contact_calendar",
    "tags": [
      "account",
      "calendar",
      "contact",
      "date",
      "face",
      "human",
      "information",
      "people",
      "perm",
      "person",
      "profile",
      "schedule",
      "time",
      "user"
    ],
    "popularity": 1684
  },
  {
    "name": "flag_circle",
    "tags": ["circle", "country", "flag", "goal", "mark", "nation", "report", "round", "start"],
    "popularity": 1681
  },
  {
    "name": "swipe_right",
    "tags": [
      "accept",
      "arrows",
      "direction",
      "finger",
      "hands",
      "hit",
      "navigation",
      "right",
      "strike",
      "swing",
      "swpie",
      "take"
    ],
    "popularity": 1681
  },
  {
    "name": "data_object",
    "tags": ["brackets", "code", "coder", "data", "object", "parentheses"],
    "popularity": 1679
  },
  {
    "name": "do_not_disturb_on_total_silence",
    "tags": ["busy", "disturb", "do", "mute", "no", "not", "on total", "quiet", "silence"],
    "popularity": 1678
  },
  {
    "name": "no_encryption_gmailerrorred",
    "tags": ["disabled", "enabled", "encryption", "error", "gmail", "lock", "locked", "no", "off", "on", "slash"],
    "popularity": 1678
  },
  {
    "name": "cut",
    "tags": ["content", "copy", "cut", "doc", "document", "file", "past", "scissors", "trim"],
    "popularity": 1675
  },
  {
    "name": "join_right",
    "tags": ["circle", "command", "join", "matching", "overlap", "right", "sql", "values"],
    "popularity": 1674
  },
  {
    "name": "filter_b_and_w",
    "tags": [
      "and",
      "b",
      "black",
      "contrast",
      "edit",
      "editing",
      "effect",
      "filter",
      "grayscale",
      "image",
      "images",
      "photography",
      "picture",
      "pictures",
      "settings",
      "w",
      "white"
    ],
    "popularity": 1670
  },
  {
    "name": "wifi_calling",
    "tags": [
      "call",
      "calling",
      "cell",
      "connect",
      "connection",
      "connectivity",
      "contact",
      "device",
      "hardware",
      "mobile",
      "phone",
      "signal",
      "telephone",
      "wifi",
      "wireless"
    ],
    "popularity": 1668
  },
  {
    "name": "blur_linear",
    "tags": ["blur", "dots", "edit", "editing", "effect", "enhance", "filter", "linear"],
    "popularity": 1667
  },
  {
    "name": "sports_score",
    "tags": ["destination", "flag", "goal", "score", "sports"],
    "popularity": 1664
  },
  {
    "name": "agriculture",
    "tags": [
      "agriculture",
      "automobile",
      "car",
      "cars",
      "cultivation",
      "farm",
      "harvest",
      "maps",
      "tractor",
      "transport",
      "travel",
      "truck",
      "vehicle"
    ],
    "popularity": 1663
  },
  {
    "name": "mode_fan",
    "tags": ["air conditioner", "cool", "fan", "nest"],
    "popularity": 1661
  },
  {
    "name": "rtt",
    "tags": ["call", "real", "rrt", "text", "time"],
    "popularity": 1661
  },
  {
    "name": "emoji_flags",
    "tags": [
      "country",
      "destination",
      "emoji",
      "flags",
      "landmark",
      "location",
      "mark",
      "milepost",
      "milestone",
      "nation",
      "place",
      "pole",
      "save",
      "social",
      "world"
    ],
    "popularity": 1643
  },
  {
    "name": "add_location_alt",
    "tags": [
      "+",
      "add",
      "alt",
      "destination",
      "direction",
      "location",
      "maps",
      "new",
      "pin",
      "place",
      "plus",
      "stop",
      "symbol"
    ],
    "popularity": 1641
  },
  {
    "name": "sensor_occupied",
    "tags": [
      "body",
      "body response",
      "connection",
      "fitbit",
      "human",
      "network",
      "people",
      "person",
      "scan",
      "sensors",
      "signal",
      "smart body scan sensor",
      "wireless"
    ],
    "popularity": 1637
  },
  {
    "name": "crop_3_2",
    "tags": [
      "2",
      "3",
      "adjust",
      "adjustments",
      "area",
      "by",
      "crop",
      "edit",
      "editing",
      "frame",
      "image",
      "images",
      "photo",
      "photos",
      "rectangle",
      "settings",
      "size",
      "square"
    ],
    "popularity": 1635
  },
  {
    "name": "personal_injury",
    "tags": [
      "accident",
      "aid",
      "arm",
      "bandage",
      "body",
      "broke",
      "cast",
      "fracture",
      "health",
      "human",
      "injury",
      "medical",
      "patient",
      "people",
      "person",
      "personal",
      "sling",
      "social"
    ],
    "popularity": 1635
  },
  {
    "name": "airline_stops",
    "tags": [
      "airline",
      "arrow",
      "destination",
      "direction",
      "layover",
      "location",
      "maps",
      "place",
      "stops",
      "transportation",
      "travel",
      "trip"
    ],
    "popularity": 1632
  },
  {
    "name": "turn_right",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "maps",
      "navigation",
      "path",
      "right",
      "route",
      "sign",
      "traffic",
      "turn"
    ],
    "popularity": 1630
  },
  {
    "name": "battery_5_bar",
    "tags": ["5", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 1629
  },
  {
    "name": "airplanemode_inactive",
    "tags": [
      "airplane",
      "airplanemode",
      "airport",
      "disabled",
      "enabled",
      "flight",
      "fly",
      "inactive",
      "maps",
      "mode",
      "off",
      "offline",
      "on",
      "slash",
      "transportation",
      "travel"
    ],
    "popularity": 1628
  },
  {
    "name": "crop_landscape",
    "tags": [
      "adjust",
      "adjustments",
      "area",
      "crop",
      "edit",
      "editing",
      "frame",
      "image",
      "images",
      "landscape",
      "photo",
      "photos",
      "settings",
      "size"
    ],
    "popularity": 1628
  },
  {
    "name": "subject",
    "tags": ["alignment", "doc", "document", "email", "full", "justify", "list", "note", "subject", "text", "writing"],
    "popularity": 1628
  },
  {
    "name": "contact_emergency",
    "tags": [
      "account",
      "avatar",
      "call",
      "cell",
      "contacts",
      "face",
      "human",
      "info",
      "information",
      "mobile",
      "people",
      "person",
      "phone",
      "profile",
      "user"
    ],
    "popularity": 1627
  },
  {
    "name": "laptop_windows",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "device",
      "display",
      "hardware",
      "iOS",
      "laptop",
      "mac",
      "monitor",
      "screen",
      "web",
      "window",
      "windows"
    ],
    "popularity": 1627
  },
  {
    "name": "history_toggle_off",
    "tags": ["clock", "date", "history", "off", "schedule", "time", "toggle"],
    "popularity": 1626
  },
  {
    "name": "switch_access_shortcut_add",
    "tags": [
      "+",
      "access",
      "add",
      "arrow",
      "arrows",
      "direction",
      "navigation",
      "new",
      "north",
      "plus",
      "shortcut",
      "switch",
      "symbol",
      "up"
    ],
    "popularity": 1626
  },
  {
    "name": "production_quantity_limits",
    "tags": [
      "!",
      "alert",
      "attention",
      "bill",
      "card",
      "cart",
      "cash",
      "caution",
      "coin",
      "commerce",
      "credit",
      "currency",
      "danger",
      "dollars",
      "error",
      "exclamation",
      "important",
      "limits",
      "mark",
      "money",
      "notification",
      "online",
      "pay",
      "payment",
      "production",
      "quantity",
      "shopping",
      "symbol",
      "warning"
    ],
    "popularity": 1623
  },
  {
    "name": "approval",
    "tags": [
      "apply",
      "approval",
      "approvals",
      "approve",
      "certificate",
      "certification",
      "disapproval",
      "drive",
      "file",
      "impression",
      "ink",
      "mark",
      "postage",
      "stamp"
    ],
    "popularity": 1619
  },
  {
    "name": "browse_gallery",
    "tags": ["clock", "collection", "gallery", "library", "stack", "watch"],
    "popularity": 1616
  },
  {
    "name": "functions",
    "tags": [
      "average",
      "calculate",
      "count",
      "custom",
      "doc",
      "edit",
      "editing",
      "editor",
      "functions",
      "math",
      "sheet",
      "spreadsheet",
      "style",
      "sum",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1616
  },
  {
    "name": "bluetooth_audio",
    "tags": ["audio", "bluetooth", "connect", "connection", "device", "music", "signal", "sound", "symbol"],
    "popularity": 1615
  },
  {
    "name": "donut_large",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "donut",
      "graph",
      "infographic",
      "inprogress",
      "large",
      "measure",
      "metrics",
      "pie",
      "statistics",
      "tracking"
    ],
    "popularity": 1615
  },
  {
    "name": "nearby_error",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "important",
      "mark",
      "nearby",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 1615
  },
  {
    "name": "check_small",
    "tags": [
      "approve",
      "check",
      "circle",
      "complete",
      "done",
      "finished",
      "mark",
      "ok",
      "outline",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 1614
  },
  {
    "name": "square_foot",
    "tags": [
      "construction",
      "feet",
      "foot",
      "inches",
      "length",
      "measurement",
      "ruler",
      "school",
      "set",
      "square",
      "tools"
    ],
    "popularity": 1614
  },
  {
    "name": "sports_basketball",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "basketball",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "social",
      "sports"
    ],
    "popularity": 1613
  },
  {
    "name": "portable_wifi_off",
    "tags": [
      "connection",
      "data",
      "disabled",
      "enabled",
      "internet",
      "network",
      "off",
      "offline",
      "on",
      "portable",
      "service",
      "signal",
      "slash",
      "wifi",
      "wireless"
    ],
    "popularity": 1611
  },
  {
    "name": "density_small",
    "tags": ["density", "horizontal", "lines", "rule", "rules", "small"],
    "popularity": 1595
  },
  {
    "name": "electric_meter",
    "tags": [
      "bolt",
      "electric",
      "energy",
      "fast",
      "lightning",
      "measure",
      "meter",
      "nest",
      "thunderbolt",
      "usage",
      "voltage",
      "volts"
    ],
    "popularity": 1595
  },
  {
    "name": "more",
    "tags": [
      "3",
      "archive",
      "bookmark",
      "dots",
      "etc",
      "favorite",
      "indent",
      "label",
      "more",
      "remember",
      "save",
      "stamp",
      "sticker",
      "tab",
      "tag",
      "three"
    ],
    "popularity": 1595
  },
  {
    "name": "1x_mobiledata",
    "tags": [
      "1x",
      "alphabet",
      "cellular",
      "character",
      "digit",
      "font",
      "letter",
      "mobile",
      "mobiledata",
      "network",
      "number",
      "phone",
      "signal",
      "speed",
      "symbol",
      "text",
      "type",
      "wifi"
    ],
    "popularity": 1593
  },
  {
    "name": "css",
    "tags": [
      "alphabet",
      "brackets",
      "character",
      "code",
      "css",
      "develop",
      "developer",
      "engineer",
      "engineering",
      "font",
      "html",
      "letter",
      "platform",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1591
  },
  {
    "name": "cell_tower",
    "tags": ["broadcast", "casting", "cell", "network", "signal", "tower", "transmitting", "wireless"],
    "popularity": 1589
  },
  {
    "name": "swipe",
    "tags": ["arrow", "arrows", "fingers", "gesture", "hand", "hands", "swipe", "touch"],
    "popularity": 1589
  },
  {
    "name": "do_not_step",
    "tags": [
      "boot",
      "disabled",
      "do",
      "enabled",
      "feet",
      "foot",
      "not",
      "off",
      "on",
      "shoe",
      "slash",
      "sneaker",
      "step",
      "steps"
    ],
    "popularity": 1587
  },
  {
    "name": "masks",
    "tags": [
      "air",
      "cover",
      "covid",
      "face",
      "hospital",
      "masks",
      "medical",
      "pollution",
      "protection",
      "respirator",
      "sick",
      "social"
    ],
    "popularity": 1587
  },
  {
    "name": "assistant_direction",
    "tags": [
      "assistant",
      "destination",
      "direction",
      "location",
      "maps",
      "navigate",
      "navigation",
      "pin",
      "place",
      "right",
      "stop"
    ],
    "popularity": 1586
  },
  {
    "name": "directions_railway",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "directions",
      "maps",
      "public",
      "railway",
      "train",
      "transportation",
      "vehicle"
    ],
    "popularity": 1586
  },
  {
    "name": "crop_free",
    "tags": [
      "adjust",
      "adjustments",
      "crop",
      "edit",
      "editing",
      "focus",
      "frame",
      "free",
      "image",
      "photo",
      "photos",
      "settings",
      "size",
      "zoom"
    ],
    "popularity": 1585
  },
  {
    "name": "pentagon",
    "tags": ["five sides", "pentagon", "shape"],
    "popularity": 1584
  },
  {
    "name": "adjust",
    "tags": ["adjust", "alter", "center", "circle", "circles", "dot", "fix", "image", "move", "target"],
    "popularity": 1583
  },
  {
    "name": "format_italic",
    "tags": [
      "alphabet",
      "character",
      "doc",
      "edit",
      "editing",
      "editor",
      "font",
      "format",
      "italic",
      "letter",
      "sheet",
      "spreadsheet",
      "style",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1583
  },
  {
    "name": "security_update_warning",
    "tags": [
      "!",
      "Android",
      "OS",
      "alert",
      "attention",
      "caution",
      "danger",
      "device",
      "download",
      "error",
      "exclamation",
      "hardware",
      "iOS",
      "important",
      "mark",
      "mobile",
      "notification",
      "phone",
      "security",
      "symbol",
      "tablet",
      "update",
      "warning"
    ],
    "popularity": 1580
  },
  {
    "name": "content_paste_search",
    "tags": ["clipboard", "content", "doc", "document", "file", "find", "paste", "search", "trace", "track"],
    "popularity": 1579
  },
  {
    "name": "sync_lock",
    "tags": [
      "around",
      "arrow",
      "arrows",
      "lock",
      "locked",
      "password",
      "privacy",
      "private",
      "protection",
      "renew",
      "rotate",
      "safety",
      "secure",
      "security",
      "sync",
      "turn"
    ],
    "popularity": 1579
  },
  {
    "name": "wrap_text",
    "tags": [
      "arrow writing",
      "doc",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "wrap",
      "write",
      "writing"
    ],
    "popularity": 1575
  },
  {
    "name": "deselect",
    "tags": ["all", "disabled", "enabled", "off", "on", "selection", "slash", "square", "tool"],
    "popularity": 1574
  },
  {
    "name": "sd_card_alert",
    "tags": [
      "!",
      "alert",
      "attention",
      "camera",
      "card",
      "caution",
      "danger",
      "digital",
      "error",
      "exclamation",
      "important",
      "mark",
      "memory",
      "notification",
      "photos",
      "sd",
      "secure",
      "storage",
      "symbol",
      "warning"
    ],
    "popularity": 1574
  },
  {
    "name": "casino",
    "tags": ["casino", "dice", "dots", "entertainment", "gamble", "gambling", "game", "games", "luck", "places"],
    "popularity": 1573
  },
  {
    "name": "style",
    "tags": ["booklet", "cards", "filters", "options", "style", "tags"],
    "popularity": 1573
  },
  {
    "name": "fast_rewind",
    "tags": ["back", "control", "fast", "media", "music", "play", "rewind", "speed", "time", "tv", "video"],
    "popularity": 1571
  },
  {
    "name": "no_meeting_room",
    "tags": [
      "building",
      "disabled",
      "door",
      "doorway",
      "enabled",
      "entrance",
      "home",
      "house",
      "interior",
      "meeting",
      "no",
      "off",
      "office",
      "on",
      "open",
      "places",
      "room",
      "slash"
    ],
    "popularity": 1570
  },
  {
    "name": "scoreboard",
    "tags": ["board", "points", "score", "scoreboard", "sports"],
    "popularity": 1570
  },
  {
    "name": "local_taxi",
    "tags": [
      "automobile",
      "cab",
      "call",
      "car",
      "cars",
      "direction",
      "local",
      "lyft",
      "maps",
      "public",
      "taxi",
      "transportation",
      "uber",
      "vehicle",
      "yellow"
    ],
    "popularity": 1566
  },
  {
    "name": "airplane_ticket",
    "tags": ["airplane", "airport", "boarding", "flight", "fly", "maps", "pass", "ticket", "transportation", "travel"],
    "popularity": 1563
  },
  {
    "name": "format_color_fill",
    "tags": [
      "bucket",
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "fill",
      "format",
      "paint",
      "sheet",
      "spreadsheet",
      "style",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1561
  },
  {
    "name": "router",
    "tags": ["box", "cable", "connection", "hardware", "internet", "network", "router", "signal", "wifi"],
    "popularity": 1559
  },
  {
    "name": "switch_camera",
    "tags": ["arrow", "arrows", "camera", "photo", "photography", "picture", "switch"],
    "popularity": 1559
  },
  {
    "name": "folder_shared",
    "tags": [
      "account",
      "collaboration",
      "data",
      "doc",
      "document",
      "drive",
      "face",
      "file",
      "folder",
      "human",
      "people",
      "person",
      "profile",
      "share",
      "shared",
      "sheet",
      "slide",
      "storage",
      "team",
      "user"
    ],
    "popularity": 1558
  },
  {
    "name": "align_vertical_top",
    "tags": [
      "align",
      "alignment",
      "format",
      "layout",
      "lines",
      "paragraph",
      "rule",
      "rules",
      "style",
      "text",
      "top",
      "vertical"
    ],
    "popularity": 1556
  },
  {
    "name": "swipe_right_alt",
    "tags": [
      "accept",
      "alt",
      "arrows",
      "direction",
      "finger",
      "hands",
      "hit",
      "navigation",
      "right",
      "strike",
      "swing",
      "swpie",
      "take"
    ],
    "popularity": 1556
  },
  {
    "name": "border_clear",
    "tags": [
      "border",
      "clear",
      "doc",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1555
  },
  {
    "name": "text_rotate_up",
    "tags": [
      "A",
      "alphabet",
      "arrow",
      "character",
      "field",
      "font",
      "letter",
      "move",
      "rotate",
      "symbol",
      "text",
      "type",
      "up"
    ],
    "popularity": 1554
  },
  {
    "name": "no_meals",
    "tags": [
      "dining",
      "disabled",
      "eat",
      "enabled",
      "food",
      "fork",
      "knife",
      "meal",
      "meals",
      "no",
      "off",
      "on",
      "restaurant",
      "slash",
      "spoon",
      "utensils"
    ],
    "popularity": 1553
  },
  {
    "name": "align_vertical_center",
    "tags": [
      "align",
      "alignment",
      "center",
      "format",
      "layout",
      "lines",
      "paragraph",
      "rule",
      "rules",
      "style",
      "text",
      "vertical"
    ],
    "popularity": 1552
  },
  {
    "name": "developer_board",
    "tags": ["board", "chip", "computer", "developer", "development", "hardware", "microchip", "processor"],
    "popularity": 1552
  },
  {
    "name": "signal_wifi_4_bar",
    "tags": [
      "4",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 1552
  },
  {
    "name": "battery_2_bar",
    "tags": ["2", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 1551
  },
  {
    "name": "aspect_ratio",
    "tags": ["aspect", "expand", "image", "ratio", "resize", "scale", "size", "square"],
    "popularity": 1550
  },
  {
    "name": "subscript",
    "tags": [
      "2",
      "doc",
      "edit",
      "editing",
      "editor",
      "gmail",
      "novitas",
      "sheet",
      "spreadsheet",
      "style",
      "subscript",
      "symbol",
      "text",
      "writing",
      "x"
    ],
    "popularity": 1545
  },
  {
    "name": "repeat_one_on",
    "tags": [
      "arrow",
      "arrows",
      "control",
      "controls",
      "digit",
      "media",
      "music",
      "number",
      "on",
      "one",
      "repeat",
      "symbol",
      "video"
    ],
    "popularity": 1544
  },
  {
    "name": "switch_video",
    "tags": ["arrow", "arrows", "camera", "photography", "switch", "video", "videos"],
    "popularity": 1544
  },
  {
    "name": "hive",
    "tags": ["bee", "honey", "honeycomb"],
    "popularity": 1543
  },
  {
    "name": "mop",
    "tags": ["clean", "mop", "nest", "polish", "sweeper", "wash", "wipe"],
    "popularity": 1542
  },
  {
    "name": "font_download_off",
    "tags": [
      "alphabet",
      "character",
      "disabled",
      "download",
      "enabled",
      "font",
      "letter",
      "off",
      "on",
      "slash",
      "square",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1539
  },
  {
    "name": "directions",
    "tags": ["arrow", "directions", "maps", "right", "route", "sign", "traffic"],
    "popularity": 1534
  },
  {
    "name": "sim_card_alert",
    "tags": [
      "!",
      "alert",
      "attention",
      "camera",
      "card",
      "caution",
      "danger",
      "digital",
      "error",
      "exclamation",
      "important",
      "mark",
      "memory",
      "notification",
      "photos",
      "sd",
      "secure",
      "storage",
      "symbol",
      "warning"
    ],
    "popularity": 1534
  },
  {
    "name": "kitchen",
    "tags": [
      "appliance",
      "cold",
      "food",
      "fridge",
      "home",
      "house",
      "ice",
      "kitchen",
      "places",
      "refrigerator",
      "storage"
    ],
    "popularity": 1533
  },
  {
    "name": "heat_pump",
    "tags": ["air conditioner", "cool", "energy", "furnance", "heat", "nest", "pump", "usage"],
    "popularity": 1528
  },
  {
    "name": "heart_broken",
    "tags": ["break", "broken", "core", "crush", "health", "heart", "nucleus", "split"],
    "popularity": 1525
  },
  {
    "name": "plagiarism",
    "tags": ["doc", "document", "find", "glass", "look", "magnifying", "page", "paper", "plagiarism", "search", "see"],
    "popularity": 1525
  },
  {
    "name": "youtube_searched_for",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "find",
      "glass",
      "history",
      "inprogress",
      "load",
      "loading",
      "look",
      "magnify",
      "magnifying",
      "refresh",
      "renew",
      "restore",
      "reverse",
      "rotate",
      "search",
      "see",
      "youtube"
    ],
    "popularity": 1523
  },
  {
    "name": "move_up",
    "tags": ["arrow", "direction", "jump", "move", "navigation", "transfer", "up"],
    "popularity": 1522
  },
  {
    "name": "signal_cellular_connected_no_internet_0_bar",
    "tags": [
      "!",
      "0",
      "alert",
      "attention",
      "bar",
      "caution",
      "cell",
      "cellular",
      "connected",
      "danger",
      "data",
      "error",
      "exclamation",
      "important",
      "internet",
      "mark",
      "mobile",
      "network",
      "no",
      "notification",
      "phone",
      "signal",
      "symbol",
      "warning",
      "wifi",
      "wireless"
    ],
    "popularity": 1522
  },
  {
    "name": "file_download_done",
    "tags": [
      "arrow",
      "arrows",
      "check",
      "done",
      "down",
      "download",
      "downloads",
      "drive",
      "file",
      "install",
      "installed",
      "tick",
      "upload"
    ],
    "popularity": 1521
  },
  {
    "name": "sailing",
    "tags": [
      "boat",
      "entertainment",
      "fishing",
      "hobby",
      "ocean",
      "sailboat",
      "sailing",
      "sea",
      "social sports",
      "travel",
      "water"
    ],
    "popularity": 1520
  },
  {
    "name": "queue_music",
    "tags": ["collection", "list", "music", "playlist", "queue"],
    "popularity": 1519
  },
  {
    "name": "sound_detection_dog_barking",
    "tags": ["animal", "barking", "detection", "dog", "hound", "loyalty", "pet", "protection", "security", "sound"],
    "popularity": 1519
  },
  {
    "name": "sentiment_extremely_dissatisfied",
    "tags": [
      "angry",
      "dissatisfied",
      "emotions",
      "expressions",
      "extremely",
      "face",
      "feelings",
      "furious",
      "mad",
      "mood",
      "person",
      "sentiment",
      "survey",
      "unhappy",
      "upset"
    ],
    "popularity": 1517
  },
  {
    "name": "component_exchange",
    "tags": [],
    "popularity": 1515
  },
  {
    "name": "text_rotation_angleup",
    "tags": [
      "A",
      "alphabet",
      "angleup",
      "arrow",
      "character",
      "field",
      "font",
      "letter",
      "move",
      "rotate",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1515
  },
  {
    "name": "brightness_6",
    "tags": ["6", "brightness", "circle", "control", "crescent", "level", "moon", "screen", "sun"],
    "popularity": 1513
  },
  {
    "name": "text_rotation_down",
    "tags": [
      "A",
      "alphabet",
      "arrow",
      "character",
      "dow",
      "field",
      "font",
      "letter",
      "move",
      "rotate",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1510
  },
  {
    "name": "gpp_maybe",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "certified",
      "danger",
      "error",
      "exclamation",
      "gpp",
      "important",
      "mark",
      "maybe",
      "notification",
      "privacy",
      "private",
      "protect",
      "protection",
      "security",
      "shield",
      "sim",
      "symbol",
      "verified",
      "warning"
    ],
    "popularity": 1509
  },
  {
    "name": "railway_alert",
    "tags": [
      "!",
      "alert",
      "attention",
      "automobile",
      "bike",
      "car",
      "cars",
      "caution",
      "danger",
      "direction",
      "error",
      "exclamation",
      "important",
      "maps",
      "mark",
      "notification",
      "public",
      "railway",
      "scooter",
      "subway",
      "symbol",
      "train",
      "transportation",
      "vehicle",
      "vespa",
      "warning"
    ],
    "popularity": 1509
  },
  {
    "name": "horizontal_rule",
    "tags": ["gmail", "horizontal", "line", "novitas", "rule"],
    "popularity": 1508
  },
  {
    "name": "escalator",
    "tags": ["down", "escalator", "staircase", "up"],
    "popularity": 1500
  },
  {
    "name": "fork_right",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "fork",
      "maps",
      "navigation",
      "path",
      "right",
      "route",
      "sign",
      "traffic"
    ],
    "popularity": 1500
  },
  {
    "name": "mark_chat_unread",
    "tags": [
      "bubble",
      "chat",
      "circle",
      "comment",
      "communicate",
      "mark",
      "message",
      "notification",
      "speech",
      "unread"
    ],
    "popularity": 1497
  },
  {
    "name": "waves",
    "tags": ["beach", "lake", "ocean", "pool", "river", "sea", "swim", "water", "wave", "waves"],
    "popularity": 1496
  },
  {
    "name": "person_2",
    "tags": ["account", "face", "human", "people", "person", "profile", "user"],
    "popularity": 1493
  },
  {
    "name": "electric_moped",
    "tags": [
      "automobile",
      "bike",
      "car",
      "cars",
      "electric",
      "maps",
      "moped",
      "scooter",
      "transportation",
      "travel",
      "vehicle",
      "vespa"
    ],
    "popularity": 1492
  },
  {
    "name": "clear_day",
    "tags": [
      "clear",
      "climate",
      "home",
      "hot",
      "nest",
      "summer",
      "sun",
      "sunny",
      "temperature",
      "thermostat",
      "warm",
      "weather"
    ],
    "popularity": 1491
  },
  {
    "name": "filter_7",
    "tags": [
      "7",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 1491
  },
  {
    "name": "closed_caption_disabled",
    "tags": [
      "accessible",
      "alphabet",
      "caption",
      "cc",
      "character",
      "closed",
      "decoder",
      "disabled",
      "enabled",
      "font",
      "language",
      "letter",
      "media",
      "movies",
      "off",
      "on",
      "slash",
      "subtitle",
      "subtitles",
      "symbol",
      "text",
      "tv",
      "type"
    ],
    "popularity": 1489
  },
  {
    "name": "shelves",
    "tags": ["box", "factory", "furniture", "home", "manufactory", "shelf", "storage"],
    "popularity": 1489
  },
  {
    "name": "do_not_disturb_off",
    "tags": [
      "cancel",
      "close",
      "denied",
      "deny",
      "disabled",
      "disturb",
      "do",
      "enabled",
      "off",
      "on",
      "remove",
      "silence",
      "slash",
      "stop"
    ],
    "popularity": 1487
  },
  {
    "name": "dry",
    "tags": ["air", "bathroom", "dry", "dryer", "fingers", "gesture", "hand", "wc"],
    "popularity": 1487
  },
  {
    "name": "video_camera_front",
    "tags": [
      "account",
      "camera",
      "face",
      "front",
      "human",
      "image",
      "people",
      "person",
      "photo",
      "photography",
      "picture",
      "profile",
      "user",
      "video"
    ],
    "popularity": 1486
  },
  {
    "name": "room_service",
    "tags": ["alert", "bell", "delivery", "hotel", "notify", "room", "service"],
    "popularity": 1485
  },
  {
    "name": "file_present",
    "tags": [
      "clip",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "note",
      "paper",
      "present",
      "reminder",
      "sheet",
      "slide",
      "storage",
      "writing"
    ],
    "popularity": 1482
  },
  {
    "name": "display_settings",
    "tags": [
      "Android",
      "OS",
      "application",
      "change",
      "chrome",
      "desktop",
      "details",
      "device",
      "display",
      "gear",
      "hardware",
      "iOS",
      "info",
      "information",
      "mac",
      "monitor",
      "options",
      "personal",
      "screen",
      "service",
      "settings",
      "web",
      "window"
    ],
    "popularity": 1479
  },
  {
    "name": "text_rotation_angledown",
    "tags": [
      "A",
      "alphabet",
      "angledown",
      "arrow",
      "character",
      "field",
      "font",
      "letter",
      "move",
      "rotate",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1477
  },
  {
    "name": "keyboard_command_key",
    "tags": ["button", "command key", "control", "keyboard"],
    "popularity": 1476
  },
  {
    "name": "swap_horizontal_circle",
    "tags": ["arrow", "arrows", "back", "circle", "forward", "horizontal", "swap"],
    "popularity": 1474
  },
  {
    "name": "screen_lock_portrait",
    "tags": [
      "Android",
      "OS",
      "device",
      "hardware",
      "iOS",
      "lock",
      "mobile",
      "phone",
      "portrait",
      "rotate",
      "screen",
      "tablet"
    ],
    "popularity": 1472
  },
  {
    "name": "send_time_extension",
    "tags": ["deliver", "dispatch", "envelop", "extension", "mail", "message", "schedule", "send", "time"],
    "popularity": 1472
  },
  {
    "name": "bookmark_added",
    "tags": [
      "added",
      "approve",
      "bookmark",
      "check",
      "complete",
      "done",
      "favorite",
      "mark",
      "ok",
      "remember",
      "save",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 1471
  },
  {
    "name": "event_repeat",
    "tags": [
      "around",
      "calendar",
      "date",
      "day",
      "event",
      "inprogress",
      "load",
      "loading refresh",
      "month",
      "renew",
      "rotate",
      "schedule",
      "turn"
    ],
    "popularity": 1470
  },
  {
    "name": "sports_bar",
    "tags": ["alcohol", "bar", "beer", "drink", "liquor", "pint", "places", "pub", "sports"],
    "popularity": 1469
  },
  {
    "name": "exposure_plus_2",
    "tags": [
      "2",
      "add",
      "brightness",
      "contrast",
      "digit",
      "edit",
      "editing",
      "effect",
      "exposure",
      "image",
      "number",
      "photo",
      "photography",
      "plus",
      "settings",
      "symbol"
    ],
    "popularity": 1468
  },
  {
    "name": "filter_4",
    "tags": [
      "4",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 1466
  },
  {
    "name": "filter_9_plus",
    "tags": [
      "+",
      "9",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "plus",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 1464
  },
  {
    "name": "remove_from_queue",
    "tags": ["desktop", "device", "display", "from", "hardware", "monitor", "queue", "remove", "screen", "steam"],
    "popularity": 1462
  },
  {
    "name": "boy",
    "tags": ["body", "boy", "gender", "human", "male", "man", "people", "person", "social", "symbol"],
    "popularity": 1459
  },
  {
    "name": "folder_copy",
    "tags": [
      "content",
      "copy",
      "cut",
      "data",
      "doc",
      "document",
      "drive",
      "duplicate",
      "file",
      "folder",
      "folders",
      "multiple",
      "paste",
      "sheet",
      "slide",
      "storage"
    ],
    "popularity": 1458
  },
  {
    "name": "fmd_bad",
    "tags": [
      "!",
      "alert",
      "attention",
      "bad",
      "caution",
      "danger",
      "destination",
      "direction",
      "error",
      "exclamation",
      "fmd",
      "important",
      "location",
      "maps",
      "mark",
      "notification",
      "pin",
      "place",
      "symbol",
      "warning"
    ],
    "popularity": 1456
  },
  {
    "name": "scale",
    "tags": ["measure", "monitor", "scale", "weight"],
    "popularity": 1454
  },
  {
    "name": "subtitles",
    "tags": [
      "accessible",
      "caption",
      "cc",
      "character",
      "closed",
      "decoder",
      "language",
      "media",
      "movies",
      "subtitle",
      "subtitles",
      "tv"
    ],
    "popularity": 1452
  },
  {
    "name": "surround_sound",
    "tags": ["circle", "signal", "sound", "speaker", "surround", "system", "volumn", "wireless"],
    "popularity": 1452
  },
  {
    "name": "screenshot_monitor",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "screengrab",
      "screenshot",
      "web",
      "window"
    ],
    "popularity": 1451
  },
  {
    "name": "data_thresholding",
    "tags": ["data", "hidden", "privacy", "thresholding", "thresold"],
    "popularity": 1450
  },
  {
    "name": "tenancy",
    "tags": ["connect", "data", "tenancy"],
    "popularity": 1448
  },
  {
    "name": "whatshot",
    "tags": ["arrow", "circle", "direction", "fire", "frames", "hot", "round", "whatshot"],
    "popularity": 1448
  },
  {
    "name": "airline_seat_individual_suite",
    "tags": [
      "airline",
      "body",
      "business",
      "class",
      "first",
      "human",
      "individual",
      "people",
      "person",
      "rest",
      "seat",
      "sleep",
      "suite",
      "travel"
    ],
    "popularity": 1447
  },
  {
    "name": "home_max",
    "tags": ["device", "gadget", "hardware", "home", "internet", "iot", "max", "nest", "smart", "things"],
    "popularity": 1442
  },
  {
    "name": "browse_gallery",
    "tags": ["clock", "collection", "gallery", "library", "stack", "watch"],
    "popularity": 1440
  },
  {
    "name": "schedule_send",
    "tags": ["calendar", "clock", "date", "email", "letter", "mail", "remember", "schedule", "send", "share", "time"],
    "popularity": 1440
  },
  {
    "name": "book_online",
    "tags": [
      "Android",
      "OS",
      "admission",
      "appointment",
      "book",
      "cell",
      "device",
      "event",
      "hardware",
      "iOS",
      "mobile",
      "online",
      "pass",
      "phone",
      "reservation",
      "tablet",
      "ticket"
    ],
    "popularity": 1439
  },
  {
    "name": "phone_paused",
    "tags": ["call", "cell", "contact", "device", "hardware", "mobile", "pause", "paused", "phone", "telephone"],
    "popularity": 1439
  },
  {
    "name": "local_play",
    "tags": [],
    "popularity": 1438
  },
  {
    "name": "cloudy_snowing",
    "tags": ["climate", "cloud", "cold", "snow", "temperature", "weather", "winter"],
    "popularity": 1435
  },
  {
    "name": "theater_comedy",
    "tags": [
      "broadway",
      "comedy",
      "event",
      "movie",
      "musical",
      "places",
      "show",
      "standup",
      "theater",
      "tour",
      "watch"
    ],
    "popularity": 1433
  },
  {
    "name": "volume_down",
    "tags": ["audio", "control", "down", "music", "sound", "speaker", "tv", "volume"],
    "popularity": 1433
  },
  {
    "name": "thermometer",
    "tags": ["celsius", "fahrenheit", "meter", "nest", "temp", "temperature", "thermometer", "thermostat"],
    "popularity": 1432
  },
  {
    "name": "wifi_password",
    "tags": [
      "(scan)",
      "[cellular",
      "connection",
      "data",
      "internet",
      "lock",
      "mobile]",
      "network",
      "password",
      "secure",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 1431
  },
  {
    "name": "install_mobile",
    "tags": ["Android", "OS", "cell", "device", "hardware", "iOS", "install", "mobile", "phone", "pwa", "tablet"],
    "popularity": 1429
  },
  {
    "name": "php",
    "tags": [
      "alphabet",
      "brackets",
      "character",
      "code",
      "css",
      "develop",
      "developer",
      "engineer",
      "engineering",
      "font",
      "html",
      "letter",
      "php",
      "platform",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1428
  },
  {
    "name": "app_shortcut",
    "tags": [
      "app",
      "bookmarked",
      "favorite",
      "highlight",
      "important",
      "marked",
      "mobile",
      "save",
      "saved",
      "shortcut",
      "software",
      "special",
      "star"
    ],
    "popularity": 1426
  },
  {
    "name": "format_list_bulleted_add",
    "tags": [
      "+",
      "add",
      "align",
      "alignment",
      "bulleted",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "list",
      "new",
      "note",
      "notes",
      "plus",
      "quick",
      "sheet",
      "spreadsheet",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1426
  },
  {
    "name": "stroller",
    "tags": [
      "baby",
      "care",
      "carriage",
      "child",
      "children",
      "infant",
      "kid",
      "newborn",
      "stroller",
      "toddler",
      "young"
    ],
    "popularity": 1420
  },
  {
    "name": "play_pause",
    "tags": ["arrow", "control", "controls", "media", "music", "pause", "play", "video"],
    "popularity": 1418
  },
  {
    "name": "styler",
    "tags": ["appliance", "clothes", "fashion", "hairdresser", "hanger", "nest", "organization", "style", "styler"],
    "popularity": 1417
  },
  {
    "name": "photo",
    "tags": ["image", "mountain", "mountains", "photo", "photography", "picture"],
    "popularity": 1415
  },
  {
    "name": "wb_iridescent",
    "tags": [
      "balance",
      "bright",
      "edit",
      "editing",
      "iridescent",
      "light",
      "lighting",
      "setting",
      "settings",
      "white",
      "wp"
    ],
    "popularity": 1412
  },
  {
    "name": "system_security_update",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "cell",
      "device",
      "down",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "security",
      "system",
      "tablet",
      "update"
    ],
    "popularity": 1411
  },
  {
    "name": "album",
    "tags": [
      "album",
      "artist",
      "audio",
      "bvb",
      "cd",
      "computer",
      "data",
      "disk",
      "file",
      "music",
      "record",
      "sound",
      "storage",
      "track"
    ],
    "popularity": 1410
  },
  {
    "name": "developer_mode",
    "tags": [
      "Android",
      "OS",
      "bracket",
      "cell",
      "code",
      "developer",
      "development",
      "device",
      "engineer",
      "hardware",
      "iOS",
      "mobile",
      "mode",
      "phone",
      "tablet"
    ],
    "popularity": 1409
  },
  {
    "name": "grid_off",
    "tags": ["collage", "disabled", "enabled", "grid", "image", "layout", "off", "on", "slash", "view"],
    "popularity": 1409
  },
  {
    "name": "abc",
    "tags": ["alphabet", "character", "font", "letter", "symbol", "text", "type"],
    "popularity": 1407
  },
  {
    "name": "phishing",
    "tags": ["fish", "fishing", "fraud", "hook", "phishing", "scam"],
    "popularity": 1407
  },
  {
    "name": "system_security_update_warning",
    "tags": [
      "!",
      "Android",
      "OS",
      "alert",
      "attention",
      "caution",
      "cell",
      "danger",
      "device",
      "error",
      "exclamation",
      "hardware",
      "iOS",
      "important",
      "mark",
      "mobile",
      "notification",
      "phone",
      "security",
      "symbol",
      "system",
      "tablet",
      "update",
      "warning"
    ],
    "popularity": 1407
  },
  {
    "name": "cast",
    "tags": [
      "Android",
      "OS",
      "airplay",
      "cast",
      "chrome",
      "connect",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "screencast",
      "streaming",
      "television",
      "tv",
      "web",
      "window",
      "wireless"
    ],
    "popularity": 1404
  },
  {
    "name": "unpublished",
    "tags": [
      "approve",
      "check",
      "circle",
      "complete",
      "disabled",
      "done",
      "enabled",
      "mark",
      "off",
      "ok",
      "on",
      "select",
      "slash",
      "tick",
      "unpublished",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 1402
  },
  {
    "name": "play_disabled",
    "tags": ["control", "controls", "disabled", "enabled", "media", "music", "off", "on", "play", "slash", "video"],
    "popularity": 1400
  },
  {
    "name": "border_style",
    "tags": [
      "border",
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "stroke",
      "style",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1399
  },
  {
    "name": "dataset_linked",
    "tags": [],
    "popularity": 1397
  },
  {
    "name": "open_in_browser",
    "tags": ["arrow", "browser", "in", "open", "site", "up", "web", "website", "window"],
    "popularity": 1396
  },
  {
    "name": "restore_from_trash",
    "tags": [
      "arrow",
      "back",
      "backwards",
      "clock",
      "date",
      "history",
      "refresh",
      "renew",
      "restore",
      "reverse",
      "rotate",
      "schedule",
      "time",
      "turn"
    ],
    "popularity": 1395
  },
  {
    "name": "move_down",
    "tags": ["arrow", "direction", "down", "jump", "move", "navigation", "transfer"],
    "popularity": 1394
  },
  {
    "name": "fax",
    "tags": ["fax", "machine", "office", "phone", "send"],
    "popularity": 1391
  },
  {
    "name": "headphones_battery",
    "tags": [
      "accessory",
      "audio",
      "battery",
      "charging",
      "device",
      "ear",
      "earphone",
      "headphones",
      "headset",
      "listen",
      "music",
      "sound"
    ],
    "popularity": 1391
  },
  {
    "name": "view_comfy_alt",
    "tags": ["alt", "comfy", "cozy", "design", "format", "layout", "view", "web"],
    "popularity": 1388
  },
  {
    "name": "motion_photos_paused",
    "tags": ["animation", "circle", "motion", "pause", "paused", "photos", "video"],
    "popularity": 1387
  },
  {
    "name": "nature_people",
    "tags": [
      "activity",
      "body",
      "forest",
      "human",
      "nature",
      "outdoor",
      "outside",
      "park",
      "people",
      "person",
      "tree",
      "wilderness"
    ],
    "popularity": 1387
  },
  {
    "name": "format_align_left",
    "tags": [
      "align",
      "alignment",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "left",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1386
  },
  {
    "name": "ballot",
    "tags": ["ballot", "bullet", "election", "list", "point", "poll", "vote"],
    "popularity": 1385
  },
  {
    "name": "monochrome_photos",
    "tags": ["black", "camera", "image", "monochrome", "photo", "photography", "photos", "picture", "white"],
    "popularity": 1384
  },
  {
    "name": "text_decrease",
    "tags": [
      "-",
      "alphabet",
      "character",
      "decrease",
      "font",
      "letter",
      "minus",
      "remove",
      "resize",
      "subtract",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1383
  },
  {
    "name": "cloud_off",
    "tags": [
      "app",
      "application",
      "backup",
      "cloud",
      "connection",
      "disabled",
      "drive",
      "enabled",
      "files",
      "folders",
      "internet",
      "network",
      "off",
      "offline",
      "on",
      "sky",
      "slash",
      "storage",
      "upload"
    ],
    "popularity": 1381
  },
  {
    "name": "dataset",
    "tags": [],
    "popularity": 1381
  },
  {
    "name": "gas_meter",
    "tags": ["droplet", "energy", "gas", "measure", "meter", "nest", "usage", "water"],
    "popularity": 1381
  },
  {
    "name": "team_dashboard",
    "tags": ["cards", "dashboard", "shapes", "square", "team"],
    "popularity": 1380
  },
  {
    "name": "web_asset_off",
    "tags": [
      "asset",
      "browser",
      "disabled",
      "enabled",
      "internet",
      "off",
      "on",
      "page",
      "screen",
      "slash",
      "web",
      "webpage",
      "website",
      "windows",
      "www"
    ],
    "popularity": 1379
  },
  {
    "name": "format_paint",
    "tags": [
      "brush",
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "fill",
      "format",
      "paint",
      "roller",
      "sheet",
      "spreadsheet",
      "style",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1378
  },
  {
    "name": "notification_add",
    "tags": [
      "+",
      "active",
      "add",
      "alarm",
      "alert",
      "bell",
      "chime",
      "notification",
      "notifications",
      "notify",
      "plus",
      "reminder",
      "ring",
      "sound",
      "symbol"
    ],
    "popularity": 1378
  },
  {
    "name": "face_2",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 1377
  },
  {
    "name": "folder_off",
    "tags": [
      "data",
      "disabled",
      "doc",
      "document",
      "drive",
      "enabled",
      "file",
      "folder",
      "folders",
      "off",
      "on",
      "online",
      "sheet",
      "slash",
      "slide",
      "storage"
    ],
    "popularity": 1376
  },
  {
    "name": "wifi_tethering_off",
    "tags": [
      "cell",
      "cellular",
      "connection",
      "data",
      "disabled",
      "enabled",
      "internet",
      "mobile",
      "network",
      "off",
      "offline",
      "on",
      "phone",
      "scan",
      "service",
      "signal",
      "slash",
      "speed",
      "tethering",
      "wifi",
      "wireless"
    ],
    "popularity": 1376
  },
  {
    "name": "emoji_food_beverage",
    "tags": ["beverage", "coffee", "cup", "drink", "emoji", "mug", "plate", "set", "tea"],
    "popularity": 1372
  },
  {
    "name": "dialpad",
    "tags": ["buttons", "call", "contact", "device", "dial", "dialpad", "dots", "mobile", "numbers", "pad", "phone"],
    "popularity": 1371
  },
  {
    "name": "data_exploration",
    "tags": [
      "analytics",
      "arrow",
      "chart",
      "data",
      "diagram",
      "exploration",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 1366
  },
  {
    "name": "add_link",
    "tags": ["add", "attach", "clip", "link", "new", "plus", "symbol"],
    "popularity": 1364
  },
  {
    "name": "wind_power",
    "tags": ["eco", "energy", "nest", "power", "wind", "windy"],
    "popularity": 1364
  },
  {
    "name": "filter_vintage",
    "tags": [
      "edit",
      "editing",
      "effect",
      "filter",
      "flower",
      "image",
      "images",
      "photography",
      "picture",
      "pictures",
      "vintage"
    ],
    "popularity": 1360
  },
  {
    "name": "photo_camera_back",
    "tags": [
      "back",
      "camera",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "rear"
    ],
    "popularity": 1360
  },
  {
    "name": "mail_lock",
    "tags": [
      "email",
      "envelop",
      "letter",
      "lock",
      "locked",
      "mail",
      "message",
      "password",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "send"
    ],
    "popularity": 1359
  },
  {
    "name": "emoji_transportation",
    "tags": [
      "architecture",
      "automobile",
      "building",
      "car",
      "cars",
      "direction",
      "emoji",
      "estate",
      "maps",
      "place",
      "public",
      "real",
      "residence",
      "residential",
      "shelter",
      "transportation",
      "travel",
      "vehicle"
    ],
    "popularity": 1357
  },
  {
    "name": "stay_current_landscape",
    "tags": ["Android", "OS", "current", "device", "hardware", "iOS", "landscape", "mobile", "phone", "stay", "tablet"],
    "popularity": 1352
  },
  {
    "name": "theaters",
    "tags": ["film", "movie", "movies", "show", "showtimes", "theater", "theaters", "watch"],
    "popularity": 1352
  },
  {
    "name": "view_column",
    "tags": ["column", "design", "format", "grid", "layout", "vertical", "view", "website"],
    "popularity": 1352
  },
  {
    "name": "assistant_navigation",
    "tags": [
      "assistant",
      "destination",
      "direction",
      "location",
      "maps",
      "navigation",
      "pin",
      "place",
      "stop",
      "straight",
      "up"
    ],
    "popularity": 1351
  },
  {
    "name": "image_search",
    "tags": [
      "find",
      "glass",
      "image",
      "landscape",
      "look",
      "magnify",
      "magnifying",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "search",
      "see"
    ],
    "popularity": 1350
  },
  {
    "name": "offline_bolt",
    "tags": ["bolt", "circle", "electric", "fast", "lightning", "offline", "thunderbolt"],
    "popularity": 1350
  },
  {
    "name": "call_made",
    "tags": ["arrow", "call", "device", "made", "mobile"],
    "popularity": 1347
  },
  {
    "name": "filter_5",
    "tags": [
      "5",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 1344
  },
  {
    "name": "edgesensor_high",
    "tags": [
      "Android",
      "OS",
      "cell",
      "device",
      "edge",
      "hardware",
      "high",
      "iOS",
      "mobile",
      "move",
      "phone",
      "sensitivity",
      "sensor",
      "tablet",
      "vibrate"
    ],
    "popularity": 1343
  },
  {
    "name": "read_more",
    "tags": ["arrow", "more", "read", "text"],
    "popularity": 1338
  },
  {
    "name": "sip",
    "tags": [
      "alphabet",
      "call",
      "character",
      "dialer",
      "font",
      "initiation",
      "internet",
      "letter",
      "over",
      "phone",
      "protocol",
      "routing",
      "session",
      "sip",
      "symbol",
      "text",
      "type",
      "voice"
    ],
    "popularity": 1338
  },
  {
    "name": "power_input",
    "tags": ["input", "lines", "power", "supply"],
    "popularity": 1335
  },
  {
    "name": "radio",
    "tags": [
      "antenna",
      "audio",
      "device",
      "frequency",
      "hardware",
      "listen",
      "media",
      "music",
      "player",
      "radio",
      "signal",
      "tune"
    ],
    "popularity": 1334
  },
  {
    "name": "difference",
    "tags": [
      "compare",
      "content",
      "copy",
      "cut",
      "diff",
      "difference",
      "doc",
      "document",
      "duplicate",
      "file",
      "multiple",
      "past"
    ],
    "popularity": 1332
  },
  {
    "name": "smart_screen",
    "tags": [
      "Android",
      "OS",
      "airplay",
      "cast",
      "cell",
      "connect",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "screen",
      "screencast",
      "smart",
      "stream",
      "tablet",
      "video"
    ],
    "popularity": 1328
  },
  {
    "name": "elderly",
    "tags": ["body", "cane", "elderly", "human", "old", "people", "person", "senior"],
    "popularity": 1327
  },
  {
    "name": "dock",
    "tags": [
      "Android",
      "OS",
      "cell",
      "charging",
      "connector",
      "device",
      "dock",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "power",
      "station",
      "tablet"
    ],
    "popularity": 1323
  },
  {
    "name": "local_drink",
    "tags": ["cup", "drink", "drop", "droplet", "liquid", "local", "park", "water"],
    "popularity": 1323
  },
  {
    "name": "discover_tune",
    "tags": ["adjust", "discover", "edit", "editing", "music", "options", "setting", "settings", "tune"],
    "popularity": 1322
  },
  {
    "name": "do_disturb_off",
    "tags": [
      "cancel",
      "close",
      "denied",
      "deny",
      "disabled",
      "disturb",
      "do",
      "enabled",
      "off",
      "on",
      "remove",
      "silence",
      "slash",
      "stop"
    ],
    "popularity": 1322
  },
  {
    "name": "face_4",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 1322
  },
  {
    "name": "nat",
    "tags": ["communication", "nat"],
    "popularity": 1319
  },
  {
    "name": "location_home",
    "tags": [
      "account",
      "architecture",
      "avatar",
      "building",
      "estate",
      "face",
      "home",
      "human",
      "location",
      "people",
      "person",
      "place",
      "profile",
      "real",
      "residence",
      "residential",
      "shelter",
      "user"
    ],
    "popularity": 1317
  },
  {
    "name": "bike_scooter",
    "tags": ["automobile", "bike", "car", "cars", "maps", "scooter", "transportation", "vehicle", "vespa"],
    "popularity": 1316
  },
  {
    "name": "crop",
    "tags": [
      "adjust",
      "adjustments",
      "area",
      "crop",
      "edit",
      "editing",
      "frame",
      "image",
      "images",
      "photo",
      "photos",
      "rectangle",
      "settings",
      "size",
      "square"
    ],
    "popularity": 1315
  },
  {
    "name": "face_6",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 1315
  },
  {
    "name": "no_drinks",
    "tags": ["alcohol", "beverage", "bottle", "cocktail", "drink", "drinks", "food", "liquor", "no", "wine"],
    "popularity": 1315
  },
  {
    "name": "auto_fix_off",
    "tags": [
      "ai",
      "artificial",
      "auto",
      "automatic",
      "automation",
      "custom",
      "disabled",
      "edit",
      "enabled",
      "erase",
      "fix",
      "genai",
      "intelligence",
      "magic",
      "modify",
      "off",
      "on",
      "slash",
      "smart",
      "spark",
      "sparkle",
      "star",
      "wand"
    ],
    "popularity": 1312
  },
  {
    "name": "av_timer",
    "tags": ["av", "clock", "countdown", "duration", "minutes", "seconds", "time", "timer", "watch"],
    "popularity": 1312
  },
  {
    "name": "no_accounts",
    "tags": [
      "account",
      "accounts",
      "avatar",
      "disabled",
      "enabled",
      "face",
      "human",
      "no",
      "off",
      "offline",
      "on",
      "people",
      "person",
      "profile",
      "slash",
      "thumbnail",
      "unavailable",
      "unidentifiable",
      "unknown",
      "user"
    ],
    "popularity": 1311
  },
  {
    "name": "local_pizza",
    "tags": ["drink", "fastfood", "food", "local", "meal", "pizza"],
    "popularity": 1308
  },
  {
    "name": "yard",
    "tags": ["backyard", "flower", "garden", "home", "house", "nature", "pettle", "plants", "yard"],
    "popularity": 1308
  },
  {
    "name": "face_retouching_off",
    "tags": [
      "disabled",
      "edit",
      "editing",
      "effect",
      "emoji",
      "emotion",
      "enabled",
      "face",
      "faces",
      "image",
      "natural",
      "off",
      "on",
      "photo",
      "photography",
      "retouch",
      "retouching",
      "settings",
      "slash",
      "tag"
    ],
    "popularity": 1305
  },
  {
    "name": "not_listed_location",
    "tags": [
      "?",
      "assistance",
      "destination",
      "direction",
      "help",
      "info",
      "information",
      "listed",
      "location",
      "maps",
      "not",
      "pin",
      "place",
      "punctuation",
      "question mark",
      "stop",
      "support",
      "symbol"
    ],
    "popularity": 1303
  },
  {
    "name": "pallet",
    "tags": ["box", "construction", "factory", "manufactory", "storage", "transport"],
    "popularity": 1301
  },
  {
    "name": "phone_locked",
    "tags": [
      "call",
      "cell",
      "contact",
      "device",
      "hardware",
      "lock",
      "locked",
      "mobile",
      "password",
      "phone",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "telephone"
    ],
    "popularity": 1301
  },
  {
    "name": "view_compact_alt",
    "tags": ["alt", "compact", "design", "format", "layout dense", "view", "web"],
    "popularity": 1301
  },
  {
    "name": "network_locked",
    "tags": [
      "alert",
      "available",
      "cellular",
      "connection",
      "data",
      "error",
      "internet",
      "lock",
      "locked",
      "mobile",
      "network",
      "not",
      "privacy",
      "private",
      "protection",
      "restricted",
      "safety",
      "secure",
      "security",
      "service",
      "signal",
      "warning",
      "wifi",
      "wireless"
    ],
    "popularity": 1300
  },
  {
    "name": "local_post_office",
    "tags": [
      "delivery",
      "email",
      "envelop",
      "letter",
      "local",
      "mail",
      "message",
      "office",
      "package",
      "parcel",
      "post",
      "postal",
      "send",
      "stamp"
    ],
    "popularity": 1299
  },
  {
    "name": "exposure_neg_1",
    "tags": [
      "1",
      "brightness",
      "contrast",
      "digit",
      "edit",
      "editing",
      "effect",
      "exposure",
      "image",
      "neg",
      "negative",
      "number",
      "photo",
      "photography",
      "settings",
      "symbol"
    ],
    "popularity": 1297
  },
  {
    "name": "bakery_dining",
    "tags": ["bakery", "bread", "breakfast", "brunch", "croissant", "dining", "food"],
    "popularity": 1296
  },
  {
    "name": "wine_bar",
    "tags": ["alcohol", "bar", "cocktail", "cup", "drink", "glass", "liquor", "wine"],
    "popularity": 1296
  },
  {
    "name": "airline_seat_flat",
    "tags": [
      "airline",
      "body",
      "business",
      "class",
      "first",
      "flat",
      "human",
      "people",
      "person",
      "rest",
      "seat",
      "sleep",
      "travel"
    ],
    "popularity": 1295
  },
  {
    "name": "sports_tennis",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "bat",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "racket",
      "social",
      "sports",
      "tennis"
    ],
    "popularity": 1295
  },
  {
    "name": "rebase_edit",
    "tags": [
      "arrow",
      "arrows",
      "chart",
      "combine",
      "compose",
      "create",
      "direction",
      "draft",
      "edit",
      "editing",
      "input",
      "navigation",
      "path",
      "pen",
      "pencil",
      "process",
      "workflow",
      "write",
      "writing"
    ],
    "popularity": 1294
  },
  {
    "name": "free_cancellation",
    "tags": [
      "approve",
      "calendar",
      "cancel",
      "cancellation",
      "check",
      "complete",
      "date",
      "day",
      "done",
      "event",
      "exit",
      "free",
      "mark",
      "month",
      "no",
      "ok",
      "remove",
      "schedule",
      "select",
      "stop",
      "tick",
      "validate",
      "verified",
      "x",
      "yes"
    ],
    "popularity": 1292
  },
  {
    "name": "enable",
    "tags": ["arrow", "circle", "down", "enable", "pixel", "settings"],
    "popularity": 1290
  },
  {
    "name": "padding",
    "tags": ["design", "layout", "margin", "padding", "size", "square"],
    "popularity": 1290
  },
  {
    "name": "turn_left",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "left",
      "maps",
      "navigation",
      "path",
      "route",
      "sign",
      "traffic",
      "turn"
    ],
    "popularity": 1288
  },
  {
    "name": "sign_language",
    "tags": ["communication", "deaf", "fingers", "gesture", "hand", "language", "sign"],
    "popularity": 1285
  },
  {
    "name": "airlines",
    "tags": ["airlines", "airplane", "airport", "flight", "plane", "transportation", "travel", "trip"],
    "popularity": 1283
  },
  {
    "name": "beenhere",
    "tags": [
      "approve",
      "archive",
      "beenhere",
      "bookmark",
      "check",
      "complete",
      "done",
      "favorite",
      "label",
      "library",
      "mark",
      "ok",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "select",
      "tag",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 1283
  },
  {
    "name": "browser_not_supported",
    "tags": [
      "browser",
      "disabled",
      "enabled",
      "internet",
      "not",
      "off",
      "on",
      "page",
      "screen",
      "site",
      "slash",
      "supported",
      "web",
      "website",
      "www"
    ],
    "popularity": 1283
  },
  {
    "name": "border_outer",
    "tags": [
      "border",
      "doc",
      "edit",
      "editing",
      "editor",
      "outer",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1282
  },
  {
    "name": "satellite_alt",
    "tags": ["alternative", "artificial", "communication", "satellite", "space", "space station", "television"],
    "popularity": 1281
  },
  {
    "name": "view_agenda",
    "tags": ["agenda", "cards", "design", "format", "grid", "layout", "stacked", "view", "website"],
    "popularity": 1281
  },
  {
    "name": "swipe_down_alt",
    "tags": [
      "alt",
      "arrows",
      "direction",
      "disable",
      "down",
      "enable",
      "finger",
      "hands",
      "hit",
      "navigation",
      "strike",
      "swing",
      "swpie",
      "take"
    ],
    "popularity": 1280
  },
  {
    "name": "pest_control_rodent",
    "tags": ["control", "exterminator", "mice", "pest", "rodent"],
    "popularity": 1276
  },
  {
    "name": "cast_for_education",
    "tags": [
      "Android",
      "OS",
      "airplay",
      "cast",
      "chrome",
      "connect",
      "desktop",
      "device",
      "display",
      "education",
      "for",
      "hardware",
      "iOS",
      "learning",
      "lessons teaching",
      "mac",
      "monitor",
      "screen",
      "screencast",
      "streaming",
      "television",
      "tv",
      "web",
      "window",
      "wireless"
    ],
    "popularity": 1275
  },
  {
    "name": "blur_on",
    "tags": [
      "blur",
      "disabled",
      "dots",
      "edit",
      "editing",
      "effect",
      "enabled",
      "enhance",
      "filter",
      "off",
      "on",
      "slash"
    ],
    "popularity": 1274
  },
  {
    "name": "bubble_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "bubble",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 1272
  },
  {
    "name": "install_desktop",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "desktop",
      "device",
      "display",
      "fix",
      "hardware",
      "iOS",
      "install",
      "mac",
      "monitor",
      "place",
      "pwa",
      "screen",
      "web",
      "window"
    ],
    "popularity": 1271
  },
  {
    "name": "network_ping",
    "tags": [
      "alert",
      "available",
      "cellular",
      "connection",
      "data",
      "internet",
      "ip",
      "mobile",
      "network",
      "ping",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 1271
  },
  {
    "name": "bathtub",
    "tags": ["bath", "bathing", "bathroom", "bathtub", "home", "hotel", "human", "person", "shower", "travel", "tub"],
    "popularity": 1269
  },
  {
    "name": "videogame_asset",
    "tags": ["asset", "console", "controller", "device", "game", "gamepad", "gaming", "playstation", "video"],
    "popularity": 1269
  },
  {
    "name": "sd",
    "tags": [
      "alphabet",
      "camera",
      "card",
      "character",
      "data",
      "device",
      "digital",
      "drive",
      "flash",
      "font",
      "image",
      "letter",
      "memory",
      "photo",
      "sd",
      "secure",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1268
  },
  {
    "name": "no_crash",
    "tags": [
      "accident",
      "auto",
      "automobile",
      "car",
      "cars",
      "check",
      "collision",
      "confirm",
      "correct",
      "crash",
      "direction",
      "done",
      "enter",
      "maps",
      "mark",
      "no",
      "ok",
      "okay",
      "select",
      "tick",
      "transportation",
      "vehicle",
      "yes"
    ],
    "popularity": 1267
  },
  {
    "name": "cable",
    "tags": ["cable", "connect", "connection", "device", "electronics", "usb", "wire"],
    "popularity": 1265
  },
  {
    "name": "mark_unread_chat_alt",
    "tags": [
      "bubble",
      "chat",
      "circle",
      "comment",
      "communicate",
      "mark",
      "message",
      "notification",
      "speech",
      "unread"
    ],
    "popularity": 1264
  },
  {
    "name": "near_me_disabled",
    "tags": [
      "destination",
      "direction",
      "disabled",
      "enabled",
      "location",
      "maps",
      "me",
      "navigation",
      "near",
      "off",
      "on",
      "pin",
      "place",
      "point",
      "slash"
    ],
    "popularity": 1263
  },
  {
    "name": "stay_primary_landscape",
    "tags": [
      "Android",
      "OS",
      "current",
      "device",
      "hardware",
      "iOS",
      "landscape",
      "mobile",
      "phone",
      "primary",
      "stay",
      "tablet"
    ],
    "popularity": 1260
  },
  {
    "name": "king_bed",
    "tags": [
      "bed",
      "bedroom",
      "double",
      "furniture",
      "home",
      "hotel",
      "house",
      "king",
      "night",
      "pillows",
      "queen",
      "rest",
      "room",
      "sleep"
    ],
    "popularity": 1259
  },
  {
    "name": "4g_plus_mobiledata",
    "tags": [
      "4g",
      "alphabet",
      "cellular",
      "character",
      "digit",
      "font",
      "letter",
      "mobile",
      "mobiledata",
      "network",
      "number",
      "phone",
      "plus",
      "signal",
      "speed",
      "symbol",
      "text",
      "type",
      "wifi"
    ],
    "popularity": 1255
  },
  {
    "name": "unarchive",
    "tags": ["archive", "arrow", "inbox", "mail", "store", "unarchive", "undo", "up"],
    "popularity": 1255
  },
  {
    "name": "keyboard_command_key",
    "tags": ["button", "command key", "control", "keyboard"],
    "popularity": 1254
  },
  {
    "name": "switch_account",
    "tags": [
      "account",
      "choices",
      "face",
      "human",
      "multiple",
      "options",
      "people",
      "person",
      "profile",
      "social",
      "switch",
      "user"
    ],
    "popularity": 1254
  },
  {
    "name": "donut_small",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "donut",
      "graph",
      "infographic",
      "inprogress",
      "measure",
      "metrics",
      "pie",
      "small",
      "statistics",
      "tracking"
    ],
    "popularity": 1253
  },
  {
    "name": "signpost",
    "tags": ["arrow", "direction", "left", "maps", "right", "signal", "signs", "street", "traffic"],
    "popularity": 1252
  },
  {
    "name": "snowmobile",
    "tags": [
      "automobile",
      "car",
      "direction",
      "skimobile",
      "snow",
      "snowmobile",
      "social",
      "sports",
      "transportation",
      "travel",
      "vehicle",
      "winter"
    ],
    "popularity": 1252
  },
  {
    "name": "center_focus_strong",
    "tags": ["camera", "center", "focus", "image", "lens", "photo", "photography", "strong", "zoom"],
    "popularity": 1251
  },
  {
    "name": "local_convenience_store",
    "tags": [
      "--",
      "24",
      "bill",
      "building",
      "business",
      "card",
      "cash",
      "coin",
      "commerce",
      "company",
      "convenience",
      "credit",
      "currency",
      "dollars",
      "local",
      "maps",
      "market",
      "money",
      "new",
      "online",
      "pay",
      "payment",
      "plus",
      "shop",
      "shopping",
      "store",
      "storefront",
      "symbol"
    ],
    "popularity": 1251
  },
  {
    "name": "format_size",
    "tags": [
      "alphabet",
      "character",
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "fill",
      "font",
      "format",
      "letter",
      "paint",
      "sheet",
      "size",
      "spreadsheet",
      "style",
      "symbol",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1250
  },
  {
    "name": "library_add_check",
    "tags": [
      "add",
      "approve",
      "check",
      "collection",
      "complete",
      "done",
      "layers",
      "library",
      "mark",
      "multiple",
      "music",
      "ok",
      "select",
      "stacked",
      "tick",
      "validate",
      "verified",
      "video",
      "yes"
    ],
    "popularity": 1241
  },
  {
    "name": "roofing",
    "tags": [
      "architecture",
      "building",
      "chimney",
      "construction",
      "estate",
      "home",
      "house",
      "real",
      "residence",
      "residential",
      "roof",
      "roofing",
      "service",
      "shelter"
    ],
    "popularity": 1241
  },
  {
    "name": "running_with_errors",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "danger",
      "duration",
      "error",
      "errors",
      "exclamation",
      "important",
      "mark",
      "notification",
      "process",
      "processing",
      "running",
      "symbol",
      "time",
      "warning",
      "with"
    ],
    "popularity": 1239
  },
  {
    "name": "view_kanban",
    "tags": ["grid", "kanban", "layout", "pattern", "squares", "view"],
    "popularity": 1237
  },
  {
    "name": "vpn_lock",
    "tags": [
      "earth",
      "globe",
      "lock",
      "locked",
      "network",
      "password",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "virtual",
      "vpn",
      "world"
    ],
    "popularity": 1237
  },
  {
    "name": "signal_cellular_nodata",
    "tags": [
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "no",
      "nodata",
      "offline",
      "phone",
      "quit",
      "signal",
      "wifi",
      "wireless",
      "x"
    ],
    "popularity": 1236
  },
  {
    "name": "signal_cellular_off",
    "tags": [
      "cell",
      "cellular",
      "data",
      "disabled",
      "enabled",
      "internet",
      "mobile",
      "network",
      "off",
      "offline",
      "on",
      "phone",
      "signal",
      "slash",
      "wifi",
      "wireless"
    ],
    "popularity": 1234
  },
  {
    "name": "gpp_bad",
    "tags": [
      "bad",
      "cancel",
      "certified",
      "close",
      "error",
      "exit",
      "gpp",
      "no",
      "privacy",
      "private",
      "protect",
      "protection",
      "remove",
      "security",
      "shield",
      "sim",
      "stop",
      "verified",
      "x"
    ],
    "popularity": 1233
  },
  {
    "name": "background_replace",
    "tags": [
      "backdrop",
      "background",
      "camera",
      "filter",
      "human",
      "people",
      "person",
      "replace",
      "user",
      "video",
      "webcam"
    ],
    "popularity": 1232
  },
  {
    "name": "electric_car",
    "tags": ["automobile", "car", "cars", "electric", "electricity", "maps", "transportation", "travel", "vehicle"],
    "popularity": 1232
  },
  {
    "name": "door_open",
    "tags": ["clock", "device", "home", "nest", "open"],
    "popularity": 1230
  },
  {
    "name": "no_sim",
    "tags": ["camera", "card", "device", "eject", "insert", "memory", "no", "phone", "sim", "storage"],
    "popularity": 1229
  },
  {
    "name": "browse_activity",
    "tags": ["activity", "browse", "desktop", "device", "display", "hardware", "history", "monitor", "screen", "star"],
    "popularity": 1225
  },
  {
    "name": "contrast",
    "tags": [
      "black",
      "contrast",
      "edit",
      "editing",
      "effect",
      "filter",
      "grayscale",
      "image",
      "images",
      "photography",
      "picture",
      "pictures",
      "settings",
      "white"
    ],
    "popularity": 1225
  },
  {
    "name": "contactless",
    "tags": [
      "bluetooth",
      "cash",
      "connect",
      "connection",
      "connectivity",
      "contact",
      "contactless",
      "credit",
      "device",
      "finance",
      "pay",
      "payment",
      "signal",
      "transaction",
      "wifi",
      "wireless"
    ],
    "popularity": 1223
  },
  {
    "name": "u_turn_left",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "left",
      "maps",
      "navigation",
      "path",
      "route",
      "sign",
      "traffic",
      "u-turn"
    ],
    "popularity": 1222
  },
  {
    "name": "missed_video_call",
    "tags": [
      "arrow",
      "call",
      "camera",
      "film",
      "filming",
      "hardware",
      "image",
      "missed",
      "motion",
      "picture",
      "record",
      "video",
      "videography"
    ],
    "popularity": 1221
  },
  {
    "name": "signal_wifi_4_bar_lock",
    "tags": [
      "4",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "lock",
      "locked",
      "mobile",
      "network",
      "password",
      "phone",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 1221
  },
  {
    "name": "alt_route",
    "tags": [
      "alt",
      "alternate",
      "alternative",
      "arrows",
      "direction",
      "maps",
      "navigation",
      "options",
      "other",
      "route",
      "routes",
      "split",
      "symbol"
    ],
    "popularity": 1219
  },
  {
    "name": "earbuds_battery",
    "tags": [
      "accessory",
      "audio",
      "battery",
      "charging",
      "earbuds",
      "earphone",
      "headphone",
      "listen",
      "music",
      "sound"
    ],
    "popularity": 1217
  },
  {
    "name": "lte_mobiledata",
    "tags": [
      "alphabet",
      "character",
      "data",
      "font",
      "internet",
      "letter",
      "lte",
      "mobile",
      "network",
      "speed",
      "symbol",
      "text",
      "type",
      "wifi",
      "wireless"
    ],
    "popularity": 1217
  },
  {
    "name": "ramen_dining",
    "tags": [
      "breakfast",
      "dining",
      "dinner",
      "drink",
      "fastfood",
      "food",
      "lunch",
      "meal",
      "noodles",
      "ramen",
      "restaurant"
    ],
    "popularity": 1215
  },
  {
    "name": "data_usage",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking",
      "usage"
    ],
    "popularity": 1214
  },
  {
    "name": "line_axis",
    "tags": ["axis", "dash", "horizontal", "line", "stroke", "vertical"],
    "popularity": 1214
  },
  {
    "name": "format_underlined",
    "tags": [
      "alphabet",
      "character",
      "doc",
      "edit",
      "editing",
      "editor",
      "font",
      "format",
      "letter",
      "line",
      "sheet",
      "spreadsheet",
      "style",
      "symbol",
      "text",
      "type",
      "under",
      "underlined",
      "writing"
    ],
    "popularity": 1213
  },
  {
    "name": "webhook",
    "tags": ["api", "developer", "development", "enterprise", "software", "webhook"],
    "popularity": 1212
  },
  {
    "name": "density_large",
    "tags": ["density", "horizontal", "large", "lines", "rule", "rules"],
    "popularity": 1211
  },
  {
    "name": "add_alarm",
    "tags": [],
    "popularity": 1210
  },
  {
    "name": "reply_all",
    "tags": ["all", "arrow", "backward", "group", "left", "mail", "message", "multiple", "reply", "send", "share"],
    "popularity": 1210
  },
  {
    "name": "energy_savings_leaf",
    "tags": ["eco", "energy", "leaf", "leaves", "nest", "savings", "usage"],
    "popularity": 1208
  },
  {
    "name": "panorama_photosphere",
    "tags": ["angle", "horizontal", "image", "panorama", "photo", "photography", "photosphere", "picture", "wide"],
    "popularity": 1208
  },
  {
    "name": "directions_transit_filled",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "directions",
      "filled",
      "maps",
      "public",
      "rail",
      "subway",
      "train",
      "transit",
      "transportation",
      "vehicle"
    ],
    "popularity": 1205
  },
  {
    "name": "device_hub",
    "tags": [
      "Android",
      "OS",
      "circle",
      "computer",
      "desktop",
      "device",
      "hardware",
      "hub",
      "iOS",
      "laptop",
      "mobile",
      "monitor",
      "phone",
      "square",
      "tablet",
      "triangle",
      "watch",
      "wearable",
      "web"
    ],
    "popularity": 1204
  },
  {
    "name": "money",
    "tags": [
      "100",
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "digit",
      "dollars",
      "finance",
      "money",
      "number",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 1202
  },
  {
    "name": "compare",
    "tags": [
      "adjust",
      "adjustment",
      "compare",
      "edit",
      "editing",
      "edits",
      "enhance",
      "fix",
      "image",
      "images",
      "photo",
      "photography",
      "photos",
      "scan",
      "settings"
    ],
    "popularity": 1200
  },
  {
    "name": "30fps",
    "tags": [
      "30fps",
      "alphabet",
      "camera",
      "character",
      "digit",
      "font",
      "fps",
      "frames",
      "letter",
      "number",
      "symbol",
      "text",
      "type",
      "video"
    ],
    "popularity": 1198
  },
  {
    "name": "tour",
    "tags": ["destination", "flag", "places", "tour", "travel", "visit"],
    "popularity": 1198
  },
  {
    "name": "3p",
    "tags": [
      "3",
      "3p",
      "account",
      "avatar",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "face",
      "human",
      "message",
      "party",
      "people",
      "person",
      "profile",
      "speech",
      "user"
    ],
    "popularity": 1197
  },
  {
    "name": "anchor",
    "tags": ["anchor", "google", "logo"],
    "popularity": 1197
  },
  {
    "name": "location_disabled",
    "tags": [
      "destination",
      "direction",
      "disabled",
      "enabled",
      "location",
      "maps",
      "off",
      "on",
      "pin",
      "place",
      "pointer",
      "slash",
      "stop",
      "tracking"
    ],
    "popularity": 1196
  },
  {
    "name": "vertical_align_top",
    "tags": [
      "align",
      "alignment",
      "arrow",
      "doc",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "text",
      "top",
      "type",
      "up",
      "vertical",
      "writing"
    ],
    "popularity": 1191
  },
  {
    "name": "bluetooth_drive",
    "tags": [
      "automobile",
      "bluetooth",
      "car",
      "cars",
      "cast",
      "connect",
      "connection",
      "device",
      "drive",
      "maps",
      "paring",
      "streaming",
      "symbol",
      "transportation",
      "travel",
      "vehicle",
      "wireless"
    ],
    "popularity": 1190
  },
  {
    "name": "reduce_capacity",
    "tags": ["arrow", "body", "capacity", "covid", "decrease", "down", "human", "people", "person", "reduce", "social"],
    "popularity": 1190
  },
  {
    "name": "key_off",
    "tags": ["disabled", "enabled", "key", "lock", "off", "offline", "on", "password", "slash", "unlock"],
    "popularity": 1187
  },
  {
    "name": "toc",
    "tags": ["content", "format", "lines", "list", "order", "reorder", "stacked", "table", "title", "titles", "toc"],
    "popularity": 1185
  },
  {
    "name": "filter_8",
    "tags": [
      "8",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 1183
  },
  {
    "name": "label_important_outline",
    "tags": [
      "favorite",
      "important",
      "indent",
      "label",
      "library",
      "mail",
      "outline",
      "remember",
      "save",
      "stamp",
      "sticker",
      "tag",
      "wing"
    ],
    "popularity": 1182
  },
  {
    "name": "add_home",
    "tags": [],
    "popularity": 1181
  },
  {
    "name": "no_luggage",
    "tags": [
      "bag",
      "baggage",
      "carry",
      "disabled",
      "enabled",
      "luggage",
      "no",
      "off",
      "on",
      "slash",
      "suitcase",
      "travel"
    ],
    "popularity": 1180
  },
  {
    "name": "leak_remove",
    "tags": [
      "connection",
      "data",
      "disabled",
      "enabled",
      "leak",
      "link",
      "network",
      "off",
      "offline",
      "on",
      "remove",
      "service",
      "signals",
      "slash",
      "synce",
      "wireless"
    ],
    "popularity": 1179
  },
  {
    "name": "3d_rotation",
    "tags": [
      "3",
      "3d",
      "D",
      "alphabet",
      "arrow",
      "arrows",
      "av",
      "camera",
      "character",
      "digit",
      "font",
      "letter",
      "number",
      "rotation",
      "symbol",
      "text",
      "type",
      "vr"
    ],
    "popularity": 1178
  },
  {
    "name": "switch_left",
    "tags": ["arrows", "directional", "left", "navigation", "switch", "toggle"],
    "popularity": 1176
  },
  {
    "name": "straight",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "maps",
      "navigation",
      "path",
      "route",
      "sign",
      "straight",
      "traffic",
      "up"
    ],
    "popularity": 1175
  },
  {
    "name": "on_device_training",
    "tags": [
      "arrow",
      "bulb",
      "call",
      "cell",
      "contact",
      "device",
      "hardware",
      "idea",
      "inprogress",
      "light",
      "load",
      "loading",
      "mobile",
      "model",
      "phone",
      "refresh",
      "renew",
      "restore",
      "reverse",
      "rotate",
      "telephone",
      "training"
    ],
    "popularity": 1172
  },
  {
    "name": "trip_origin",
    "tags": ["circle", "departure", "origin", "trip"],
    "popularity": 1170
  },
  {
    "name": "filter_9",
    "tags": [
      "9",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 1167
  },
  {
    "name": "looks_two",
    "tags": ["2", "digit", "looks", "numbers", "square", "symbol"],
    "popularity": 1166
  },
  {
    "name": "mobile_off",
    "tags": [
      "Android",
      "OS",
      "cell",
      "device",
      "disabled",
      "enabled",
      "hardware",
      "iOS",
      "mobile",
      "off",
      "on",
      "phone",
      "silence",
      "slash",
      "tablet"
    ],
    "popularity": 1165
  },
  {
    "name": "signal_cellular_null",
    "tags": [
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "null",
      "phone",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 1163
  },
  {
    "name": "church",
    "tags": ["christian", "christianity", "ideology", "religion", "spiritual", "worship"],
    "popularity": 1162
  },
  {
    "name": "nightlife",
    "tags": [
      "alcohol",
      "bar",
      "bottle",
      "club",
      "cocktail",
      "dance",
      "drink",
      "food",
      "glass",
      "liquor",
      "music",
      "nightlife",
      "note",
      "wine"
    ],
    "popularity": 1161
  },
  {
    "name": "phonelink_off",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "computer",
      "connect",
      "desktop",
      "device",
      "disabled",
      "enabled",
      "hardware",
      "iOS",
      "link",
      "mac",
      "mobile",
      "off",
      "on",
      "phone",
      "phonelink",
      "slash",
      "sync",
      "tablet",
      "web",
      "windows"
    ],
    "popularity": 1161
  },
  {
    "name": "traffic",
    "tags": ["direction", "light", "maps", "signal", "street", "traffic"],
    "popularity": 1159
  },
  {
    "name": "egg_alt",
    "tags": ["breakfast", "brunch", "egg", "food"],
    "popularity": 1156
  },
  {
    "name": "battery_4_bar",
    "tags": ["4", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 1155
  },
  {
    "name": "media_bluetooth_on",
    "tags": [
      "bluetooth",
      "connect",
      "connection",
      "connectivity",
      "device",
      "disabled",
      "enabled",
      "media",
      "music",
      "note",
      "off",
      "on",
      "online",
      "paring",
      "signal",
      "slash",
      "symbol",
      "wireless"
    ],
    "popularity": 1155
  },
  {
    "name": "10k",
    "tags": [
      "10000",
      "10K",
      "alphabet",
      "character",
      "digit",
      "display",
      "font",
      "letter",
      "number",
      "pixel",
      "pixels",
      "resolution",
      "symbol",
      "text",
      "type",
      "video"
    ],
    "popularity": 1153
  },
  {
    "name": "signal_cellular_4_bar",
    "tags": [
      "4",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "signal",
      "speed",
      "wifi",
      "wireless"
    ],
    "popularity": 1153
  },
  {
    "name": "rotate_left",
    "tags": [
      "around",
      "arrow",
      "direction",
      "inprogress",
      "left",
      "load",
      "loading refresh",
      "renew",
      "rotate",
      "turn"
    ],
    "popularity": 1152
  },
  {
    "name": "home_mini",
    "tags": ["Internet", "device", "gadget", "hardware", "home", "iot", "mini", "nest", "smart", "things"],
    "popularity": 1151
  },
  {
    "name": "stacked_line_chart",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "line",
      "measure",
      "metrics",
      "stacked",
      "statistics",
      "tracking"
    ],
    "popularity": 1149
  },
  {
    "name": "videocam_off",
    "tags": [
      "cam",
      "camera",
      "conference",
      "disabled",
      "enabled",
      "film",
      "filming",
      "hardware",
      "image",
      "motion",
      "off",
      "offline",
      "on",
      "picture",
      "slash",
      "video",
      "videography"
    ],
    "popularity": 1149
  },
  {
    "name": "closed_caption",
    "tags": [
      "accessible",
      "alphabet",
      "caption",
      "cc",
      "character",
      "closed",
      "decoder",
      "font",
      "language",
      "letter",
      "media",
      "movies",
      "subtitle",
      "subtitles",
      "symbol",
      "text",
      "tv",
      "type"
    ],
    "popularity": 1148
  },
  {
    "name": "colorize",
    "tags": ["color", "colorize", "dropper", "extract", "eye", "picker", "tool"],
    "popularity": 1148
  },
  {
    "name": "radar",
    "tags": ["detect", "military", "near", "network", "position", "radar", "scan"],
    "popularity": 1146
  },
  {
    "name": "cancel_presentation",
    "tags": [
      "cancel",
      "close",
      "device",
      "exit",
      "no",
      "present",
      "presentation",
      "quit",
      "remove",
      "screen",
      "slide",
      "stop",
      "website",
      "window",
      "x"
    ],
    "popularity": 1144
  },
  {
    "name": "battery_full_alt",
    "tags": ["0", "bar", "battery", "cell", "charge", "full", "mobile", "power"],
    "popularity": 1142
  },
  {
    "name": "compress",
    "tags": ["arrow", "arrows", "collide", "compress", "pressure", "push", "together"],
    "popularity": 1140
  },
  {
    "name": "flare",
    "tags": [
      "bright",
      "edit",
      "editing",
      "effect",
      "flare",
      "image",
      "images",
      "light",
      "photography",
      "picture",
      "pictures",
      "sun"
    ],
    "popularity": 1140
  },
  {
    "name": "lock_person",
    "tags": [],
    "popularity": 1138
  },
  {
    "name": "video_stable",
    "tags": ["film", "filming", "recording", "setting", "stability", "stable", "taping", "video"],
    "popularity": 1137
  },
  {
    "name": "sick",
    "tags": [
      "covid",
      "discomfort",
      "emotions",
      "expressions",
      "face",
      "feelings",
      "fever",
      "flu",
      "ill",
      "mood",
      "pain",
      "person",
      "sick",
      "survey",
      "upset"
    ],
    "popularity": 1135
  },
  {
    "name": "airplanemode_active",
    "tags": ["active", "airplane", "airplanemode", "flight", "mode", "on", "signal"],
    "popularity": 1133
  },
  {
    "name": "height",
    "tags": [
      "arrow",
      "color",
      "doc",
      "down",
      "edit",
      "editing",
      "editor",
      "fill",
      "format",
      "height",
      "paint",
      "sheet",
      "spreadsheet",
      "style",
      "text",
      "type",
      "up",
      "writing"
    ],
    "popularity": 1133
  },
  {
    "name": "local_laundry_service",
    "tags": ["cleaning", "clothing", "dry", "dryer", "hotel", "laundry", "local", "service", "washer"],
    "popularity": 1130
  },
  {
    "name": "swipe_left_alt",
    "tags": [
      "alt",
      "arrow",
      "arrows",
      "finger",
      "hand",
      "hit",
      "left",
      "navigation",
      "reject",
      "strike",
      "swing",
      "swipe",
      "take"
    ],
    "popularity": 1130
  },
  {
    "name": "disabled_visible",
    "tags": [
      "cancel",
      "close",
      "disabled",
      "exit",
      "eye",
      "no",
      "on",
      "quit",
      "remove",
      "reveal",
      "see",
      "show",
      "stop",
      "view",
      "visibility",
      "visible"
    ],
    "popularity": 1127
  },
  {
    "name": "flight_land",
    "tags": ["airport", "arrival", "arriving", "flight", "fly", "land", "landing", "plane", "transportation", "travel"],
    "popularity": 1125
  },
  {
    "name": "no_transfer",
    "tags": [
      "automobile",
      "bus",
      "car",
      "cars",
      "direction",
      "disabled",
      "enabled",
      "maps",
      "no",
      "off",
      "on",
      "public",
      "slash",
      "transfer",
      "transportation",
      "vehicle"
    ],
    "popularity": 1122
  },
  {
    "name": "stacked_bar_chart",
    "tags": [
      "analytics",
      "bar",
      "chart-chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "stacked",
      "statistics",
      "tracking"
    ],
    "popularity": 1121
  },
  {
    "name": "cloudy_snowing",
    "tags": ["climate", "cloud", "cold", "snow", "temperature", "weather", "winter"],
    "popularity": 1120
  },
  {
    "name": "cyclone",
    "tags": ["crisis", "disaster", "natural", "rain", "storm", "weather", "wind", "winds"],
    "popularity": 1120
  },
  {
    "name": "directions_subway_filled",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "directions",
      "filled",
      "maps",
      "public",
      "rail",
      "subway",
      "train",
      "transportation",
      "vehicle"
    ],
    "popularity": 1119
  },
  {
    "name": "local_dining",
    "tags": ["dining", "eat", "food", "fork", "knife", "local", "meal", "restaurant", "spoon"],
    "popularity": 1118
  },
  {
    "name": "filter_none",
    "tags": ["filter", "multiple", "none", "square", "stack"],
    "popularity": 1117
  },
  {
    "name": "lyrics",
    "tags": [
      "audio",
      "bubble",
      "chat",
      "comment",
      "communicate",
      "feedback",
      "key",
      "lyrics",
      "message",
      "music",
      "note",
      "song",
      "sound",
      "speech",
      "track"
    ],
    "popularity": 1117
  },
  {
    "name": "workspaces_filled",
    "tags": ["circles", "collaboration", "dot", "filled", "group", "space", "team", "work", "workspaces"],
    "popularity": 1117
  },
  {
    "name": "timer_10",
    "tags": ["10", "digits", "duration", "number", "numbers", "seconds", "time", "timer"],
    "popularity": 1116
  },
  {
    "name": "toll",
    "tags": [
      "bill",
      "booth",
      "car",
      "card",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "highway",
      "money",
      "online",
      "pay",
      "payment",
      "ticket",
      "toll"
    ],
    "popularity": 1114
  },
  {
    "name": "network_wifi_1_bar",
    "tags": ["cell", "cellular", "data", "internet", "mobile", "network", "phone", "speed", "wifi", "wireless"],
    "popularity": 1113
  },
  {
    "name": "wb_incandescent",
    "tags": [
      "balance",
      "bright",
      "edit",
      "editing",
      "incandescent",
      "light",
      "lighting",
      "setting",
      "settings",
      "white",
      "wp"
    ],
    "popularity": 1112
  },
  {
    "name": "wb_shade",
    "tags": ["balance", "house", "light", "lighting", "shade", "wb", "white"],
    "popularity": 1108
  },
  {
    "name": "insert_page_break",
    "tags": ["break", "doc", "document", "file", "page", "paper"],
    "popularity": 1107
  },
  {
    "name": "money_off",
    "tags": [
      "bill",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "disabled",
      "dollars",
      "enabled",
      "money",
      "off",
      "on",
      "online",
      "pay",
      "payment",
      "shopping",
      "slash",
      "symbol"
    ],
    "popularity": 1107
  },
  {
    "name": "filter_6",
    "tags": [
      "6",
      "digit",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "images",
      "multiple",
      "number",
      "photography",
      "picture",
      "pictures",
      "settings",
      "stack",
      "symbol"
    ],
    "popularity": 1106
  },
  {
    "name": "new_label",
    "tags": [
      "+",
      "add",
      "archive",
      "bookmark",
      "favorite",
      "label",
      "library",
      "new",
      "plus",
      "read",
      "reading",
      "remember",
      "ribbon",
      "save",
      "symbol",
      "tag"
    ],
    "popularity": 1106
  },
  {
    "name": "nights_stay",
    "tags": [
      "climate",
      "cloud",
      "crescent",
      "dark",
      "lunar",
      "mode",
      "moon",
      "nights",
      "phases",
      "silence",
      "silent",
      "sky",
      "stay",
      "time",
      "weather"
    ],
    "popularity": 1106
  },
  {
    "name": "face_3",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 1103
  },
  {
    "name": "add_home_work",
    "tags": [],
    "popularity": 1102
  },
  {
    "name": "lock_clock",
    "tags": [
      "clock",
      "date",
      "lock",
      "locked",
      "password",
      "privacy",
      "private",
      "protection",
      "safety",
      "schedule",
      "secure",
      "security",
      "time"
    ],
    "popularity": 1100
  },
  {
    "name": "pregnant_woman",
    "tags": [
      "baby",
      "birth",
      "body",
      "female",
      "human",
      "lady",
      "maternity",
      "mom",
      "mother",
      "people",
      "person",
      "pregnant",
      "women"
    ],
    "popularity": 1100
  },
  {
    "name": "wifi_find",
    "tags": [
      "(scan)",
      "[cellular",
      "connection",
      "data",
      "detect",
      "discover",
      "find",
      "internet",
      "look",
      "magnifying glass",
      "mobile]",
      "network",
      "notice",
      "search",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 1100
  },
  {
    "name": "mark_as_unread",
    "tags": ["as", "envelop", "letter", "mail", "mark", "post", "postal", "read", "receive", "send", "unread"],
    "popularity": 1098
  },
  {
    "name": "swipe_down",
    "tags": [
      "arrows",
      "direction",
      "disable",
      "down",
      "enable",
      "finger",
      "hands",
      "hit",
      "navigation",
      "strike",
      "swing",
      "swpie",
      "take"
    ],
    "popularity": 1098
  },
  {
    "name": "directions_railway_filled",
    "tags": [
      "automobile",
      "car",
      "cars",
      "direction",
      "directions",
      "filled",
      "maps",
      "public",
      "railway",
      "train",
      "transportation",
      "vehicle"
    ],
    "popularity": 1093
  },
  {
    "name": "tire_repair",
    "tags": ["auto", "automobile", "car", "cars", "gauge", "mechanic", "pressure", "repair", "tire", "vehicle"],
    "popularity": 1093
  },
  {
    "name": "blur_off",
    "tags": ["blur", "disabled", "dots", "edit", "editing", "effect", "enabled", "enhance", "off", "on", "slash"],
    "popularity": 1092
  },
  {
    "name": "swipe_up_alt",
    "tags": [
      "alt",
      "arrows",
      "direction",
      "disable",
      "enable",
      "finger",
      "hands",
      "hit",
      "navigation",
      "strike",
      "swing",
      "swpie",
      "take",
      "up"
    ],
    "popularity": 1091
  },
  {
    "name": "move_to_inbox",
    "tags": [
      "archive",
      "arrow",
      "down",
      "email",
      "envelop",
      "inbox",
      "incoming",
      "letter",
      "mail",
      "message",
      "move to",
      "send"
    ],
    "popularity": 1090
  },
  {
    "name": "motion_photos_off",
    "tags": ["animation", "circle", "disabled", "enabled", "motion", "off", "on", "photos", "slash", "video"],
    "popularity": 1088
  },
  {
    "name": "holiday_village",
    "tags": [
      "architecture",
      "beach",
      "camping",
      "cottage",
      "estate",
      "holiday",
      "home",
      "house",
      "lake",
      "lodge",
      "maps",
      "place",
      "real",
      "residence",
      "residential",
      "stay",
      "traveling",
      "vacation",
      "village"
    ],
    "popularity": 1087
  },
  {
    "name": "spatial_tracking",
    "tags": [
      "audio",
      "disabled",
      "enabled",
      "music",
      "note",
      "off",
      "offline",
      "on",
      "slash",
      "sound",
      "spatial",
      "tracking"
    ],
    "popularity": 1087
  },
  {
    "name": "swap_vertical_circle",
    "tags": ["arrow", "arrows", "circle", "down", "swap", "up", "vertical"],
    "popularity": 1087
  },
  {
    "name": "flight_class",
    "tags": [
      "airplane",
      "business",
      "class",
      "first",
      "flight",
      "plane",
      "seat",
      "transportation",
      "travel",
      "trip",
      "window"
    ],
    "popularity": 1085
  },
  {
    "name": "raw_on",
    "tags": [
      "alphabet",
      "character",
      "disabled",
      "enabled",
      "font",
      "image",
      "letter",
      "off",
      "on",
      "original",
      "photo",
      "photography",
      "raw",
      "slash",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1085
  },
  {
    "name": "window",
    "tags": ["close", "glass", "grid", "home", "house", "interior", "layout", "outside", "window"],
    "popularity": 1081
  },
  {
    "name": "remove_done",
    "tags": [
      "approve",
      "check",
      "complete",
      "disabled",
      "done",
      "enabled",
      "finished",
      "mark",
      "multiple",
      "off",
      "ok",
      "on",
      "remove",
      "select",
      "slash",
      "tick",
      "yes"
    ],
    "popularity": 1079
  },
  {
    "name": "apps_outage",
    "tags": [
      "all",
      "applications",
      "apps",
      "circles",
      "collection",
      "components",
      "dots",
      "grid",
      "interface",
      "outage",
      "squares",
      "ui",
      "ux"
    ],
    "popularity": 1076
  },
  {
    "name": "valve",
    "tags": ["controller", "faucet", "gas", "lid", "nest", "pipe", "valve", "water"],
    "popularity": 1076
  },
  {
    "name": "vertical_align_bottom",
    "tags": [
      "align",
      "alignment",
      "arrow",
      "bottom",
      "doc",
      "down",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "vertical",
      "writing"
    ],
    "popularity": 1076
  },
  {
    "name": "forklift",
    "tags": ["carry", "factory", "industrial", "lift", "manufactory", "supply", "truck", "vehicle"],
    "popularity": 1075
  },
  {
    "name": "network_wifi_3_bar",
    "tags": ["cell", "cellular", "data", "internet", "mobile", "network", "phone", "speed", "wifi", "wireless"],
    "popularity": 1074
  },
  {
    "name": "cases",
    "tags": ["bag", "baggage", "briefcase", "business", "case", "cases", "purse", "suitcase"],
    "popularity": 1071
  },
  {
    "name": "rsvp",
    "tags": [
      "alphabet",
      "character",
      "font",
      "invitation",
      "invite",
      "letter",
      "pla\u00eet",
      "respond",
      "rsvp",
      "r\u00e9pondez",
      "sil",
      "symbol",
      "text",
      "type",
      "vous"
    ],
    "popularity": 1070
  },
  {
    "name": "filter_list_off",
    "tags": ["alt", "disabled", "edit", "filter", "list", "off", "offline", "options", "refine", "sift", "slash"],
    "popularity": 1069
  },
  {
    "name": "icecream",
    "tags": ["cream", "dessert", "food", "ice", "icecream", "snack"],
    "popularity": 1069
  },
  {
    "name": "bloodtype",
    "tags": [
      "blood",
      "bloodtype",
      "donate",
      "droplet",
      "emergency",
      "hospital",
      "medicine",
      "negative",
      "positive",
      "type",
      "water"
    ],
    "popularity": 1066
  },
  {
    "name": "motion_photos_pause",
    "tags": ["animation", "circle", "motion", "pause", "paused", "photos", "video"],
    "popularity": 1066
  },
  {
    "name": "stream",
    "tags": ["cast", "connected", "feed", "live", "network", "signal", "stream", "wireless"],
    "popularity": 1066
  },
  {
    "name": "cooking",
    "tags": ["cooking", "food", "home", "house", "kitchen", "meals", "nest"],
    "popularity": 1065
  },
  {
    "name": "safety_check",
    "tags": [
      "certified",
      "check",
      "clock",
      "privacy",
      "private",
      "protect",
      "protection",
      "safety",
      "schedule",
      "security",
      "shield",
      "time",
      "verified"
    ],
    "popularity": 1065
  },
  {
    "name": "block_flipped",
    "tags": ["block", "flipped"],
    "popularity": 1064
  },
  {
    "name": "3g_mobiledata",
    "tags": [
      "3g",
      "alphabet",
      "cellular",
      "character",
      "digit",
      "font",
      "letter",
      "mobile",
      "mobiledata",
      "network",
      "number",
      "phone",
      "signal",
      "speed",
      "symbol",
      "text",
      "type",
      "wifi"
    ],
    "popularity": 1063
  },
  {
    "name": "battery_0_bar",
    "tags": ["0", "bar", "battery", "cell", "charge", "full", "mobile", "power"],
    "popularity": 1062
  },
  {
    "name": "screen_search_desktop",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "desktop",
      "device",
      "hardware",
      "iOS",
      "lock",
      "monitor",
      "rotate",
      "screen",
      "web"
    ],
    "popularity": 1062
  },
  {
    "name": "copy_all",
    "tags": ["all", "content", "copy", "cut", "doc", "document", "file", "multiple", "page", "paper", "past"],
    "popularity": 1061
  },
  {
    "name": "tv_off",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "desktop",
      "device",
      "disabled",
      "enabled",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "off",
      "on",
      "slash",
      "television",
      "tv",
      "web",
      "window"
    ],
    "popularity": 1061
  },
  {
    "name": "cameraswitch",
    "tags": ["arrows", "camera", "cameraswitch", "flip", "rotate", "swap", "switch", "view"],
    "popularity": 1060
  },
  {
    "name": "view_week",
    "tags": ["bars", "columns", "design", "format", "grid", "layout", "view", "website", "week"],
    "popularity": 1060
  },
  {
    "name": "group_remove",
    "tags": [
      "accounts",
      "committee",
      "face",
      "family",
      "friends",
      "group",
      "humans",
      "network",
      "people",
      "persons",
      "profiles",
      "remove",
      "social",
      "team",
      "users"
    ],
    "popularity": 1059
  },
  {
    "name": "egg",
    "tags": ["breakfast", "brunch", "egg", "food"],
    "popularity": 1058
  },
  {
    "name": "filter_drama",
    "tags": [
      "cloud",
      "drama",
      "edit",
      "editing",
      "effect",
      "filter",
      "image",
      "photo",
      "photography",
      "picture",
      "sky camera"
    ],
    "popularity": 1058
  },
  {
    "name": "edgesensor_low",
    "tags": [
      "Android",
      "cell",
      "device",
      "edge",
      "hardware",
      "iOS",
      "low",
      "mobile",
      "move",
      "phone",
      "sensitivity",
      "sensor",
      "tablet",
      "vibrate"
    ],
    "popularity": 1057
  },
  {
    "name": "grid_goldenratio",
    "tags": ["golden", "goldenratio", "grid", "layout", "lines", "ratio", "space"],
    "popularity": 1057
  },
  {
    "name": "hdr_on",
    "tags": [
      "add",
      "alphabet",
      "character",
      "dynamic",
      "enhance",
      "font",
      "hdr",
      "high",
      "letter",
      "on",
      "plus",
      "range",
      "select",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 1056
  },
  {
    "name": "accessible_forward",
    "tags": [
      "accessibility",
      "accessible",
      "body",
      "forward",
      "handicap",
      "help",
      "human",
      "people",
      "person",
      "wheelchair"
    ],
    "popularity": 1055
  },
  {
    "name": "sports_gymnastics",
    "tags": ["athlete", "athletic", "entertainment", "exercise", "gymnastics", "hobby", "social", "sports"],
    "popularity": 1055
  },
  {
    "name": "drive_folder_upload",
    "tags": [
      "arrow",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "sheet",
      "slide",
      "storage",
      "up",
      "upload"
    ],
    "popularity": 1053
  },
  {
    "name": "fort",
    "tags": ["castle", "fort", "fortress", "mansion", "palace"],
    "popularity": 1052
  },
  {
    "name": "attach_email",
    "tags": [
      "attach",
      "attachment",
      "clip",
      "compose",
      "email",
      "envelop",
      "letter",
      "link",
      "mail",
      "message",
      "send"
    ],
    "popularity": 1050
  },
  {
    "name": "groups_3",
    "tags": [
      "abstract",
      "body",
      "club",
      "collaboration",
      "crowd",
      "gathering",
      "groups",
      "human",
      "meeting",
      "people",
      "person",
      "social",
      "teams"
    ],
    "popularity": 1050
  },
  {
    "name": "assignment_late",
    "tags": [
      "!",
      "alert",
      "assignment",
      "attention",
      "caution",
      "clipboard",
      "danger",
      "doc",
      "document",
      "error",
      "exclamation",
      "important",
      "late",
      "mark",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 1049
  },
  {
    "name": "auto_delete",
    "tags": ["auto", "bin", "can", "clock", "date", "delete", "garbage", "remove", "schedule", "time", "trash"],
    "popularity": 1048
  },
  {
    "name": "medication_liquid",
    "tags": [
      "+",
      "bottle",
      "doctor",
      "drug",
      "health",
      "hospital",
      "liquid",
      "medications",
      "medicine",
      "pharmacy",
      "spoon",
      "vessel"
    ],
    "popularity": 1048
  },
  {
    "name": "e911_emergency",
    "tags": [],
    "popularity": 1047
  },
  {
    "name": "garage_home",
    "tags": ["car", "garage", "home", "nest", "parking", "storage"],
    "popularity": 1047
  },
  {
    "name": "mobile_friendly",
    "tags": [
      "Android",
      "OS",
      "approve",
      "cell",
      "check",
      "complete",
      "device",
      "done",
      "friendly",
      "hardware",
      "iOS",
      "mark",
      "mobile",
      "ok",
      "phone",
      "select",
      "tablet",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 1046
  },
  {
    "name": "airline_seat_flat_angled",
    "tags": [
      "airline",
      "angled",
      "body",
      "business",
      "class",
      "first",
      "flat",
      "human",
      "people",
      "person",
      "rest",
      "seat",
      "sleep",
      "travel"
    ],
    "popularity": 1044
  },
  {
    "name": "desktop_mac",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "desktop",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "web",
      "window"
    ],
    "popularity": 1044
  },
  {
    "name": "temple_buddhist",
    "tags": ["buddha", "buddhism", "buddhist", "ideology", "monastery", "religion", "spiritual", "temple", "worship"],
    "popularity": 1044
  },
  {
    "name": "propane_tank",
    "tags": ["bbq", "gas", "grill", "nest", "propane", "tank"],
    "popularity": 1043
  },
  {
    "name": "format_color_text",
    "tags": [
      "color",
      "doc",
      "edit",
      "editing",
      "editor",
      "fill",
      "format",
      "paint",
      "sheet",
      "spreadsheet",
      "style",
      "text",
      "type",
      "writing"
    ],
    "popularity": 1042
  },
  {
    "name": "kebab_dining",
    "tags": ["dining", "dinner", "food", "kebab", "meal", "meat", "skewer"],
    "popularity": 1042
  },
  {
    "name": "wallpaper",
    "tags": ["background", "image", "landscape", "photo", "photography", "picture", "wallpaper"],
    "popularity": 1042
  },
  {
    "name": "conveyor_belt",
    "tags": ["factory", "logistic", "logistics", "manufactory", "production", "supply", "system", "transport"],
    "popularity": 1041
  },
  {
    "name": "next_plan",
    "tags": ["arrow", "circle", "next", "plan", "right"],
    "popularity": 1041
  },
  {
    "name": "phonelink_ring",
    "tags": [
      "Android",
      "OS",
      "cell",
      "connection",
      "data",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "network",
      "phone",
      "phonelink",
      "ring",
      "service",
      "signal",
      "tablet",
      "wireless"
    ],
    "popularity": 1041
  },
  {
    "name": "healing",
    "tags": ["bandage", "edit", "editing", "emergency", "fix", "healing", "hospital", "image", "medicine"],
    "popularity": 1040
  },
  {
    "name": "phone_bluetooth_speaker",
    "tags": [
      "bluetooth",
      "call",
      "cell",
      "connect",
      "connection",
      "connectivity",
      "contact",
      "device",
      "hardware",
      "mobile",
      "phone",
      "signal",
      "speaker",
      "symbol",
      "telephone",
      "wireless"
    ],
    "popularity": 1040
  },
  {
    "name": "add_alert",
    "tags": [
      "+",
      "active",
      "add",
      "alarm",
      "alert",
      "bell",
      "chime",
      "new",
      "notifications",
      "notify",
      "plus",
      "reminder",
      "ring",
      "sound",
      "symbol"
    ],
    "popularity": 1039
  },
  {
    "name": "fiber_pin",
    "tags": ["alphabet", "character", "fiber", "font", "letter", "network", "pin", "symbol", "text", "type"],
    "popularity": 1039
  },
  {
    "name": "escalator_warning",
    "tags": ["body", "child", "escalator", "human", "kid", "parent", "people", "person", "warning"],
    "popularity": 1038
  },
  {
    "name": "screen_lock_rotation",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "device",
      "hardware",
      "iOS",
      "lock",
      "mobile",
      "phone",
      "rotate",
      "rotation",
      "screen",
      "tablet",
      "turn"
    ],
    "popularity": 1038
  },
  {
    "name": "unfold_more_double",
    "tags": [
      "arrow",
      "arrows",
      "chevron",
      "collapse",
      "direction",
      "double",
      "down",
      "expand",
      "expandable",
      "list",
      "more",
      "navigation",
      "unfold"
    ],
    "popularity": 1037
  },
  {
    "name": "vignette",
    "tags": ["border", "edit", "editing", "filter", "gradient", "image", "photo", "photography", "setting", "vignette"],
    "popularity": 1037
  },
  {
    "name": "adf_scanner",
    "tags": ["adf", "document", "feeder", "machine", "office", "scan", "scanner"],
    "popularity": 1034
  },
  {
    "name": "clear_night",
    "tags": ["bedtime", "clear", "climate", "home", "lunar", "moon", "nest", "night", "thermostat", "weather"],
    "popularity": 1033
  },
  {
    "name": "ev_station",
    "tags": [
      "automobile",
      "car",
      "cars",
      "charging",
      "electric",
      "electricity",
      "ev",
      "maps",
      "places",
      "station",
      "transportation",
      "vehicle"
    ],
    "popularity": 1033
  },
  {
    "name": "co2",
    "tags": ["carbon", "chemical", "co2", "dioxide", "gas"],
    "popularity": 1032
  },
  {
    "name": "developer_board_off",
    "tags": [
      "board",
      "chip",
      "computer",
      "developer",
      "development",
      "disabled",
      "enabled",
      "hardware",
      "microchip",
      "off",
      "on",
      "processor",
      "slash"
    ],
    "popularity": 1032
  },
  {
    "name": "skull",
    "tags": ["body", "bone", "bones", "cranium", "head", "health", "medical", "skeleton"],
    "popularity": 1032
  },
  {
    "name": "takeout_dining",
    "tags": ["box", "container", "delivery", "dining", "food", "meal", "restaurant", "takeout"],
    "popularity": 1029
  },
  {
    "name": "panorama_horizontal",
    "tags": ["angle", "horizontal", "image", "panorama", "photo", "photography", "picture", "wide"],
    "popularity": 1028
  },
  {
    "name": "door_front",
    "tags": ["closed", "door", "doorway", "entrance", "exit", "front", "home", "house", "way"],
    "popularity": 1027
  },
  {
    "name": "hail",
    "tags": ["body", "hail", "human", "people", "person", "pick", "public", "stop", "taxi", "transportation"],
    "popularity": 1026
  },
  {
    "name": "usb_off",
    "tags": ["cable", "connection", "device", "off", "usb", "wire"],
    "popularity": 1026
  },
  {
    "name": "currency_yen",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol",
      "yen"
    ],
    "popularity": 1024
  },
  {
    "name": "settings_input_antenna",
    "tags": [
      "airplay",
      "antenna",
      "arrows",
      "cast",
      "computer",
      "connect",
      "connection",
      "connectivity",
      "dots",
      "input",
      "internet",
      "network",
      "screencast",
      "settings",
      "stream",
      "wifi",
      "wireless"
    ],
    "popularity": 1023
  },
  {
    "name": "signal_disconnected",
    "tags": ["connection", "disconnected", "internet", "network", "signal", "updates", "wifi", "wireless"],
    "popularity": 1023
  },
  {
    "name": "flashlight_on",
    "tags": ["disabled", "enabled", "flash", "flashlight", "light", "off", "on", "slash"],
    "popularity": 1020
  },
  {
    "name": "person_4",
    "tags": ["account", "face", "human", "people", "person", "profile", "user"],
    "popularity": 1020
  },
  {
    "name": "settings_ethernet",
    "tags": [
      "arrows",
      "computer",
      "connect",
      "connection",
      "connectivity",
      "dots",
      "ethernet",
      "internet",
      "network",
      "settings",
      "wifi"
    ],
    "popularity": 1020
  },
  {
    "name": "forward_10",
    "tags": [
      "10",
      "arrow",
      "control",
      "controls",
      "digit",
      "fast",
      "forward",
      "music",
      "number",
      "play",
      "seconds",
      "symbol",
      "video"
    ],
    "popularity": 1019
  },
  {
    "name": "no_cell",
    "tags": [
      "Android",
      "OS",
      "cell",
      "device",
      "disabled",
      "enabled",
      "hardware",
      "iOS",
      "mobile",
      "no",
      "off",
      "on",
      "phone",
      "slash",
      "tablet"
    ],
    "popularity": 1019
  },
  {
    "name": "view_module",
    "tags": ["design", "format", "grid", "layout", "module", "square", "squares", "stacked", "view", "website"],
    "popularity": 1019
  },
  {
    "name": "star_rate",
    "tags": [
      "achievement",
      "bookmark",
      "favorite",
      "highlight",
      "important",
      "marked",
      "ranking",
      "rate",
      "rating rank",
      "reward",
      "save",
      "saved",
      "shape",
      "special",
      "star"
    ],
    "popularity": 1018
  },
  {
    "name": "looks_3",
    "tags": ["3", "digit", "looks", "numbers", "square", "symbol"],
    "popularity": 1017
  },
  {
    "name": "60fps",
    "tags": ["60fps", "camera", "digit", "fps", "frames", "number", "symbol", "video"],
    "popularity": 1015
  },
  {
    "name": "dirty_lens",
    "tags": ["camera", "dirty", "lens", "photo", "photography", "picture", "splat"],
    "popularity": 1015
  },
  {
    "name": "drive_file_move",
    "tags": [
      "arrow",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "move",
      "right",
      "sheet",
      "slide",
      "storage"
    ],
    "popularity": 1015
  },
  {
    "name": "wb_twilight",
    "tags": ["balance", "light", "lighting", "noon", "sun", "sunset", "twilight", "wb", "white"],
    "popularity": 1014
  },
  {
    "name": "domain_verification",
    "tags": [
      "app",
      "application desktop",
      "approve",
      "check",
      "complete",
      "design",
      "domain",
      "done",
      "interface",
      "internet",
      "layout",
      "mark",
      "ok",
      "screen",
      "select",
      "site",
      "tick",
      "ui",
      "ux",
      "validate",
      "verification",
      "verified",
      "web",
      "website",
      "window",
      "www",
      "yes"
    ],
    "popularity": 1012
  },
  {
    "name": "low_priority",
    "tags": ["arrange", "arrow", "backward", "bottom", "list", "low", "move", "order", "priority"],
    "popularity": 1012
  },
  {
    "name": "spatial_audio",
    "tags": ["audio", "music", "note", "sound", "spatial"],
    "popularity": 1012
  },
  {
    "name": "30fps_select",
    "tags": [
      "30",
      "camera",
      "digits",
      "fps",
      "frame",
      "frequency",
      "image",
      "numbers",
      "per",
      "rate",
      "second",
      "seconds",
      "select",
      "video"
    ],
    "popularity": 1011
  },
  {
    "name": "image_aspect_ratio",
    "tags": ["aspect", "image", "photo", "photography", "picture", "ratio", "rectangle", "square"],
    "popularity": 1010
  },
  {
    "name": "nest_eco_leaf",
    "tags": ["climate", "eco", "home", "leaf", "nest", "thermostat"],
    "popularity": 1009
  },
  {
    "name": "face_4",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 1007
  },
  {
    "name": "follow_the_signs",
    "tags": ["arrow", "body", "directional", "follow", "human", "people", "person", "right", "signs", "social", "the"],
    "popularity": 1007
  },
  {
    "name": "lte_plus_mobiledata",
    "tags": [
      "+",
      "alphabet",
      "character",
      "data",
      "font",
      "internet",
      "letter",
      "lte",
      "mobile",
      "network",
      "plus",
      "speed",
      "symbol",
      "text",
      "type",
      "wifi",
      "wireless"
    ],
    "popularity": 1006
  },
  {
    "name": "screen_lock_landscape",
    "tags": [
      "Android",
      "OS",
      "device",
      "hardware",
      "iOS",
      "landscape",
      "lock",
      "mobile",
      "phone",
      "rotate",
      "screen",
      "tablet"
    ],
    "popularity": 1004
  },
  {
    "name": "brightness_5",
    "tags": ["5", "brightness", "circle", "control", "crescent", "level", "moon", "screen", "sun"],
    "popularity": 1002
  },
  {
    "name": "hide",
    "tags": [],
    "popularity": 1002
  },
  {
    "name": "face_5",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 1000
  },
  {
    "name": "minor_crash",
    "tags": [
      "accident",
      "auto",
      "automobile",
      "car",
      "cars",
      "collision",
      "directions",
      "maps",
      "public",
      "transportation",
      "vehicle"
    ],
    "popularity": 999
  },
  {
    "name": "not_started",
    "tags": ["circle", "media", "not", "pause", "play", "started", "video"],
    "popularity": 997
  },
  {
    "name": "area_chart",
    "tags": [
      "analytics",
      "area",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 996
  },
  {
    "name": "outbound",
    "tags": ["arrow", "circle", "directional", "outbound", "right", "up"],
    "popularity": 996
  },
  {
    "name": "network_check",
    "tags": [
      "check",
      "connect",
      "connection",
      "internet",
      "meter",
      "network",
      "signal",
      "speed",
      "tick",
      "wifi",
      "wireless"
    ],
    "popularity": 995
  },
  {
    "name": "moving",
    "tags": ["arrow", "direction", "moving", "navigation", "travel", "up"],
    "popularity": 992
  },
  {
    "name": "switch_right",
    "tags": ["arrows", "directional", "navigation", "right", "switch", "toggle"],
    "popularity": 991
  },
  {
    "name": "unsubscribe",
    "tags": [
      "cancel",
      "close",
      "email",
      "envelop",
      "letter",
      "mail",
      "message",
      "newsletter",
      "off",
      "remove",
      "send",
      "subscribe",
      "unsubscribe"
    ],
    "popularity": 990
  },
  {
    "name": "piano_off",
    "tags": [
      "disabled",
      "enabled",
      "instrument",
      "keyboard",
      "keys",
      "music",
      "musical",
      "off",
      "on",
      "piano",
      "slash",
      "social"
    ],
    "popularity": 989
  },
  {
    "name": "deblur",
    "tags": [
      "adjust",
      "deblur",
      "edit",
      "editing",
      "enhance",
      "face",
      "image",
      "lines",
      "photo",
      "photography",
      "sharpen"
    ],
    "popularity": 987
  },
  {
    "name": "mode_heat",
    "tags": ["climate", "flame", "home", "hot", "nest", "thermostat"],
    "popularity": 987
  },
  {
    "name": "sos",
    "tags": ["font", "help", "letters", "save", "sos", "text", "type"],
    "popularity": 987
  },
  {
    "name": "person_3",
    "tags": ["account", "face", "human", "people", "person", "profile", "user"],
    "popularity": 986
  },
  {
    "name": "zoom_in_map",
    "tags": ["arrow", "arrows", "destination", "in", "location", "maps", "move", "place", "stop", "zoom"],
    "popularity": 986
  },
  {
    "name": "emoji_events",
    "tags": [
      "achievement",
      "award",
      "chalice",
      "champion",
      "cup",
      "emoji",
      "events",
      "first",
      "prize",
      "reward",
      "sport",
      "trophy",
      "winner"
    ],
    "popularity": 984
  },
  {
    "name": "swipe_vertical",
    "tags": [
      "arrows",
      "direction",
      "finger",
      "hands",
      "hit",
      "navigation",
      "strike",
      "swing",
      "swpie",
      "take",
      "verticle"
    ],
    "popularity": 984
  },
  {
    "name": "light",
    "tags": ["bulb", "ceiling", "hanging", "inside", "interior", "lamp", "light", "lighting", "pendent", "room"],
    "popularity": 981
  },
  {
    "name": "monitor",
    "tags": [
      "Android",
      "OS",
      "chrome",
      "device",
      "display",
      "hardware",
      "iOS",
      "mac",
      "monitor",
      "screen",
      "web",
      "window"
    ],
    "popularity": 981
  },
  {
    "name": "atr",
    "tags": ["circles", "collaboration", "dot", "group", "space", "team", "work"],
    "popularity": 980
  },
  {
    "name": "battery_6_bar",
    "tags": ["6", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 980
  },
  {
    "name": "assignment_return",
    "tags": ["arrow", "assignment", "back", "clipboard", "doc", "document", "left", "retun"],
    "popularity": 979
  },
  {
    "name": "invert_colors",
    "tags": ["colors", "drop", "droplet", "edit", "editing", "hue", "invert", "inverted", "palette", "tone", "water"],
    "popularity": 978
  },
  {
    "name": "trolley",
    "tags": ["carry", "factory", "manufactory", "move", "transport"],
    "popularity": 978
  },
  {
    "name": "more_up",
    "tags": [],
    "popularity": 976
  },
  {
    "name": "format_align_center",
    "tags": [
      "align",
      "alignment",
      "center",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 971
  },
  {
    "name": "playlist_play",
    "tags": ["arrow", "collection", "list", "music", "play", "playlist"],
    "popularity": 971
  },
  {
    "name": "camera_rear",
    "tags": [
      "camera",
      "front",
      "lens",
      "mobile",
      "phone",
      "photo",
      "photography",
      "picture",
      "portrait",
      "rear",
      "selfie"
    ],
    "popularity": 970
  },
  {
    "name": "sync_disabled",
    "tags": [
      "360",
      "around",
      "arrow",
      "arrows",
      "direction",
      "disabled",
      "enabled",
      "inprogress",
      "load",
      "loading refresh",
      "off",
      "on",
      "renew",
      "rotate",
      "slash",
      "sync",
      "turn"
    ],
    "popularity": 970
  },
  {
    "name": "foundation",
    "tags": [
      "architecture",
      "base",
      "basis",
      "building",
      "construction",
      "estate",
      "foundation",
      "home",
      "house",
      "real",
      "residential"
    ],
    "popularity": 966
  },
  {
    "name": "how_to_vote",
    "tags": ["ballot", "election", "how", "poll", "to", "vote"],
    "popularity": 966
  },
  {
    "name": "replay_10",
    "tags": [
      "10",
      "arrow",
      "arrows",
      "control",
      "controls",
      "digit",
      "music",
      "number",
      "refresh",
      "renew",
      "repeat",
      "replay",
      "symbol",
      "ten",
      "video"
    ],
    "popularity": 966
  },
  {
    "name": "fiber_new",
    "tags": ["alphabet", "character", "fiber", "font", "letter", "network", "new", "symbol", "text", "type"],
    "popularity": 965
  },
  {
    "name": "pinch",
    "tags": [
      "arrow",
      "arrows",
      "compress",
      "direction",
      "finger",
      "grasp",
      "hand",
      "navigation",
      "nip",
      "pinch",
      "squeeze",
      "tweak"
    ],
    "popularity": 965
  },
  {
    "name": "segment",
    "tags": [
      "alignment",
      "fonts",
      "format",
      "lines",
      "list",
      "paragraph",
      "part",
      "piece",
      "rule",
      "rules",
      "segment",
      "style",
      "text"
    ],
    "popularity": 964
  },
  {
    "name": "flood",
    "tags": ["crisis", "disaster", "natural", "rain", "storm", "weather"],
    "popularity": 962
  },
  {
    "name": "timer_10_select",
    "tags": [
      "10",
      "alphabet",
      "camera",
      "character",
      "digit",
      "font",
      "letter",
      "number",
      "seconds",
      "select",
      "symbol",
      "text",
      "timer",
      "type"
    ],
    "popularity": 961
  },
  {
    "name": "enhanced_encryption",
    "tags": [
      "+",
      "add",
      "encryption",
      "enhanced",
      "lock",
      "locked",
      "new",
      "password",
      "plus",
      "privacy",
      "private",
      "protection",
      "safety",
      "secure",
      "security",
      "symbol"
    ],
    "popularity": 960
  },
  {
    "name": "folder_special",
    "tags": [
      "bookmark",
      "data",
      "doc",
      "document",
      "drive",
      "favorite",
      "file",
      "folder",
      "highlight",
      "important",
      "marked",
      "save",
      "saved",
      "shape",
      "sheet",
      "slide",
      "special",
      "star",
      "storage"
    ],
    "popularity": 959
  },
  {
    "name": "keyboard_control_key",
    "tags": ["control key", "keyboard"],
    "popularity": 959
  },
  {
    "name": "remove_shopping_cart",
    "tags": [
      "card",
      "cart",
      "cash",
      "checkout",
      "coin",
      "commerce",
      "credit",
      "currency",
      "disabled",
      "dollars",
      "enabled",
      "off",
      "on",
      "online",
      "pay",
      "payment",
      "remove",
      "shopping",
      "slash",
      "tick"
    ],
    "popularity": 957
  },
  {
    "name": "videogame_asset_off",
    "tags": [
      "asset",
      "console",
      "controller",
      "device",
      "disabled",
      "enabled",
      "game",
      "gamepad",
      "gaming",
      "off",
      "on",
      "playstation",
      "slash",
      "video",
      "videogame"
    ],
    "popularity": 954
  },
  {
    "name": "elderly_woman",
    "tags": [
      "body",
      "cane",
      "elderly",
      "female",
      "gender",
      "girl",
      "human",
      "lady",
      "old",
      "people",
      "person",
      "senior",
      "social",
      "symbol",
      "woman",
      "women"
    ],
    "popularity": 953
  },
  {
    "name": "no_crash",
    "tags": [
      "accident",
      "auto",
      "automobile",
      "car",
      "cars",
      "check",
      "collision",
      "confirm",
      "correct",
      "crash",
      "direction",
      "done",
      "enter",
      "maps",
      "mark",
      "no",
      "ok",
      "okay",
      "select",
      "tick",
      "transportation",
      "vehicle",
      "yes"
    ],
    "popularity": 951
  },
  {
    "name": "oil_barrel",
    "tags": ["barrel", "droplet", "gas", "gasoline", "nest", "oil", "water"],
    "popularity": 951
  },
  {
    "name": "device_reset",
    "tags": ["clock", "device", "home", "nest", "reset"],
    "popularity": 950
  },
  {
    "name": "transgender",
    "tags": ["female", "gender", "lgbt", "male", "neutral", "social", "symbol", "transgender"],
    "popularity": 950
  },
  {
    "name": "vpn_key_off",
    "tags": [
      "code",
      "disabled",
      "enabled",
      "key",
      "lock",
      "network",
      "off",
      "offline",
      "on",
      "passcode",
      "password",
      "slash",
      "unlock",
      "vpn"
    ],
    "popularity": 949
  },
  {
    "name": "backpack",
    "tags": ["back", "backpack", "bag", "book", "bookbag", "knapsack", "pack", "storage", "travel"],
    "popularity": 948
  },
  {
    "name": "eject",
    "tags": ["disc", "drive", "dvd", "eject", "remove", "triangle", "usb"],
    "popularity": 948
  },
  {
    "name": "phone_callback",
    "tags": [
      "arrow",
      "call",
      "callback",
      "cell",
      "contact",
      "device",
      "down",
      "hardware",
      "mobile",
      "phone",
      "telephone"
    ],
    "popularity": 945
  },
  {
    "name": "branding_watermark",
    "tags": [
      "branding",
      "components",
      "copyright",
      "design",
      "emblem",
      "format",
      "identity",
      "interface",
      "layout",
      "logo",
      "screen",
      "site",
      "stamp",
      "ui",
      "ux",
      "watermark",
      "web",
      "website",
      "window"
    ],
    "popularity": 944
  },
  {
    "name": "nest_remote_comfort_sensor",
    "tags": [
      "comfort",
      "connection",
      "data",
      "google",
      "internet",
      "nest",
      "network",
      "remote",
      "scan",
      "sensor",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 944
  },
  {
    "name": "room_preferences",
    "tags": [
      "building",
      "door",
      "doorway",
      "entrance",
      "gear",
      "home",
      "house",
      "interior",
      "office",
      "open",
      "preferences",
      "room",
      "settings"
    ],
    "popularity": 944
  },
  {
    "name": "animation",
    "tags": ["animation", "circles", "film", "motion", "movement", "sequence", "video"],
    "popularity": 943
  },
  {
    "name": "hand_gesture",
    "tags": ["fingers", "gesture", "hand", "palm"],
    "popularity": 942
  },
  {
    "name": "sports_motorsports",
    "tags": [
      "athlete",
      "athletic",
      "automobile",
      "bike",
      "drive",
      "driving",
      "entertainment",
      "helmet",
      "hobby",
      "motorcycle",
      "motorsports",
      "protect",
      "social",
      "sports",
      "vehicle"
    ],
    "popularity": 941
  },
  {
    "name": "timer_3",
    "tags": ["3", "digits", "duration", "number", "numbers", "seconds", "time", "timer"],
    "popularity": 941
  },
  {
    "name": "60fps_select",
    "tags": [
      "60",
      "camera",
      "digits",
      "fps",
      "frame",
      "frequency",
      "numbers",
      "per",
      "rate",
      "second",
      "seconds",
      "select",
      "video"
    ],
    "popularity": 940
  },
  {
    "name": "calendar_view_month",
    "tags": ["calendar", "date", "day", "event", "format", "grid", "layout", "month", "schedule", "today", "view"],
    "popularity": 940
  },
  {
    "name": "folder_zip",
    "tags": [
      "compress",
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "open",
      "sheet",
      "slide",
      "storage",
      "zip"
    ],
    "popularity": 939
  },
  {
    "name": "lens",
    "tags": ["circle", "full", "geometry", "lens", "moon"],
    "popularity": 939
  },
  {
    "name": "nest_clock_farsight_analog",
    "tags": ["analog", "climate", "clock", "farsight", "home", "nest", "thermostat"],
    "popularity": 937
  },
  {
    "name": "emergency_share",
    "tags": ["alert", "attention", "caution", "danger", "emergency", "important", "notification", "share", "warning"],
    "popularity": 935
  },
  {
    "name": "directions_off",
    "tags": [
      "arrow",
      "directions",
      "disabled",
      "enabled",
      "maps",
      "off",
      "on",
      "right",
      "route",
      "sign",
      "slash",
      "traffic"
    ],
    "popularity": 932
  },
  {
    "name": "surfing",
    "tags": [
      "athlete",
      "athletic",
      "beach",
      "body",
      "entertainment",
      "exercise",
      "hobby",
      "human",
      "people",
      "person",
      "sea",
      "social sports",
      "sports",
      "summer",
      "surfing",
      "water"
    ],
    "popularity": 932
  },
  {
    "name": "charger",
    "tags": ["adapter", "batteries", "charger", "device", "nest", "power"],
    "popularity": 931
  },
  {
    "name": "polyline",
    "tags": ["compose", "create", "design", "draw", "line", "polyline", "vector"],
    "popularity": 931
  },
  {
    "name": "tab",
    "tags": [
      "browser",
      "computer",
      "document",
      "documents",
      "folder",
      "internet",
      "tab",
      "tabs",
      "web",
      "website",
      "window",
      "windows"
    ],
    "popularity": 931
  },
  {
    "name": "important_devices",
    "tags": [
      "Android",
      "OS",
      "desktop",
      "devices",
      "hardware",
      "iOS",
      "important",
      "mobile",
      "monitor",
      "phone",
      "star",
      "tablet",
      "web"
    ],
    "popularity": 930
  },
  {
    "name": "sports_kabaddi",
    "tags": [
      "athlete",
      "athletic",
      "body",
      "combat",
      "entertainment",
      "exercise",
      "fighting",
      "game",
      "hobby",
      "human",
      "kabaddi",
      "people",
      "person",
      "social",
      "sports",
      "wrestle",
      "wrestling"
    ],
    "popularity": 930
  },
  {
    "name": "airline_seat_legroom_normal",
    "tags": [
      "airline",
      "body",
      "feet",
      "human",
      "leg",
      "legroom",
      "normal",
      "people",
      "person",
      "seat",
      "sitting",
      "space",
      "travel"
    ],
    "popularity": 929
  },
  {
    "name": "dinner_dining",
    "tags": ["breakfast", "dining", "dinner", "food", "fork", "lunch", "meal", "restaurant", "spaghetti", "utensils"],
    "popularity": 929
  },
  {
    "name": "scuba_diving",
    "tags": ["diving", "entertainment", "exercise", "hobby", "scuba", "social", "swim", "swimming"],
    "popularity": 929
  },
  {
    "name": "sanitizer",
    "tags": ["bacteria", "bottle", "clean", "covid", "disinfect", "germs", "pump", "sanitizer"],
    "popularity": 928
  },
  {
    "name": "commute",
    "tags": [
      "automobile",
      "car",
      "commute",
      "direction",
      "maps",
      "public",
      "train",
      "transportation",
      "trip",
      "vehicle"
    ],
    "popularity": 927
  },
  {
    "name": "key_off",
    "tags": ["disabled", "enabled", "key", "lock", "off", "offline", "on", "password", "slash", "unlock"],
    "popularity": 927
  },
  {
    "name": "panorama_wide_angle_select",
    "tags": ["angle", "image", "panorama", "photo", "photography", "picture", "select", "wide"],
    "popularity": 925
  },
  {
    "name": "square",
    "tags": ["draw", "four", "shape quadrangle", "sides", "square"],
    "popularity": 925
  },
  {
    "name": "clean_hands",
    "tags": ["bacteria", "clean", "disinfect", "germs", "gesture", "hand", "hands", "sanitize", "sanitizer"],
    "popularity": 924
  },
  {
    "name": "opacity",
    "tags": ["color", "drop", "droplet", "hue", "invert", "inverted", "opacity", "palette", "tone", "water"],
    "popularity": 924
  },
  {
    "name": "fiber_dvr",
    "tags": [
      "alphabet",
      "character",
      "digital",
      "dvr",
      "electronics",
      "fiber",
      "font",
      "letter",
      "network",
      "record",
      "recorder",
      "symbol",
      "text",
      "tv",
      "type",
      "video"
    ],
    "popularity": 923
  },
  {
    "name": "send_to_mobile",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "device",
      "export",
      "forward",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "right",
      "send",
      "share",
      "tablet",
      "to"
    ],
    "popularity": 923
  },
  {
    "name": "php",
    "tags": [
      "alphabet",
      "brackets",
      "character",
      "code",
      "css",
      "develop",
      "developer",
      "engineer",
      "engineering",
      "font",
      "html",
      "letter",
      "php",
      "platform",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 922
  },
  {
    "name": "text_to_speech",
    "tags": [
      "doc data",
      "document",
      "file",
      "listen",
      "speak",
      "speaker",
      "speech",
      "talk",
      "text",
      "tts",
      "volume",
      "writing"
    ],
    "popularity": 922
  },
  {
    "name": "workspaces_outline",
    "tags": ["circles", "collaboration", "dot", "group", "outline", "space", "team", "work", "workspaces"],
    "popularity": 922
  },
  {
    "name": "settings_power",
    "tags": ["info", "information", "off", "on", "power", "save", "settings", "shutdown"],
    "popularity": 921
  },
  {
    "name": "breaking_news_alt_1",
    "tags": [
      "!",
      "alert",
      "announcement",
      "attention",
      "caution",
      "danger",
      "error",
      "exclamation",
      "headline",
      "important",
      "mark",
      "news",
      "newspaper",
      "notification",
      "symbol",
      "warning"
    ],
    "popularity": 920
  },
  {
    "name": "chrome_reader_mode",
    "tags": ["chrome", "mode", "read", "reader", "text"],
    "popularity": 920
  },
  {
    "name": "devices_other",
    "tags": [
      "Android",
      "OS",
      "ar",
      "cell",
      "chrome",
      "desktop",
      "device",
      "gadget",
      "hardware",
      "iOS",
      "ipad",
      "mac",
      "mobile",
      "monitor",
      "other",
      "phone",
      "tablet",
      "vr",
      "watch",
      "wearables",
      "window"
    ],
    "popularity": 920
  },
  {
    "name": "tablet_mac",
    "tags": ["Android", "OS", "device", "hardware", "iOS", "ipad", "mobile", "tablet mac", "web"],
    "popularity": 920
  },
  {
    "name": "piano",
    "tags": ["instrument", "keyboard", "keys", "music", "musical", "piano", "social"],
    "popularity": 919
  },
  {
    "name": "outdoor_grill",
    "tags": ["barbecue", "bbq", "charcoal", "cooking", "grill", "home", "house", "outdoor", "outside"],
    "popularity": 916
  },
  {
    "name": "signal_cellular_no_sim",
    "tags": [
      "camera",
      "card",
      "cellular",
      "chip",
      "device",
      "disabled",
      "enabled",
      "memory",
      "no",
      "off",
      "offline",
      "on",
      "phone",
      "signal",
      "sim",
      "slash",
      "storage"
    ],
    "popularity": 914
  },
  {
    "name": "garage",
    "tags": [
      "automobile",
      "automotive",
      "car",
      "cars",
      "direction",
      "garage",
      "maps",
      "transportation",
      "travel",
      "vehicle"
    ],
    "popularity": 913
  },
  {
    "name": "soup_kitchen",
    "tags": ["breakfast", "brunch", "dining", "food", "kitchen", "lunch", "meal", "soup"],
    "popularity": 913
  },
  {
    "name": "24mp",
    "tags": [
      "24",
      "camera",
      "digits",
      "font",
      "image",
      "letters",
      "megapixel",
      "megapixels",
      "mp",
      "numbers",
      "pixel",
      "pixels",
      "quality",
      "resolution",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 911
  },
  {
    "name": "online_prediction",
    "tags": ["bulb", "connection", "idea", "light", "network", "online", "prediction", "signal", "wireless"],
    "popularity": 911
  },
  {
    "name": "exposure_neg_2",
    "tags": [
      "2",
      "brightness",
      "contrast",
      "digit",
      "edit",
      "editing",
      "effect",
      "exposure",
      "image",
      "neg",
      "negative",
      "number",
      "photo",
      "photography",
      "settings",
      "symbol"
    ],
    "popularity": 909
  },
  {
    "name": "subdirectory_arrow_left",
    "tags": ["arrow", "directory", "down", "left", "navigation", "sub", "subdirectory"],
    "popularity": 909
  },
  {
    "name": "incomplete_circle",
    "tags": ["chart", "circle", "incomplete"],
    "popularity": 907
  },
  {
    "name": "network_wifi_2_bar",
    "tags": ["cell", "cellular", "data", "internet", "mobile", "network", "phone", "speed", "wifi", "wireless"],
    "popularity": 907
  },
  {
    "name": "recent_actors",
    "tags": [
      "account",
      "actors",
      "avatar",
      "card",
      "cards",
      "carousel",
      "face",
      "human",
      "layers",
      "list",
      "people",
      "person",
      "profile",
      "recent",
      "thumbnail",
      "user"
    ],
    "popularity": 907
  },
  {
    "name": "wifi_2_bar",
    "tags": [
      "2",
      "bar",
      "cell",
      "cellular",
      "connection",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "scan",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 903
  },
  {
    "name": "format_align_right",
    "tags": [
      "align",
      "alignment",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "right",
      "sheet",
      "spreadsheet",
      "text",
      "type",
      "writing"
    ],
    "popularity": 901
  },
  {
    "name": "playlist_remove",
    "tags": ["-", "collection", "list", "minus", "music", "playlist", "remove"],
    "popularity": 900
  },
  {
    "name": "call_received",
    "tags": ["arrow", "call", "device", "mobile", "received"],
    "popularity": 898
  },
  {
    "name": "u_turn_right",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "maps",
      "navigation",
      "path",
      "right",
      "route",
      "sign",
      "traffic",
      "u-turn"
    ],
    "popularity": 895
  },
  {
    "name": "add_chart",
    "tags": [
      "+",
      "add",
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "new",
      "plus",
      "statistics",
      "symbol",
      "tracking"
    ],
    "popularity": 894
  },
  {
    "name": "broken_image",
    "tags": [
      "broken",
      "corrupt",
      "error",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "picture",
      "torn"
    ],
    "popularity": 893
  },
  {
    "name": "system_update",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "arrows",
      "cell",
      "device",
      "direction",
      "down",
      "download",
      "hardware",
      "iOS",
      "install",
      "mobile",
      "phone",
      "system",
      "tablet",
      "update"
    ],
    "popularity": 891
  },
  {
    "name": "currency_yuan",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol",
      "yuan"
    ],
    "popularity": 889
  },
  {
    "name": "settings_phone",
    "tags": ["call", "cell", "contact", "device", "hardware", "mobile", "phone", "settings", "telephone"],
    "popularity": 888
  },
  {
    "name": "gesture",
    "tags": ["drawing", "finger", "gesture", "gestures", "hand", "motion"],
    "popularity": 886
  },
  {
    "name": "shop",
    "tags": [
      "bag",
      "bill",
      "buy",
      "card",
      "cart",
      "cash",
      "coin",
      "commerce",
      "credit",
      "currency",
      "dollars",
      "google",
      "money",
      "online",
      "pay",
      "payment",
      "play",
      "shop",
      "shopping",
      "store"
    ],
    "popularity": 885
  },
  {
    "name": "person_2",
    "tags": ["account", "face", "human", "people", "person", "profile", "user"],
    "popularity": 884
  },
  {
    "name": "mode_fan_off",
    "tags": ["air conditioner", "cool", "disabled", "enabled", "fan", "nest", "off", "on", "slash"],
    "popularity": 882
  },
  {
    "name": "wifi_tethering",
    "tags": [
      "cell",
      "cellular",
      "connection",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "scan",
      "service",
      "signal",
      "speed",
      "tethering",
      "wifi",
      "wireless"
    ],
    "popularity": 880
  },
  {
    "name": "view_cozy",
    "tags": ["comfy", "cozy", "design", "format", "layout", "view", "web"],
    "popularity": 879
  },
  {
    "name": "currency_lira",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "lira",
      "money",
      "online",
      "pay",
      "payment",
      "price",
      "shopping",
      "symbol"
    ],
    "popularity": 876
  },
  {
    "name": "museum",
    "tags": [
      "architecture",
      "attraction",
      "building",
      "estate",
      "event",
      "exhibition",
      "explore",
      "local",
      "museum",
      "places",
      "real",
      "see",
      "shop",
      "store",
      "tour"
    ],
    "popularity": 876
  },
  {
    "name": "grading",
    "tags": [
      "'favorite'_new'.  ' Remove this icon & keep 'star'.",
      "'star_boarder'",
      "'star_border_purple500'",
      "'star_outline'",
      "'star_purple500'",
      "'star_rate'",
      "Same as 'star'"
    ],
    "popularity": 874
  },
  {
    "name": "laundry",
    "tags": ["home", "laundry", "shirt", "washer"],
    "popularity": 874
  },
  {
    "name": "filter_center_focus",
    "tags": ["camera", "center", "dot", "edit", "filter", "focus", "image", "photo", "photography", "picture"],
    "popularity": 872
  },
  {
    "name": "temple_hindu",
    "tags": ["hindu", "hinduism", "hindus", "ideology", "mandir", "religion", "spiritual", "temple", "worship"],
    "popularity": 872
  },
  {
    "name": "settings_remote",
    "tags": ["bluetooth", "connection", "connectivity", "device", "remote", "settings", "signal", "wifi", "wireless"],
    "popularity": 871
  },
  {
    "name": "transcribe",
    "tags": [],
    "popularity": 871
  },
  {
    "name": "wifi_tethering_error",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "cell",
      "cellular",
      "connection",
      "danger",
      "data",
      "error",
      "exclamation",
      "important",
      "internet",
      "mark",
      "mobile",
      "network",
      "notification",
      "phone",
      "rounded",
      "scan",
      "service",
      "signal",
      "speed",
      "symbol",
      "tethering",
      "warning",
      "wifi",
      "wireless"
    ],
    "popularity": 871
  },
  {
    "name": "no_flash",
    "tags": [
      "bolt",
      "camera",
      "disabled",
      "enabled",
      "flash",
      "image",
      "lightning",
      "no",
      "off",
      "on",
      "photo",
      "photography",
      "picture",
      "slash",
      "thunderbolt"
    ],
    "popularity": 870
  },
  {
    "name": "table_restaurant",
    "tags": ["bar", "dining", "table"],
    "popularity": 870
  },
  {
    "name": "airline_seat_legroom_extra",
    "tags": [
      "airline",
      "body",
      "extra",
      "feet",
      "human",
      "leg",
      "legroom",
      "people",
      "person",
      "seat",
      "sitting",
      "space",
      "travel"
    ],
    "popularity": 869
  },
  {
    "name": "dining",
    "tags": ["cafe", "cafeteria", "cutlery", "diner", "dining", "eat", "eating", "fork", "room", "spoon"],
    "popularity": 869
  },
  {
    "name": "interpreter_mode",
    "tags": ["interpreter", "language", "microphone", "mode", "person", "speaking", "symbol"],
    "popularity": 867
  },
  {
    "name": "domain_add",
    "tags": [
      "+",
      "add",
      "apartment",
      "architecture",
      "building",
      "business",
      "domain",
      "estate",
      "home",
      "new",
      "place",
      "plus",
      "real",
      "residence",
      "residential",
      "shelter",
      "symbol",
      "web",
      "www"
    ],
    "popularity": 865
  },
  {
    "name": "edit_notifications",
    "tags": [
      "active",
      "alarm",
      "alert",
      "bell",
      "chime",
      "compose",
      "create",
      "draft",
      "edit",
      "editing",
      "input",
      "new",
      "notifications",
      "notify",
      "pen",
      "pencil",
      "reminder",
      "ring",
      "sound",
      "write",
      "writing"
    ],
    "popularity": 865
  },
  {
    "name": "food_bank",
    "tags": [
      "architecture",
      "bank",
      "building",
      "charity",
      "eat",
      "estate",
      "food",
      "fork",
      "house",
      "knife",
      "meal",
      "place",
      "real",
      "residence",
      "residential",
      "shelter",
      "utensils"
    ],
    "popularity": 865
  },
  {
    "name": "pest_control",
    "tags": ["bug", "control", "exterminator", "insects", "pest"],
    "popularity": 865
  },
  {
    "name": "4k_plus",
    "tags": [
      "+",
      "4000",
      "4K",
      "alphabet",
      "character",
      "digit",
      "display",
      "font",
      "letter",
      "number",
      "pixel",
      "pixels",
      "plus",
      "resolution",
      "symbol",
      "text",
      "type",
      "video"
    ],
    "popularity": 861
  },
  {
    "name": "bring_your_own_ip",
    "tags": ["bring", "globe", "internet", "ip", "own", "protocol", "world", "your"],
    "popularity": 861
  },
  {
    "name": "night_shelter",
    "tags": [
      "architecture",
      "bed",
      "building",
      "estate",
      "homeless",
      "house",
      "night",
      "place",
      "real",
      "shelter",
      "sleep"
    ],
    "popularity": 861
  },
  {
    "name": "lightbulb_circle",
    "tags": ["alert", "announcement", "idea", "info", "information", "light", "lightbulb"],
    "popularity": 859
  },
  {
    "name": "grouped_bar_chart",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "data",
      "diagram",
      "graph",
      "grouped",
      "infographic",
      "measure",
      "metrics",
      "statistics",
      "tracking"
    ],
    "popularity": 858
  },
  {
    "name": "synagogue",
    "tags": ["ideology", "jew", "jewish", "religion", "shul", "spiritual", "temple", "worship"],
    "popularity": 857
  },
  {
    "name": "view_headline",
    "tags": ["design", "format", "grid", "headline", "layout", "paragraph", "text", "view", "website"],
    "popularity": 857
  },
  {
    "name": "border_inner",
    "tags": [
      "border",
      "doc",
      "edit",
      "editing",
      "editor",
      "inner",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "writing"
    ],
    "popularity": 856
  },
  {
    "name": "card_travel",
    "tags": [
      "bill",
      "card",
      "cash",
      "coin",
      "commerce",
      "cost",
      "credit",
      "currency",
      "dollars",
      "finance",
      "membership",
      "miles",
      "money",
      "online",
      "pay",
      "payment",
      "travel",
      "trip"
    ],
    "popularity": 856
  },
  {
    "name": "call_split",
    "tags": ["arrow", "call", "device", "mobile", "split"],
    "popularity": 855
  },
  {
    "name": "do_not_disturb_off",
    "tags": [
      "cancel",
      "close",
      "denied",
      "deny",
      "disabled",
      "disturb",
      "do",
      "enabled",
      "off",
      "on",
      "remove",
      "silence",
      "slash",
      "stop"
    ],
    "popularity": 853
  },
  {
    "name": "present_to_all",
    "tags": ["all", "arrow", "present", "presentation", "screen", "share", "site", "slides", "to", "web", "website"],
    "popularity": 853
  },
  {
    "name": "stadium",
    "tags": ["activity", "amphitheater", "arena", "coliseum", "event", "local", "stadium", "star", "things", "ticket"],
    "popularity": 853
  },
  {
    "name": "add_to_photos",
    "tags": [
      "add",
      "collection",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "photo",
      "photography",
      "photos",
      "picture",
      "plus",
      "to"
    ],
    "popularity": 852
  },
  {
    "name": "transfer_within_a_station",
    "tags": [
      "a",
      "arrow",
      "arrows",
      "body",
      "direction",
      "human",
      "left",
      "maps",
      "people",
      "person",
      "public",
      "right",
      "route",
      "station",
      "stop",
      "transfer",
      "transportation",
      "vehicle",
      "walk",
      "within"
    ],
    "popularity": 852
  },
  {
    "name": "find_replace",
    "tags": [
      "around",
      "arrows",
      "find",
      "glass",
      "inprogress",
      "load",
      "loading refresh",
      "look",
      "magnify",
      "magnifying",
      "renew",
      "replace",
      "rotate",
      "search",
      "see"
    ],
    "popularity": 850
  },
  {
    "name": "brightness_4",
    "tags": ["4", "brightness", "circle", "control", "crescent", "level", "moon", "screen", "sun"],
    "popularity": 849
  },
  {
    "name": "linear_scale",
    "tags": [
      "app",
      "application",
      "components",
      "design",
      "interface",
      "layout",
      "linear",
      "measure",
      "menu",
      "scale",
      "screen",
      "site",
      "slider",
      "ui",
      "ux",
      "web",
      "website",
      "window"
    ],
    "popularity": 849
  },
  {
    "name": "sports",
    "tags": [
      "athlete",
      "athletic",
      "blowing",
      "coach",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "instrument",
      "referee",
      "social",
      "sound",
      "sports",
      "warning",
      "whistle"
    ],
    "popularity": 848
  },
  {
    "name": "signal_cellular_alt_2_bar",
    "tags": [
      "2",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "signal",
      "speed",
      "wifi",
      "wireless"
    ],
    "popularity": 846
  },
  {
    "name": "airline_seat_legroom_reduced",
    "tags": [
      "airline",
      "body",
      "feet",
      "human",
      "leg",
      "legroom",
      "people",
      "person",
      "reduced",
      "seat",
      "sitting",
      "space",
      "travel"
    ],
    "popularity": 844
  },
  {
    "name": "location_off",
    "tags": ["destination", "direction", "location", "maps", "off", "pin", "place", "room", "stop"],
    "popularity": 843
  },
  {
    "name": "festival",
    "tags": ["circus", "event", "festival", "local", "maps", "places", "tent", "tour", "travel"],
    "popularity": 842
  },
  {
    "name": "sim_card_download",
    "tags": ["arrow", "camera", "card", "chip", "device", "down", "download", "memory", "phone", "sim", "storage"],
    "popularity": 841
  },
  {
    "name": "usb",
    "tags": ["cable", "connection", "device", "usb", "wire"],
    "popularity": 841
  },
  {
    "name": "attractions",
    "tags": ["amusement", "attractions", "entertainment", "ferris", "fun", "maps", "park", "places", "wheel"],
    "popularity": 838
  },
  {
    "name": "flash_off",
    "tags": [
      "bolt",
      "disabled",
      "electric",
      "enabled",
      "fast",
      "flash",
      "lightning",
      "off",
      "on",
      "slash",
      "thunderbolt"
    ],
    "popularity": 838
  },
  {
    "name": "view_quilt",
    "tags": ["design", "format", "grid", "layout", "quilt", "square", "squares", "stacked", "view", "website"],
    "popularity": 838
  },
  {
    "name": "border_left",
    "tags": [
      "border",
      "doc",
      "edit",
      "editing",
      "editor",
      "left",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "writing"
    ],
    "popularity": 837
  },
  {
    "name": "edit_off",
    "tags": [
      "compose",
      "create",
      "disabled",
      "draft",
      "edit",
      "editing",
      "enabled",
      "input",
      "new",
      "off",
      "offline",
      "on",
      "pen",
      "pencil",
      "slash",
      "write",
      "writing"
    ],
    "popularity": 837
  },
  {
    "name": "send_time_extension",
    "tags": ["deliver", "dispatch", "envelop", "extension", "mail", "message", "schedule", "send", "time"],
    "popularity": 836
  },
  {
    "name": "flip",
    "tags": ["edit", "editing", "flip", "image", "orientation", "scan scanning"],
    "popularity": 835
  },
  {
    "name": "public_off",
    "tags": [
      "disabled",
      "earth",
      "enabled",
      "global",
      "globe",
      "map",
      "network",
      "off",
      "on",
      "planet",
      "public",
      "slash",
      "social",
      "space",
      "web",
      "world"
    ],
    "popularity": 833
  },
  {
    "name": "sensor_occupied",
    "tags": [
      "body",
      "body response",
      "connection",
      "fitbit",
      "human",
      "network",
      "people",
      "person",
      "scan",
      "sensors",
      "signal",
      "smart body scan sensor",
      "wireless"
    ],
    "popularity": 833
  },
  {
    "name": "autofps_select",
    "tags": [
      "A",
      "alphabet",
      "auto",
      "character",
      "font",
      "fps",
      "frame",
      "frequency",
      "letter",
      "per",
      "rate",
      "second",
      "seconds",
      "select",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 832
  },
  {
    "name": "fork_left",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "fork",
      "left",
      "maps",
      "navigation",
      "path",
      "route",
      "sign",
      "traffic"
    ],
    "popularity": 832
  },
  {
    "name": "face_2",
    "tags": [
      "account",
      "emoji",
      "eyes",
      "face",
      "human",
      "lock",
      "log",
      "login",
      "logout",
      "people",
      "person",
      "profile",
      "recognition",
      "security",
      "social",
      "thumbnail",
      "unlock",
      "user"
    ],
    "popularity": 831
  },
  {
    "name": "golf_course",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "club",
      "course",
      "entertainment",
      "flag",
      "golf",
      "golfer",
      "golfing",
      "hobby",
      "hole",
      "places",
      "putt",
      "sports"
    ],
    "popularity": 831
  },
  {
    "name": "legend_toggle",
    "tags": [
      "analytics",
      "chart",
      "data",
      "diagram",
      "graph",
      "infographic",
      "legend",
      "measure",
      "metrics",
      "monitoring",
      "stackdriver",
      "statistics",
      "toggle",
      "tracking"
    ],
    "popularity": 831
  },
  {
    "name": "center_focus_weak",
    "tags": ["camera", "center", "focus", "image", "lens", "photo", "photography", "weak", "zoom"],
    "popularity": 830
  },
  {
    "name": "quick_phrases",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "phrases", "quick", "speech"],
    "popularity": 830
  },
  {
    "name": "severe_cold",
    "tags": [
      "!",
      "alert",
      "attention",
      "caution",
      "climate",
      "cold",
      "crisis",
      "danger",
      "disaster",
      "error",
      "exclamation",
      "important",
      "notification",
      "severe",
      "snow",
      "snowflake",
      "warning",
      "weather",
      "winter"
    ],
    "popularity": 830
  },
  {
    "name": "motorcycle",
    "tags": [
      "automobile",
      "bicycle",
      "bike",
      "car",
      "cars",
      "direction",
      "maps",
      "motorcycle",
      "public",
      "sport",
      "transportation",
      "vehicle"
    ],
    "popularity": 829
  },
  {
    "name": "auto_awesome_motion",
    "tags": ["adjust", "auto", "awesome", "collage", "edit", "editing", "enhance", "image", "motion", "photo", "video"],
    "popularity": 827
  },
  {
    "name": "signal_cellular_alt_1_bar",
    "tags": [
      "1",
      "bar",
      "cell",
      "cellular",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "signal",
      "speed",
      "wifi",
      "wireless"
    ],
    "popularity": 827
  },
  {
    "name": "monitor_weight",
    "tags": ["body", "device", "diet", "health", "monitor", "scale", "smart", "weight"],
    "popularity": 825
  },
  {
    "name": "screen_rotation",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "phone",
      "rotate",
      "rotation",
      "screen",
      "tablet",
      "turn"
    ],
    "popularity": 825
  },
  {
    "name": "g_mobiledata",
    "tags": [
      "alphabet",
      "character",
      "data",
      "font",
      "g",
      "letter",
      "mobile",
      "network",
      "service",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 822
  },
  {
    "name": "deck",
    "tags": [
      "chairs",
      "deck",
      "home",
      "house",
      "outdoors",
      "outside",
      "patio",
      "social",
      "terrace",
      "umbrella",
      "yard"
    ],
    "popularity": 821
  },
  {
    "name": "connecting_airports",
    "tags": [
      "airplane",
      "airplanes",
      "airport",
      "airports",
      "connecting",
      "flight",
      "plane",
      "transportation",
      "travel",
      "trip"
    ],
    "popularity": 819
  },
  {
    "name": "toys",
    "tags": ["car", "games", "kids", "toy", "toys", "windmill"],
    "popularity": 818
  },
  {
    "name": "tsunami",
    "tags": ["crisis", "disaster", "flood", "rain", "storm", "tsunami", "weather"],
    "popularity": 817
  },
  {
    "name": "format_textdirection_l_to_r",
    "tags": [
      "align",
      "alignment",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "ltr",
      "sheet",
      "spreadsheet",
      "text",
      "textdirection",
      "type",
      "writing"
    ],
    "popularity": 816
  },
  {
    "name": "screen_share",
    "tags": [
      "Android",
      "OS",
      "arrow",
      "cast",
      "chrome",
      "device",
      "display",
      "hardware",
      "iOS",
      "laptop",
      "mac",
      "mirror",
      "monitor",
      "screen",
      "share",
      "steam",
      "streaming",
      "web",
      "window"
    ],
    "popularity": 816
  },
  {
    "name": "1k",
    "tags": [
      "1000",
      "1K",
      "alphabet",
      "character",
      "digit",
      "display",
      "font",
      "letter",
      "number",
      "pixel",
      "pixels",
      "resolution",
      "symbol",
      "text",
      "type",
      "video"
    ],
    "popularity": 815
  },
  {
    "name": "border_bottom",
    "tags": [
      "border",
      "bottom",
      "doc",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "writing"
    ],
    "popularity": 815
  },
  {
    "name": "scatter_plot",
    "tags": [
      "analytics",
      "bar",
      "bars",
      "chart",
      "circles",
      "data",
      "diagram",
      "dot",
      "graph",
      "infographic",
      "measure",
      "metrics",
      "plot",
      "scatter",
      "statistics",
      "tracking"
    ],
    "popularity": 814
  },
  {
    "name": "car_crash",
    "tags": [
      "accident",
      "automobile",
      "car",
      "cars",
      "collision",
      "crash",
      "direction",
      "maps",
      "public",
      "transportation",
      "vehicle"
    ],
    "popularity": 813
  },
  {
    "name": "width_normal",
    "tags": [],
    "popularity": 813
  },
  {
    "name": "social_distance",
    "tags": ["6", "apart", "body", "distance", "ft", "human", "people", "person", "social", "space"],
    "popularity": 810
  },
  {
    "name": "routine",
    "tags": ["climate", "lunar", "moon", "nest", "order", "pattern", "routine", "schedule", "sun", "weather"],
    "popularity": 808
  },
  {
    "name": "turn_sharp_right",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "maps",
      "navigation",
      "path",
      "right",
      "route",
      "sharp",
      "sign",
      "traffic",
      "turn"
    ],
    "popularity": 808
  },
  {
    "name": "add_call",
    "tags": [
      "+",
      "add",
      "call",
      "cell",
      "contact",
      "device",
      "hardware",
      "mobile",
      "new",
      "phone",
      "plus",
      "symbol",
      "telephone"
    ],
    "popularity": 805
  },
  {
    "name": "sign_language",
    "tags": ["communication", "deaf", "fingers", "gesture", "hand", "language", "sign"],
    "popularity": 805
  },
  {
    "name": "weekend",
    "tags": ["chair", "couch", "furniture", "home", "living", "lounge", "relax", "room", "weekend"],
    "popularity": 805
  },
  {
    "name": "battery_horiz_075",
    "tags": ["75%", "battery", "home", "horizontal", "nest", "percent", "seventy-five"],
    "popularity": 804
  },
  {
    "name": "remove_road",
    "tags": [
      "-",
      "cancel",
      "close",
      "destination",
      "direction",
      "exit",
      "highway",
      "maps",
      "minus",
      "new",
      "no",
      "remove",
      "road",
      "stop",
      "street",
      "symbol",
      "traffic",
      "x"
    ],
    "popularity": 804
  },
  {
    "name": "splitscreen",
    "tags": ["column", "grid", "layout", "multitasking", "row", "screen", "split", "splitscreen", "two"],
    "popularity": 804
  },
  {
    "name": "roller_skating",
    "tags": [
      "athlete",
      "athletic",
      "entertainment",
      "exercise",
      "hobby",
      "roller",
      "shoe",
      "skate",
      "skates",
      "skating",
      "social",
      "sports",
      "travel"
    ],
    "popularity": 802
  },
  {
    "name": "south_america",
    "tags": ["continent", "landscape", "place", "region", "south america"],
    "popularity": 802
  },
  {
    "name": "view_carousel",
    "tags": ["cards", "carousel", "design", "format", "grid", "layout", "view", "website"],
    "popularity": 802
  },
  {
    "name": "coffee_maker",
    "tags": ["appliances", "beverage", "coffee", "cup", "drink", "machine", "maker", "mug"],
    "popularity": 800
  },
  {
    "name": "sunny_snowing",
    "tags": ["climate", "cold", "snow", "sun", "sunny", "temperature", "weather", "winter"],
    "popularity": 798
  },
  {
    "name": "border_vertical",
    "tags": [
      "border",
      "doc",
      "edit",
      "editing",
      "editor",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "vertical",
      "writing"
    ],
    "popularity": 796
  },
  {
    "name": "markunread_mailbox",
    "tags": [
      "deliver",
      "envelop",
      "letter",
      "mail",
      "mailbox",
      "markunread",
      "post",
      "postal",
      "postbox",
      "receive",
      "send",
      "unread"
    ],
    "popularity": 796
  },
  {
    "name": "all_inbox",
    "tags": ["Inbox", "all", "delivered", "delivery", "email", "mail", "message", "send"],
    "popularity": 791
  },
  {
    "name": "timer_3_select",
    "tags": [
      "3",
      "alphabet",
      "camera",
      "character",
      "digit",
      "font",
      "letter",
      "number",
      "seconds",
      "select",
      "symbol",
      "text",
      "timer",
      "type"
    ],
    "popularity": 789
  },
  {
    "name": "no_backpack",
    "tags": ["accessory", "backpack", "bag", "bookbag", "knapsack", "no", "pack", "travel"],
    "popularity": 788
  },
  {
    "name": "offline_pin",
    "tags": [
      "approve",
      "check",
      "checkmark",
      "circle",
      "complete",
      "done",
      "mark",
      "offline",
      "ok",
      "pin",
      "select",
      "tick",
      "validate",
      "verified",
      "yes"
    ],
    "popularity": 787
  },
  {
    "name": "multiple_stop",
    "tags": ["arrows", "directions", "dots", "left", "maps", "multiple", "navigation", "right", "stop"],
    "popularity": 786
  },
  {
    "name": "wrong_location",
    "tags": [
      "cancel",
      "close",
      "destination",
      "direction",
      "exit",
      "location",
      "maps",
      "no",
      "pin",
      "place",
      "quit",
      "remove",
      "stop",
      "wrong",
      "x"
    ],
    "popularity": 786
  },
  {
    "name": "stairs",
    "tags": ["down", "staircase", "stairs", "up"],
    "popularity": 785
  },
  {
    "name": "flip_camera_android",
    "tags": [
      "android",
      "camera",
      "center",
      "edit",
      "editing",
      "flip",
      "image",
      "mobile",
      "orientation",
      "rotate",
      "turn"
    ],
    "popularity": 784
  },
  {
    "name": "border_horizontal",
    "tags": [
      "border",
      "doc",
      "edit",
      "editing",
      "editor",
      "horizontal",
      "sheet",
      "spreadsheet",
      "stroke",
      "text",
      "type",
      "writing"
    ],
    "popularity": 783
  },
  {
    "name": "text_increase",
    "tags": [
      "+",
      "add",
      "alphabet",
      "character",
      "font",
      "increase",
      "letter",
      "new",
      "plus",
      "resize",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 782
  },
  {
    "name": "backup_table",
    "tags": ["backup", "drive", "files folders", "format", "layout", "stack", "storage", "table"],
    "popularity": 780
  },
  {
    "name": "wifi_1_bar",
    "tags": [
      "1",
      "bar",
      "cell",
      "cellular",
      "connection",
      "data",
      "internet",
      "mobile",
      "network",
      "phone",
      "scan",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 780
  },
  {
    "name": "mic_external_on",
    "tags": ["audio", "disabled", "enabled", "external", "mic", "microphone", "off", "on", "slash", "sound", "voice"],
    "popularity": 779
  },
  {
    "name": "panorama_horizontal_select",
    "tags": ["angle", "horizontal", "image", "panorama", "photo", "photography", "picture", "select", "wide"],
    "popularity": 779
  },
  {
    "name": "edit_location",
    "tags": ["destination", "direction", "edit", "location", "maps", "pen", "pencil", "pin", "place", "stop"],
    "popularity": 778
  },
  {
    "name": "voice_chat",
    "tags": [
      "bubble",
      "cam",
      "camera",
      "chat",
      "comment",
      "communicate",
      "facetime",
      "feedback",
      "message",
      "speech",
      "video",
      "voice"
    ],
    "popularity": 778
  },
  {
    "name": "view_comfy_alt",
    "tags": ["alt", "comfy", "cozy", "design", "format", "layout", "view", "web"],
    "popularity": 777
  },
  {
    "name": "wifi_channel",
    "tags": [
      "(scan)",
      "[cellular",
      "channel",
      "connection",
      "data",
      "internet",
      "mobile]",
      "network",
      "service",
      "signal",
      "wifi",
      "wireless"
    ],
    "popularity": 777
  },
  {
    "name": "phone_forwarded",
    "tags": [
      "arrow",
      "call",
      "cell",
      "contact",
      "device",
      "direction",
      "forwarded",
      "hardware",
      "mobile",
      "phone",
      "right",
      "telephone"
    ],
    "popularity": 776
  },
  {
    "name": "width_full",
    "tags": [],
    "popularity": 776
  },
  {
    "name": "format_textdirection_r_to_l",
    "tags": [
      "align",
      "alignment",
      "doc",
      "edit",
      "editing",
      "editor",
      "format",
      "rtl",
      "sheet",
      "spreadsheet",
      "text",
      "textdirection",
      "type",
      "writing"
    ],
    "popularity": 775
  },
  {
    "name": "2k",
    "tags": [
      "2000",
      "2K",
      "alphabet",
      "character",
      "digit",
      "display",
      "font",
      "letter",
      "number",
      "pixel",
      "pixels",
      "resolution",
      "symbol",
      "text",
      "type",
      "video"
    ],
    "popularity": 774
  },
  {
    "name": "roundabout_right",
    "tags": [
      "arrow",
      "arrows",
      "direction",
      "directions",
      "maps",
      "navigation",
      "path",
      "right",
      "roundabout",
      "route",
      "sign",
      "traffic"
    ],
    "popularity": 774
  },
  {
    "name": "heart_minus",
    "tags": [
      "-",
      "appreciate",
      "delete",
      "favorite",
      "like",
      "love",
      "minus",
      "remember",
      "remove",
      "save",
      "subtract"
    ],
    "popularity": 773
  },
  {
    "name": "battery_3_bar",
    "tags": ["3", "bar", "battery", "cell", "charge", "mobile", "power"],
    "popularity": 772
  },
  {
    "name": "dew_point",
    "tags": ["atmospheric", "condense", "dew", "droplets", "point", "temperature", "thermometer", "water"],
    "popularity": 772
  },
  {
    "name": "front_loader",
    "tags": ["carry", "factory", "industrial", "load", "manufactory", "supply", "truck", "vehicle"],
    "popularity": 772
  },
  {
    "name": "emoji_symbols",
    "tags": ["ampersand", "character", "emoji", "hieroglyph", "music", "note", "percent", "sign", "symbols"],
    "popularity": 770
  },
  {
    "name": "keyboard_alt",
    "tags": [
      "alt",
      "computer",
      "device",
      "hardware",
      "input",
      "keyboard",
      "keypad",
      "letter",
      "office",
      "text",
      "type"
    ],
    "popularity": 770
  },
  {
    "name": "grain",
    "tags": [
      "dots",
      "edit",
      "editing",
      "effect",
      "filter",
      "grain",
      "image",
      "images",
      "photography",
      "picture",
      "pictures"
    ],
    "popularity": 769
  },
  {
    "name": "plumbing",
    "tags": ["build", "construction", "fix", "handyman", "plumbing", "repair", "tools", "wrench"],
    "popularity": 769
  },
  {
    "name": "roller_shades",
    "tags": ["blinds", "cover", "curtains", "nest", "open", "roller", "shade", "shutter", "sunshade"],
    "popularity": 768
  },
  {
    "name": "request_page",
    "tags": [
      "data",
      "doc",
      "document",
      "drive",
      "file",
      "folder",
      "folders",
      "page",
      "paper",
      "request",
      "sheet",
      "slide",
      "writing"
    ],
    "popularity": 767
  },
  {
    "name": "no_photography",
    "tags": ["camera", "disabled", "enabled", "image", "no", "off", "on", "photo", "photography", "picture", "slash"],
    "popularity": 766
  },
  {
    "name": "details",
    "tags": ["details", "edit", "editing", "enhance", "image", "photo", "photography", "sharpen", "triangle"],
    "popularity": 763
  },
  {
    "name": "lens_blur",
    "tags": ["blur", "camera", "dim", "dot", "effect", "foggy", "fuzzy", "image", "lens", "photo", "soften"],
    "popularity": 763
  },
  {
    "name": "mode_of_travel",
    "tags": [
      "arrow",
      "destination",
      "direction",
      "location",
      "maps",
      "mode",
      "of",
      "pin",
      "place",
      "stop",
      "transportation",
      "travel",
      "trip"
    ],
    "popularity": 761
  },
  {
    "name": "settings_input_component",
    "tags": [
      "audio",
      "av",
      "cable",
      "cables",
      "component",
      "connect",
      "connection",
      "connectivity",
      "input",
      "internet",
      "plug",
      "points",
      "settings",
      "video",
      "wifi"
    ],
    "popularity": 761
  },
  {
    "name": "hdr_plus",
    "tags": [
      "+",
      "add",
      "alphabet",
      "character",
      "circle",
      "dynamic",
      "enhance",
      "font",
      "hdr",
      "high",
      "letter",
      "plus",
      "range",
      "select",
      "symbol",
      "text",
      "type"
    ],
    "popularity": 760
  },
  {
    "name": "panorama_photosphere_select",
    "tags": [
      "angle",
      "horizontal",
      "image",
      "panorama",
      "photo",
      "photography",
      "photosphere",
      "picture",
      "select",
      "wide"
    ],
    "popularity": 760
  },
  {
    "name": "garden_cart",
    "tags": ["cart", "garden", "gardening", "wheelbarrow", "yard"],
    "popularity": 759
  },
  {
    "name": "image_not_supported",
    "tags": [
      "disabled",
      "enabled",
      "image",
      "landscape",
      "mountain",
      "mountains",
      "not",
      "off",
      "on",
      "photo",
      "photography",
      "picture",
      "slash",
      "supported"
    ],
    "popularity": 759
  },
  {
    "name": "wb_auto",
    "tags": [
      "A",
      "W",
      "alphabet",
      "auto",
      "automatic",
      "balance",
      "character",
      "edit",
      "editing",
      "font",
      "image",
      "letter",
      "photo",
      "photography",
      "symbol",
      "text",
      "type",
      "white",
      "wp"
    ],
    "popularity": 759
  },
  {
    "name": "wifi_protected_setup",
    "tags": ["around", "arrow", "arrows", "protected", "rotate", "setup", "wifi"],
    "popularity": 759
  },
  {
    "name": "humidity_high",
    "tags": ["atmosphere", "droplet", "high", "moisture", "vapor", "water"],
    "popularity": 758
  },
  {
    "name": "share_reviews",
    "tags": ["bubble", "chat", "comment", "communicate", "feedback", "message", "review", "reviews", "share", "speech"],
    "popularity": 758
  },
  {
    "name": "adb",
    "tags": ["adb", "android", "bridge", "debug"],
    "popularity": 757
  },
  {
    "name": "panorama_wide_angle",
    "tags": ["angle", "image", "panorama", "photo", "photography", "picture", "wide"],
    "popularity": 757
  },
  {
    "name": "ad_units",
    "tags": [
      "Android",
      "OS",
      "ad",
      "banner",
      "cell",
      "device",
      "hardware",
      "iOS",
      "mobile",
      "notification",
      "notifications",
      "phone",
      "tablet",
      "top",
      "units"
    ],
    "popularity": 756
  },
  {
    "name": "sports_volleyball",
    "tags": [
      "athlete",
      "athletic",
      "ball",
      "entertainment",
      "exercise",
      "game",
      "hobby",
      "social",
      "sports",
      "volleyball"
    ],
    "popularity": 756
  },
  {
    "name": "minor_crash",
    "tags": [
      "accident",
      "auto",
      "automobile",
      "car",
      "cars",
      "collision",
      "directions",
      "maps",
      "public",
      "transportation",
      "vehicle"
    ],
    "popularity": 755
  },
  {
    "name": "unfold_less_double",
    "tags": [
      "arrow",
      "arrows",
      "chevron",
      "collapse",
      "direction",
      "double",
      "expand",
      "expandable",
      "inward",
      "less",
      "list",
      "navigation",
      "unfold",
      "up"
    ],
    "popularity": 755
  },
  {
    "name": "flatware",
    "tags": ["cafe", "cafeteria", "cutlery", "diner", "dining", "eat", "eating", "fork", "room", "spoon"],
    "popularity": 754
  },
  {
    "name": "panorama_vertical_select",
    "tags": ["angle", "image", "panorama", "photo", "photography", "picture", "select", "vertical", "wide"],
    "popularity": 754
  }
]
